/* eslint-disable max-len, max-lines */
import {getContent, getPatchNote, PatchNoteContent, PatchNoteType} from '../../../shared/scripts/patch_notes/UIPatchNoteModule'
import {PatchNoteData} from '../../../shared/scripts/patch_notes/PatchNoteData'
import IconMummy from '@static/images/icon_mummy.svg'
import MapMonopolyIslandsPreview from '@static/images/map_monopoly_islands_preview.png'
import MapGoldrushPreview from '@static/images/map_goldrush_preview.png'
import IconRobberCupid from '@static/images/icon_robber_cupid.png'
import IconRobberLunar from '@static/images/icon_robber_lunar.png'
import MapStripesPreview from '@static/images/map_stripes_preview.png'
import MapEuropePreview from '@static/images/map_europe_preview.png'
import MapVietnamPreview from '@static/images/map_vietnam_preview.png'
import IconRobberSanta from '@static/images/icon_robber_santa.svg'
import MapIstanbulPreview from '@static/images/map_istanbul_preview.png'
import MapJellyfishPreview from '@static/images/map_jellyfish_preview.png'
import MapMountainOfRichesPreview from '@static/images/map_mountain_of_riches_preview.png'
import IconSombrero from '@static/images/icon_sombrero.svg'
import IconFarmer from '@static/images/icon_farmer.svg'
import MapVolcanoPreview from '@static/images/map_volcano_preview.png'
import IconWorker from '@static/images/icon_worker.svg'
import MapBlackforestPreview from '@static/images/map_blackforest_preview.png'
import IconScarf from '@static/images/icon_scarf.svg'
import IconSnorkel from '@static/images/icon_snorkel.svg'
import IconCactus from '@static/images/icon_cactus.svg'
import IconSwords from '@static/images/icon_swords.svg'
import GameModeIconsSeafarers from '@static/images/game_mode_icons/seafarers.svg'
import MapRomaniaPreview from '@static/images/map_romania_preview.png'
import MapUkPreview from '@static/images/map_uk_preview.png'
import MapEarthPreview from '@static/images/map_earth_preview.png'
import ImageNotAvailable from '@static/images/logo.svg'
import MapTwirlPreview from '@static/images/map_twirl_preview.png'
import MapUsaPreview from '@static/images/map_usa_preview.png'
import MapGearPreview from '@static/images/map_gear_preview.png'
import RoadBlack from '@static/images/road_black.svg'
import SettlementBlack from '@static/images/settlement_black.svg'
import CityBlack from '@static/images/city_black.svg'
import MapLakesPreview from '@static/images/map_lakes_preview.png'
import MapSnowflakePreview from '@static/images/map_snowflake_preview.png'
import IconHelmet from '@static/images/icon_helmet.svg'
import IconTie from '@static/images/icon_tie.svg'
import IconAvocado from '@static/images/icon_avocado.svg'
import IconCrown from '@static/images/icon_crown.svg'

export class AllPatchNoteData extends PatchNoteData {
    constructor() {
        super()

        const v265: PatchNoteContent[] = []
        v265.push(getContent(PatchNoteType.Update, 'New matchmaking selection screen!', undefined, 'https://i.imgur.com/h6844Va.png', 'https://i.imgur.com/bKoojJG.png'))
        v265.push(getContent(PatchNoteType.Update, '[Mobile] Update leaderboard design', undefined, 'https://i.imgur.com/srmFzwk.png', 'https://i.imgur.com/AmcnG64.png'))
        v265.push(getContent(PatchNoteType.Fix, 'Fixed low-res icons in game', undefined, 'https://i.imgur.com/TGMTTRT.png', 'https://i.imgur.com/y5DQzQz.png'))
        v265.push(getContent(PatchNoteType.Fix, 'Fixed Longest Road highlight showing on loss instead of gain', undefined, 'https://i.imgur.com/TKATDmY.png', 'https://i.imgur.com/yq08EZV.png'))

        // Devyesh
        // [Mobile] Add leaderboard header to mobile
        // [Mobile] Fixing beginner mode level increment

        // Muhammad
        // AB test to show a new CTA for the store Membership buttons
        // Replace swords with logo in mobile bottom nav

        this.patchNotes.push(getPatchNote(2025, 8, 12, 265, v265))

        const v264: PatchNoteContent[] = []
        v264.push(getContent(PatchNoteType.Fix, '[Mobile] Improve profile page popup loading time and responsiveness', undefined, 'https://imgur.com/a/AhlmCtA', 'https://imgur.com/a/snHVa7w'))

        // Devyesh
        // [Mobile] Update targetSdkVersion to 35

        // Oguz
        // Fixed game breaking when a spectator sends a chat message
        // Fixed event dice always being barbarian progress (#20420)

        // Stan
        // Integrated ReactJS UI for mobile end screen (Removed all UIGameEnd PixiJS code)
        // Converted UIGameAchievement to a React component
        // Converted UIMGameTimer to a React component

        // Muhammad
        // v264.push(getContent(PatchNoteType.Update, '[Web/Discord] Profiles in the lobby and in-game now open in a popup', undefined, 'https://imgur.com/a/Jq4e5nq', 'https://imgur.com/a/mL3h2hn'))
        // v264.push(getContent(PatchNoteType.Update, '[Mobile] Clicking a friend in your friends list now opens their profile', undefined, undefined, 'https://imgur.com/a/yDXzxKY'))
        // v264.push(getContent(PatchNoteType.Update, 'View previous profiles from the profile popup', undefined, undefined, 'https://imgur.com/a/E6rrW0i'))

        // Marc
        // Add public view for user_reactivation table
        // Re-run AB test for reactivate Discord inactive users
        // Remove AB test on the text sent when sharing the activity link on Discord

        // Dang
        // [Mobile] Remove default global font-size

        this.patchNotes.push(getPatchNote(2025, 8, 5, 264, v264))

        const v263: PatchNoteContent[] = []
        v263.push(getContent(PatchNoteType.Update, 'Updated upper section of room UI', undefined, 'https://imgur.com/a/euZ08aW', 'https://imgur.com/a/ROeb0BX'))
        v263.push(getContent(PatchNoteType.Fix, 'Fixed Commodity card order', undefined, 'https://i.imgur.com/wPI058O.png', 'https://i.imgur.com/Dg2B8w9.png'))
        v263.push(getContent(PatchNoteType.Fix, '[Mobile] Improved game performance on older devices'))
        v263.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed special build phase button overlap', undefined, 'https://i.imgur.com/PJ37xEY.png', 'https://i.imgur.com/Cg4tGFE.png'))

        // Rob
        // Upgrade Discord API to v9
        // Fix Discord leaderboard console error

        // Oguz
        // Refactored base game mechanics to use isPlayersTurn instead of currentTurnPlayerColor
        // Created new type ActionNotificationData and refactored base game mechanics' ActionNotifications to use it

        // Stan
        // Remove rate chat experience notification

        // Marc
        // Fix this.removeChangeListener is not a function error

        this.patchNotes.push(getPatchNote(2025, 7, 29, 263, v263))

        const v262: PatchNoteContent[] = []
        v262.push(getContent(PatchNoteType.Update, 'New Rules selector in room!', undefined, 'https://imgur.com/a/4GSJ141', 'https://imgur.com/a/9TfpYWL'))
        v262.push(getContent(PatchNoteType.Fix, 'Fixed room flickering when adjusting sliders'))
        v262.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed scrolling issues in room settings'))
        v262.push(getContent(PatchNoteType.Fix, '[Mobile] Fix end game screen resizing'))
        v262.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fix loading issues in parts of Europe'))

        // Devyesh
        // [Mobile] Show notification icon in android and ios
        // [Mobile] Scroll discord login page on 13 inch iPad

        // Muhammad
        // Refactor discord reactivation message logic
        // Send reactivation message to mobile users

        // Marc
        // Re-run AB test for share activity link text
        // AB Test push referrers to invite more friends
        // Re-run AB test for end game share results

        this.patchNotes.push(getPatchNote(2025, 7, 22, 262, v262))

        const v261: PatchNoteContent[] = []
        v261.push(getContent(PatchNoteType.Update, '[Mobile] Updated side menu', undefined, 'https://imgur.com/a/5vvq45Y', 'https://imgur.com/a/0tctpLt'))
        v261.push(getContent(PatchNoteType.Update, 'Updated social media icons', undefined, 'https://i.imgur.com/A0qUpEF.png', 'https://i.imgur.com/YrgzIBF.png'))
        v261.push(getContent(PatchNoteType.Fix, 'Fixed game display issues on older browsers'))
        v261.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed reconnection bug'))

        // Rob
        // Updated social link icons and order

        // Devyesh
        // [Mobile] Update notification icon in android

        // Oguz
        // Refactor UIGameStateController
        // Implement UIGameCurrentStatus.tsx

        // Muhammad
        // Add ab test for new store membership title
        // Replace product designer ad with generic join team ad

        this.patchNotes.push(getPatchNote(2025, 7, 15, 261, v261))

        const v260: PatchNoteContent[] = []
        v260.push(getContent(PatchNoteType.Update, 'New Mode and Map selectors in room!', undefined, 'https://imgur.com/a/IbHcabE', 'https://imgur.com/a/QK3p2Jx'))
        v260.push(getContent(PatchNoteType.Update, '[Mobile] Added road, settlement, city amounts to profile on portrait mode', undefined, undefined, undefined))
        v260.push(getContent(PatchNoteType.Fix, 'Fixed lag present in some devices'))
        v260.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed keyboard resizing when joining a game'))
        v260.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fix double popups appearing when returning to the homepage after a game'))

        // Devyesh
        // Notification logic updated
        // [Mobile] Fixing get more colors link redirect

        // Muhammad
        // Move vscode settings to .vscode/settings.example.json
        // Add ab test for end game tip

        // Marc
        // Update texts for the share activity link A/B test

        this.patchNotes.push(getPatchNote(2025, 7, 8, 260, v260))

        const v259: PatchNoteContent[] = []
        v259.push(getContent(PatchNoteType.Update, '[Mobile] Guests can now play Casual 1v1 and 4p games', undefined, 'https://imgur.com/a/Q397Ydc', 'https://imgur.com/a/MfjWbX4'))
        v259.push(getContent(PatchNoteType.Update, 'Leaving a game you\'re spectating takes you to the spectate list'))
        v259.push(getContent(PatchNoteType.Fix, 'Removed horizontal scrollbar from homepage on certain languages', undefined, 'https://imgur.com/a/6B56GJH', 'https://imgur.com/a/FcNDfRY'))
        v259.push(getContent(PatchNoteType.Fix, 'Fixed elements around a top notification not being clickable'))
        v259.push(getContent(PatchNoteType.Fix, 'Fixed inventor progress card popup getting stuck and breaking its animations', undefined, undefined, undefined))
        v259.push(getContent(PatchNoteType.Blog, 'Why Colonist is Going Portrait-First on Mobile. <a href="https://blog.colonist.io/why-colonist-is-going-portrait-on-mobile/" target="_blank">Read here!</a>', undefined, undefined, undefined, ['https://blog.colonist.io/why-colonist-is-going-portrait-on-mobile/']))

        // Devyesh
        // [Mobile] Fix deeplink redirection to catan rules page

        // Marc
        // AB test to display automatically the share game results on end screen

        this.patchNotes.push(getPatchNote(2025, 7, 1, 259, v259))

        const v258: PatchNoteContent[] = []
        v258.push(getContent(PatchNoteType.Update, '[Mobile] Search players in profile page', undefined, undefined, 'https://imgur.com/a/mnffGIU'))
        v258.push(getContent(PatchNoteType.Fix, 'Fixed clicking your flag opening both the change region popup and leaderboard filter', undefined, undefined, undefined))

        // Devyesh
        // Migration to support local currency in transactions

        // Marc
        // Add a new reward to the referral program

        // Dang
        // Enable Replay for Specators after a live game

        this.patchNotes.push(getPatchNote(2025, 6, 24, 258, v258))

        const v257: PatchNoteContent[] = []
        v257.push(getContent(PatchNoteType.Update, 'New Edit Profile popup', undefined, 'https://imgur.com/a/NJoBkLF', 'https://imgur.com/a/qWWctoF'))
        v257.push(getContent(PatchNoteType.Update, '[Mobile] Added a search undo button to the leaderboard', undefined, 'https://imgur.com/a/g1IHLGF', 'https://imgur.com/a/kOIoXx1'))
        v257.push(getContent(PatchNoteType.Fix, '[Tablet] Fixed overflowing game mode buttons', undefined, 'https://imgur.com/a/EscmyYd', 'https://imgur.com/a/MxRmn73'))
        v257.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed accidental interactions with elements behind popups'))
        v257.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed slider minimum value for Card Discard Limit', undefined, 'https://i.imgur.com/wj5BYIM.jpeg', 'https://i.imgur.com/XAdf0rM.jpeg'))

        // Rob
        // Add analytic event for ranked info icon

        // Devyesh
        // [Mobile] Refactor leaderboard - phase 3
        // [Mobile] Added endpoint to check active subscriptions
        // [Mobile] Close singleton pages when entering game

        // Oguz
        // Add Growthbook instructions to ab test documentation
        // Fixed missing currency sign in the store

        // Muhammad
        // Always lineup page content with header/footer

        // Marc
        // AB test two different texts for the share activity invitation on Discord

        // Kyle
        // Cancel membership via discord steps added to faq

        this.patchNotes.push(getPatchNote(2025, 6, 17, 257, v257))

        const v256: PatchNoteContent[] = []
        v256.push(getContent(PatchNoteType.Update, 'Large notification count now shows 99+', undefined, 'https://imgur.com/D6f9umF', 'https://imgur.com/o2ywUxp'))
        v256.push(getContent(PatchNoteType.Fix, 'Fixed received friend requests not showing up on some pages'))
        v256.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed the leaderboard Membership icon opening the store and profile page at the same time', undefined, 'https://imgur.com/a/fJDpV4a', 'https://imgur.com/a/8IUDLjj'))
        v256.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed clicking on the leaderboard flag icon opening profile page', undefined, 'https://imgur.com/a/LenUbNC', 'https://imgur.com/a/tXpaH94'))
        v256.push(getContent(PatchNoteType.Fix, '[Mobile] Increase profile page view height', undefined, 'https://imgur.com/a/1vMRQ7q', 'https://imgur.com/a/DJ95CmL'))

        // Devyesh
        // [Mobile] Added endpoint to check active subscriptions
        // [Mobile] Fixing UI on first load in mobile app
        // [Mobile] Fix UI breaking when selecting avatar
        // [Mobile] Added payments in mobile app
        // [Mobile] Fixing deeplink to iOS app
        // Removed ads from matchmaking page on Android

        // Oguz
        // Stop STORE_YEARLY_MEMBERSHIP_PRICE_ADJUSTMENT A/B test
        // Fixed game breaking edge case in tournament rooms
        // Added unit tests for tournament rooms

        // Muhammad
        // Add no trolls to mobile rules
        // Remove check/X buttons from popups that don't need them
        // Adjust spacing between sections on singleton pages

        // Marc
        // AB test to reactivate Discord inactive users by sending DMs with our Discord bot

        this.patchNotes.push(getPatchNote(2025, 6, 10, 256, v256))

        const v255: PatchNoteContent[] = []
        v255.push(getContent(PatchNoteType.Update, 'Show max values in room sliders', undefined, 'https://i.imgur.com/HtTQkjU.png', 'https://i.imgur.com/MFqT6JQ.png'))
        v255.push(getContent(PatchNoteType.Update, '[Mobile] Updated profile page styles', undefined, 'https://imgur.com/a/IyjTcni', 'https://imgur.com/a/rDe6avP'))
        v255.push(getContent(PatchNoteType.Update, '[Mobile] Swapped map and edit icons in room settings', undefined, 'https://imgur.com/a/DXYc6oT', 'https://imgur.com/a/0L03IZd'))
        v255.push(getContent(PatchNoteType.Update, '[Mobile] Improved friends view in profile', undefined, 'https://imgur.com/a/KauPq75', 'https://imgur.com/a/yZ9Trlr'))
        v255.push(getContent(PatchNoteType.Update, '[Mobile] Updated splash screen image and font sizes', undefined, undefined, undefined))

        // Rob
        // [Mobile] Consistent ranked/casual button text
        // Beginner mode button shows on mobile when you have 0 or 1 games
        // Fix homepage ranked lock icon
        // Add X button to delete account popup
        // [Mobile] Increase side menu font size
        // Remove background image from store popups

        // Devyesh
        // [Mobile] Minor leaderboard refactor - 2
        // [Mobile] Standarize popup styles in mobile

        // Oguz
        // Rename Card.tsx as UIGameCard.tsx and add optional count prop

        this.patchNotes.push(getPatchNote(2025, 6, 3, 255, v255))

        const v254: PatchNoteContent[] = []
        v254.push(getContent(PatchNoteType.Update, 'Remove Wins/Loss and Completed Games stats from profile', undefined, 'https://imgur.com/a/y5GsCoz', 'https://imgur.com/a/yn15zvm'))
        v254.push(getContent(PatchNoteType.Update, 'Remove Wins/Loss stat from homepage', undefined, 'https://imgur.com/a/UMfR1cN', 'https://imgur.com/a/yceH7R6'))
        v254.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed mobile lobby header position', undefined, 'https://i.imgur.com/qKecl3S.jpeg', 'https://i.imgur.com/YaCSqym.jpeg'))
        v254.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed player count display on mobile', undefined, 'https://i.imgur.com/Ps3grZQ.png', 'https://i.imgur.com/f74MbPZ.png'))
        v254.push(getContent(PatchNoteType.Fix, '[Mobile] Automatically open the keyboard when showing a popup with text box'))

        // Devyesh
        // [Mobile] Merged UILeaderboardBaseTableRowView with UIMLeaderboardBaseTableRowView
        // [Mobile] Use UserAgent instead of isTablet to detect tablet devices on events
        // [Mobile] Handle error screen when socket is established after the error is shown
        // [Mobile] Set default resolution to min of 2 or devicePixelRatio
        // [Mobile] Added starting userId to AuthMigration

        // Oguz
        // Created /banmostreportedplayers command
        // Implemented UIGameTimer React Component
        // Added Google Tag Manager events

        this.patchNotes.push(getPatchNote(2025, 5, 27, 254, v254))

        const v253: PatchNoteContent[] = []
        v253.push(getContent(PatchNoteType.Update, '[Discord Activity] Invite Discord friends to a Colonist room when playing via direct messages'))

        // Devyesh
        // [Mobile] Use UserAgent instead of isTablet to detect tablet devices on events

        // Oguz
        // Implemented UIGameTimer React Component
        // Added Google Tag Manager events

        // Marc
        // Refactor Discord Bot reactivation messages
        // Make it possible to invite Discord friends to a room even when playing Colonist from a DM

        this.patchNotes.push(getPatchNote(2025, 5, 20, 253, v253))

        const v252: PatchNoteContent[] = []
        v252.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed end game screen not appearing on tablets'))
        v252.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed game rotation on tablet'))

        // Rob
        // Rename discord classes and variables
        // Rework Discord Mount architecture

        // Devyesh
        // [Mobile] Support tablet mode on website

        // Oguz
        // Added Google Tag Manager events
        // Implemented store yearly subscriptions LTV A/B test

        // Stan
        // Added rate chat experience notification on end game screen
        // Replaced HowlerJS with AudioManager + Web Audio API

        this.patchNotes.push(getPatchNote(2025, 5, 13, 252, v252))

        const v251: PatchNoteContent[] = []
        v251.push(getContent(PatchNoteType.Update, 'Players who quit now have 100 seconds to rejoin before the game ends automatically'))
        v251.push(getContent(PatchNoteType.Fix, '[Discord] Fixed invite online friends button not working'))

        // Rob
        // Rename discord classes and variables

        // Devyesh
        // [Mobile] Bumps @babel/helpers from 7.26.9 to 7.27.0.
        // [Mobile] Bumps @babel/runtime from 7.26.9 to 7.27.0.
        // [Mobile] Fixing app related issues
        // [Mobile] Android full screen mode fixed
        // [Mobile] Added landscape mode is deprecated popup. Also removes toggle for new players

        // Marc
        // Catch error when sending DM 24h after last activity launch and ignore if user cannot receive messages

        this.patchNotes.push(getPatchNote(2025, 5, 6, 251, v251))

        const v250: PatchNoteContent[] = []
        v250.push(getContent(PatchNoteType.Update, 'Add friends from the room', undefined, undefined, 'https://imgur.com/a/JmLOT3I'))
        v250.push(getContent(PatchNoteType.Update, 'Redesigned top notification banners', undefined, 'https://imgur.com/a/T4ocWXF', 'https://imgur.com/a/ujkJ8Ov'))

        // Devyesh
        // [Mobile] Migrate apple users from old account to new account

        // Muhammad
        // Cleanup console logs in prod & dev
        // Web and discord default rooms settings now the same (except discord is private and karma inactive)
        // v250.push(getContent(PatchNoteType.Update, '[Mobile] Improved store sidebar style', undefined, 'https://imgur.com/a/DP7uZMm', 'https://imgur.com/a/vOeAOKC'))

        // Marc
        // New popup when returning to homepage at the end of a game to promote the rewards program
        // New Lobby Ad to promote the rewards program

        this.patchNotes.push(getPatchNote(2025, 4, 29, 250, v250))

        const v249: PatchNoteContent[] = []
        v249.push(getContent(PatchNoteType.Update, 'Chat box can now be minimized', undefined, undefined, 'https://imgur.com/a/H01N6bs'))
        v249.push(getContent(PatchNoteType.Update, '[Discord Activity] You can now view your friends\' profiles', undefined, undefined, 'https://imgur.com/a/N3C59de'))
        v249.push(getContent(PatchNoteType.Fix, 'Fixed sending repetitive \'Action taken\' report notifications'))
        v249.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed leaderboard tabs scrolling', undefined, 'https://imgur.com/a/nStswhs', 'https://imgur.com/a/7zrxm9v'))

        // Oguz
        // Improved strikethrough price style in store page yearly membership cards

        // Muhammad
        // Fix tourney register link not working on discord
        // Remove tshirt survey ad

        // Marc
        // Update Rewards Program text
        // Fix referral bugs (https://github.com/colonistio/katan/pull/19355#issuecomment-2810779261)

        // Dang
        // Build React End game screen and remove old canvas End game screen
        // Fix Game log and Game chat sizing in mobile landscape
        // Fix UI game position resizing
        // Fix Discord Avatar alignment in Game Chat
        // Fix missing avatar in Game Feed Log

        this.patchNotes.push(getPatchNote(2025, 4, 22, 249, v249))

        const v248: PatchNoteContent[] = []
        v248.push(getContent(PatchNoteType.Feature, '[Discord Activity] Automatically join your activity\'s room when you load the game'))
        v248.push(getContent(PatchNoteType.Fix, 'Fixed lobby ads overlapping with notification panel', undefined, 'https://imgur.com/a/SW7w5tC', 'https://imgur.com/a/pE1WGUI'))
        v248.push(getContent(PatchNoteType.Fix, 'Fixed leaderboard search bar on smaller screens', undefined, 'https://imgur.com/a/Pig2CUn', 'https://imgur.com/a/HCGbpcV'))

        // Rob
        // Remove 1v1 Easy Bot A/B Test; Beginner Mode is default
        // Added beginner hints to web for users with fewer than 2 completed games
        // Hide beginner mode for users with 2+ completed games
        // Removed unused beginner stuff

        // Devyesh
        // [Mobile] Hide status bar on mobile

        // Oguz
        // Improved username moderation: Perspective API now checks for bad words in usernames
        // Stopped tracking [first game analytics, hover action usages, profile page section visits, game statistics, player game statistics, player game turn statistics] to free up space in the database

        // Muhammad
        // Fix discord mobile not opening because of gift icon
        // Fix ads overlapping notification panel
        // Fix duplicate change username popup when clicking info icon in room

        // Marc
        // AB test sending a DM 24h after last activity launch to reactive discord players
        // Remove AB Test that inverts the main CTA on Discord and rename it to "Play with Friends", it is now default

        this.patchNotes.push(getPatchNote(2025, 4, 15, 248, v248))

        const v247: PatchNoteContent[] = []
        v247.push(getContent(PatchNoteType.Update, 'Refreshed the site\'s background color', undefined, 'https://imgur.com/a/9pyZav3', 'https://imgur.com/a/m8Nr3p6'))
        v247.push(getContent(PatchNoteType.Fix, 'End game screen progress bar animation speed now depends on the winning action'))
        v247.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed store gift avatar text link not opening the gift overlay'))

        // Jeff
        // Disable AFK kick timer for private games

        // Rob
        // Remove 1v1 Easy Bot A/B Test; Beginner Mode is default
        // v248.push(getContent(PatchNoteType.Feature, 'Automatically reconnect to your game if disconnected'))

        // Devyesh
        // [Mobile] Update logo in mobile app
        // [Mobile] Fix hover color when button is disabled
        // [Mobile] Let app reconnect even if hidden on mobile device
        // [Mobile] Show notification popup when homepage is loaded instead of when game started

        // Oguz
        // Fixed bots trading with opponents in tournaments

        // Muhammad
        // Add country flag to discord ranked games if they've updated their region
        // Add gift icon to mobile store
        // v247.push(getContent(PatchNoteType.Update, 'Improved tooltip accessibility across the site', undefined, 'https://imgur.com/a/B5RF17I', 'https://imgur.com/a/6cMBe7Z'))

        // Marc
        // Add the Referral Program to the store page
        // Add a new AB test that inverts the main CTA on Discord and rename it to "Play with Friends"

        this.patchNotes.push(getPatchNote(2025, 4, 8, 247, v247))

        const v246: PatchNoteContent[] = []
        v246.push(getContent(PatchNoteType.Update, '1v1 lobby games will award the win after a player quits'))
        v246.push(getContent(PatchNoteType.Update, 'Hide Rematch button from spectators'))
        v246.push(getContent(PatchNoteType.Update, 'Prevent accidental turn skipping by pressing spacebar right after the turn starts'))
        v246.push(getContent(PatchNoteType.Fix, 'Fixed online players displaying a bot avatar during the game'))
        v246.push(getContent(PatchNoteType.Fix, 'Fixed room color selector overlapping with the player name'))

        // Devyesh
        // [Mobile] Update mobile version api with approval build version number
        // [Mobile] Fix the enlarged color image in store popup
        // [Mobile] Fix positioning of the trophy icon in CnK games
        // [Mobile] Fix leaderboard UI
        // [Mobile] Fixing white space in new mobile app and migrating to new ios account

        // Oguz
        // Move Gifting overlay A/B test to store page.
        // Added A/B Test - GIFTING_CHANGE_BEST_VALUE_HINT

        // Muhammad
        // Add colonist marks to press kit
        // Remove colonist marks from press kit
        // Billed monthly -> billed monthly, cancel anytime
        // New homepage ad for tshirt survey

        // Marc
        // Remove AB Test animation of the Invite Friends button on Discord: always animate the button
        // Remove completely Catan Masterpiece Series Ads
        // AB Test Referral Programs

        this.patchNotes.push(getPatchNote(2025, 4, 1, 246, v246))

        const v245: PatchNoteContent[] = []
        v245.push(getContent(PatchNoteType.Fix, '[Mobile] Fix Create Room button getting cut off in some devices', undefined, 'https://i.imgur.com/jtE4vHH.png', 'https://i.imgur.com/DY70YPI.png'))

        // Devyesh
        // [Mobile] Do not show beginner mode button if user has completed 2 games
        // Added /removefeaturevalue command to remove feature values, in case accident added

        // Andrew
        // Replaced the PNG for the Easter ad

        this.patchNotes.push(getPatchNote(2025, 3, 25, 245, v245))

        const v244: PatchNoteContent[] = []
        v244.push(getContent(PatchNoteType.Update, 'Added Easy, Medium, and Hard bot games for web', undefined, undefined, 'https://imgur.com/2sfYVbH'))
        v244.push(getContent(PatchNoteType.Update, 'Room containers take the whole screen on large screens', undefined, 'https://imgur.com/a/DAhKhQS', 'https://imgur.com/a/7UE8Or2'))
        v244.push(getContent(PatchNoteType.Fix, '[Mobile] Hide settings button in replay and game over screen', undefined, 'https://i.imgur.com/KQCzDQ6.png', 'https://i.imgur.com/IhKgY5v.png'))

        // Rob
        // Clear DOM on game load
        // Discord uses same default power and resolution settings as web
        // Discord end game placement text same as web
        // AB Test 1v1 Easy Bots instead of Beginner Mode
        // Remove AB Test PRIVATE_ROOM_BY_DEFAULT

        // Devyesh
        // [Mobile] Ported cloudflare turnstile to mobile
        // [Mobile] Added banner ads support on matchmaking screen
        // [Mobile] Remove landscape vs portrait selection popup
        // [Mobile] Do not show beginner mode button if user has completed 2 games
        // [Mobile] Added push notification popup at high intent locations
        // [Mobile] Show update app popup if user is using an old version of the app

        // Oguz
        // Added creation and removal of multiple tournament room keywords
        // Updated mobile store membership card styles
        // Implemented Mute Punishment Table and replaced all User.mutedUntil usages with it

        // Muhammad
        // Player hover animations in lobby reflect the player's click action
        // Fix no scrolling on mobile

        // Marc
        // Remove prepopup before showing the actual popup to share the activity on Discord
        // Store Discord channel type in the database

        this.patchNotes.push(getPatchNote(2025, 3, 18, 244, v244))

        const v243: PatchNoteContent[] = []
        v243.push(getContent(PatchNoteType.Update, 'Improved notification panel interface on hover', undefined, 'https://imgur.com/B2RLbz1', 'https://imgur.com/cL5THJi'))
        v243.push(getContent(PatchNoteType.Update, '[Discord Activity] Can gift to others at end-game screen, or during a game', undefined, undefined, 'https://imgur.com/Bd7E9kb'))
        v243.push(getContent(PatchNoteType.Update, 'Prevent bots from spamming useless trades'))

        // Devyesh
        // [Mobile] Implements AB test for push notification popup v2

        // Muhammad
        // [Discord] Gift users in game and in endgame
        // [Mobile] Gift users in endgame
        // Complete small discord feature gaps

        // Marc
        // Add a pre-popup before showing the actual popup to share the activity on Discord
        // AB Test to animate the invite friends button inside a room on Discord to draw attention

        this.patchNotes.push(getPatchNote(2025, 3, 11, 243, v243))

        const v242: PatchNoteContent[] = []
        v242.push(getContent(PatchNoteType.Update, '[Discord] Can now gift to others', undefined, undefined, 'https://imgur.com/a/s5RRc2b'))
        v242.push(getContent(PatchNoteType.Update, '[Mobile] Added No Troll mode'))
        v242.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed chat not being visible when game ends'))
        v242.push(getContent(PatchNoteType.Fix, 'Prevent tab blinking in bot games'))

        // Devyesh
        // [Mobile] Merge web and mobile store membership pages
        // [Mobile] Fixing external url bug in mobile app
        // [Mobile] Added no troll mode in mobile

        // Oguz
        // Prevent auto trade rejection countdown in tournament rooms
        // Fixed edge case where easy bot can't place robber

        // Stan
        // Fix muted players being able to send chat messages in games
        // Change auto-mute behavior: Mute after 3 reports in 7 days, shadow mute instead of the default mute behavior.

        // Muhammad
        // Fix patch note winner link and overview page on discord mobile

        // Marc
        // Fix Invite Friends button container still showing when button is hidden
        // Add popup to share the activity on Discord when returning to homepage after game ends

        this.patchNotes.push(getPatchNote(2025, 3, 4, 242, v242))

        const v241: PatchNoteContent[] = []
        v241.push(getContent(PatchNoteType.Update, 'Added keyboard shortcuts to Replay', undefined, undefined, 'https://www.loom.com/share/c1bcf4c2c0ff47c2ac0b297852ae4833?sid=1b625472-c2d9-405e-a411-2c5e9168642e'))
        v241.push(getContent(PatchNoteType.Update, 'Added animations and sounds to Replay'))
        v241.push(getContent(PatchNoteType.Fix, 'Fixed shore tile overlap'))
        v241.push(getContent(PatchNoteType.Fix, 'Fixed tooltip overlapping with replay controllers'))

        // Jeff
        // Replay bug: fixed slider not syncing with button index

        // Devyesh
        // [Mobile] Fixing external url bug in mobile app
        // [Mobile] AB test for landscape/portrait switch popup
        // [Mobile] Fixing console errors during development
        // [Mobile] Added value support for feature flags

        // Oguz
        // Removed A/B Tests YEARLY_STRIKETHROUGH_PRICE & GIFTING_MONTHLY_PRICE_FOR_YEARLY_TIERS
        // Added A/B Test GIFTING_LESS_PERKS

        // Stan
        // Fixed room setting & replay sliders outline after space bar press

        // Muhammad
        // Remove youtube videos and sub button from leaderboard

        this.patchNotes.push(getPatchNote(2025, 2, 25, 241, v241))

        const v240: PatchNoteContent[] = []
        v240.push(getContent(PatchNoteType.Fix, 'Karma penalty is only given after being disconnected for 2 mins'))
        v240.push(getContent(PatchNoteType.Fix, 'Fixed displaying "Your turn" during trades'))
        v240.push(getContent(PatchNoteType.Fix, 'Fix notification panel going offscreen', undefined, 'https://imgur.com/a/iVfpNi3', 'https://imgur.com/a/loj1EmD'))
        v240.push(getContent(PatchNoteType.Fix, 'Fixed last player not being automatically awarded the win when another player disconnected in 1v1 Ranked'))

        // Rob
        // Add beginner mode to web. Hidden PN because it's a test
        // AB test private vs public rooms by default for web and mobile. Collect room usage data
        // Rebranded Online Username as Colonist Username on Discord
        // Membership and gifting tabs on Discord are annual by default
        // Landing page shown to first time Discord users. Otherwise homepage shown

        // Devyesh
        // [Mobile] Show room full message when room is full in invite friends drawer
        // [Mobile] Added push notification support. As an example, user gets push notification when it's their turn to play.
        // [Mobile] Saved room settings for the host
        // [Mobile] Implementation of push notifications on player turn ends
        // [Mobile] Added analytics for invite friends button
        // [Mobile] Added popup to request push notifications

        // Oguz
        // Added apps/game-states-analysis

        // Muhammad
        // General improvements to header styles
        // Lint rule to not use window.location.href and window.open; use navigateToPage instead
        // Fix paypal and xsolla portals not opening on mobile

        // Marc
        // Remove AB Test No Trolls vs. High Karma
        // Update Catan Masterpiece Series Ads
        // Add virality tracking with new table 'user_referral'
        // Add new logic to share activity via a link and track referral with it

        this.patchNotes.push(getPatchNote(2025, 2, 18, 240, v240))

        const v239: PatchNoteContent[] = []
        v239.push(getContent(PatchNoteType.Update, 'Notification panel has a refreshed look', undefined, 'https://imgur.com/aBk94HQ', 'https://imgur.com/8au1xdL'))
        v239.push(getContent(PatchNoteType.Update, 'Merchant Fleet no longer allows you to select a card you already have 2:1 rate'))
        v239.push(getContent(PatchNoteType.Update, '[Mobile] Added invite friends button to room', undefined, 'https://i.imgur.com/Tq7S6Xj.png', 'https://i.imgur.com/7ks5Cc9.png'))
        v239.push(getContent(PatchNoteType.Fix, 'Fix road icons displaying incorrectly', undefined, 'https://imgur.com/a/shuKOeQ', 'https://imgur.com/a/wHnph6X'))
        v239.push(getContent(PatchNoteType.Fix, 'Fixed some C&K actions not providing bonus time'))
        v239.push(getContent(PatchNoteType.Fix, 'Fixed card animations not working in spectator mode'))
        v239.push(getContent(PatchNoteType.Fix, '[Discord Mobile] Fixed some pages not displaying correctly', undefined, 'https://imgur.com/a/LGCvDbN.png', 'https://imgur.com/a/t75jsKU.png'))
        v239.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed dice view position on replay', undefined, 'https://i.imgur.com/TUcfwoE.png', 'https://i.imgur.com/snIhfA9.png'))

        // Jeff
        // Remove development season to make test servers behave like production

        // Devyesh
        // [Mobile] Updated join room mobile notification for room invites
        // [Mobile] Added analytics for invite friends button
        // [Mobile] Fix misclick in mobile gift friend button

        // Oguz
        // Replace store and gifting a/b tests ('GIFTING_NUMBER_OF_PAGES' -> 'GIFTING_MONTHLY_PRICE_FOR_YEARLY_TIERS', 'MEMBERSHIP_PERKS_EXPLANATION' -> 'YEARLY_STRIKETHROUGH_PRICE')
        // Auto-mute players if they are reported for chat abuse and they have sent 2 messages above 0.8 toxicity score

        // Muhammad
        // Minor style improvements on homepage
        // Added youtube videos to leaderboards page https://i.imgur.com/hdYjbGg.jpeg

        this.patchNotes.push(getPatchNote(2025, 2, 11, 239, v239))

        const v238: PatchNoteContent[] = []
        v238.push(getContent(PatchNoteType.Blog, 'Colonist 2024 Summary! <a href="https://blog.colonist.io/colonist-io-2024-summary/" target="_blank">Read here!</a>', undefined, undefined, undefined, ['https://blog.colonist.io/colonist-io-2024-summary/']))
        v238.push(getContent(PatchNoteType.Update, 'Muted players are now announced at the start of the game', undefined, undefined, 'https://i.imgur.com/8gbRJK5.png'))
        v238.push(getContent(PatchNoteType.Update, '[Discord Activity] Replays are now available from profile history page', undefined, undefined, 'https://imgur.com/a/Y42nB31'))
        v238.push(getContent(PatchNoteType.Update, '[Discord Activity] Access player profiles while playing in public games', undefined, undefined, 'https://imgur.com/a/7wYcoyk'))
        v238.push(getContent(PatchNoteType.Update, '[Discord Activity] Colonist social media links are shown in the footer', undefined, 'https://imgur.com/a/qTCh8li', 'https://imgur.com/a/5UelIuy'))
        v238.push(getContent(PatchNoteType.Update, '[Mobile] Added invite friends button to room', undefined, undefined, undefined))
        v238.push(getContent(PatchNoteType.Fix, '[Discord Activity] Friend request notifications are received when you log in'))
        v238.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed Visit Store button on end game screen'))

        // Jeff
        // Remove counter offer for trade creator

        // Rob
        // Fix discord profile replay when you're not a member

        // Devyesh
        // [Mobile] Fix vendor specific css in header

        // Oguz
        // Create PageVisit Analytic Events for entry pages in frontend
        // created command `/generategifturls`. Generates bulk gift URLs for easy distribution

        // Muhammad
        // Remove use of iframecommunication; now uses sendSDKRequest()
        // Refactor listener.register to use map of constructors
        // Fix roads on animated map

        this.patchNotes.push(getPatchNote(2025, 2, 4, 238, v238))

        const v237: PatchNoteContent[] = []
        v237.push(getContent(PatchNoteType.Update, '[Mobile] You can now change your avatar!', undefined, undefined, 'https://i.imgur.com/DgkaEeu.png'))
        v237.push(getContent(PatchNoteType.Update, '[Mobile] Added viewing other player\'s profiles', undefined, undefined, undefined))
        v237.push(getContent(PatchNoteType.Update, 'Bank trade mode is now the default setting for 1v1 matchmaking games', undefined, undefined, 'https://i.imgur.com/YZ4k7zk.png'))
        v237.push(getContent(PatchNoteType.Update, 'Click on chat messages to view player options', undefined, undefined, 'https://imgur.com/a/pJ6Bmev'))
        v237.push(getContent(PatchNoteType.Update, 'Added notification when muting/unmuting users', undefined, undefined, 'https://imgur.com/a/n4f9qQe'))
        v237.push(getContent(PatchNoteType.Update, 'Friend request notifications are received without page refresh'))
        v237.push(getContent(PatchNoteType.Update, '[Discord Activity] Added No Trolls room option', undefined, undefined, 'https://imgur.com/a/zP7wB9T'))
        v237.push(getContent(PatchNoteType.Update, '[Discord Activity] Can add and accept friends on Discord'))
        v237.push(getContent(PatchNoteType.Fix, 'Fixed the last 5-second countdown sound not being played for the turn player', undefined, undefined, undefined))
        v237.push(getContent(PatchNoteType.Fix, 'Fixed bug where top left corner of the game was unresponsive'))
        v237.push(getContent(PatchNoteType.Fix, 'Fixed ghost Metropolis icon appearing during replay'))
        v237.push(getContent(PatchNoteType.Fix, 'Removed Metropolis animation during replay'))
        v237.push(getContent(PatchNoteType.Fix, 'Removed Merchant animation during replay'))

        // Jeff
        // Clean up code owners
        // VSCode mocha explorer now works properly

        // Devyesh
        // [Mobile] Make dice visible over chat and logs

        // Muhammad
        // Fix mp4 videos taking whole screen on ios
        // Fix gift overlay not showing for 50% of people

        // Marc
        // Fix bug empty recipient username works on re-accessing gifting overlay
        // Display login popup on gift overlay when user is not logged in
        // AB testing No Trolls vs. High Karma name

        this.patchNotes.push(getPatchNote(2025, 1, 28, 237, v237))

        const v236: PatchNoteContent[] = []
        v236.push(getContent(PatchNoteType.Update, '[Discord Activity] Added Plus and Elite yearly Memberships'))
        v236.push(getContent(PatchNoteType.Update, '[Discord Activity] Gifting Memberships is now available!'))
        v236.push(getContent(PatchNoteType.Update, '[Discord Activity] Supports all languages web does', undefined, 'https://imgur.com/a/kB4lhvv', 'https://imgur.com/a/u6clWh8'))
        v236.push(getContent(PatchNoteType.Update, '[Discord Activity] Added Karma for public rooms', undefined, 'https://imgur.com/a/lw4esZL', 'https://imgur.com/a/GpJ8cnZ'))
        v236.push(getContent(PatchNoteType.Update, 'Removed info icon from Karma in room', undefined, 'https://imgur.com/a/4ryLWou', 'https://imgur.com/a/vJbAgQ9'))
        v236.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed dice appearing behind chat and game log in portrait mode'))
        v236.push(getContent(PatchNoteType.Fix, 'Fixed incorrect longest road count after using Deserter'))
        v236.push(getContent(PatchNoteType.Fix, 'Fixed flickering tooltips on small screens'))
        v236.push(getContent(PatchNoteType.Fix, 'Fixed ghost city wall appearing during replay'))
        v236.push(getContent(PatchNoteType.Fix, 'Fixed city wall animation during replay'))

        // Jeff
        // Fix "development" card text in CK end game screen
        // Fix initial state not returning to initial state when sliding replay slider

        // Rob
        // Rework notifications to send through lobby server
        // Fix notifications not sending until you refresh the page
        // Add A/B Test - Show Homepage on Discord
        // Allow Gifting and all membership ads on Discord
        // Add A/B Test - Show all social media links on Discord footer

        // Oguz
        // Fixed gift overlay page order on consecutive access through different access points
        // Fixed the next button position on gift tier selection page
        // Trades get auto-rejected when the player moves Colonist to the background

        // Muhammad
        // Add /values, /terms, /press-kit, /refund-policy pages to discord

        this.patchNotes.push(getPatchNote(2025, 1, 21, 236, v236))

        const v235: PatchNoteContent[] = []
        v235.push(getContent(PatchNoteType.Update, 'Timer turns red when you have 5 seconds left', undefined, undefined, 'https://i.imgur.com/Um04x18.png'))
        v235.push(getContent(PatchNoteType.Update, 'Disabled City Wall sound during replay'))
        v235.push(getContent(PatchNoteType.Update, '[Discord Activity] Added profile page', undefined, 'https://imgur.com/a/PwhUQ91', 'https://imgur.com/a/Wpi6Lmp'))
        v235.push(getContent(PatchNoteType.Update, '[Discord Activity] Added Avatars'))
        v235.push(getContent(PatchNoteType.Fix, 'Fixed roads alignment on the map', undefined, 'https://i.imgur.com/pJUstbm.jpeg', 'https://i.imgur.com/8VY2Bk8.png'))
        v235.push(getContent(PatchNoteType.Fix, 'Fixed gaps between tiles on the map', undefined, 'https://i.imgur.com/tLqeD4A.png', 'https://i.imgur.com/3TwjGMa.png'))
        v235.push(getContent(PatchNoteType.Fix, 'Fixed dice appearing twice during replay'))
        v235.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed player profile not opening on the app'))

        // Jeff
        // Fix exploit that allowed players to see the order of the progress cards and dev cards in the bank.
        // Fix exploit that allowed players to see other players dev cards or progress cards.
        // Fix small bug with replay + chat + changing perspectives. 1 line fix

        // Rob
        // Save and use metadata in db when gifting on Discord
        // Coin section available on Discord mobile

        // Devyesh
        // [Mobile] Merging Profile > friends section in web and mobile
        // [Mobile] Force refresh client when new version is available (to break the cache)
        // [Mobile] Fixing singleton page horizontal scroll
        // [Mobile] Fix translation on app reload
        // [Mobile] Fix multiple friend requests being shown for same user
        // [Mobile] Fixing replay url not working

        // Oguz
        // All gift purchases now exist in gift_membership table
        // Fixed item deletion transaction type on gift membership activation
        // Force-enabled Flicker, Shake and Cooldown animations for the players who set animations as disabled in settings
        // Add A/B Test - Merge Maps and Expansions Description in Store Membership Cards
        // Fixed sentry error caused by browser tab blinking

        // Muhammad
        // Rename corner popup to corner notification; classes and classnames/styles
        // Fix discord redirect to web popup not working on profile settings page
        // Added new resources for <a href="/press-kit#content_creation">content creators</a>

        // Marc
        // Add Avatars on Discord

        // Dang
        // Update Return To Map text

        this.patchNotes.push(getPatchNote(2025, 1, 14, 235, v235))

        const v234: PatchNoteContent[] = []
        v234.push(getContent(PatchNoteType.Update, 'Browser tab title now blinks if you are on another tab and you should take action', undefined, undefined, 'https://i.imgur.com/57uq3Cc.png'))
        v234.push(getContent(PatchNoteType.Update, '[Mobile] Updated icons on login page and press kit page'))
        v234.push(getContent(PatchNoteType.Fix, 'Fixed dice not being displayed when on another tab'))
        v234.push(getContent(PatchNoteType.Fix, '[Mobile] Removed underlines on links in mobile sidebar'))

        // Jeff
        // Adjusted report system a bit. Added new "king making" options, randomized report order in popup, forced user to make selection
        // Changes to chat system. No chat filtering in private msgs. Filtered chat msgs are shadow sent back to the player.

        // Rob
        // Public Discord games visible for spectating
        // Add chat for all Discord games (not public pn because Discord in theory disapproves)

        // Devyesh
        // [Mobile] Merging Profile > friends section in web and mobile
        // [Mobile] Force refresh client when new version is available (to break the cache)

        // Muhammad
        // Wrap leaderboard page in main container to normalize styles
        // Remove underlines on some buttons that had them
        // Adjust times for recruitment process

        // Marc
        // Add new gifting banner
        // Fix bug on Holiday date logic
        // Holiday date logic refactor
        // Remove two Catan Masterpiece Series ads
        // New gifting banner in lobby

        this.patchNotes.push(getPatchNote(2025, 1, 7, 234, v234))

        const v233: PatchNoteContent[] = []
        v233.push(getContent(PatchNoteType.Update, 'Bank trade mode is now default in 1v1 games', undefined, undefined, undefined))
        v233.push(getContent(PatchNoteType.Fix, 'Fixed inverted trade status for counter offers for spectators'))
        v233.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed FPS counter showing when exiting corner mode'))
        v233.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed horizontal scroll appearing on some devices'))

        // Jeff
        // Final lowering of dice timers to target values

        // Devyesh
        // [Mobile] Fixing careers page deeplink
        // [Mobile] Fixed horizontal scroll on room page, player container
        // [Mobile] Removed unused button styles and extended web styles to mobile
        // [Mobile] Merging Profile > friends section in web and mobile
        // [Mobile] Force refresh client when new version is available (to break the cache)

        // Oguz
        // Disabled auto trade rejections in beginner mode
        // Create AB Test - Remove Details Page From Gifting Process
        // Fixed user icon scrolling issue on mobile gifting flow - recipient selection page

        // Marc
        // Implement feedbacks on gifting recipient selection UI
        // Update docs to include Stylelint as a must have extension for VSCode

        this.patchNotes.push(getPatchNote(2025, 1, 1, 233, v233))

        const v232: PatchNoteContent[] = []
        v232.push(getContent(PatchNoteType.Update, 'Trade offers are now automatically rejected after a cooldown period', undefined, undefined, undefined))
        v232.push(getContent(PatchNoteType.Update, '[Mobile] Colonist mobile app is now available in 30+ different languages!'))
        v232.push(getContent(PatchNoteType.Update, '[Mobile] Fixed the game mode layout for tablets', undefined, 'https://i.imgur.com/fkfEoED.png', 'https://i.imgur.com/MhrZ8TQ.png'))
        v232.push(getContent(PatchNoteType.Fix, 'Fixed ingame dropdowns on small screens', undefined, 'https://imgur.com/a/rItaMjI', 'https://imgur.com/a/Hgw4GcB'))
        v232.push(getContent(PatchNoteType.Fix, 'Fixed profile page responsiveness', undefined, 'https://imgur.com/a/0xjGjzI', 'https://imgur.com/a/sl9fN01'))
        v232.push(getContent(PatchNoteType.Fix, 'Fixed store page responsiveness', undefined, 'https://imgur.com/a/4m10pRb', 'https://imgur.com/a/noAHYHs'))
        v232.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed the order of the Speed setting bar inside a room', undefined, 'https://i.imgur.com/wlqQmC5.png', 'https://i.imgur.com/KPx5AVF.png'))
        v232.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed Special Build Phase button being in the wrong position on reconnect', undefined, 'https://imgur.com/em7Giic', 'https://imgur.com/1aYcSyx'))
        v232.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed error when clicking Visit Store from Membership popup'))

        // Devyesh
        // [Mobile] Navigate to store page when clicking on username change popup opens inside the app
        // [Mobile] Fixing careers page deeplink
        // [Mobile] Fixed horizontal scroll on room page, player container
        // [Mobile] We remove toggle from mobile profile page
        // [Mobile] Fixed gift icon on mobile
        // [Mobile] Fixing UI issues with long messages in notifications
        // v232.push(getContent(PatchNoteType.Update, '[Mobile] Colonist Mobile is now available 31 different languages!'))
        // [Mobile] Fixed game speed and bot speed not being ordered correctly
        // [Mobile] Fixed special build phase button always showing up when page is loaded
        // [Mobile] Fixed the build failing

        // Oguz
        // Improvements in gifting flow - tier selection page
        // Fix next button behavior on recipient selection page
        // Fix redirecting to checkout page after cancelling gift payment on stripe
        // Fixed the trade offers quickly disappearing when animations are disabled (hotfix)

        // Marc
        // Add new ad banners to promote gifting
        // Prevent users from gifting themselves in room
        // AB Test on No Trolls option in-game
        // New UI to select recipient for gift

        this.patchNotes.push(getPatchNote(2024, 12, 24, 232, v232))

        const v231: PatchNoteContent[] = []
        v231.push(getContent(PatchNoteType.Update, '[Discord Activity] Lobby now available on Discord!'))
        v231.push(getContent(PatchNoteType.Update, '[Discord Activity] Replay now available on Discord!'))
        v231.push(getContent(PatchNoteType.Update, '[Discord Activity] All monthly Membership tiers are now available!'))
        v231.push(getContent(PatchNoteType.Update, '[Discord Activity] Added Patch Notes page'))
        v231.push(getContent(PatchNoteType.Update, '[Discord Activity] Added search bar on leaderboards'))
        v231.push(getContent(PatchNoteType.Fix, 'Fixed map circles not resetting properly when running out of time at end of turn'))
        v231.push(getContent(PatchNoteType.Fix, 'Fixed changing username while in room'))
        v231.push(getContent(PatchNoteType.Fix, 'Fixed \'User is connected\' notification showing to the host on room creation'))
        v231.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed issues when joining a room via notification'))

        // Jeff
        // Refactoring reconnect code so that it can work on all pages
        // Fix rounding error in auto-mute system that would cause an extra day to be added to the range
        // Removed ~1s from dice timers on Very Fast, Fast and Normal

        // Devyesh
        // [Mobile] Removing duplicate notification on socket reconnect
        // [Mobile] Fixing store link in notifications
        // [Mobile] Fixing remove the hit area of of notification item on mobile
        // [Mobile] Fixing background and removing transparency
        // [Mobile] Prevent refresh on notification click

        // Muhammad
        // Fix membership cards in mobile store

        // Marc
        // Prevent users from gifting themselves in room
        // Add Catan Masterpiece Series Ads

        // Efe
        // Refactored border radii system
        // Systemized buttons' heights

        this.patchNotes.push(getPatchNote(2024, 12, 17, 231, v231))

        const v230: PatchNoteContent[] = []
        v230.push(getContent(PatchNoteType.Update, 'New Gifter avatar', undefined, undefined, 'https://i.imgur.com/9PlPyQv.png'))
        v230.push(getContent(PatchNoteType.Update, 'Reduced time to roll dice when no dev cards in hand'))
        v230.push(getContent(PatchNoteType.Update, 'You may now <a href="/store#gift">gift Memberships</a> through the mobile app', undefined, undefined, 'https://imgur.com/KHX8msL'))
        v230.push(getContent(PatchNoteType.Fix, 'Fixed endgame share image on Safari', undefined, 'https://imgur.com/a/15vjYu0', 'https://imgur.com/a/byngwR4'))
        v230.push(getContent(PatchNoteType.Fix, 'Fixed broken leaderboards on small screens', undefined, 'https://imgur.com/a/Osg7cWZ', 'https://imgur.com/a/uRhyxC1'))

        // Jeff
        // reports from profile page are no longer counted towards any of our automated systems (notification, auto-mute or Mayla bans)
        // Auto-mute durations now increase more aggresively
        // consolidate client `isTakingAction` code to simplify client and create a source of truth
        // players that haven't replied to a trade are considered as players still taking action
        // Fixing bug in how `ActionStates.None` was being handled in replay data

        // Rob
        // Only use Discord profile pics and usernames in private Discord rooms with people in your activity instance
        // Add "hard" bots option for single player on Discord (not real pn so that people don't confuse with adding a new bot level)
        // Make bots easy by default on Discord
        // Remove duplicate styles on Discord
        // Fix Discord assets loading

        // Devyesh
        // [Mobile] Ported notification in mobile
        // [Mobile] Minor redesign of profile page
        // [Mobile] App icon updated
        // [Mobile] Remove duplicate notification on socket reconnect

        // Oguz
        // Fix redundant `Dice Already Rolled` error
        // Add data trackers to understand how many steps users complete during the gifting process
        // Remove gift membership disclaimer text A/B Test

        // Add A/B test for default tab on gift membership monthly/yearly toggle
        // Added on-hover tooltip for gift membership button in room player view

        // Muhammad
        // Change ashby link to open 'any location' roles
        // v229.push(getContent(PatchNoteType.Fix, 'Fix endgame share image on Safari', undefined, 'https://imgur.com/a/15vjYu0', 'https://imgur.com/a/byngwR4'))
        // Fix gifting overlay state resetting/management

        // Marc
        // Remove gifter field on the 3rd step of the gifting overlay
        // refactor holidays logic

        this.patchNotes.push(getPatchNote(2024, 12, 10, 230, v230))

        const v229: PatchNoteContent[] = []
        v229.push(getContent(PatchNoteType.Fix, 'Removed duplicate volume notifications', undefined, 'https://imgur.com/a/ZHZykk9', 'https://imgur.com/a/xL80CZL'))
        v229.push(getContent(PatchNoteType.Fix, 'Fixed profile buttons only being clickable over the text'))

        // Jeff
        // Fixing bug in how `ActionStates.None` was being handled in replay data

        // Rob
        // Add "hard" bots option for single player on Discord (not real pn so that people don't confuse with adding a new bot level)
        // Make bots easy by default on Discord

        // Oguz
        // Implemented gift membership disclaimer text A/B Test

        // Muhammad
        // Darken lobby action icons on hover

        this.patchNotes.push(getPatchNote(2024, 12, 3, 229, v229))

        const v228: PatchNoteContent[] = []
        v228.push(getContent(PatchNoteType.Feature, '[Web] You may now <a href="/store#gift">gift Memberships</a>!', undefined, undefined, 'https://imgur.com/a/gwDFwty'))
        v228.push(getContent(PatchNoteType.Update, 'Updated icons for expansions', undefined, 'https://i.imgur.com/RZaAKMm.png', 'https://i.imgur.com/1kSyHkN.png'))
        v228.push(getContent(PatchNoteType.Update, 'Change volume popup gets updated faster'))
        v228.push(getContent(PatchNoteType.Update, 'Simplified color blue palette for a cleaner interface', undefined, 'https://i.imgur.com/QvXIM4s.png', 'https://i.imgur.com/OZolITQ.png'))
        v228.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed returning to map loading slowly'))
        v228.push(getContent(PatchNoteType.Fix, '[Mobile] Matchmaking is canceled when internet connection is lost'))
        v228.push(getContent(PatchNoteType.Fix, '[Discord Mobile] Fixed non-English languages not working'))

        // Jeff
        // Fix broken state msg when multiple players selecting gold tile
        // Game state information box

        // Devyesh
        // [Mobile] Merging Overview page of mobile and web
        // [Mobile] Merge profile history with web and mobile
        // [Mobile] Merged profile > items in mobile and web
        // [Mobile] Updated the background on mobile

        // Oguz
        // Added holiday lobby banners

        // Stan
        // vxxx.push(getContent(PatchNoteType.Update, 'Create shareable replay links from mobile', undefined, undefined, 'https://imgur.com/a/PDf9gAb'))
        // Added new game mode icons

        // Muhammad
        // Fix padding on difficulty selector in lobby
        // Hide arrow on difficulty selector in lobby when disabled
        // Add gift buttons throughout web app

        this.patchNotes.push(getPatchNote(2024, 11, 27, 228, v228))

        const v227: PatchNoteContent[] = []
        v227.push(getContent(PatchNoteType.Fix, 'Fixed corner notifications when adding/removing friends'))
        v227.push(getContent(PatchNoteType.Fix, 'Fixed open ended trades not getting auto declined when you have no resources to offer'))
        v227.push(getContent(PatchNoteType.Fix, 'Fixed commodity cards tooltips not showing correctly in bank'))
        v227.push(getContent(PatchNoteType.Fix, 'Fixed FAQ page sidebar not scrolling down on click'))
        v227.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed numbers in building buttons getting smaller when resizing the window'))
        v227.push(getContent(PatchNoteType.Youtube, 'Watch our latest <a href="https://youtu.be/4pWElobPBDg" target="_blank">Colonist Updates video</a>, you can win a free Membership!'))

        // Jeff
        // patch perspective API error handling
        // only remove leaderboard scores for players not are permanently banned (not soft-banned)

        // Devyesh
        // [Mobile] Merging Ranked Profile page with Web Profile page
        // [Mobile] Merge profile history with web and mobile
        // [Mobile] Merged profile > items in mobile and web

        // Oguz
        // Track store gift button clicks

        // Muhammad
        // Remove duplicate ids for component dropdowns

        this.patchNotes.push(getPatchNote(2024, 11, 19, 227, v227))

        const v226: PatchNoteContent[] = []
        v226.push(getContent(PatchNoteType.Update, 'Improved chat toxicity filtering'))
        v226.push(getContent(PatchNoteType.Update, 'Perfected Portuguese translation'))
        v226.push(getContent(PatchNoteType.Update, '[Discord Activity] Added notification panel'))
        v226.push(getContent(PatchNoteType.Update, '[Discord Activity] Now available in Portuguese'))
        v226.push(getContent(PatchNoteType.Fix, 'Fixed players not winning automatically in 1v1 if the other player quit'))
        v226.push(getContent(PatchNoteType.Fix, 'Fixed +VP count not being displayed correctly when upgrading a settlement on foreign land in Seafarers'))
        v226.push(getContent(PatchNoteType.Fix, 'Fixed trades not auto-rejecting when using Any Resource card on trades'))

        // Rob
        // Add on load listener for ClientUserState
        // Only check for Discord purchases after user state loaded
        // Discord child only listens once for parent to be ready
        // Fix scss warning

        // Devyesh
        // Sprite sheets are converted to webp. Saves 70% of the file size

        // Oguz
        // Enabled multiple quantity purchase for one-time purchases on Stripe
        // Refactored store membership buttons
        // Added gift membership button to store membership product views
        // Implemented recipient selection and gift details pages for gift membership
        // Implemented sender and recipient notifications for gift membership
        // Implemented gift code redeem process for gift membership

        // Stan
        // Homepage added membership icon

        // Muhammad
        // Gift membership optional receiver id; fix db to allow null
        // Add team photos to careers page
        // New popup designs
        // Add scroll-to from href on discord
        // Fix overlapping help buttons on web mobile

        // Marc
        // Redirect to home page when clicking on logo at the end of a game
        // Add gifting avatar
        // Automate robber skin selection
        // New Gifting FAQ section

        this.patchNotes.push(getPatchNote(2024, 11, 12, 226, v226))

        const v225: PatchNoteContent[] = []
        v225.push(getContent(PatchNoteType.Update, '[Discord Activity] Updated footer and rulebook layout', undefined, 'https://imgur.com/a/7KowhAw', 'https://imgur.com/a/ab2dCIY'))
        v225.push(getContent(PatchNoteType.Update, 'Redirect to home page when clicking Colonist logo on the end game screen'))
        v225.push(getContent(PatchNoteType.Fix, 'Fixed some tooltips on lobby screen being cutoff', undefined, 'https://imgur.com/a/yHjg0Df', 'https://imgur.com/a/HknFsl2'))
        v225.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed overflowing usernames in corner notification', undefined, 'https://imgur.com/a/yS1gFmh', 'https://imgur.com/a/7HDzbje'))
        v225.push(getContent(PatchNoteType.Fix, '[Mobile] Fixing error popup links for mobile'))
        v225.push(getContent(PatchNoteType.Youtube, 'Don\'t miss Colonist Con 2024! <a href="https://www.youtube.com/@colonistio/?sub_confirmation=1" target="_blank">Subscribe to our Youtube channel</a>'))

        // Jeff
        // Adding more logging to game action system to find edge cases in AFK system

        // Devyesh
        // [Mobile] Fixing new room ids created in mobile to be case insensitive

        // Muhammad
        // Link to the new recruiter website on careers page

        // Marc
        // When player can select who to rob from, it displays the pirate ship instead of the robber when it is on a sea tile

        this.patchNotes.push(getPatchNote(2024, 11, 5, 225, v225))

        const v224: PatchNoteContent[] = []
        v224.push(getContent(PatchNoteType.Update, 'AFK kick timer will now kick players sooner'))
        v224.push(getContent(PatchNoteType.Update, '4P and 1v1 Ranked queues are now 25% faster', undefined, undefined, undefined))
        v224.push(getContent(PatchNoteType.Update, 'Made landing page board animation smoother'))
        v224.push(getContent(PatchNoteType.Update, '[Mobile] Added Hard, Medium and Easy bot modes'))
        v224.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed dice position when chat and logs are open'))

        // Jeff
        // Prevent clicking dice from resetting timer
        // Bot game timers are now the same as human game timers

        // Rob
        // If Discord avatar fails to load, use default avatar

        // Devyesh
        // [Mobile] Fixing black screen on orientation change
        // [Mobile] Fixing rulebook page breaking
        // [Mobile] Fix rulebook links
        // [Discord] Preventing matchmaking ads for discord users
        // [Mobile] Make room ids case insensitive
        // [Mobile] Added Hard, Medium and Easy bot modes
        // [Mobile] Populated coins and membership IAP SKU ids to Colonist Products
        // [Mobile] Remove sentry errors for deactivated keepAwake
        // [Mobile] Fix homepage url for mobile app
        // [Mobile] Updating the check if user is on tablet app
        // [Mobile] Fixes master issues of bugs related to mobile
        // Merged Profile Sidebar in mobile and web

        // Oguz
        // Reverted previous change that adjusted balanced dice fairness in friendly robber activated games
        // v224.push(getContent(PatchNoteType.Update, '4P and 1v1 ranked matchmaking are now 25% faster!', undefined, undefined, undefined))

        // Muhammad
        // Create gift membership backend db + service
        // Create gift membership api
        // Careers page minor ui fixes
        // More careers page fixes/cleanup

        // Marc
        // Fix bug resources not updating while hovering
        // Fix matchmaking error popup language
        // Fix matchmaking search popup closing when connection breaks

        this.patchNotes.push(getPatchNote(2024, 10, 29, 224, v224))

        const v223: PatchNoteContent[] = []
        v223.push(getContent(PatchNoteType.Update, 'Replay now available on Mobile!', undefined, undefined, 'https://imgur.com/a/Ky9nKfr'))
        v223.push(getContent(PatchNoteType.Update, 'Revamped the <a href="/careers" target="_blank">Careers page</a>. Check it out!'))
        v223.push(getContent(PatchNoteType.Fix, 'Fixed endgame share button text overlapping icon in some languages', undefined, undefined))

        // Devyesh
        // [Mobile] Fix rulebook links
        // [Discord] Preventing matchmaking ads for discord users
        // [Mobile] Fixing auto-rotate for mobile
        // [Mobile] Remove sentry errors for deactivated keepAwake

        // Muhammad
        // Add log for when server fails to create a new discord user

        this.patchNotes.push(getPatchNote(2024, 10, 22, 223, v223))

        const v222: PatchNoteContent[] = []
        v222.push(getContent(PatchNoteType.Fix, 'Fixed some players not getting kicked for going AFK'))
        v222.push(getContent(PatchNoteType.Fix, 'Fixed Replay game logs not being preserved properly when changing perspectives'))
        v222.push(getContent(PatchNoteType.Fix, 'Fixed missing player reconnect game log and sound'))
        v222.push(getContent(PatchNoteType.Fix, 'Fixed cancel trade button shifting off screen'))
        v222.push(getContent(PatchNoteType.Fix, 'Fixed username in profile page missing Membership icons', undefined, undefined, 'https://i.imgur.com/4NlPfev.png'))
        v222.push(getContent(PatchNoteType.Fix, 'Fixed Any Resource card getting removed from trade box on screen resize'))
        v222.push(getContent(PatchNoteType.Fix, 'Fixed top navigation bar gap on small screens', undefined, 'https://imgur.com/a/AMvVNHX', 'https://imgur.com/a/aDsElm9'))
        v222.push(getContent(PatchNoteType.Fix, 'Fixed displaying wrong player avatar on the trade box after screen resize', undefined, 'https://imgur.com/a/ERFZG8d', 'https://imgur.com/a/8GobTjT'))
        v222.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed end game buttons not redirecting to game'))

        // Jeff
        // Fix accessing replay perspectives in /#event rooms on end game scree (tournament rooms)
        // Allow admins, manager and moderators to access any replay information to help debug and ban players
        // fix WebGL popup not being displayed to players loading the site
        // add map pip count statistics

        // Rob
        // Replace isUserOnDiscordMobile ejs var
        // Rework parent iframe loader to use discord url params
        // Fix Discord mobile rulebook

        // Devyesh
        // [Mobile] Added ios banner for app store
        // [Mobile] In tablet app we fix the menu orientation to landscape

        // Oguz
        // v222.push(getContent(PatchNoteType.Fix, 'Fixed profile pages missing membership icons', undefined, undefined, https://i.imgur.com/4NlPfev.png))

        // Stan
        // [Mobile] Fixed landscape resize for landscape game

        // Muhammad
        // Make feedback form more responsive, mostly on discord mobile
        // Set better error popup for discord subscription error
        // Remove adcontroller initialization for discord

        this.patchNotes.push(getPatchNote(2024, 10, 15, 222, v222))

        const v221: PatchNoteContent[] = []
        v221.push(getContent(PatchNoteType.Update, '[Mobile] Added color selector for players in room', undefined, undefined, 'https://i.imgur.com/SKi9w4a.png'))
        v221.push(getContent(PatchNoteType.Fix, '[Discord] Performance improvements'))
        v221.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed game assets not updating when spectating a rematch'))

        // Jeff
        // automatically forward users inputting random 4 character url to room
        // Send spectator data to reconnecting players

        // Rob
        // Add "Keep playing on web" popup for Russian users
        // Not logged out after coin or item purchase
        // [Discord] success popup for initial membership purchase (not renewal)
        // Fix Discord memberships after subscription update
        // Removed mobile portrait check for showing "End Turn" tooltip

        // Devyesh
        // [Mobile] Fix deeplinks on android and ios
        // [Mobile] Fix toggle on leaderboard page
        // [Mobile] Fix cancel_url for stripe checkout on mobile

        this.patchNotes.push(getPatchNote(2024, 10, 8, 221, v221))

        const v220: PatchNoteContent[] = []
        v220.push(getContent(PatchNoteType.Fix, 'Fixed Replay not displaying the correct game settings'))
        v220.push(getContent(PatchNoteType.Fix, 'Fixed information button content preventing clicking on the background', undefined, undefined, undefined))
        v220.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed Membership not getting updated unless you reloaded the page'))
        v220.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed game assets when spectating a rematch'))
        v220.push(getContent(PatchNoteType.Fix, '[Discord Mobile] Fixed "End Turn" tip getting stuck after ending turn'))
        v220.push(getContent(PatchNoteType.Fix, '[Discord Mobile] Fixed build costs not showing on tap'))
        v220.push(getContent(PatchNoteType.Fix, '[Discord Mobile] Fixed tiny build costs on small screens', undefined, 'https://imgur.com/a/okc5lVD', 'https://imgur.com/a/uaeDc3j'))

        // Jeff
        // Send spectator data to reconnecting players

        // Rob
        // Add "Keep playing on web" popup for Russian users

        // Oguz
        // Add data tracking for possible RNG complaint reasons
        // Update tournament room default settings
        // Create player_game_turn_statistics table to track number of actions and amount of time taken per turn

        // Muhammad
        // [Mobile/Discord Mobile] Show additional C&K info on player section arrow tap

        this.patchNotes.push(getPatchNote(2024, 10, 1, 220, v220))

        const v219: PatchNoteContent[] = []
        v219.push(getContent(PatchNoteType.Update, 'Replay now supports Cities & Knights expansion!'))
        v219.push(getContent(PatchNoteType.Fix, 'Fixed cards overflowing outside of card container', undefined, 'https://i.imgur.com/G5vPLJM.png', 'https://i.imgur.com/RNjqEtb.png'))
        v219.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed leaderboard page buttons not working properly'))

        // Jeff
        // Fix whitespaces in command usage
        // adding new tsc rule `exactOptionalPropertyTypes` to make working with replay more pleasant

        // Devyesh
        // Removed MobileAnalytics events
        // Removed isUserOnMobileApp function usage in routes and ejs variables
        // Fixing auth redirect after login

        // Oguz
        // Removed Feedback button from homepage
        // Removed overly-frequent feedback form from the beginner mode
        // Decrease ranked matchmaking wait time constant `targetWaitTimeInSeconds`
        // Group users as `DEFAULT` for inactive AB tests
        // Remove buggy command /toggleabtest

        // Muhammad
        // v219.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed new user signup when switching accounts'))
        // Remove unecessary color check when selecting color

        this.patchNotes.push(getPatchNote(2024, 9, 24, 219, v219))

        const v218: PatchNoteContent[] = []
        v218.push(getContent(PatchNoteType.Update, 'Updated profile history page', undefined, 'https://imgur.com/a/cDWUyEe', 'https://imgur.com/8Rpy6Nw'))
        v218.push(getContent(PatchNoteType.Fix, '[C&K] Fixed knights counter not updating correctly after refresh'))
        v218.push(getContent(PatchNoteType.Fix, '[C&K] Fixed knight buttons not highlighting properly'))

        // Rob
        // Memberships and transactions accept null membership end date
        // Remove FPS tracker for Sentry

        // Devyesh
        // [Mobile] Fixing UI in create room flow for some devices
        // [Mobile] Fix leaderboard UI
        // [Mobile] Fix gifted memberships UI

        // Oguz
        // Fix broken beginner mode initialization
        // Remove A/B Test - Alternative level to the beginner mode
        // Refactor BeginnerHints initialization
        // Remove OptionalGameMechanicEnum
        // Remove FeatureUpvote related code
        // Enhanced seven-roll balance in 1v1 Ranked games

        // Muhammad
        // Fix leaderboard spacing below sticky row
        // Remove reamining refs to premium rooms

        this.patchNotes.push(getPatchNote(2024, 9, 17, 218, v218))

        const v217: PatchNoteContent[] = []
        v217.push(getContent(PatchNoteType.Fix, 'Fixed page footer not being visible on small screen sizes', undefined, 'https://imgur.com/a/Tm92I1u', 'https://imgur.com/a/hKE8z8v'))
        v217.push(getContent(PatchNoteType.Fix, 'Fixed rulebook visibility on small screen sizes', undefined, 'https://imgur.com/a/Pldms6P', 'https://imgur.com/a/U4FxZ9N'))
        v217.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed player icon not always having circular border', undefined, 'https://imgur.com/a/xzq3NKd', 'https://imgur.com/a/ptVBo83'))
        v217.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed not being able to join a new room after being kicked'))
        v217.push(getContent(PatchNoteType.Youtube, '<a href="https://www.youtube.com/watch?v=-DzUha5twvg" target="_blank">I Hired a Catan Coach to Make Me Pro</a>'))

        // Rob
        // Remove FPS tracker for Sentry
        // Fix Beginner Mode Sentry errors
        // Fix flicker cards error
        // Fix suppression of Sentry audio device error
        // v217.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed purchases for legacy users')) // TODO Juan decide if you want to include this in patch notes
        // [Discord Activity] Fixed purchases for legacy users
        // Fix Join Discord server button
        // Add 'applications.commands' to Discord OAuth2 scope

        // Devyesh
        // [Mobile] Remove notification feature from mobile
        // Fix sentry error - https://katan.sentry.io/issues/5667239736/?alert_rule_id=14743554&alert_type=issue&notification_uuid=89bc5b75-c8cf-423e-a4c1-37a71961fc19&project=6266971
        // [Mobile] Fixes hover animation on button

        // Oguz
        // Enable modes & maps for TournamentRoom
        // Refactored CityImprovements mechanic
        // Implement feedback of TournamentRoom structure

        // Muhammad
        // Remove unused feature flags DiscordOnlinePlayEnabled, DiscordMatchmakingChatEnabled, DiscordPremiumRoomsEnabled
        // v217.push(getContent(PatchNoteType.Fix, 'Fixed rulebook visibility on small screen sizes', undefined, 'https://imgur.com/a/Pldms6P', 'https://imgur.com/a/U4FxZ9N'))
        // Remove unused feature flags DiscordOnlinePlayEnabled, DiscordMatchmakingChatEnabled, ShouldSaveDiscordData
        // Remove DiscordPremiumRoomsEnabled flag
        // Remove unused feature flags DiscordOnlinePlayEnabled, Disco
        // Remove leaderboard tab horizontal scroll

        this.patchNotes.push(getPatchNote(2024, 9, 10, 217, v217))

        const v216: PatchNoteContent[] = []
        v216.push(getContent(PatchNoteType.Update, 'Perfected Polish translation'))
        v216.push(getContent(PatchNoteType.Update, '[Discord Activity] Now available in Polish!'))
        v216.push(getContent(PatchNoteType.Fix, 'Fixed broken assets in C&K rulebook section', undefined, 'https://imgur.com/a/W8S470n', 'https://imgur.com/a/gHxDjq1'))
        v216.push(getContent(PatchNoteType.Fix, 'Fixed bug preventing bots from replying to certain trade offers'))
        v216.push(getContent(PatchNoteType.Fix, 'Removed corner notification for friend requests'))
        v216.push(getContent(PatchNoteType.Fix, '[Mobile] Automatic rejoining to a game without clicking the reconnect button'))
        v216.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed tablet orientation bug'))

        // Jeff
        // Fix being able to accept trades when it should have been showing errors

        // Devyesh
        // [Mobile] Fixing auto reconnection in the game
        // [Mobile] Stops dice animation on every state update
        // Added stylint rule to include only kebab case in scss
        // [Mobile] Remove notification feature from mobile
        // [Mobile] Toggle all player information views together in portrait mode

        // Oguz
        // Implement feedback of TournamentRoom structure

        // Muhammad
        // Auto mute users who get chat reported by 5 unique users in a single week; mute time varies based on number of mutes in the past

        this.patchNotes.push(getPatchNote(2024, 9, 3, 216, v216))

        const v215: PatchNoteContent[] = []
        v215.push(getContent(PatchNoteType.Feature, 'Added notification panel', undefined, undefined, 'https://i.imgur.com/6b26A3c.png'))
        v215.push(getContent(PatchNoteType.Update, 'Replay now supports 5-6 Player and Seafarers expansions!'))
        v215.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed Ranked Games for Mobile Activity'))
        v215.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed profile username vertical alignment', undefined, 'https://i.imgur.com/j1Hr9WD.png', 'https://i.imgur.com/Xr5Bbmy.png'))
        v215.push(getContent(PatchNoteType.Youtube, '<a href="https://www.youtube.com/watch?v=Y93SYAiDLKQ" target="_blank">Ranking EVERY Colonist Expansion</a>'))

        // Rob
        // Remove versioning for external image urls
        // Fix corner popup close logic
        // Fix slider onInput error
        // Add back Discord landing page Subscribe popup
        // Rename 'isDiscordIntegrationServer' to 'isUserOnDiscord'

        // Devyesh
        // fixes duplicate dices
        // [Mobile] Made stencil workable in game menu
        // Handling room connection when socket connection drops

        // Oguz
        // Remove A/B Test - Discount for veterans

        // Kyle
        // web room friends list doesn't offline on page change or refresh
        // web room friends list shows for guests and says login to add friends

        this.patchNotes.push(getPatchNote(2024, 8, 27, 215, v215))

        const v214: PatchNoteContent[] = []
        v214.push(getContent(PatchNoteType.Feature, 'Discord Activity is now available on mobile devices!'))
        v214.push(getContent(PatchNoteType.Update, 'Added chat history to Replay'))
        v214.push(getContent(PatchNoteType.Update, 'Added hover state to info icons and profile arrow', undefined, 'https://imgur.com/DRmvpO4', 'https://imgur.com/nkd0Z16'))
        v214.push(getContent(PatchNoteType.Update, 'Profile dropdown opens on hover', undefined, 'https://imgur.com/kicGCRR', 'https://imgur.com/UGcwYRk'))
        v214.push(getContent(PatchNoteType.Fix, '[Discord Activity] Remove broken links from rulebook'))
        v214.push(getContent(PatchNoteType.Youtube, '<a href="https://www.youtube.com/watch?v=1ZbPdjTd8dI" target="_blank">The Player Who Broke Catan</a>'))

        // Rob
        // [Discord] Update proxy paths for new CSP
        // Refactor image, sound, locale, sprite path getters
        // Remove 'Join Our Discord' popup and references

        // Kyle
        // Fixed pages showing room popups when they shouldn't

        // Muhammad
        // Add gap between prompt and select in report popup
        // Set the coin button in navbar to direct to /store if the user is not currently on the store page

        // Tyler
        // After bot is added then removed in lobby newly joined player's karma is no longer hidden

        this.patchNotes.push(getPatchNote(2024, 8, 20, 214, v214))

        const v213: PatchNoteContent[] = []
        v213.push(getContent(PatchNoteType.Feature, 'Ranked Season 10 has started!'))
        v213.push(getContent(PatchNoteType.Update, 'Add hover state to placement spots', undefined, 'https://imgur.com/a/WtSH86Q', 'https://imgur.com/vSpuVTm'))
        v213.push(getContent(PatchNoteType.Update, 'Close dev card game log popup on click'))
        v213.push(getContent(PatchNoteType.Update, '[Discord Activity] Now available in French!'))

        // Rob
        // Discord - upgrade to public SDK
        // Reverse toast timer direction
        // Refactor Discord manage subscription popups
        // [Discord Mobile] Increase disconnect game shutdown to 2 minutes
        // New Discord activity description on August 12 2024: "Settlers of Catan alternative. Strategy game featuring elements of building, trading, expanding, and negotiating. Colonist.io combines simple rules with deep gameplay."
        // Fix WebGL Context Loss popup text for Discord vs web

        // Oguz
        // Beginner mode - Added road race level 2

        // Muhammad
        // Give random memberships to users created in localhost using /populatefakeleaderboarddata
        // Update prompt for when deleting an account
        // Correctly display available ranked games modes on home page
        // Add new patchnote type for youtube
        // Fix: remove hover hint for hidden placement circles

        this.patchNotes.push(getPatchNote(2024, 8, 13, 213, v213))

        const v212: PatchNoteContent[] = []
        v212.push(getContent(PatchNoteType.Update, '[Replay] Share & save Replay links from your profile game history'))
        v212.push(getContent(PatchNoteType.Update, '[Replay] Important game events are shown in the progress bar', undefined, undefined, 'https://i.imgur.com/xjDzDmL.png'))
        v212.push(getContent(PatchNoteType.Fix, 'Fixed game logs showing private cards information'))
        v212.push(getContent(PatchNoteType.Fix, 'Fixed spectators being able to click on trade & embargo buttons'))

        // Rob
        // Reverse toast timer direction
        // [Discord Activity] Annual Memberships now available

        // Devyesh
        // [Mobile] Increase bot game timeout and handle cases when game reconnects after the game ends

        // Muhammad
        // Fix ranked ad leading to deleted user
        // Make floating errors in game more legible
        // Disable mute button for spectators
        // Update error text for when a bank resource (city, road etc) can't be bought by user
        // Add hover effect to C&K Ranked membership button

        this.patchNotes.push(getPatchNote(2024, 8, 6, 212, v212))

        const v211: PatchNoteContent[] = []
        v211.push(getContent(PatchNoteType.Update, '[Discord Activity] Removed duplicate "Invite Friends" button', undefined, 'https://imgur.com/HoeXFe5', 'https://imgur.com/IyPr2Ze'))
        v211.push(getContent(PatchNoteType.Fix, 'Removed duplicate steal messages in 1v1'))
        v211.push(getContent(PatchNoteType.Fix, 'Removed Ranked "Plus" button for C&K owners', undefined, 'https://imgur.com/qfIN2ve', 'https://imgur.com/FIG8Rn6'))
        v211.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed tablet orientation bug', undefined, undefined, undefined))

        // Rob
        // Display Monthly League tournaments
        // Small community page fixes

        // Kyle
        // Track header coin button clicks

        // Muhammad
        // Change Login button in header profile dropdown to green

        // Shutsen
        // Redesigned Community page

        this.patchNotes.push(getPatchNote(2024, 7, 30, 211, v211))

        const v210: PatchNoteContent[] = []
        v210.push(getContent(PatchNoteType.Feature, 'Invite friends to your room', undefined, 'https://i.imgur.com/l21Z9yu', 'https://i.imgur.com/qiQbu1e', ['https://colonist.featureupvote.com/suggestions/342127/play-with-friends']))
        v210.push(getContent(PatchNoteType.Feature, 'Added corner notification when your friend comes online', undefined, undefined, 'https://i.imgur.com/6gM0URo.png'))
        v210.push(getContent(PatchNoteType.Update, 'Added timer bar to corner notification popup for auto-close', undefined, 'https://i.imgur.com/eHuORDg.png', 'https://i.imgur.com/6NW68yC.png'))
        v210.push(getContent(PatchNoteType.Update, '[Mobile] Play without logging in', undefined, undefined, undefined))
        v210.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed location of Special Build Phase Button in landscape mode', undefined, 'https://i.imgur.com/Yghm6EW.png', 'https://i.imgur.com/GGLfi1i.png', undefined))
        v210.push(getContent(PatchNoteType.Fix, '[Mobile] Spectators don\'t see trade prompts', undefined, undefined, undefined))
        v210.push(getContent(PatchNoteType.Fix, '[Mobile] Moving the map closes tooltips', undefined, undefined, undefined))

        // Rob
        // Add Discord Mobile device type
        // Save isMobile for discord activity launches
        // [Discord Mobile] two columns in room items panels
        // Remove discord mobile socket/session logging
        // [Discord Mobile] Make matchmaking card text smaller
        // Fix invite friends button data

        // Devyesh
        // Bug fixes on mobile app version
        // Remove store from mobile using feature flag
        // [Mobile] Measure disconnection events
        // v208.push(getContent(PatchNoteType.Fix, '[Mobile] Fix merchant view in landscape mode', 'https://i.imgur.com/0HDz8h1.png', 'https://i.imgur.com/JU6glIN.png', undefined))
        // [Mobile] User should be able to play as guest on mobile

        // Oguz
        // Beginner mode alternative level architectural & ux improvements

        // Shutsen
        // Ranked C&K block, shows subscribe CTA when user is not subscribed

        this.patchNotes.push(getPatchNote(2024, 7, 23, 210, v210))

        const v209: PatchNoteContent[] = []
        v209.push(getContent(PatchNoteType.Fix, '[Mobile] Fix landscape tooltips appearing over buttons', undefined, undefined, undefined))
        v209.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed game sound not restarting after going back to the app', undefined, undefined, undefined))
        v209.push(getContent(PatchNoteType.Fix, '[Mobile] Trade prompts are hidden when spectating', undefined, undefined, undefined))
        v209.push(getContent(PatchNoteType.Fix, '[Mobile] Tooltips close when the map is moved around', undefined, undefined, undefined))
        v209.push(getContent(PatchNoteType.Fix, 'Removed unnecessary scrollbar on Home Page\'s Ranked buttons', undefined, undefined, undefined))

        // Rob
        // [Discord] remove landing page popups
        // [Discord Mobile] modify socket connection

        // Shutsen
        // Ranked C&K block, shows subscribe CTA when user is not subscribed

        // Devyesh
        // Prevent auto selection of option in player avatar popup
        // Remove store from mobile using feature flag
        // [Mobile] Measure disconnection events
        // Remove service worker if exists

        this.patchNotes.push(getPatchNote(2024, 7, 16, 209, v209))

        const v208: PatchNoteContent[] = []
        v208.push(getContent(PatchNoteType.Fix, '[Mobile] Long usernames are visible on end game screen', undefined, 'https://i.imgur.com/DC9SN47.png', 'https://i.imgur.com/SMUnjVT.png'))
        v208.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed multiple popups opening on hold on iOS', undefined, undefined, undefined))

        // Jeff
        // refactored entire CardState system to optimize replay. Now has `CardStateOrdered` and `CardStateUnordered` to minimize memory
        // replay state system now only captures state changes when there is a delta in the state. Preventing empty actions
        // replay mode doesn't hold action data to keep things cleaner

        // Oguz
        // Beginner mode Level 1 - Show build road button from start
        // Added unit tests for MechanicBeginnerMode
        // Removed A/B Test - Force/Hide/Optionally suggest the Beginner Mode

        this.patchNotes.push(getPatchNote(2024, 7, 9, 208, v208))

        const v207: PatchNoteContent[] = []
        v207.push(getContent(PatchNoteType.Fix, 'Fixed Inventor progress card not working properly in maps with fog tiles', undefined, undefined, undefined))
        v207.push(getContent(PatchNoteType.Fix, 'Improved Replay performance', undefined, undefined, undefined))

        // Jeff
        // refactored entire CardState system to optimize replay. Now has `CardStateOrdered` and `CardStateUnordered` to minimize memory
        // replay state system now only captures state changes when there is a delta in the state. Preventing empty actions
        // replay mode doesn't hold action data to keep things cleaner

        // Rob
        // Discord mobile - adjust input popups for mobile keyboards
        // Discord mobile - fix sounds after Discord app is put in background
        // Discord mobile - fix vote view
        // Discord mobile - fix iPad
        // Discord mobile - fix username input popups

        // Oguz
        // Removed tutorial code except for the part thats being used for unit tests

        // Kyle
        // record analytics on how people enter rooms

        this.patchNotes.push(getPatchNote(2024, 7, 2, 207, v207))

        const v206: PatchNoteContent[] = []
        v206.push(getContent(PatchNoteType.Feature, '[Replay] Click on events in the game log to jump to different actions', undefined, undefined, 'https://i.imgur.com/NU1hEZr.gif'))
        v206.push(getContent(PatchNoteType.Feature, '[Replay] Auto-scroll game logs along with actions', undefined, undefined, 'https://i.imgur.com/AYdoWOx.gif'))

        // Rob
        // Discord mobile - fix sounds after Discord app is put in background
        // Discord mobile - fix vote view
        // Discord mobile - fix iPad

        this.patchNotes.push(getPatchNote(2024, 6, 25, 206, v206))

        const v205: PatchNoteContent[] = []
        v205.push(getContent(PatchNoteType.Update, 'Top Ranked players will earn Memberships! For more info check our <a href="https://colonist.io/faq" target="_blank">FAQ page</a>', undefined, undefined, undefined))
        v205.push(getContent(PatchNoteType.Update, '[Beginner Mode] Hide rolled dice number after card distributions', undefined, undefined, undefined))
        v205.push(getContent(PatchNoteType.Fix, '[Beginner Mode] Fixed VP ribbon animation playing for initial placements', undefined, undefined, undefined))

        // Jeff
        // Refactored entire system that determines where roads can be placed on map. Main change was moving it to shared folder so that client can access logic.
        // Refactored entire system that determines where settlements can be placed on the map. Main change was moving logic to shared folder so that client could execute logic that was happening on the backend which was complicated and expensive
        // Refactored how player cards and bank cards are being tracked in the game state system
        // Refactored `PlayerStateController` to be initiated in the client and the backend so that logic can be shared
        // Refactored `isBot` in the client to `isUser` so the logic is consistent

        // Rob
        // Discord mobile - update room subscription popup
        // Discord mobile - remove footer from store
        // Discord mobile - Remove share image functionality

        // Devyesh
        // Part 1 of merging socket controller for web and mobile

        // Oguz
        // Fix false alarm for SelectedCardsState
        // Track initial pip counts in player_game_statistics table

        this.patchNotes.push(getPatchNote(2024, 6, 18, 205, v205))

        const v204: PatchNoteContent[] = []
        v204.push(getContent(PatchNoteType.Feature, 'Replay mode! <i>Beta version</i>', undefined, undefined, 'https://i.imgur.com/WDgW6iN.jpeg'))
        v204.push(getContent(PatchNoteType.Update, '[Mobile] Added tooltips for landscape view', undefined, undefined, undefined))
        v204.push(getContent(PatchNoteType.Update, '[Mobile] Enabled spectating games', undefined, undefined, undefined))
        v204.push(getContent(PatchNoteType.Update, '[Mobile] Room list auto refreshes', undefined, undefined, undefined))
        v204.push(getContent(PatchNoteType.Fix, 'Fixed trade status button for Pink opponents', undefined, 'https://i.imgur.com/H9YjhBh.png', 'https://i.imgur.com/GlJu9fb.png'))
        v204.push(getContent(PatchNoteType.Fix, 'Fixed Progress Card discard popup not showing all cards in hand', undefined, undefined, undefined))
        v204.push(getContent(PatchNoteType.Fix, 'Fixed friends list overflowing if you had too many friends', undefined, undefined, undefined))

        // Jeff
        // Refactored entire system that determines where roads can be placed on map. Main change was moving it to shared folder so that client can access logic.
        // Refactored entire system that determines where settlements can be placed on the map. Main change was moving logic to shared folder so that client could execute logic that was happening on the backend which was complicated and expensive
        // Refactored how player cards and bank cards are being tracked in the game state system
        // Refactored `PlayerStateController` to be initiated in the client and the backend so that logic can be shared
        // Refactored `isBot` in the client to `isUser` so the logic is consistent

        // Rob
        // Discord mobile - update store and purchase CTAs
        // Discord mobile - fix room styles
        // Fix Discord mobile redirect urls
        // Discord mobile - remove chat for discord mobile games
        // Fix Discord coin header for legacy users
        // v204.push(getContent(PatchNoteType.Update, '[Mobile] Add tooltips for landscape', undefined, undefined, undefined))
        // Discord mobile - Fix Android safe areas
        // Discord mobile - Add info icon in game

        // Devyesh
        // Updated the mobile card animations and made them same as web
        // v203.push(getContent(PatchNoteType.Fix, '[Mobile] Improves the interaction experience with game map', undefined, undefined, undefined))
        // add dimensions to the analytic events in mobile
        // v203.push(getContent(PatchNoteType.Update, '[Mobile] Spectate games in mobile', undefined, undefined, undefined))
        // v203.push(getContent(PatchNoteType.Update, '[Mobile] Room list auto refreshes', undefined, undefined, undefined))
        // Clean up UILobbyTableController
        // slow down map movement in mobile
        // enable fedcm in google-one-tap-login
        // remove replay from discord and mobile
        // Improved the interaction experience with game map

        // Mustafa
        // Replay - Disabled dice sounds
        // Replay - Centered tooltips
        // Replay - Fixed endgame screen shows multiple times
        // Replay - Fixed click/drag last actions on slider is buggy
        // Replay - Removed 6x added 0.5x speed
        // Replay - Fixed disconnected players show bot icon instead of their avatars

        this.patchNotes.push(getPatchNote(2024, 6, 11, 204, v204))

        const v203: PatchNoteContent[] = []
        v203.push(getContent(PatchNoteType.Fix, 'Fixed trade offers order in the game log for spectators', undefined, undefined, undefined))
        v203.push(getContent(PatchNoteType.Fix, 'Fixed end game button not starting a new matchmaking queue', undefined, undefined, undefined))
        v203.push(getContent(PatchNoteType.Fix, 'Fixed Ranked video ads not being displayed', undefined, undefined, undefined))
        v203.push(getContent(PatchNoteType.Blog, 'Transitioning from Board Game to Colonist.io. <a href="https://blog.colonist.io/transitioning-from-board-game-to-colonist-io/" target="_blank">Read here!</a>', undefined, undefined, undefined, ['https://blog.colonist.io/transitioning-from-board-game-to-colonist-io/']))

        // Jeff
        // Fixed C&K rating algorithm

        // Oguz
        // Fixed pause votes acting as resume votes if pause ends during voting
        // Beginner mode - Shortened level 1 by giving two more wools as starting resources

        // Kyle
        // clicking outside gift membership popup doesn't take user to store

        this.patchNotes.push(getPatchNote(2024, 6, 4, 203, v203))

        const v202: PatchNoteContent[] = []
        v202.push(getContent(PatchNoteType.Update, 'Perfected Spanish translation'))
        v202.push(getContent(PatchNoteType.Update, '[Discord Activity] Now available in Spanish!'))
        v202.push(getContent(PatchNoteType.Fix, 'Fixed 1v1 games not restarting after pause countdown ends', undefined, undefined, undefined))
        v202.push(getContent(PatchNoteType.Fix, 'Fixed counter offers disappearing too fast when playing with bots', undefined, undefined, undefined))
        v202.push(getContent(PatchNoteType.Fix, 'Fixed ports appearing underneath the shore when a nearby fog is revealed', undefined, undefined, undefined))
        v202.push(getContent(PatchNoteType.Fix, 'Improved resolution of some game elements', undefined, undefined, undefined))
        v202.push(getContent(PatchNoteType.Fix, '[Mobile] Increased connection reliability', undefined, undefined, undefined))
        v202.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed Rematch button not working on some devices', undefined, undefined, undefined))
        v202.push(getContent(PatchNoteType.Blog, '3 Strategies to Make Enemies at Catan. <a href="https://blog.colonist.io/3-strategies-to-make-enemies-at-catan/" target="_blank">Read here!</a>', undefined, undefined, undefined, ['https://blog.colonist.io/3-strategies-to-make-enemies-at-catan/']))

        // Rob
        // Refactor auth for Discord mobile (use jwt in header and local storage)
        // Fix Discord Mobile rulebook

        // Devyesh
        // Add splash screen between the games
        // Implements service worker in mobile
        // v200.push(getContent(PatchNoteType.Fix, '[Mobile] Improving socket connection and preventing it to go idle', undefined, undefined, ''))
        // Fixing asset loading stability in mobile
        // Fixes one tap login

        // Oguz
        // Revert #15963 - Bring back GameState.GivePlayerResourcesFromTile
        // Beginner mode - Fix ghost resources
        // Beginner mode - Fix first dice roll animation
        // Refactor beginner mode specific logic out of UIGameCardsController
        // Fixed sentry error occurs if beginner quits in beginner mode
        // Fixed 2/3 sentry errors related to gameController.currentState being undefined in specific cases
        // Added A/B Test - Force/Hide/Optionally suggest the Beginner Mode

        // Kyle
        // duplicated strings test and resolved duplicated string value occurences

        // Mustafa
        // Game logs refactor phase 2.5: derive strings on the client instead of passing them from backend
        // Track & shadowban suspicious chat messages
        // Make shadowban functionality disabled by default

        // Rok
        // Added support for Google One Tap sign in on desktop

        this.patchNotes.push(getPatchNote(2024, 5, 28, 202, v202))

        const v201: PatchNoteContent[] = []
        v201.push(getContent(PatchNoteType.Update, 'Display ban warning notification to reported users', undefined, undefined, 'https://i.imgur.com/a/BxtOInU'))
        v201.push(getContent(PatchNoteType.Fix, 'Fixed development/progress card name not being displayed in the game log', undefined, 'https://i.imgur.com/a/1kc8Qfk', 'https://i.imgur.com/a/DBuiUMb'))
        v201.push(getContent(PatchNoteType.Fix, 'Juggernaut not earned for game resignations', undefined, undefined, undefined))
        v201.push(getContent(PatchNoteType.Fix, 'Fixed timer ticking delay on reconnect', undefined, undefined, undefined))
        v201.push(getContent(PatchNoteType.Fix, 'Fixed tooltips appearing underneath the chat box', undefined, 'https://i.imgur.com/ExEmkia.png', 'https://i.imgur.com/MzfyqEE.png'))
        v201.push(getContent(PatchNoteType.Fix, 'Fixed initial road placement auto-selection on a coast spot', undefined, undefined, undefined))

        // Jeff
        // revert game map indexing system back to indexed array instead of Map

        // Mau
        // Adding mute command
        // v201.push(getContent(PatchNoteType.Fix, 'Fixed trade cards being in the wrong order when another player made a counter offer', undefined, undefined, undefined))

        // Rob
        // Removed Title popup at end of game

        // Devyesh
        // added dimensions column to Analytics table
        // fixing game related UI issues
        // Improved socket connection and preventing it to go idle

        // Oguz
        // Beginner mode - resource card clicks trigger beginner mode

        // Kyle
        // Add error logs for discard card edge cases. Closed discard card popup when player discards to fix bug.
        // Prevented playing metropolis and city wall sound and animation on auto-reconnect
        // Constitution and Printer dev cards show popup on click, consistent with VP dev card.

        this.patchNotes.push(getPatchNote(2024, 5, 21, 201, v201))

        const v200: PatchNoteContent[] = []
        v200.push(getContent(PatchNoteType.Update, 'Added game mode to \'Searching for game\' popup', undefined, 'https://imgur.com/a/B293RXX', 'https://imgur.com/a/4MPkd56'))
        v200.push(getContent(PatchNoteType.Update, 'Display (Host) text next to room host', undefined, 'https://imgur.com/a/UcL79RN', 'https://imgur.com/a/6FRz7gV'))
        v200.push(getContent(PatchNoteType.Update, 'Replaced repeated ranked info buttons with a single one', undefined, 'https://imgur.com/a/OTIZrXa', 'https://imgur.com/a/KsDeZr2'))
        v200.push(getContent(PatchNoteType.Update, 'Left aligned player names on the end game screen', undefined, 'https://imgur.com/a/gf0YeEi', 'https://imgur.com/a/CA2pltK'))
        v200.push(getContent(PatchNoteType.Fix, 'Fixed corner popup close button overlapping with the text', undefined, 'https://imgur.com/a/w3zBxBt', 'https://imgur.com/a/t4zck32'))
        v200.push(getContent(PatchNoteType.Fix, 'Fixed game start sound playing after reconnecting', undefined, undefined, undefined))
        v200.push(getContent(PatchNoteType.Fix, 'Fixed time ticking sound playing after the game ended', undefined, undefined, undefined))
        v200.push(getContent(PatchNoteType.Fix, 'Fixed long usernames not fitting the end game shared image', undefined, 'https://imgur.com/a/8vmierT', 'https://imgur.com/a/PSiK7yh'))
        v200.push(getContent(PatchNoteType.Fix, '[Mobile] Cosmetic improvements in portrait view', undefined, 'https://i.imgur.com/OkSXGM2.png', 'https://i.imgur.com/5q5vsNu.png'))
        v200.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed Rematch & Play buttons not working', undefined, undefined, undefined))
        v200.push(getContent(PatchNoteType.Fix, '[Mobile] Removed duplicate floating text notifications', undefined, undefined, undefined))

        // Jeff
        // major map state refactor to handle new replay mode
        // includes tiles, corners, edges and ports

        // Mau
        // Refactoring trade state to use EventSourcingController

        // Rob
        // Discord Mobile - iOS safe areas

        // Devyesh
        // tracks when user moves to background and foreground

        // Mustafa
        // Discord - Join our discord popup
        // Replay phase 1: refactored game logs
        // Replay phase 2: moved conversion logic to client

        // Rok
        // Removed Add Friend popup when game ends

        this.patchNotes.push(getPatchNote(2024, 5, 14, 200, v200))

        const v199: PatchNoteContent[] = []
        v199.push(getContent(PatchNoteType.Update, '[Mobile] Special Build Phase button is accessible with chat and logs open', undefined, undefined, undefined))
        v199.push(getContent(PatchNoteType.Update, 'Room list auto refreshes', undefined, undefined, undefined))
        v199.push(getContent(PatchNoteType.Fix, 'Fixed ranked video ads not working'))
        v199.push(getContent(PatchNoteType.Fix, 'Fixed settings view after screen resize', undefined, 'https://i.imgur.com/iDiy38w.png', 'https://i.imgur.com/pgLJ5sH.png'))
        v199.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed tooltips not closing on end game screen', undefined, undefined, undefined))
        v199.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed assets being pixelated', undefined, undefined, undefined))
        v199.push(getContent(PatchNoteType.Fix, 'Fixed chat and logs scrollbar showing when there was not enough text', undefined, 'https://i.imgur.com/2sl46x3.png', 'https://i.imgur.com/e1I0zdv.png'))

        // Mau
        // Refactored Victory Points to use EventSourcingController
        // Refactored all Player State to use EventSourcingController
        // Refactored GameState.PlayersTakingAction and GameState.PlayersFinishedTakingAction to use EventSourcingController

        // Rob
        // Add Discord console log UI component
        // Juggernaut award
        // Send award in end game player state
        // Update share image styles
        // Create award image
        // Add Low FPS tracker to send sentry reports
        // Change Award to Title (name of feature)
        // v200.push(getContent(PatchNoteType.Feature, 'Earn in-game Titles! Juggernaut and Monopolist', undefined, undefined, 'https://i.imgur.com/BfIdfFi.png'))

        // Devyesh
        // improve UI for end game screen
        // v199.push(getContent(PatchNoteType.Update, '[Mobile] Fixing pixelation of assets', undefined, undefined, undefined))
        // fixing cnk view on landscape orientation
        // v199.push(getContent(PatchNoteType.Update, '[Mobile] Tooltips close on end game screen', undefined, undefined, ''))
        // v199.push(getContent(PatchNoteType.Update, '[Mobile] Improved stability of rematch button on game end screen', undefined, undefined, undefined))
        // fixes resize of settings UI and issue related to portrait gameplay
        // increased spacing between avatars in embargo view
        // v199.push(getContent(PatchNoteType.Fix, '[Mobile] Close tooltips when player closes trade views', undefined, undefined, ''))
        // updates scrollbar to chat/log scrollbar's color
        // rematch button works after the matchmaking is completed
        // changing game orientation is now available inside the main menu

        // Oguz
        // Refactored BankState to use EventSourcingController
        // Refactored GameState.InitialPlacement
        // Refactored GameState.CurrentGameState
        // Refactored GameState.KarmaState
        // Refactored GameState.GivePlayerResourcesFromTile
        // Refactored GameState.BankTradeRatiosState
        // Refactored GameState.EndGameState
        // Removed GameState.GivePlayerGrantedCards

        // Kyle
        // gift membership popup cta says 'Go to Store'

        this.patchNotes.push(getPatchNote(2024, 5, 8, 199, v199))

        const v198: PatchNoteContent[] = []
        v198.push(getContent(PatchNoteType.Update, '[Mobile] Implemented Report players on landscape mode', undefined, undefined, 'https://i.imgur.com/TeAQwiR.png'))
        v198.push(getContent(PatchNoteType.Fix, '[Mobile] Improved tablet UI', undefined, 'https://i.imgur.com/u3IeLnC.png', 'https://i.imgur.com/jXphkc2.png'))
        v198.push(getContent(PatchNoteType.Fix, '[Mobile] Increased size of trade prompts', undefined, undefined, 'https://i.imgur.com/lWTL4Kf.png'))
        v198.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed dev card popups position', undefined, undefined, 'https://i.imgur.com/s3fCoOX.png'))
        v198.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed chat and game log positions when discarding cards', undefined, undefined, undefined))
        v198.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed chat icon position when using Inventor', undefined, undefined, 'https://i.imgur.com/nen9Ufm.png'))
        v198.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed tooltip pointers', undefined, 'https://i.imgur.com/xa71YXh.png', 'https://i.imgur.com/TdTvksP.png'))

        // Devyesh
        // fixing commercial harbor card usage in mobile
        // fixing tablet UI
        // removed checkout page from mobile
        // stats button size is responsive (to fit all device sizes)
        // analytics for chat interaction fixed
        // resize screen before building the game
        // add spinner when user clicks on purchase on mobile
        // add analytics to count when user finishes first in mobile
        // added event if the player skipped turn on mobile (landscape vs portrait)

        // Oguz
        // Beginner Mode - Fix no trade hint to show error

        // Kyle
        // Tooltips display downwards if overlapping chat
        // Some player avatar view tooltips now more concise
        // Move related mechanics into folders
        // Clean homepage internal ad files

        this.patchNotes.push(getPatchNote(2024, 4, 30, 198, v198))

        const v197: PatchNoteContent[] = []
        v197.push(getContent(PatchNoteType.Update, '[Discord Activity] Now available in Russian!'))
        v197.push(getContent(PatchNoteType.Update, '[Discord Activity] Moved Advanced Settings to the bottom of the room', undefined, undefined, 'https://i.imgur.com/Vb4Taox.png'))
        v197.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed app freezing after making a purchase'))
        v197.push(getContent(PatchNoteType.Feature, '[Discord Activity] Mute/Report players in matchmaking games', undefined, 'https://imgur.com/a/w4vXiwH', 'https://imgur.com/a/Rx9ggb7'))

        // Jeff
        // Replay phase 0: setting up engine to record and handle state diffing
        // Replay phase 0: converted dice state to new systaem
        // Replay phase 0: created shell for player state that needs to be converted (only converted bankRoadAmount)
        // Replay phase 0: created shell for bank state that needs to be converted (only convered hasLongestRoad)

        // Devyesh
        // removed checkout page from mobile
        // showing 2.5 trades in mobile instead of 1.5 for larger screens
        // fixing app freezing after purchase/stripe page
        // Prevent closing of keyboard when the user taps on send button

        // Oguz
        // Beginner mode - Added required resources to goals

        // Kyle
        // Fix broken images in game logs
        // Take out hardcoded refund-policy strings
        // Set language of checkout page, refund-policy, and disable ad block pages dynamically

        // Mustafa
        // Discord - Subscribe without leaving the room
        // Simplified popup close event listener logic
        // Discord - Show membership popups
        // Discord - Replaced random rich presence texts with "Come Play!"

        this.patchNotes.push(getPatchNote(2024, 4, 23, 197, v197))

        const v196: PatchNoteContent[] = []
        v196.push(getContent(PatchNoteType.Update, 'During initial placements, the selection is saved if you time out, preventing auto-placements'))
        v196.push(getContent(PatchNoteType.Update, '[Mobile] Added landscape/portrait selection icons in the right side menu', undefined, undefined, 'https://i.imgur.com/b6TYYc2.png'))
        v196.push(getContent(PatchNoteType.Update, '[Mobile] Added debug info popup in /profile', undefined, undefined, 'https://i.imgur.com/qxMN43g.jpeg'))
        v196.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed tooltips getting stuck and not closing'))
        v196.push(getContent(PatchNoteType.Fix, 'Fixed end game screen lag'))
        v196.push(getContent(PatchNoteType.Fix, 'Game performance improvements'))

        // Devyesh
        // fix - asking for rating
        // moved ClientI18n to i18n package
        // uploading source maps to sentry

        this.patchNotes.push(getPatchNote(2024, 4, 16, 196, v196))

        const v195: PatchNoteContent[] = []
        v195.push(getContent(PatchNoteType.Feature, 'Share an image of the game results!', undefined, undefined, 'https://i.imgur.com/Tc1gyBw.png'))
        v195.push(getContent(PatchNoteType.Feature, '[Discord Activity] Change your region by clicking your flag on the leaderboards', undefined, undefined, 'https://imgur.com/a/ZwXNPaB'))
        v195.push(getContent(PatchNoteType.Update, '[Discord Activity] Preview end game image when hovering Share button', undefined, undefined, 'https://i.imgur.com/aH5Trk4.png'))
        v195.push(getContent(PatchNoteType.Update, '[Discord Activity] Added \'Join Discord\' button to the homepage', undefined, undefined, 'https://i.imgur.com/N8uuAzu.png'))
        v195.push(getContent(PatchNoteType.Update, '[Discord Activity] Enabled click-to-build mechanics in Beginner Mode', undefined, undefined, 'https://i.imgur.com/DSB6W0Z.png'))
        v195.push(getContent(PatchNoteType.Update, '[Mobile] Added close button to Smith progress card in C&K', undefined, undefined, 'https://i.imgur.com/kLW9MEV.png'))
        v195.push(getContent(PatchNoteType.Update, 'In games vs Bots, the game pauses when the settings are open', undefined, undefined, 'https://i.imgur.com/x5alTNf.png'))

        // Jeff
        // auto-reconnect on game state sequence error without needing to reconnect the socket

        // Mau
        // Changing discord weekly reminders to be on sundays instead of wednesdays
        // Adding notification to ask for help on translation
        // v193.push(getContent(PatchNoteType.Fix, 'Improving asset loading performance and reliability'))
        // Updated to PIXI v7

        // Rob
        // Fix mod change email
        // Rework Discord auth to not create guest accounts, not need cookies
        // Monopolist award mechanic

        // Devyesh
        // added beta text to mobile
        // refactor - remove UIMPopupView
        // update imports for all the LobbyImages
        // added X action to smith card and fixing the bug reported by players

        // Oguz
        // Beginner mode - Added hint for first action in level 1
        // Beginner mode - Enabled hover mechanics
        // Fix action state text inconsistencies
        // Beginner mode - force specific colors
        // Beginner mode - Hide build button badges
        // Beginner mode - Enable seven logic info popup on 7 rolls

        // Kyle
        // fix internal ads productDesigner and ranked internal ads
        // vote to resume not counted as vote to pause

        this.patchNotes.push(getPatchNote(2024, 4, 9, 195, v195))

        const v194: PatchNoteContent[] = []
        v194.push(getContent(PatchNoteType.Update, '[Discord Activity] Added chat to matchmaking games'))
        v194.push(getContent(PatchNoteType.Update, '[Discord Activity] Added an Invite Friends button below players list inside the room', undefined, undefined, 'https://i.imgur.com/EljAeWa.png'))
        v194.push(getContent(PatchNoteType.Update, '[Discord Activity] Game log events show players\' profile pictures', undefined, 'https://i.imgur.com/mgKt1o3.png', 'https://i.imgur.com/CyE5RkC.png'))
        v194.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed trade accept button spamming bug in Beginner mode'))

        // Kyle
        // take out hardcoded ejs title, description, and keywords into strings.json

        // Mustafa
        // Added duplicate invite friends button to room bottom left

        this.patchNotes.push(getPatchNote(2024, 4, 2, 194, v194))

        const v193: PatchNoteContent[] = []
        v193.push(getContent(PatchNoteType.Feature, 'Share an image of the game results in the Discord Activity', undefined, undefined, 'https://i.imgur.com/64nreY9.png'))
        v193.push(getContent(PatchNoteType.Update, 'Updated select player to rob popup', undefined, 'https://i.imgur.com/ciJFhyW.png', 'https://i.imgur.com/1ZsQGiy.png'))
        v193.push(getContent(PatchNoteType.Update, '"Any Resource" cards are now separated by a partition', undefined, undefined, 'https://i.imgur.com/78cFI3j.png'))
        v193.push(getContent(PatchNoteType.Fix, 'Fixed matchmaking queue starting before video ad finishes'))
        v193.push(getContent(PatchNoteType.Fix, 'Fixed subscription button in Discord Activity store'))
        v193.push(getContent(PatchNoteType.Fix, 'Fixed ad covering the screen in mobile app'))
        v193.push(getContent(PatchNoteType.Fix, 'Removed `No such offer` popup'))
        v193.push(getContent(PatchNoteType.Fix, 'Performance improvements'))

        // Rob
        // Generate end game image

        // Devyesh
        // remove ad script from mobile if ad is not active and bottom align the CCPA test
        // added test to ensure there is no vli on mobile
        // minor change to improve speed for landscape vs portrait queries

        // Oguz
        // Beginner mode - More refactors (DiceEngine, Guide Texts structure)
        // Added beginner mode suggestion for multiplayer beginners on Discord

        // Kyle
        // disable cards that are not in bank when Year of Plenty or Aqueduct or Gold Tile are activated
        // initial road placement action text says road/ship for seafarer modes
        // strings.json popup section refactor

        this.patchNotes.push(getPatchNote(2024, 3, 27, 193, v193))

        const v192: PatchNoteContent[] = []
        v192.push(getContent(PatchNoteType.Update, 'Removed automatic chat bans'))
        v192.push(getContent(PatchNoteType.Update, 'Create counter trades using the Any Resource card', undefined, undefined, 'https://i.imgur.com/1jKW66X.png'))
        v192.push(getContent(PatchNoteType.Update, 'Updated discard card popup text', undefined, 'https://imagizer.imageshack.com/img923/7703/eEOSiN.png', 'https://imagizer.imageshack.com/img924/8729/NBjbME.png'))
        v192.push(getContent(PatchNoteType.Update, 'Improved the username change popup'))
        v192.push(getContent(PatchNoteType.Update, '[Mobile] Redesigned room Player section', undefined, 'https://i.imgur.com/ujtZRMv.png', 'https://i.imgur.com/rTS792l.png'))
        v192.push(getContent(PatchNoteType.Update, '[Mobile] Reorganized settings page', undefined, 'https://i.imgur.com/XjHHRk6.png', 'https://i.imgur.com/7dE1eQX.png'))

        // Mau
        // Saving bot difficulty inside PlayersGamesEntity
        // Not caring if city is defined and state undefined inside UserGeographicalInformation
        // Reloading website on region change
        // Adding pink color for Karm

        // Kyle
        // detect unused string test

        // Mustafa
        // Add new endgame signup to not lose progress popup
        // Updated username validation logic: Length and alphanumeric check shared, bad words and availability checked on server
        // To close a popup, the click must start and end outside the popup
        // [Input popups] Additive oninput events for additional event listeners
        // [Input popups] Check action now validates overall input validity, not just length
        // [Input popups] Check button disabled if input is invalid

        this.patchNotes.push(getPatchNote(2024, 3, 19, 192, v192))

        const v191: PatchNoteContent[] = []
        v191.push(getContent(PatchNoteType.Feature, 'Select your Leaderboards region in your profile settings!', undefined, undefined, 'https://i.imgur.com/8xDGBaN.png'))
        v191.push(getContent(PatchNoteType.Feature, 'Easy Bots are now selectable when creating a single player room game', undefined, undefined, 'https://i.imgur.com/8IcDnN2.png'))
        v191.push(getContent(PatchNoteType.Update, 'Redesigned room Player section', undefined, 'https://i.imgur.com/54843oh.png', 'https://i.imgur.com/Ttjdk0Z.png'))
        v191.push(getContent(PatchNoteType.Fix, 'Fixed cards disappearing from the trade bar when someone disconnects'))
        v191.push(getContent(PatchNoteType.Fix, 'Fixed subscription button not working in Discord Activity store'))
        v191.push(getContent(PatchNoteType.Fix, 'Fixed multiplayer profile pictures not appearing in Discord Activity'))

        // Juan
        // Modes/maps that are selected but not owned appear as "Base" in the lobby room list

        // Mau
        // Removed iso-3166-2 package and used a custom getter using json file

        // Rob
        // Generate end game image

        // Kyle
        // Add trade hints to level 2 beginner mode
        // Beginner mode dice clicks when not dice state trigger guide bubble
        // Always show feedback form if leave early in beginner mode
        // Remove disable karma from beginner mode settings dropdown

        this.patchNotes.push(getPatchNote(2024, 3, 12, 191, v191))

        const v190: PatchNoteContent[] = []
        v190.push(getContent(PatchNoteType.Feature, 'Auto-reconnect to the game without refreshing'))
        v190.push(getContent(PatchNoteType.Update, '[Discord] Added explanation box to Beginner Mode!', undefined, undefined, 'https://i.imgur.com/ZHsG2nG.png'))
        v190.push(getContent(PatchNoteType.Update, '[Mobile] Prevent chat and game log from auto-scrolling', undefined, undefined, undefined))
        v190.push(getContent(PatchNoteType.Update, '[Mobile] Added Patch Notes page', undefined, undefined, 'https://i.imgur.com/czwG3KN.png'))
        v190.push(getContent(PatchNoteType.Update, '[Mobile] Redesigned the info popup', undefined, undefined, 'https://i.imgur.com/6ZYZdQd.png'))
        v190.push(getContent(PatchNoteType.Update, '[Mobile] Added turn actions bar', undefined, undefined, 'https://i.imgur.com/p0fbqMQ.png'))
        v190.push(getContent(PatchNoteType.Fix, 'Prevent bots from getting stuck discarding cards when a player disconnects'))
        v190.push(getContent(PatchNoteType.Fix, 'Fixed map selection view dropping to the last row when selecting different game modes'))

        // Devyesh
        // recording data only when user is on mobile app
        // updated dev dependency of ip from 1.1.8 to 1.1.9
        // make bank hide on the end game screen
        // fix: preventing player to tap behind the end game scree
        // [Mobile] fixing leaderboard scroll
        // added patch notes to mobile
        // fix: preventing player to tap behind the end game screen
        // added CI test for mobile route test
        // fixing ticker when the game is paused
        // fixing scroll in store cards
        // fixes multiple issues found in game on 29th Feb
        // the match making button is not disabled for 1 second after matchmaking starts
        // added deprecated warning for landscape mode

        // Oguz
        // Fix sentry errors caused by Beginner Mode

        // Kyle
        // strings.json refactors for translations

        // Mustafa
        // Members can now correctly view ads on the right side of the homepage
        // Added new Colonist ads: Free Color, Play 1v1, Play C&K https://imgur.com/a/IHFlDIB

        this.patchNotes.push(getPatchNote(2024, 3, 5, 190, v190))

        const v189: PatchNoteContent[] = []
        v189.push(getContent(PatchNoteType.Update, 'Increased max VP limits and added warning', undefined, undefined, 'https://i.imgur.com/UpITyvN.png'))
        v189.push(getContent(PatchNoteType.Update, '[Mobile] New bank design', undefined, undefined, 'https://i.imgur.com/w1sltQO.png'))
        v189.push(getContent(PatchNoteType.Update, '[Mobile] Player turn order is now clockwise in portrait mode', undefined, undefined, undefined))
        v189.push(getContent(PatchNoteType.Fix, 'Fixed cards disappearing from the trade panel when someone disconnects'))
        v189.push(getContent(PatchNoteType.Fix, '[Mobile] Board is centered at the beginning of the game', undefined, 'https://i.imgur.com/prmXx6r.png', 'https://i.imgur.com/HfEhdAH.png'))
        v189.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed share room link not being copied', undefined, undefined, undefined))

        // Rob
        // Update email change mod command to allow for changing any provider email

        // Devyesh
        // recording data only when user is on mobile app
        // v189.push(getContent(PatchNoteType.Fix, 'Maps are centered in Mobile!', undefined, 'https://i.imgur.com/prmXx6r.png', 'https://i.imgur.com/HfEhdAH.png'))
        // adding fallback statusbar height in case app doesn't get event correctly
        // v189.push(getContent(PatchNoteType.Feature, 'Added ticker in mobile', undefined, undefined, 'https://i.imgur.com/9vxIocl.png'))
        // fixing translucent image in store
        // remove old popups and prevent them from stacking

        // Oguz
        // Beginner mode level 2 fix no-opponent tile providing resources
        // Beginner mode level 2 fix knight card being usable on wrong states edge case
        // Convert Beginner Hints into an optional game mechanic
        // Restrict beginner hints to only classic games
        // Reverted web bank ui background color
        // Beginner mode - Reduced background click amount needed to show tips
        // Beginner mode - Replaced welcome message with 'Double-click on the map for tips' in level 1
        // Beginner mode - Fixed trade button & buy dev card button random opacity activation
        // Beginner mode - Added sound & animation to level 1 button reveals
        // Refactor event collection on beginner mode

        this.patchNotes.push(getPatchNote(2024, 2, 27, 189, v189))

        const v188: PatchNoteContent[] = []
        v188.push(getContent(PatchNoteType.Feature, 'Added Beginner Mode Level 2 for Discord Activity!', undefined, undefined, 'https://i.imgur.com/TgkcKy2.png'))
        v188.push(getContent(PatchNoteType.Update, 'Trade offers are now animated!', undefined, undefined, 'https://i.imgur.com/IrIIVbU.mp4'))
        v188.push(getContent(PatchNoteType.Update, 'New mobile chat box & game log design', undefined, 'https://i.imgur.com/wUjpNqF.jpeg', 'https://i.imgur.com/jNXHu9h.jpeg'))
        v188.push(getContent(PatchNoteType.Update, 'New Colonist <a href="https://colonist.io/values" target="_blank">Values page</a>'))
        v188.push(getContent(PatchNoteType.Fix, 'Fixed being able to propose open ended trades with no resources in hand'))

        // Devyesh
        // [Mobile] Chat and log icons fixed on cancelling actions
        // added more tracking events
        // fixed dice view on tablet

        // Oguz
        // Refactored beginner mode to enable multiple levels
        // Added Goals for Beginner Mode Level 1

        // Kyle
        // strings.json refactor homePageEJS and homePageClient into homePage

        // Charith
        // Fix room link button text not reset on room load
        // Added render and redirect tests for values page

        this.patchNotes.push(getPatchNote(2024, 2, 23, 188, v188))

        const v187: PatchNoteContent[] = []
        v187.push(getContent(PatchNoteType.Feature, 'Added Leaderboards for Discord Activity!', undefined, undefined, 'https://i.imgur.com/vrX4vsO.jpg'))
        v187.push(getContent(PatchNoteType.Fix, 'Fixed players not being able to start ranked games', undefined, undefined, 'https://i.imgur.com/u4Vajez.jpg'))
        v187.push(getContent(PatchNoteType.Fix, 'Fixed in-game side ads not displaying'))
        v187.push(getContent(PatchNoteType.Fix, '\'Any Resource\' card is now separated from the rest of the cards in the trade window', undefined, undefined, 'https://i.imgur.com/ZvkanwL.jpg'))
        v187.push(getContent(PatchNoteType.Fix, 'Fixed the Next Level button for Beginner Mode on the Discord activity'))
        v187.push(getContent(PatchNoteType.Fix, 'Fixed tooltips getting stuck on the screen'))
        v187.push(getContent(PatchNoteType.Fix, 'Fixed tooltips closing after every game action'))
        v187.push(getContent(PatchNoteType.Blog, 'Colonist 2023 Summary! <a href="https://blog.colonist.io/colonist-io-2023-summary/" target="_blank">Read here!</a>', [], undefined, undefined, ['https://blog.colonist.io/colonist-io-2023-summary/']))

        // Oguz
        // Fix any card permanently hidden flag getting overridden on resize
        // Remove how to play slides from codebase

        // Kyle
        // Tooltips expire after a minute
        // added tests for selectRemainingCardsToDiscard
        // Trade offer reject button tooltip missing when animated fix

        // Charith
        // Changed color of hyperlinks 'get more colors' & 'get more avatars'

        this.patchNotes.push(getPatchNote(2024, 2, 16, 187, v187))

        const v186: PatchNoteContent[] = []
        v186.push(getContent(PatchNoteType.Update, 'Game logs and chat are now restored on reconnect'))
        v186.push(getContent(PatchNoteType.Update, 'When discarding, the selection is remembered if you time out'))
        v186.push(getContent(PatchNoteType.Fix, 'Fixed cookies issue in Safari'))
        v186.push(getContent(PatchNoteType.Fix, 'Fixed dice animation in 1 player games'))
        v186.push(getContent(PatchNoteType.Blog, 'Colonist 2023 Summary! <a href="https://blog.colonist.io/colonist-io-2023-summary/" target="_blank">Read here!</a>', [], undefined, undefined, ['https://blog.colonist.io/colonist-io-2023-summary/']))

        // Mau
        // When you counter offer in your turn, it would not be tagged as counter offer

        this.patchNotes.push(getPatchNote(2024, 2, 9, 186, v186))

        const v185: PatchNoteContent[] = []
        v185.push(getContent(PatchNoteType.Feature, 'Ranked Season 8 has started!'))
        v185.push(getContent(PatchNoteType.Feature, 'Open Ended Trades are live!', undefined, undefined, 'https://i.imgur.com/b9gZukR.png'))
        v185.push(getContent(PatchNoteType.Update, 'Maximum selectable Victory Points are determined based on room settings'))
        v185.push(getContent(PatchNoteType.Update, 'Ranked 1v1 Season 8 Dice 7\'s are balanced between the players'))
        v185.push(getContent(PatchNoteType.Update, 'More words added to the profanity filter'))
        v185.push(getContent(PatchNoteType.Fix, 'Counter offer status indicator now stays in sync with other animations'))
        v185.push(getContent(PatchNoteType.Fix, 'Fixed player response trade tooltip not displaying any username', undefined, 'https://i.imgur.com/NxwIpJp.png', 'https://i.imgur.com/KDkdhqB.png'))
        v185.push(getContent(PatchNoteType.Fix, 'Fixed animations shifting when spammed'))
        v185.push(getContent(PatchNoteType.Fix, 'Fixed embargo bugs'))
        v185.push(getContent(PatchNoteType.Fix, 'Fixed 3rd Party cookie issues for the Discord Activity'))
        v185.push(getContent(PatchNoteType.Fix, 'Fixed C&K Progress Card help popups on the Discord Activity', undefined, 'https://i.imgur.com/aVrceRz.png', 'https://i.imgur.com/kUYQgpo.png'))
        v185.push(getContent(PatchNoteType.Blog, 'Balancing 7s on 1v1! <a href="https://blog.colonist.io/balancing-7s-1v1/" target="_blank">Read here</a>', [], undefined, undefined, ['https://blog.colonist.io/balancing-7s-1v1']))

        // Mau
        // Fixing balanced dice to ensure that a one-player game rolls normal 7 distribution

        // Devyesh
        // fixing zoom bug on android
        // increase the site loading speed by reducing size of vendor.js
        // fixing dice animation on canvas resize
        // fixing layout when keyboard is opened
        // fixing sound in game
        // updated toast design
        // making friend list scroll
        // fix feed view on rerender

        // Oguz
        // Implemented beginner mode v2 (campaign mode lvl1)

        // Kyle
        // Added tooltips to selector view in trade UI, tooltips now display above if below overlaps UI and there is space above
        // Spectate tab now only displays 'featured' games, or games which have a paid map or mode.
        // Remove 'not enough resources' text on game map placement buttons

        this.patchNotes.push(getPatchNote(2024, 2, 2, 185, v185))

        const v184: PatchNoteContent[] = []
        v184.push(getContent(PatchNoteType.Update, 'Improved the layout of the \'Edit Username\' popup, and added a character counter', undefined, 'https://i.imgur.com/MOzisjT.png', 'https://i.imgur.com/uj8MHEm.png'))
        v184.push(getContent(PatchNoteType.Update, 'Added new Promotional Materials with Branding Guidelines to the <a href="https://colonist.io/press-kit" target="_blank">press kit</a>'))
        v184.push(getContent(PatchNoteType.Update, 'Made some improvements to the profanity filter'))
        v184.push(getContent(PatchNoteType.Update, 'Mobile app now launches in portrait mode by default'))
        v184.push(getContent(PatchNoteType.Fix, 'Fixed animation timing for the counter offer status indicator'))
        v184.push(getContent(PatchNoteType.Fix, 'Fixed tooltips lacking usernames when hovering over trade response status buttons'))
        v184.push(getContent(PatchNoteType.Fix, 'Fixed balanced dice bug when there was only 1 player in the game'))

        // Rob
        // Keep hidden for now! Enable online play for Discord users

        // Devyesh
        // fixed blue player colour for section backgrounds and text highlights
        // Achievement popups (longest road) now fade out properly on mobile

        // Kyle
        // Added flicker animation to missing resources above placement button

        this.patchNotes.push(getPatchNote(2024, 1, 26, 184, v184))

        const v183: PatchNoteContent[] = []
        v183.push(getContent(PatchNoteType.Feature, 'Spectators can now see the in-game chat!', undefined, undefined, 'https://i.imgur.com/qkHeJHn.png'))
        v183.push(getContent(PatchNoteType.Feature, 'Spectators can now see the active trades!', undefined, undefined, 'https://i.imgur.com/FpjCi9o.png'))
        v183.push(getContent(PatchNoteType.Feature, 'You can now report, mute, and embargo players on mobile!', undefined, undefined, 'https://i.imgur.com/fU0t4XV.png'))
        v183.push(getContent(PatchNoteType.Feature, 'You can now toggle whether to reject a trade if you\'re still considering it!', undefined, undefined, 'https://i.imgur.com/ZMD54be.mp4'))
        v183.push(getContent(PatchNoteType.Feature, 'Added a status indicator to show when someone is preparing a counter offer!', undefined, undefined, 'https://i.imgur.com/4zCwxrt.png'))
        v183.push(getContent(PatchNoteType.Feature, 'Trade offers now stay open while someone is preparing a counter offer!'))
        v183.push(getContent(PatchNoteType.Update, 'Updated trade icon', undefined, 'https://imgur.com/NpmZUT1.png', 'https://imgur.com/FGNhQA9.png'))
        v183.push(getContent(PatchNoteType.Fix, 'Fixed counter offers unintentionally turning off bank trade mode'))
        v183.push(getContent(PatchNoteType.Fix, 'Fixed missing audio in Opera Browser'))

        // Mau
        // Device Type now gets saved inside NPS Entity
        // Trade Offer View destroys entirely on resize

        // Devyesh
        // added event to resize twice

        // Oguz
        // Implement last 2 days countdown for the holiday sale
        // Implement stylelint rules to force using palette colors

        // Akito
        // Remove Santa Robber

        // Kyle
        // v183.push(getContent(PatchNoteType.Update, 'Now the bank trade buttons are hidden on a counter offer', undefined, 'https://imgur.com/6UJqbVr.png', 'https://imgur.com/LhFeFSG.png'))
        // Coin '+' icon inconsistency fix, now it always leads to store instead of coin popup.
        // Increase trade scrollbar width

        this.patchNotes.push(getPatchNote(2024, 1, 19, 183, v183))

        const v182: PatchNoteContent[] = []
        v182.push(getContent(PatchNoteType.Fix, 'Fixed C&K Bug where player could not place road after removing an enemy knight using Intrigue'))
        v182.push(getContent(PatchNoteType.Fix, 'Fixed C&K Bug where progress cards weren\'t being counted correctly'))
        v182.push(getContent(PatchNoteType.Fix, 'Fixed beginner hints having the wrong text and being hidden by the trade window on Discord'))
        v182.push(getContent(PatchNoteType.Fix, 'Fixed images failing to load and appearing as white squares'))

        // Rob
        // Discord - hide coin purchase options via feature flag
        // Discord - shorten membership products in store so buy button is visible

        // Devyesh
        // Fixing unintended AIP add refresh calls
        // New game layout for mobile
        // ability to change username on mobile

        // Kyle
        // Added Kyle info to about page, and fixed about page code inconsistencies
        // Removed seafarers from leaderboard, mobile and web
        // Remove 'More Avatars' from profile dropdown
        // Removed unnecessary welcome message text (Karma info and Discord link)

        this.patchNotes.push(getPatchNote(2024, 1, 12, 182, v182))

        const v181: PatchNoteContent[] = []
        v181.push(getContent(PatchNoteType.Feature, 'Added a beginner mode for Discord games!'))
        v181.push(getContent(PatchNoteType.Feature, 'New trade with bank mode, which can be toggled in the trade menu!', undefined, undefined, 'https://i.imgur.com/LAgfaDC.png'))
        v181.push(getContent(PatchNoteType.Fix, 'Fixed game launching in landscape mode and making menus unusable'))

        // Mau
        // Added test for account linking, unlinking and deletion
        // Only saving feedback form if it's not empty when triggered on the homepage

        // Devyesh
        // fixed scroll on stripe page
        // [Mobile] store removed "Billed at" text

        this.patchNotes.push(getPatchNote(2024, 1, 5, 181, v181))

        const v180: PatchNoteContent[] = []
        v180.push(getContent(PatchNoteType.Update, 'Added an animation when a trade is about to get auto-rejected', undefined, undefined, 'https://i.imgur.com/l7o844J.png'))
        v180.push(getContent(PatchNoteType.Fix, 'Fixed getting stuck on a building action after trading with the bank'))
        v180.push(getContent(PatchNoteType.Fix, 'Fixed rulebook popup size on smaller screens', undefined, 'https://imgur.com/1y8japY', 'https://imgur.com/cAeDyuB'))
        v180.push(getContent(PatchNoteType.Fix, 'Fixed Rematches not working properly on the Discord Activity'))
        v180.push(getContent(PatchNoteType.Fix, 'Fixed wrong username being shown in rooms on the Discord Activity'))
        v180.push(getContent(PatchNoteType.Fix, 'Hide "Invite Friend" button in Discord Activity when you lack permission to invite'))
        v180.push(getContent(PatchNoteType.Fix, 'Fixed error when cancelling purchases in Discord Activity'))

        // Mau
        // Adding Tab Communicator API and using it to send events to other tabs
        // Logging out all tabs when the user logs out

        // Rob
        // Make feedback form more responsive at smaller screen sizes
        // Discord - fix purchasing items with coins for legacy users

        // Devyesh
        // fixes some minor bugs related to mobile
        // added event logs for funnel
        // changed location of players's username position
        // release of new mobile app - sentry 2
        // adds new banners for mobile
        // disable feedback popup on mobile using feature flag
        // removed unused variables in UIHoverActionController
        // Fixes holidy sale icon for mobile

        this.patchNotes.push(getPatchNote(2023, 12, 29, 180, v180))

        const v179: PatchNoteContent[] = []
        v179.push(getContent(PatchNoteType.Update, 'Trades momentarily stay on the screen after all players have rejected'))
        v179.push(getContent(PatchNoteType.Update, 'Improved how bank trade ratios are shown in mobile portrait mode', undefined, 'https://imgur.com/R1W3ZsH', 'https://imgur.com/CuDJTcG'))
        v179.push(getContent(PatchNoteType.Update, 'Darkened the background of the bank container', undefined, 'https://imgur.com/LaIyZhw', 'https://imgur.com/msXrSDJ'))
        v179.push(getContent(PatchNoteType.Fix, 'Fixed game crashing caused by invalid resolution setting'))
        v179.push(getContent(PatchNoteType.Fix, 'Fixed how bots determine who\'s leading when deciding whether to trade'))
        v179.push(getContent(PatchNoteType.Fix, 'Fixed video ad failure preventing player from entering ranked queue'))

        // Mau
        // Saving dice distribution and goodness of fit to the database
        // Refactored Animation Controller
        // Changing how we detect if a user has adblock enabled

        // Devyesh
        // fix info view for mobile
        // ignoring eslint check for generated spritesheet logic
        // sentry bug fixes - 1

        // Oguz
        // darken bank section bg
        // Extend beginner hints to first game initial placements to show where to click
        // Fix continuous shake animations cause view misplacements
        // Remove ab test - first bot game speed adjustment
        // Remove ab test - trade flow beginner hints
        // Remove ab test- initial placement guide prompts
        // Remove ab test - auto show vp information box
        // Remove ab test - auto show beginner hint description on first hints

        this.patchNotes.push(getPatchNote(2023, 12, 22, 179, v179))

        const v178: PatchNoteContent[] = []
        v178.push(getContent(PatchNoteType.Update, 'Hiring a Designer! <a href="https://colonist.io/careers/designer" target="_blank">Click to apply</a>', [], undefined, undefined))
        v178.push(getContent(PatchNoteType.Update, 'Trade: Right click to select cards to trade with bank!', undefined, undefined, 'https://www.loom.com/share/ef7d21fb01c64d429ac0a9ea7df8f188?sid=649c9d06-2f5d-40aa-90c4-92ede4686003'))
        v178.push(getContent(PatchNoteType.Update, 'Trade: Errors now get highlighted', undefined, undefined, undefined))
        v178.push(getContent(PatchNoteType.Blog, 'Play Colonist on Discord! <a href="https://blog.colonist.io/play-colonist-on-discord/" target="_blank">Read here</a>', [], undefined, undefined, ['https://blog.colonist.io/play-colonist-on-discord/']))

        // Mau
        // Added notification system
        // If a user gets banned all user who reported the user will get a notification popup
        // Saving dice distribution and goodness of fit to the database
        // Fixed stripe recurring payments giving free subscription if payment fails

        // Rob
        // Discord - fix Tag error issue when switching accounts
        // Discord - Fix Discord User saving errors
        // Discord - Fix users logging in to previously unlinked account
        // Discord - Add Holiday Sale 2023 Pass for Discord

        // Devyesh
        // portrait feedback popup
        // fixing all the reconnection issues on mobile
        // Fixed urls for login page
        // Fix blue screen when user did not reconnect

        this.patchNotes.push(getPatchNote(2023, 12, 15, 178, v178))

        const v177: PatchNoteContent[] = []

        v177.push(getContent(PatchNoteType.Update, 'Toggle the accept trade button between accept and pending', undefined, undefined, undefined))
        v177.push(getContent(PatchNoteType.Update, 'New opponent dice transition animation', undefined, 'https://www.loom.com/share/8ec423b492ec49c5b97c3aee5eeb753f', 'https://www.loom.com/share/d3ac3579172246e0992e1dc9ec4fd965'))
        v177.push(getContent(PatchNoteType.Fix, 'Fixed \'Become a Member\' popup in end game screen', undefined, undefined, undefined))
        v177.push(getContent(PatchNoteType.Fix, 'Mobile: Fixed sliding pages getting stuck on multi touch', undefined, undefined, undefined))
        v177.push(getContent(PatchNoteType.Blog, 'Join Our Team blog post! <a href="https://blog.colonist.io/join-our-team/" target="_blank">Read here</a>', [], undefined, undefined, ['https://blog.colonist.io/join-our-team/']))

        // Devyesh
        // Enabled sentry for all the environment
        // new card exchange animation added
        // remove temp game mode
        // removed dev card sounds
        // Removed temp game mode

        // Oguz
        // Fix tiny beginner hints

        // Kyle
        // Added ESLint rule to enforce the use of arrow functions instead of bind
        // Added ESLint rule (no-restricted-syntax) to enforce import instead of require

        this.patchNotes.push(getPatchNote(2023, 12, 8, 177, v177))

        const v176: PatchNoteContent[] = []
        v176.push(getContent(PatchNoteType.Fix, 'Fix Leaderboard data being displayed in the wrong position', undefined, undefined, undefined))
        v176.push(getContent(PatchNoteType.Fix, 'Trade: Removed trading error popups', undefined, undefined, undefined))
        v176.push(getContent(PatchNoteType.Fix, 'Trade: Embargo current turn player not longer throws an error', undefined, undefined, undefined))
        v176.push(getContent(PatchNoteType.Fix, 'Trade: Fixed embargo screen getting stuck in the UI', undefined, undefined, undefined))

        // Mau
        // Updated NPS star asset
        // Adding an endgame popup to incentivize users to go to https://colonist.featureupvote.com/

        // Rob
        // Discord - Collect Data
        // Discord - Fix browser play by using better storage check
        // Karma inactive on Discord
        // Auto-link accounts when logging in with known email
        // Correct Discord user always logs in
        // Karma inactive on Discord
        // Discord - remove html tags from usernames
        // Remove bot names with apostrophes
        // Discord - save DM activity launch data
        // Discord - Show first 12 chars of username in header instead of 'Profile'
        // Discord - Improve user email error popup

        // Devyesh
        // [Fixed Dependency] Updated the dependency of axios from 0.22.0 to 1.6.0
        // [Mobile] Fixed view related bugs which were reported on 7th Nov games
        // [Mobile] Bug fixes for 15th Nov game
        // Replace AIP ads with VLI ads
        // Hide ad if user is not in game
        // add sentry to discord and record everything

        // Oguz
        // Added ABTest - Slow down bots and turn timer for first bot game
        // Added ABTest - Show initial placement information popup on first base game
        // Added ABTest - Replace in-game rulebook popup with how to play slides
        // Added ABTest - Do not show VP Information Box automatically for beginners

        this.patchNotes.push(getPatchNote(2023, 12, 1, 176, v176))

        const v175: PatchNoteContent[] = []

        v175.push(getContent(PatchNoteType.Fix, 'Trade: Prevent accidentally double bank trading during lag', undefined, undefined, undefined))
        v175.push(getContent(PatchNoteType.Fix, 'Trade: Clearing trade window when another player connects', undefined, undefined, undefined))
        v175.push(getContent(PatchNoteType.Fix, 'Trade: Opponent\'s counter offers no longer interrupt ongoing actions', undefined, undefined, undefined))
        v175.push(getContent(PatchNoteType.Fix, 'Trade: Using Year of Plenty now resets all active trades', undefined, undefined, undefined))
        v175.push(getContent(PatchNoteType.Fix, 'Trade: Properly display number of development cards in trade window', undefined, undefined, undefined))
        v175.push(getContent(PatchNoteType.Fix, 'Trade: Bots will wait a full turn before accepting trades for disconnected players', undefined, undefined, undefined))
        v175.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed leaderboards height', undefined, undefined, undefined))
        v175.push(getContent(PatchNoteType.Fix, 'Fixed "Bot Logic Not Supported" message in Cities and Knights', undefined, undefined, undefined))
        v175.push(getContent(PatchNoteType.Fix, 'Fixed Base and Tutorial room popup image inconsistencies', undefined, 'https://imgur.com/KhusmjU', 'https://imgur.com/S6vBLDS'))

        // Mau
        // Discord Bot - Reworked remind logic so it used a fixed schedule
        // Game - Updated to PIXI v6
        // Reworked Balanced Dice to balance 7s in a per player basis

        // Rob
        // Discord - Update store to handle different subscription tiers correctly
        // Active memberships determined by minute, not day
        // Discord prevent double subscriptions backend
        // [Discord Activity] Fixed issues with usernames
        // [Discord Activity] Fixed rematch issues

        // Devyesh
        // Sentry SDK setup and script removed
        // Fixes rulebook and ranked progress bar in mobile
        // Fixes sentry errors which were related to mobile
        // Enable sentry everywhere
        // [Mobile] Fixed view related bugs which were reported on 7th Nov games
        // [Mobile] Bug fixes for 15th Nov game
        // [Mobile] Added feedback if user switches from portrait to landscape

        // Oguz
        // Added ABTest - Step by step trade hints
        // Added ABTest - Display hint information if its the first time the player gets a specific hint
        // Fixed requesting how to play gifs while landing page is not shown

        this.patchNotes.push(getPatchNote(2023, 11, 24, 175, v175))

        const v174: PatchNoteContent[] = []
        v174.push(getContent(PatchNoteType.Feature, 'New Mobile game design! Play in portrait mode by clicking the banner in the Play tab', undefined, undefined, 'https://i.imgur.com/2Z8SwtL.png'))
        v174.push(getContent(PatchNoteType.Fix, 'Fixed Leaderboard header alignment', undefined, 'https://imgur.com/yTzPhoq', 'https://imgur.com/Cnu5fAp'))
        v174.push(getContent(PatchNoteType.Fix, 'Fixed sharing room link on Android', undefined, undefined, undefined))
        v174.push(getContent(PatchNoteType.Blog, 'Colonist Con 2023 blog post! <a href="https://blog.colonist.io/colonist-con-2023/" target="_blank">Read here</a>', [], undefined, undefined, ['https://blog.colonist.io/colonist-con-2023/']))

        // Devyesh
        // Flying card animation replaced with new design
        // Fixed rulebook and ranked progress bar in mobile
        // Enabled sentry everywhere

        // Oguz
        // Added ABTest - Show robber popup for beginners
        // Fixed game popups resize issue

        this.patchNotes.push(getPatchNote(2023, 11, 17, 174, v174))

        const v173: PatchNoteContent[] = []
        v173.push(getContent(PatchNoteType.Update, 'Improved map popup styling', undefined, 'https://imgur.com/WNOOGFV', 'https://imgur.com/PZUeXqJ'))
        v173.push(getContent(PatchNoteType.Fix, 'Map stays centered on window resize', undefined, 'https://www.loom.com/share/4493abee56d8420f97a47949639ce239', 'https://www.loom.com/share/2892f9eda7c744159f57276884addc05'))
        v173.push(getContent(PatchNoteType.Fix, 'Fixed game assets not loading correctly', undefined, undefined, undefined))
        v173.push(getContent(PatchNoteType.Fix, 'Fixed default resolution in Discord Activity', undefined, undefined, undefined))

        // Mau
        // Set esModuleInterop to true in tsconfig.json
        // Removed `pixi-ease` as a dependency and forked it to `@colonist/pixi`
        // Added NPS Form to the end game screen and in the homepage

        // Devyesh
        // Fixed bug where ranking screen after the game end was not loading correctly
        // Removed rotation for spritesheets
        // [Mobile] Fixed the issue where game bot game did not close when the asset popup was closed
        // [Mobile] Added flag to toggle the banner. Users will be able to toggle between portrait and landscape mode
        // [Mobile] Popup added to force users to update the app

        // Oguz
        // Added ABTest - Show how to play in landing page
        // Removed ABTest - Show hints if player is stuck: Kept the feature as discord only
        // Removed ABTest - Show dice number animation on dice rolls: Removed the feature

        this.patchNotes.push(getPatchNote(2023, 11, 10, 173, v173))

        const v172: PatchNoteContent[] = []

        v172.push(getContent(PatchNoteType.Feature, 'Ranked Season 7 has started!'))
        v172.push(getContent(PatchNoteType.Fix, 'Increased the speed of the Assets Loading popup', undefined, undefined, undefined))
        v172.push(getContent(PatchNoteType.Fix, '[C&K] Fixed Merchant not going away from the trade panel if stolen by other players', undefined, undefined, undefined))
        v172.push(getContent(PatchNoteType.Fix, '[C&K] Fixed Barbarian ship not showing up in the tracker for some screen resolutions', undefined, undefined, undefined))

        // Rob
        // Discord - remove dangerous characters from Discord usernames
        // Discord - separate autoreconnect and reconnect banners by voice channel

        // Devyesh
        // Removed rotation for spritesheets
        // [Mobile] Fixed bot game not closing when the assets popup was closed
        // Fixed sprites which had issues. Also updated the spritesheet versioning for better caching
        // Fixed animation logic

        // Kyle
        // Allowed banned players to play bot games

        this.patchNotes.push(getPatchNote(2023, 11, 3, 172, v172))

        const v171: PatchNoteContent[] = []
        v171.push(getContent(PatchNoteType.Fix, 'Improved cards flying animations', undefined, undefined, undefined))
        v171.push(getContent(PatchNoteType.Fix, 'Fixed ranked matchmaking options not showing on mobile browser', undefined, 'https://imgur.com/1Z7c5hS.png', 'https://imgur.com/5xrkjKI.png'))
        v171.push(getContent(PatchNoteType.Fix, 'Fixed room slider overlaping with tooltips', undefined, 'https://imgur.com/Ubrd6rp', 'https://imgur.com/bfOe303'))

        // Jeff
        // Fix karma database bug
        // Added script to automated testing games on server. Created new dice setting and game mode that is hidden on the client
        // Fix single player games getting stuck forever due to server lag

        // Juan
        // Victory Points are now called just Points
        // VLI Lobby Left ad tag fixed

        // Andre
        // Replace rematches with rooms

        // Rob
        // Discord - force hardware acceleration
        // Discord - update rich presence text selection
        // Discord - allow activity on Safari
        // Discord - throw error on incognito windows
        // Discord - fix broken rematch usernames
        // Discord - Remove Invite Friends button from DM voice calls
        // Discord - Use Display names when applicable
        // Discord - fix spectator usernames
        // Discord - only show Premium membership tier

        // Devyesh
        // Fixing preroll ads ads /vli-page
        // Created a script to automate spritesheet generation
        // UI fixes for /vli-page
        // Fixing the navigation issues on mobile
        // [bugfix] remove unknown png links in svgs
        // [Mobile] fix bug to close room when user is kicked

        // Oguz
        // Enable `/changeabtest` command on test servers
        // Improved dice number animations (Affects A/B test group only)
        // Added pointer cursor to in-game information box arrows

        // Kyle
        // Tooltip overlap hover fix

        this.patchNotes.push(getPatchNote(2023, 10, 27, 171, v171))

        const v170: PatchNoteContent[] = []
        v170.push(getContent(PatchNoteType.Update, '+1 Point animation appears when placing settlements or cities', [], undefined, 'https://i.imgur.com/BVWGltr.png'))
        v170.push(getContent(PatchNoteType.Update, '<a href="https://colonist.io/store#membership" target="_blank">Store checkout page</a> shows the Membership renewal date', [], undefined, 'https://i.imgur.com/niPuGTD.png', ['https://colonist.io/store#membership']))
        v170.push(getContent(PatchNoteType.Update, 'Improved Ready text in room', [], 'https://i.imgur.com/ofphxHf.png', 'https://i.imgur.com/gpHigif.png'))
        v170.push(getContent(PatchNoteType.Update, 'Neighbor tiles highlight during initial placements', [], undefined, 'https://imgur.com/4QZhEBJ.png'))
        v170.push(getContent(PatchNoteType.Update, 'Added VP information box', [], undefined, 'https://i.imgur.com/KoInWLc.png'))
        v170.push(getContent(PatchNoteType.Update, 'Removed bots\' offensive usernames'))
        v170.push(getContent(PatchNoteType.Fix, 'Fixed bot trades flashing on screen and instantly closing'))

        // Andre
        // New command /dump-server-state to get a snapshot of the live data
        // Add socket router server

        // Mau
        // Updated checkout page to display when the subscription will renew
        // Added Game Statistics Controller, 7 Dice Rolls Tracker and Time Spent Tracker
        // [Crazy Games] - Removing all references to login and ranked games

        // Rob
        // Discord - Prevent first time user login popup
        // Rename "High Karma Game" as "No Trolls"
        // Remove inapplicable membership perks from Discord membership CTA popup

        // Devyesh
        // [Mobile] Refactor create room flow
        // [Mobile] Fix the top spacing for pause notification
        // [Mobile] Fix floating text info
        // [Mobile] Add hide trade feature on mobile and fix bugs
        // [Mobile] Vote views are always above settings
        // [Mobile] Implemented ads in mobile
        // [Mobile] Fixed reconnection UI for mobile

        // Oguz
        // Initial placement resources are distributed after placing the second building, instead of second road
        // Added ABTest - Show dice number animation on dice rolls
        // Added ABTest - Show hints if player is stuck

        this.patchNotes.push(getPatchNote(2023, 10, 19, 170, v170))

        const v169: PatchNoteContent[] = []

        v169.push(getContent(PatchNoteType.Fix, 'Fixed Ranked games data being saved multiple times'))
        v169.push(getContent(PatchNoteType.Fix, 'Fixed How To Win ribbon animation not going away'))
        v169.push(getContent(PatchNoteType.Fix, 'Fixed building ships with Road Building in Seafarers'))
        v169.push(getContent(PatchNoteType.Fix, 'Fixed multiple mobile bugs'))
        v169.push(getContent(PatchNoteType.Fix, 'Fixed card badges not showing up on Development Cards'))

        // Rob
        // Handle subscription updates when purchased on different platform
        // Discord Premium Rooms feature flag
        // Discord add subscription CTAs
        // Discord add all subscription tiers

        // Devyesh
        // Fixing Road Building for Seafarers
        // [Mobile] Optimized part of the mobile by adding white dropdown arrow
        // [Mobile] Fixing CnK arrow view
        // [Mobile] Fixing issues from game testing and added notifications
        // [Fixed Dependency] Updated the dependency of get-func-name from 2.0.0 to 2.0.2

        // Oguz
        // Added ABTest - Show VP Information Popup on information button clicks
        // Added ABTest -  Highlight connected tiles in initial placements for beginners
        // Removed ABTest - Show Production Tip during initial placements for beginners
        // Removed ABTest - Hide low production corners during initial placements for beginners
        // Removed ABTest - Highlight alternative build locations on build location clicks
        // Removed ABTest - Gained/Lost VP amount is shown after building

        this.patchNotes.push(getPatchNote(2023, 10, 10, 169, v169))

        const v168: PatchNoteContent[] = []
        v168.push(getContent(PatchNoteType.Update, 'New trade view!', [], 'https://i.imgur.com/lsB7aWH.png', 'https://i.imgur.com/a4ULFUQ.jpg'))
        v168.push(getContent(PatchNoteType.Update, 'Points needed to win is shown at the start of the game', [], undefined, 'https://i.imgur.com/WBmpgC4.png'))
        v168.push(getContent(PatchNoteType.Update, 'Removed description from matchmaking popup options', [], undefined, 'https://i.imgur.com/COHZYfv.png'))
        v168.push(getContent(PatchNoteType.Fix, 'Improved game performance'))

        // Andre
        // Move game code into new game package
        // Create standalone game server

        // Mau
        // Crazy Games - Hiding Login when the client detects we are running on CrazyGames iFrame

        // Rob
        // Only update room mode and map when one changes
        // Add back membership section to store
        // Discord - Update membership perks
        // Discord - move Invite Friends button to top right of room
        // Discord - reorganize room CTAs
        // Discord store items have appropriate text
        // Add back membership section to store
        // Discord - improve discord server link image styling
        // Discord - store items have appropriate text
        // Discord - Add back membership section to store
        // Discord - turn on subscriptions
        // Discord - Remove annual memberships
        // Discord - Subscription purchase flow
        // Discord - Fix error styinlg

        // Devyesh
        // [Mobile] Fixed safe area related issues
        // [Mobile] Fixes issue with deeplinking
        // [Mobile] High priority bugs fixed with issues in team game
        // [Mobile] Mobile UI with rating functionality

        // Oguz
        // Removed A/B test for landing page CTAs
        // Added ABTest - Show Production Tip during initial placements for beginners
        // Added ABTest - Hide low production corners during initial placements for beginners
        // Added ABTest - Gained/Lost VP amount is shown after building

        this.patchNotes.push(getPatchNote(2023, 9, 22, 168, v168))

        const v167: PatchNoteContent[] = []
        v167.push(getContent(PatchNoteType.Update, 'Replaced check mark confirmation buttons with placement buttons', undefined, 'https://i.imgur.com/mL7pmpz.png', 'https://i.imgur.com/mEQJDyJ.png', undefined))
        v167.push(getContent(PatchNoteType.Update, 'Improved dice contrast', undefined, 'https://imgur.com/16TLrnZ', 'https://imgur.com/7mEjzR5', undefined))
        v167.push(getContent(PatchNoteType.Fix, 'Disabled chat sound on muted opponent messages', undefined, undefined, undefined))

        // Rob
        // Item panel component
        // Fix player count selection
        // Item panel UI fixes
        // Default color modal not overlapped by mode/map selection images

        // Devyesh
        // Remove unused dependency from package.json
        // webgl-check fixed
        // Codeowners updated
        // [Mobile] Mobile users will only see valid placement locations
        // [Mobile] Fixing bank positions and toggle it's visibility on click only
        // [Mobile] Hide/Show dice when player is taking action
        // [Mobile] Make chat and logs draggable
        // [Mobile] Implemented feedbacks to previous PRs
        // [Mobile] Added dice with higher res svgs
        // [Mobile] Change the default resolution value to 2
        // [Mobile] Fixed positions with various SVGs
        // [Mobile] Updated dice viewbox sizes
        // [Mobile] Implemented Socket disconnection screen and appropriate fixes
        // [Mobile] Added dropdown view on mobile

        // Oguz
        // Implemented A/B test for landing page CTAs
        // Created GameUsedHoverActions event

        // PatAle
        // [Mobile] Hide bottom stats in end game screen ranked
        // Add layer for end game screen
        // Remove private uiGameManager reference in derived help button classes
        // [Mobile] Fixed special build phase button position
        // [Mobile] Moves the city improvement button above the dice
        // [Mobile] Opening build costs closes bank
        // Refactor action button positions
        // [Mobile] open tooltips on press and hold

        this.patchNotes.push(getPatchNote(2023, 9, 8, 167, v167))

        const v166: PatchNoteContent[] = []
        v166.push(getContent(PatchNoteType.Update, 'Updated mode and map selection UI', undefined, 'https://i.imgur.com/W1hqMix.png', 'https://i.imgur.com/FRR22FN.png'))
        v166.push(getContent(PatchNoteType.Update, 'Updated cards discard popup', [], 'https://imgur.com/11HUElg', 'https://imgur.com/NpM3Wre'))
        v166.push(getContent(PatchNoteType.Update, 'Increased animation speed by 20%'))
        v166.push(getContent(PatchNoteType.Update, 'Players can make bots be any owned color'))
        v166.push(getContent(PatchNoteType.Fix, 'Fixed matchmaking connection issues'))
        v166.push(getContent(PatchNoteType.Blog, 'Ranked 1v1 - A Comprehensive Strategy Guide. <a href="https://blog.colonist.io/ranked-1v1-comprehensive-strategy-guide-colonist-io/" target="_blank">Read Here</a>', [], undefined, undefined, ['https://blog.colonist.io/ranked-1v1-comprehensive-strategy-guide-colonist-io/']))

        // Andre
        // Remove SSL for local development
        // Merge matchmaking back into socket server

        // Rob
        // Fix online count alignment
        // Remove Become a Member room CTA for Members

        // Oguz
        // Fixed the "Home" tab displayed an underline when the landing page was shown
        // Standardized "Home" tab button behavior, regardless of where the user is

        // Stan
        // Increased animation speed by 20%

        // PatAle
        // [Mobile] fix end game screen for tablet and current mobile UI
        // [Mobile] Fixed commercial harbor popups
        // [Mobile] fix end game screen bugs and imperfections
        // [Mobile] fix bugs in the current mobile UI
        // Adjust build costs pointer position
        // [Mobile] fix player information view background being cut short

        this.patchNotes.push(getPatchNote(2023, 8, 25, 166, v166))

        const v165: PatchNoteContent[] = []
        v165.push(getContent(PatchNoteType.Update, 'Changed in-room player color select menu to popup', [], 'https://imgur.com/a/DHyi2Gh', 'https://imgur.com/a/ZbImULV'))
        v165.push(getContent(PatchNoteType.Update, 'Trade UI Updated (more fixes coming next version)', [], 'https://i.imgur.com/NH2KEG2.png', 'https://i.imgur.com/raQAuMP.png'))
        v165.push(getContent(PatchNoteType.Fix, 'Fixed game animation speed'))
        v165.push(getContent(PatchNoteType.Fix, 'Changed the "Resign" button to "Leave Game" after the game is over', [], 'https://imgur.com/4Algs9L', 'https://imgur.com/FefFGzM'))

        // Prevent import from colonist package directories (@colonist/types/src)
        // Revert standalone packages
        // Add message queue

        // Rob
        // Remove window size check, since Discord patched their app
        // Fix broken game tooltips
        // [Discord] Handle long usernames across the app
        // Update styling for broadcast top notification
        // Add Discord specific online count
        // [Discord] Update linking error language and make it blocking
        // Don't show Discord games in Lobby room or game/spectate lists
        // [Discord] Add build costs to Discord
        // [Discord] Hide premium room section when host is member; update guest view
        // [Discord] Don't send notification to host
        // [Discord] Deactivate premium room when host leaves
        // [Discord] Make payment last step in premium room flow
        // [Discord] Update room color selection for Discord and premium rooms
        // [Discord] Track online count
        // Refactor Premium Room UI class
        // Track online count for Discord
        // Fix Discord device type setting
        // Fix premium room bug on web

        // Devyesh
        // [Mobile] Fixing the myPlayerController resize bug and conditional CSS removed for mobile
        // [Mobile] Created opponent view for mobile
        // [Mobile] Trading view updated
        // [Mobile] Added dice for opponent player view
        // [Mobile] Fixed all UI related changes and and build flags
        // [Mobile] Fixed bugs related to mobile and tablet

        // Oguz
        // Add google analytics for mobile trade interactions
        // Add metabase events to track beginner behavior

        // Stan
        // upgrade webpack v5
        // Fixed pixi map view resizing on discord
        // Development cards are greyed out in the trade creation window
        // Trade creation tab view is always visible

        // PatAle
        // [Mobile] make tooltips work on toggle
        // [Mobile] implement end game screen
        // v165.push(getContent(PatchNoteType.Fix, 'Add horizontal scroll box to end game screen', [], 'https://imgur.com/OFchPp7', 'https://imgur.com/uQkCfPB'))
        // [Mobile] fixes popups breaking the action circles
        // Refactor UIGameEndStatsController
        // Refactor UIGameEndController
        // [Mobile] make the new mobile UI look good in tablet
        // [Mobile] implements the third popup in the commercial harbor flow
        // v165.push(getContent(PatchNoteType.Fix, 'Change the "Resign" button to "Leave Game" after the game is over', [], 'https://imgur.com/4Algs9L', 'https://imgur.com/FefFGzM'))
        // [Mobile] fix build costs for mobile
        // [Mobile] implement popup where the player is forced to give up a card to an opponent
        // [Mobile] implement popup for select player
        // [Mobile] fixed inventor and diplomat cards
        // Login link in the friends page opens a login popup instead of redirecting to Google login

        // Fahri
        // Moved RandomUtils into utils package
        // Fixed vertical positioning of bank elements https://imgur.com/a/2s9OcHp
        // Fixed warning messages disappearing behind the chatbox

        // Anil
        // Fixed friendly robber tooltip direction

        this.patchNotes.push(getPatchNote(2023, 8, 11, 165, v165))

        const v164v2: PatchNoteContent[] = []
        v164v2.push(getContent(PatchNoteType.Fix, 'Fixed multiple Discord related bugs'))
        this.patchNotes.push(getPatchNote(2023, 7, 31, 164.2, v164v2))

        const v164v1: PatchNoteContent[] = []
        v164v1.push(getContent(PatchNoteType.Feature, 'New trade interface with bank and players tabs', [], 'https://imgur.com/a/vYn6A0e', 'https://i.imgur.com/4Tc2dKo.png'))
        this.patchNotes.push(getPatchNote(2023, 7, 29, 164.1, v164v1))

        const v164: PatchNoteContent[] = []
        v164.push(getContent(PatchNoteType.Update, 'Room settings sliders are hidden from non-host players', [], 'https://imgur.com/a/6ZYMXnE', 'https://imgur.com/a/ChuxjdU'))
        v164.push(getContent(PatchNoteType.Update, 'Dice button in mobile room settings says "Balanced Dice" instead of "Dice"', [], 'https://imgbox.com/6FPVXn21', 'https://imgur.com/PcUzaZT'))
        v164.push(getContent(PatchNoteType.Fix, 'Fixed "Hide Bank Cards" tooltip to suit the new bank UI', [], 'https://imgur.com/nRxWeF9', 'https://imgur.com/dlvo2ZG'))
        v164.push(getContent(PatchNoteType.Fix, 'Fixed incorrect card tooltips', [], 'https://imgur.com/a/ZjGQRWA', 'https://imgur.com/a/ev3TClB'))

        // Juan
        // The VP slider in the mobile room settings goes as low as 3, not 1

        // Andre
        // add nx as the monorepo manager

        // Mau
        // [Discord] Upgraded Discord SDK to 2.0 and added Command Validator

        // Rob
        // Fix broken game tooltips
        // [Discord] Handle long usernames across the app
        // Add Become a Member CTA to room center
        // Make online count have correct number format

        // Devyesh
        // [Mobile] Fixed issue where dev cards popup was not closing

        // Oguz
        // Remove ActivateRedDice event
        // Added ABTest - Highlight alternative build locations when player has resources
        // Refactored UIGameMapHighlightController
        // Refactored UIGameMapHoverController

        // Stan
        // Added block trades option to player popup

        // PatAle
        // [Mobile] implemented discard cards popup
        // [Mobile] implement dice select popup
        // [Mobile] Implement select cards popup
        // [Mobile] implements proper look for dev card popups
        // [Mobile] tapping off a popup will close it
        // [Mobile] Change popup confirmation buttons position
        // [Mobile] remove buttons to move and build ships in seafarers

        this.patchNotes.push(getPatchNote(2023, 7, 27, 164, v164))

        const v163: PatchNoteContent[] = []
        v163.push(getContent(PatchNoteType.Update, 'Dice appear beside opponents on their turn', [], undefined, 'https://i.imgur.com/XejbVpt.png'))
        v163.push(getContent(PatchNoteType.Update, 'Replaced Leaderboards button with Home button in Ranked end game screen', [], 'https://i.imgur.com/TKMFynD.png', 'https://i.imgur.com/jXlnNZS.png'))
        v163.push(getContent(PatchNoteType.Update, 'Improved the new bank UI', [], 'https://i.imgur.com/9QaX5gU.png', 'https://imgur.com/x994eeK.png'))
        v163.push(getContent(PatchNoteType.Fix, 'Fixed "There is no such offer" popup during trades',))
        v163.push(getContent(PatchNoteType.Fix, 'Fixed C&K progress card tooltip', []))

        // Jeff
        // Medium size refacto on how `UserSession` is being in game code. Haven't fully decoupled but removed a lot of references
        // things that could be broken: sending socket data, receiving socket data, connecting/disconnecting, specatating, bot logic, game data validation
        // Ranked Season 6

        // Andre
        // Move locales to packages/i18n/src/locales/

        // Mau
        // Discord: Added Premium Rooms

        // Rob
        // [Discord] Add Rejoin Game CTA text for when player disconnects
        // Fix broken game tooltips
        // Fix game state tooltip

        // Devyesh
        // [Fixed Dependeny] Updated the dependency of semver from 5.7.1 to 5.7.2
        // [Web] Logout bug fixed

        // Oguz
        // Improved solution for the PIXI.Scrollbox bug that caused unexpected shifts on scrolls

        // Stan
        // Replaced Leaderboards CTA button with Home CTA in ranked end game

        // PatAle
        // [Mobile] Fixes action button positions

        // Berke
        // Improved the new Bank UI

        // Fahri
        // Moved TimeUtils into utils package
        // Moved EnumUtils into utils package

        this.patchNotes.push(getPatchNote(2023, 7, 21, 163, v163))

        const v162: PatchNoteContent[] = []
        v162.push(getContent(PatchNoteType.Update, 'Redesigned Bank cards', [], 'https://i.imgur.com/konB2Fg.png', 'https://i.imgur.com/9QaX5gU.png'))
        v162.push(getContent(PatchNoteType.Update, 'Trade with the Bank by clicking on its cards', []))
        v162.push(getContent(PatchNoteType.Update, 'Translated the Rulebook', []))
        v162.push(getContent(PatchNoteType.Fix, 'Fixed room chat messages', [], 'https://imgur.com/GBtE93E', 'https://imgur.com/bGqri6R'))
        v162.push(getContent(PatchNoteType.Fix, '[Mobile] Clicking your own avatar doesn\'t open the browser', []))
        v162.push(getContent(PatchNoteType.Fix, 'Fixed missing semicolon in mobile room chat messages', [], 'https://imgur.com/GBtE93E', 'https://imgur.com/bGqri6R'))

        // Jeff
        // Converted all trade socket msgs to new data type. Converters from old to new system were written
        // Functionality should NOT have changed yet. Only data being communicated has changed (to lay foundation for new system)

        // Andre
        // auto deployment for staging branch to hexs.io
        // auto deployment for development branch to onlinecatan.com
        // moved StringUtils into utils package
        // create server-utils package for code that should not be used on the client
        // npm commands to run colonist without docker

        // Mau
        // Refactor - Refactored Profile Controller on Web to use shared classes
        // update development and ci node version to 18
        // fix spectator commands in game chat
        // remove server startup synchronization

        // Rob
        // [Discord] Enable chat on dev
        // Fix login error translation
        // [Discord] Separate room dropdowns by premium
        // [Discord] Fix broken version number
        // Fix dropdown positions
        // Discord env docs
        // Remove Beaner from name list
        // [Discord] Fix game freeze when switching between pip mode
        // [Discord] Fix Vote popup size
        // [Discord] Translate discord room center text
        // [Discord] Update landing page CTA

        // Devyesh
        // added env variable USERS_CAN_ACCESS_ALL_COMMANDS_IN_TEST_SERVER and removed AdminAccessController

        // Oguz
        // added env variable MATCHMAKING_TESTING_ON_DEVELOPMENT_AND_STAGING and removed SEASON_RANKED_TESTING_VICTORY_POINTS variable

        // Stan
        // Remove internal pixi.js implementation
        // Translated img alts
        // Converted /disable-ad-block page to standard singleton page
        // Improved footer styling, fixed language popup and sidebar overlap

        // PatAle
        // [Mobile] position and style player information counters in cities and knights
        // [Mobile] position player information arrow (cities and knights)
        // [Mobile] add merchant view
        // [Mobile] adjust player username
        // Refactor longest road view and largest army view
        // [Mobile] Move longest road counter
        // [Mobile] Change position of progress card view in c&k
        // Remove green line in the rulebook tabs

        // Fahri
        // Moved ArrayUtils into utils package
        // Moved ObjectUtils into utils package

        this.patchNotes.push(getPatchNote(2023, 7, 7, 162, v162))

        const v161: PatchNoteContent[] = []
        v161.push(getContent(PatchNoteType.Update, 'Added options popup in the end game players list', [], undefined, 'https://imgur.com/2E8pm8b.png'))
        v161.push(getContent(PatchNoteType.Fix, 'Fixed resolution issues caused by resizing window'))
        v161.push(getContent(PatchNoteType.Fix, 'Resign button no longer changes after refreshing'))
        v161.push(getContent(PatchNoteType.Fix, 'Dropdown texts no longer take more than 1 line', [], 'https://imgur.com/nGBUSLR', 'https://imgur.com/sttBHhj'))

        // Jeff
        // Create GitHub workflow to trigger pre-translation using machine translation on Crowdin

        // Andre
        // Move KatanConfig and KatanSetting from shared/ to server/
        // Show extended version info as hint on the footer version on deployed servers
        // Remove /branch
        // Replace AccessLevel.Customer with User.isCustomer
        // Automatic revisions for statically included assets
        // Render queue to avoid rendering blocking the server
        // Move AccessLevel and BidId into @colonist/types. Update the deprecated imports when you edit files

        // Mau
        // Move AccessLevel and BigId into @colonist/types. Update the deprecated imports when you edit files
        // Create @colonist/server-chat package

        // Rob
        // Fix multiple "Has left game" messages in logs
        // Fix broken UI for owned and subscribed store items
        // [Discord] Enable store and Coin IAPs
        // Fix broken store image
        // Fix broken translation in endgame membership incentive popup
        // Add /cancelmembership command to all environments

        // Devyesh
        // Added part of mobile UI

        // Oguz
        // A/B test always on build highlight circles for beginners
        // v161.push(getContent(PatchNoteType.Update, 'Added options popup for end game player name & icon clicks', [], undefined, 'https://imgur.com/2E8pm8b.png'))

        // Berke
        // Update scrollbar for opponent player array
        // Redesigned board hover action buttons

        // Stan
        // Fixed public node_modules and code/client vulnerability

        // PatAle
        // [Mobile] Move largest army counter
        // [Mobile] Add card confirmation popups to the new mobile design
        // [Mobile] Moves event die to proper position
        // v161.push(getContent(PatchNoteType.Update, 'Small change to achievement popup', [], 'https://imgur.com/MuV9NL1', 'https://imgur.com/dlUUfGa'))
        // Adds achievement popups to mobile
        // v161.push(getContent(PatchNoteType.Fix, 'Resign button no longer changes on refresh'))
        // Remove background on icons from player logs and chat
        // Added semibold font for dev card titles, achievement popups, and usernames in chat and game logs
        // v161.push(getContent(PatchNoteType.Fix, 'Tooltip pointer stays on tooltip', [], 'https://imgur.com/pAVgOQY', 'https://imgur.com/ENIqtql'))
        // v161.push(getContent(PatchNoteType.Update, 'Add pointer to build costs', [], 'https://imgur.com/ejWUsF1', 'https://imgur.com/dxdzYJ1'))
        // Refactor broadCastChatData
        // Add pointer to build costs
        // Tooltip pointer stays on tooltip
        // Usernames are properly colored when larger username contains smaller one

        // Fahri
        // Refactor UIGamePopupController to use its derived classes for mobile and web popups

        this.patchNotes.push(getPatchNote(2023, 6, 23, 161, v161))

        const v160: PatchNoteContent[] = []
        v160.push(getContent(PatchNoteType.Feature, '<b>Translations are live!</b> <i>Some words might be inaccurate; these will get fixed in upcoming updates</i>'))
        v160.push(getContent(PatchNoteType.Update, 'Redesigned game logs', [], 'https://i.imgur.com/1fndCZR.png', 'https://i.imgur.com/NMEEPbH.png'))
        v160.push(getContent(PatchNoteType.Update, 'New Achievements UI', [], 'https://imagizer.imageshack.com/img923/6131/zcv9IE.png', 'https://imgur.com/7wzV4UK.png'))
        v160.push(getContent(PatchNoteType.Update, 'Added tooltips for trade ratios & hidden bank resources', [], undefined, 'https://i.imgur.com/WDiBFGh.jpg'))
        v160.push(getContent(PatchNoteType.Update, 'Redesigned Build Cost popup and made it accessible to all game modes', [], 'https://i.imgur.com/iWN6RPi.png', 'https://i.imgur.com/cnhTkT5.png'))
        v160.push(getContent(PatchNoteType.Update, 'Change \'Leave Game\' button to \'Resign\' in 1v1 games', [], 'https://i.imgur.com/J2FFMLN.png', 'https://i.imgur.com/4huJbmz.png'))
        v160.push(getContent(PatchNoteType.Update, 'Add pointer to tooltips', [], undefined, 'https://i.imgur.com/IN07yvK.png'))
        v160.push(getContent(PatchNoteType.Update, 'Redesigned voting interface', [], 'https://i.imgur.com/ZTKLwPT.png', 'https://i.imgur.com/y7HNSlz.png'))
        v160.push(getContent(PatchNoteType.Update, 'Timer ticks on 10 seconds left instead of 5'))
        v160.push(getContent(PatchNoteType.Update, 'Removed error message for multiple responses to trade offers', [], 'https://i.imgur.com/ss9us5W.png', undefined))
        v160.push(getContent(PatchNoteType.Update, 'Buy Dev Card button now shows a dev card instead of an icon', [], 'https://i.imgur.com/zuiBaHa.png', 'https://i.imgur.com/bPdtQ4k.png'))
        v160.push(getContent(PatchNoteType.Fix, 'Fixed highlighting spots in the board after the game is over', [], undefined, undefined))

        // Juan
        // Disabled settings menu for spectators
        // Added cancel option for the room kick player popup

        // Andre
        // Added command to deploy PR to new dev servers. Comment a PR with `/deploy-dev name` to start the deployment. A check will be added that's done when it's finished
        // Option to store logs files in DO spaces
        // Option to change the JWT cookie name
        // Removed AccessLevel Player and Guest
        // Send in game chats through new GameChatSubmit action

        // Mau
        // [Moderation] Added a new command to change google auth email of a user
        // [Discord] Disabling karma
        // [Discord] Explaining what Discord Scopes do
        // [Discord] Added auth error analytic
        // [Discord] Discord-specific maintenance page
        // Implemented Channel Architecture
        // [Discord] Updated isDiscordIntegrationServer to also be true on a specific env variable

        // Rob
        // Added new About section
        // [Discord] Removed Karma references from Discord
        // [Discord] Updated linking error
        // [Discord] Removed white border from spectator UI
        // [Discord] End game when last player leaves or disconnects
        // [Discord] Fixed broken port / dead zone on screen

        // Devyesh
        // [Mobile] Implemented the layouts of the game UI

        // Oguz
        // Added ABTest - Display Tutorial in first base game

        // Berke
        // Added ABTest - Display Home CTA on ranked end game
        // v160.push(getContent(PatchNoteType.Update, 'Added cancel option for the kick popup in the game room', [], 'https://imgur.com/Qy6DjYn', 'https://imgur.com/QzL5pgn'))
        // v160.push(getContent(PatchNoteType.Update, 'New disabled button design for spectators', [], 'https://imgur.com/ih4D8iP', 'https://imgur.com/rdoC4vq'))

        // PatAle
        // Clicking back in settings does not close settings
        // [Mobile] Reduce chat and log size to half of the screen
        // Refactor game logs
        // v160.push(getContent(PatchNoteType.Update, 'Add colored background to game logs and chat', [], 'https://imgur.com/9X2abmt', 'https://imgur.com/eKgGnCX'))
        // v160.push(getContent(PatchNoteType.Update, 'New voting view', [], 'https://imgur.com/ZTKLwPT', 'https://imgur.com/y7HNSlz'))
        // [Mobile] Change timer location on mobile
        // v160.push(getContent(PatchNoteType.Update, 'Timer ticks on 10 seconds left instead of 5'))
        // [Mobile] Changed tool tips styling for mobile
        // [Mobile] Changed timer location on mobile
        // [Mobile] Added tooltips to mobile
        // Chat recognizes usernames with wrong capitalization
        // [Mobile] Implemented new dice view in mobile

        // Fahri
        // Removed UIMGameStateController in UIMGameManager

        this.patchNotes.push(getPatchNote(2023, 6, 14, 160, v160))

        const v159: PatchNoteContent[] = []
        v159.push(getContent(PatchNoteType.Update, 'Updated player view in end-game screen', [], 'https://i.imgur.com/lzYugw7.png', 'https://i.imgur.com/dPJsOYU.jpg'))
        v159.push(getContent(PatchNoteType.Update, 'Added tooltips for trade ratios & hidden bank resources', [], undefined, 'https://i.imgur.com/dB1cBH6.jpg'))
        v159.push(getContent(PatchNoteType.Update, 'Added loading animation to mobile login buttons', [], undefined, 'https://i.imgur.com/Strn6xa.png'))
        v159.push(getContent(PatchNoteType.Update, 'Removed player color from chat messages', [], 'https://i.imgur.com/p0AsjcI.png', 'https://i.imgur.com/AdthBj9.png'))
        v159.push(getContent(PatchNoteType.Update, 'Volume can be adjusted by clicking anywhere on the slider', [], '', 'https://i.imgur.com/0Pz3j7I.png'))
        v159.push(getContent(PatchNoteType.Fix, 'Fixed players getting stuck on settings page after game ends', [], 'https://i.imgur.com/Ya1JHuF.png', undefined))
        v159.push(getContent(PatchNoteType.Fix, 'Fixed single pages scrolling to the bottom of the page', [], undefined, undefined))
        v159.push(getContent(PatchNoteType.Fix, 'Fixed end-game ad not fitting on smaller screens', [], 'https://i.imgur.com/qodMgC0.png', 'https://i.imgur.com/yi3Tbbj.jpg'))
        v159.push(getContent(PatchNoteType.Fix, 'Fixed robber and port tooltips not appearing on your turn', [], '', 'https://i.imgur.com/5lAbKHC.png'))
        v159.push(getContent(PatchNoteType.Fix, 'Mobile: game history in profile stays on screen when scrolling'))

        // Goku
        // Added temporary features:
        // Created new JWT keys to fix the leaked JWT keys for leaked .env file
        // Added temporary JWT functions to migrate old JWT keys to new JWT keys
        // Moved Google Auth credentials to a new gmail account
        // Updated SyncServerStart to include no server clusters without Matchmaking servers
        // Added new docker entry points to be able to test Double servers
        // We can use empty Mixpanel token

        // Andre
        // Replace the socket commands to list rooms and games with endpoints that can be cached
        // Fixed hover button shaking bug
        // Mobile room mode and map selection bug

        // Mau
        // [Discord] Change Avatar and Username to user Server Avatar and Username
        // [Discord] Using the same Game ID to create a rematch
        // [Discord] Allowing users to join back into a room if they were kicked

        // Devyesh
        // [Mobile Game UI] Architected the folder structure of the new game UI
        // [Mobile Game UI] UIMGameCanvasController decoupled for web and mobile
        // reset cache on server movement

        // Rob
        // [Discord] Don't show patch notes on new version load
        // [Discord] Replace default log messages with Discord-specific one
        // [Discord] Fix room settings being interactable as guest
        // [Discord] Force bots and disconnected players to show bot icon
        // [Discord] Fix broken rematch
        // Don't send rematch create/join chat message to player who created/joined rematch room
        // [Discord] More appropriate error popup
        // [Discord] Refactor external links to always open our Discord channel url
        // Add maintenance page for when servers are down

        // PatAle
        // [Mobile] Apply voting view positioning
        // [Mobile] Fix sliders appearing over game mode/map menu

        this.patchNotes.push(getPatchNote(2023, 5, 26, 159, v159))

        const v158: PatchNoteContent[] = []
        v158.push(getContent(PatchNoteType.Feature, '<b>Hover mechanics: click on the board to build!</b>', [], undefined, 'https://i.imgur.com/H9fpos0.png'))
        v158.push(getContent(PatchNoteType.Update, 'Added confetti animation to the victory screen 🎊'))
        v158.push(getContent(PatchNoteType.Update, 'Mobile: Added separators to room settings sliders', [], undefined, 'https://i.imgur.com/nQIGLGE.png'))
        v158.push(getContent(PatchNoteType.Update, 'Mobile: screen stays on while playing the game', [], undefined, undefined))
        v158.push(getContent(PatchNoteType.Update, 'Simplified the tooltips in endgame graphs', [], 'https://i.imgur.com/YTd2hOc.png', 'https://i.imgur.com/jz6fOhD.png'))
        v158.push(getContent(PatchNoteType.Update, 'Updated the ranked subdivisions roman numerals', [], undefined, 'https://i.imgur.com/mBLGO9W.png'))
        v158.push(getContent(PatchNoteType.Fix, 'Fixed dev card info popups overlapping with the trade UI', [], 'https://i.imgur.com/18uA6yb.png', undefined))
        v158.push(getContent(PatchNoteType.Fix, 'Fixed resource stats graph overflowing', [], 'https://i.imgur.com/qLCsiqb.png', 'https://i.imgur.com/zQdeGTi.png'))

        // Jeff
        // Delete `EnglishText.ts` after translating the remaining strings.

        // Andre
        // prevent the server from possibly hanging when a new version is deployed
        // remove User entity email

        // Mau
        // [Discord] Adding Util that clears Discord Cache
        // Refactored uiManager into its own singleton class
        // [Discord] Added child iframe entrypoint to separate discord from web
        // [Discord] Auto updating the main CTA based on room status and player count
        // [Discord] Changed Discord Channel URL to `Official Discord Server`, removed online count and games played, simplified title

        // Devyesh
        // abstracted if user has cnk mode to shared folder
        // debug release release for android and iOS
        // [Mobile] Bug fixes for mobile
        // [Mobile] Corrected button text
        // [Mobile] Sentry errors fixing
        // [Mobile] Mobile bugs fixed II
        // rulebook made to load only when required
        // [Mobile] Apple login fix
        // [Mobile] bug fixes
        // Hover action caching issue fixed

        // Rob
        // [Discord] Removed chat box and mute button for Discord
        // Auto-reconnection feature, enabled on Discord

        // Stan
        // v158.push(getContent(PatchNoteType.Update, 'Added confetti animation to the victory screen 🎊'))
        // improved rulebook spacing at bottom of scroll view
        // fixed auth-link discord erroring if user cancelled login
        // refactored ShakeAnimation class for UIPlacementConfirmationButton

        // PatAle
        // Change rank subdivision (the roman numeral) image https://imgur.com/a/H8dso4B

        // Berke
        // Updated player profile action menu design https://imgur.com/SW0cmYr

        this.patchNotes.push(getPatchNote(2023, 5, 12, 158, v158))

        const v157: PatchNoteContent[] = []
        v157.push(getContent(PatchNoteType.Fix, 'Fixed mobile scaling, popups, and other bugs'))
        v157.push(getContent(PatchNoteType.Update, 'Updated endgame graphs UI', [], 'https://imgur.com/a/suuaxVL', 'https://imgur.com/a/LhcYzNW'))
        v157.push(getContent(PatchNoteType.Update, 'Updated Victory Point dev card popup', [], 'https://imgur.com/a/ah1e6Bk', 'https://imgur.com/QZjFtZL'))

        // Mau
        // [API Cleanup] Cleaned up the profile API endpoints with the new error handling architecture
        // [Discord] Updated Loading Screen Image
        // [Discord] Made Store Single Page Application to avoid using Multi Page Applications on Discord Activities
        // [Auth] Fixed page breaking when user cancelled login with discord
        // [Moderation] Added new command to delete all login providers from a user

        // Devyesh
        // [Mobile] Create private room on Create room
        // [Mobile] Corrected incentive popup
        // [Mobile] Corrected button text

        // Rob
        // [SEO] removed language paths that map to other languages from page heads
        // [SEO] made store page title h1, not h2
        // [Discord] Added Invite Friends button in room settings
        // [SEO] made job page titles unique
        // more translation fixes

        // Oguz
        // [Mobile] game settings rules information button & popup implementation

        this.patchNotes.push(getPatchNote(2023, 4, 28, 157, v157))

        const v156v1: PatchNoteContent[] = []
        v156v1.push(getContent(PatchNoteType.Fix, 'Fixed mobile resolution and other bugs'))

        // Devyesh
        // [Mobile] Bug fixes for mobile
        // [Mobile] added sentry dsn

        // Rob
        // translation bugs
        // cancelmembership command

        // Berkay
        // v157.push(getContent(PatchNoteType.Update, 'New tooltip design', [], 'https://imgur.com/a/dKiRz6w', 'https://imgur.com/a/7MKkYxw'))

        this.patchNotes.push(getPatchNote(2023, 4, 16, 156, v156v1))

        const v156: PatchNoteContent[] = []
        v156.push(getContent(PatchNoteType.Update, 'New Mobile app menu interface!', [], undefined, 'https://i.imgur.com/Iizmr4i.jpg'))
        v156.push(getContent(PatchNoteType.Update, 'Redesigned end game screen', [], 'https://imgur.com/a/yeIVnWY', 'https://imgur.com/a/B6NVKDo'))
        v156.push(getContent(PatchNoteType.Update, 'Access Blog from the footer', [], undefined, 'https://imgur.com/a/qgekw46'))
        v156.push(getContent(PatchNoteType.Update, 'Removed trash can button from room lobby chat'))
        v156.push(getContent(PatchNoteType.Blog, 'Interview with ThePhantomCatan! <a href="blog.colonist.io/thephantomcatan-interview/" target="_blank">Read Here</a>', [], undefined, undefined, ['blog.colonist.io/thephantomcatan-interview/']))

        // Jeff
        // Translate file `ViewPopup.ts` which was used everywhere in the frontend
        // Small refactor to store strings in the backend. All purchasing should be tested this version.
        // Translate leaderboard
        // Translate store

        // Devyesh
        // [Mobile] refactored react native code
        // [Translation] Translated games settings page
        // [Mobile] update app popup removed
        // [Mobile] resize fix removed for old app

        // Rob
        // Blacklisted more chat terms
        // Fixed majority of web vitals issues
        // Fixed translation caching issues
        // Translated Error messages
        // Activated login and email list

        // Oguz
        // Implemented basic ranked eligibility check on frontend
        // Refactored KeyBindController so that it is a Singleton class
        // Fixed height difference of room chat box speaker icon and header text
        // Removed medal icons from end game screen

        this.patchNotes.push(getPatchNote(2023, 4, 14, 156, v156))

        const v155: PatchNoteContent[] = []
        v155.push(getContent(PatchNoteType.Feature, 'Ranked Season 5!'))
        v155.push(getContent(PatchNoteType.Fix, 'Added contract button in fullscreen mode'))
        v155.push(getContent(PatchNoteType.Fix, 'Fixed Community page spacing'))
        v155.push(getContent(PatchNoteType.Fix, 'Fixed level 3 city improvement sound in C&K'))
        v155.push(getContent(PatchNoteType.Fix, 'Improved date format in /profile#history'))

        // Jeff
        // refactor i18n backend to include type safety and wrap translation in try/catch

        // Rob
        // Do not surface login incentive popup when clicking information icon on ranked match buttons
        // Fix back issues and room exit button for other languages
        // Fixed text issues

        // Mau
        // [Mobile] Adding profile controller
        // [Mobile] Adding a URL route that renders the mobile entry point
        // [Mobile] Adding room controller
        // [Mobile Expo] Added automatic version checker
        // [Mobile] Adding logout button
        // [Mobile] Not allowing certain sounds to play on mobile when the app is in the background

        // Devyesh
        // removed mobile entry point
        // [Mobile] leaderboard, store, ios, android app pushed

        // Omar
        // Change language behavior in link from: only appears when non-selected (selected shows `/`) to: always appears
        // Remove temp landing pages

        this.patchNotes.push(getPatchNote(2023, 3, 31, 155, v155))

        const v154: PatchNoteContent[] = []
        v154.push(getContent(PatchNoteType.Feature, 'Karma filter setting for room games', [], undefined, 'https://i.imgur.com/U5oIsgm.jpg', ['https://colonist.featureupvote.com/suggestions/68123/add-karma-filter-setting-when-creating-a-new-game']))
        v154.push(getContent(PatchNoteType.Update, 'Disabled emojis from usernames', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/83647/disable-emojis-from-usernames']))
        v154.push(getContent(PatchNoteType.Update, 'Exiting room now takes users to Lobby'))
        v154.push(getContent(PatchNoteType.Update, 'Room hosts are no longer notified when changing settings'))
        v154.push(getContent(PatchNoteType.Fix, 'Fixed Bots not trading with bank in Ranked games'))
        v154.push(getContent(PatchNoteType.Fix, 'Fixed broken "back" button', [], undefined, 'https://www.loom.com/share/a37f55c581644b05b58c6ba1d2ea0dc1'))

        // Goku
        // Fixed hexs.io being indexed by search engines
        // Added sitemap.xml to robots.txt
        // Edited out FE, QA, Anything forms and ads

        // Jeff
        // Add device type enum to session table
        // Translation dev environment fixes: ignore all files but english
        // Translation dev environment fixes: configured linter for json files
        // Translation dev environment fixes: added type safety to translation keys
        // Season 5 backend is ready

        // Juan
        // Lower and upper limits for card discarding changed to 5 and 20

        // Rob
        // Remove ABTest for Login Incentive Popup
        // Update conditions and buttons that cause Login Incentive Popup to appear
        // Added /giftmembership command on dev

        // Mau
        // [Mobile] Adding bottom nav slider animation
        // [Mobile] Refactoring UIMSingletonPageController to a generic UIMFullscreenPageController class
        // [Mobile] Adding button styles
        // [Mobile] Adding lobby style
        // [Mobile] Adding Profile Design

        // Devyesh
        // [Mobile] menu completed
        // Enabled mobile route only in development build
        // [Mobile] matchmaking view complete
        // [Mobile] notifications added
        // Added error log on pixi image load fail

        this.patchNotes.push(getPatchNote(2023, 3, 17, 154, v154))

        const v153: PatchNoteContent[] = []
        v153.push(getContent(PatchNoteType.Update, 'Disable bot trading in Ranked games', [], undefined, undefined))
        v153.push(getContent(PatchNoteType.Fix, 'Improved matchmaking connection to start a game'))
        v153.push(getContent(PatchNoteType.Fix, 'Remove notification showing in room when loading saved settings'))
        v153.push(getContent(PatchNoteType.Blog, 'Answering The Most Common Catan Questions! <a href="https://blog.colonist.io/catan-faq/" target="_blank">Read here!</a>', [], undefined, undefined, ['https://blog.colonist.io/catan-faq/']))

        // Jeff
        // Fixed broken socket messages `InteractedWithSite`, `SetAdBlockStatus` and `SaveClientReferrer` dropping data when database lags
        // Fixing multi-server problems with `SaveClientReferrer` not working on matchmaking server
        // Fixed frontend issue with UIReferralController not being able to track referrers when socket is not initiated
        // Fix session logic not creating a database instance for every session created on server
        // Update error structure on APIs: /api/leaderboards-tabs/, /api/leaderboards-my-sticky-row-data/, /api/leaderboards/:rankedModeType/, /api/leaderboards-username-search/ and /api/find-game-ranked-state

        // Omar
        // remove Omar from about page
        // fix translations loading incorrectly in profile page

        // Logan
        // v153.push(getContent(PatchNoteType.Update, 'Disable bot trading in ranked games', [], undefined, undefined))

        // Rob
        // new abtest login popup

        // Mau
        // [Mobile] Created initial classes
        // [Mobile] Adding Text Styles CSS
        // [Mobile] Adding Color Styles CSS
        // [Mobile] Adding swiping body gestures
        // [Mobile] Adding header html and css
        // [Mobile] Adding footer html and css

        // Devyesh
        // [Refactor] created mobile, web and shared parts
        // [Refactor] removed currentUserState dependency as global variable
        // [Fixes] added UIReferralController to shared
        // [Refactor] socket load test file removed
        // [Mobile] rotation removed from iOS build
        // [Refactor] fixed mobile workflow and completed the boilerplate
        // Fixing width of setting menu
        // [Mobile] added singleton pages
        // [mobile] able to play matchmaking game

        this.patchNotes.push(getPatchNote(2023, 3, 3, 153, v153))

        const v152: PatchNoteContent[] = []
        v152.push(getContent(PatchNoteType.Feature, 'Added Fullscreen button and keyboard shortcut (F)', [], undefined, 'https://i.imgur.com/v1hx2me.jpeg', undefined))
        v152.push(getContent(PatchNoteType.Update, 'Mobile App: show Progress Cards by tapping in Cities & Knights', [], undefined, 'https://i.imgur.com/bAnNdPJ.png', undefined))
        v152.push(getContent(PatchNoteType.Update, 'Hit Escape key to close game settings', [], undefined, undefined))
        v152.push(getContent(PatchNoteType.Update, 'Add volume % in corner notification popup when hitting up/down arrows', [], undefined, 'https://i.imgur.com/Mf3hzXq.png', undefined))
        v152.push(getContent(PatchNoteType.Update, 'Updated font to Open Sans', [], undefined, undefined))
        v152.push(getContent(PatchNoteType.Fix, 'Fixed sounds loading time'))
        v152.push(getContent(PatchNoteType.Fix, 'Mobile app: centered the place robber circles'))
        v152.push(getContent(PatchNoteType.Blog, 'What is the Most Popular Catan Expansion? <a href="https://blog.colonist.io/best-catan-expansions/" target="_blank">Find out!</a>', [], undefined, undefined, ['https://blog.colonist.io/best-catan-expansions/']))

        // Jeff
        // Add session id to player games table, this will only update if defined. May contain bugs in the session side of the code.
        // Add first session id to user table
        // Added referral system to track referrer and referralCodes in our database (in session)

        // Omar
        // Stop using webpack to bundle client translations and use http backend instead

        // Logan
        // Add click analytic for full screen

        // Andre
        // Remove compiled files when calling `make clean` or `make clean-all` (to fix enum sync issues)

        // Mau
        // Cleaning up /api/analytic-events, /api/profile-edit/username, /api/profile-edit/add-friend-request, /api/profile-edit/accept-friend-request and /api/profile-edit/remove-friend to use the new error handling system
        // Adding ban and unban commands
        // Added underline when hovering over account emails in the Account Settings page
        // Adding disconnect command to disconnect a user from the socket server
        // Reconnect to socket server when the user is disconnected inside the game
        // Appending game id to url when starting bot game
        // Refactored auth error handling system
        // Changing expo project id config so the build is shared to all team members

        // Devyesh
        // updated ua-parser-js from 0.7.32 to 0.7.33 in /code/mobile_rn
        // removed mobile flutter folder

        this.patchNotes.push(getPatchNote(2023, 2, 17, 152, v152))

        const v151: PatchNoteContent[] = []
        v151.push(getContent(PatchNoteType.Feature, 'New keyboard shortcuts: Mute sounds (M), Volume (up/down arrows), Pause (P)', [], undefined, 'https://i.imgur.com/4NhWV9J.jpg'))
        v151.push(getContent(PatchNoteType.Feature, 'Change email associated with account', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/87007/enable-changing-email-associated-with-account']))
        v151.push(getContent(PatchNoteType.Feature, 'Remove login providers from your account', [], undefined, 'https://i.imgur.com/hZhGsO8.jpg'))
        v151.push(getContent(PatchNoteType.Update, 'New in-game Settings', [], 'https://imgur.com/a/oyrIVpp', 'https://imgur.com/a/Swf8FNz'))
        v151.push(getContent(PatchNoteType.Update, 'Decreased ranked wait times'))
        v151.push(getContent(PatchNoteType.Update, 'Updated city improvements sound effects in C&K', [], undefined, undefined, ['https://www.youtube.com/watch?v=oByHuuxq1BA']))
        v151.push(getContent(PatchNoteType.Fix, 'Mobile app: fixed chat font size being too big'))
        v151.push(getContent(PatchNoteType.Fix, 'Mobile app: fix button sizes in game to be easier to click'))
        v151.push(getContent(PatchNoteType.Fix, 'Fixed matchmaking connection issues'))
        v151.push(getContent(PatchNoteType.Blog, 'Interview with Bo Peng, US Catan National Champion! <a href="https://blog.colonist.io/bo-peng-interview/" target="_blank">Read here</a>', [], undefined, undefined, ['https://blog.colonist.io/bo-peng-interview/']))

        // Goku
        // Fixed Stripe Membership Management Portal back button leading to //store

        // Jeff
        // Refactor API error handling system to automatically, catch, log and send errors
        // Frontend receives error and just automatically handles the error

        // Omar
        // Fix the profile area in 404 page behaving wrongly
        // Fix some SVGs having the wrong paths causing spams to wrong paths

        // Logan
        // Implement multiple audio groups using audio sprites. This will support grouped audio such as music and SFX
        // rename a bunch of sound files to decrease entropy
        // Fix image path for ranked profile and sign in private ad
        // Remove room popup to only showing membership popup when entering site and finishing a game
        // Fix cities and knights sounds so metro and lvl3 play for all players, not just the one receiving
        // Fix login popup dimensions on mobile

        // Rob
        // Changed most expensive coin package banner to be 'Best Value' instead of 'Best Price'
        // Add comma to online players figure when 1,000 or greater

        // Mau
        // Refactored user-state, user-login-state and stats api to use new error handling system
        // v151.push(getContent(PatchNoteType.Feature, 'Remove login providers from your account'))
        // v151.push(getContent(PatchNoteType.Feature, 'Change Email Associated with Account', ['v'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/87007/enable-changing-email-associated-with-account']))

        // Devyesh
        // Feature flags removed. MobileDownloadOnLandingPage defaulted to true and HideLoginOnMobile defaulted to false
        // implemented new UX for settings options
        // implemented pause functionality
        // Updates ua-parser-js from 1.0.2 to 1.0.33
        // added precommit hook for lint testing

        // Simon
        // Fix meta descriptions for Terms of Use, Refund Policy, and Press Kit

        this.patchNotes.push(getPatchNote(2023, 2, 5, 151, v151))

        const v150: PatchNoteContent[] = []
        v150.push(getContent(PatchNoteType.Update, 'Mobile app: removed landing page, Home page shows instead'))
        v150.push(getContent(PatchNoteType.Fix, 'Mobile app: Fixed scrolling in single pages'))
        v150.push(getContent(PatchNoteType.Fix, 'Fix Home page to show ranked buttons on smaller screens'))
        v150.push(getContent(PatchNoteType.Fix, 'Cities & Knights: don\'t distribute Progress Cards if there aren\'t enough of that type in the bank'))
        v150.push(getContent(PatchNoteType.Fix, 'Fixed avatars sometimes not loading in-game'))
        v150.push(getContent(PatchNoteType.Fix, 'Fixed oversized font size on iOS devices'))
        v150.push(getContent(PatchNoteType.Blog, 'Colonist 2022 Summary! <a href="https://blog.colonist.io/colonist-io-2022-summary/" target="_blank">Read here!</a>', [], undefined, undefined, ['https://blog.colonist.io/colonist-io-2022-summary/']))

        // Goku
        // v150 Hotfix: Updated store annual price texts https://github.com/colonistio/katan/pull/9721

        // Jeff
        // Refactor out all usage of `req: any` and `req as any` in our API calls
        // Refactor `req.colonistVariables.user` to reduce number of database calls for APIs
        // Build error handling framework for APIs

        // Juan
        // Removed santa robber from the board and disabled it from the store

        // Omar
        // Fix FAQ `<html lang>` attribute
        // Make the title of each rulebook page depend on the page

        // Alex

        // Logan
        // v150.push(getContent(PatchNoteType.Feature, 'Add Button to select Language'))
        // create ejs varaible for isUserOnMobileBrowser to distinguish between mobile devices and mobile app
        // fix account linking homepage and private ads
        // Move ranked subdivision img to be to the right of the division icon
        // Remove some unnecessary logging from front end console
        // updated backend logic for checking number of progress cards available in bank before distributing
        // Fix hover state for login popup buttons

        // Rob
        // Link end of game Leaderboards popup button to leaderboard of that game mode
        // Fixed UI bug where tile numbers still appeared clickable after using Inventor in C&K

        // Andreme
        // Add generic audit event table

        // Mau
        // Fixed Async Asset Loader isImageAlreadyDownloaded giving false positives when the object was defined, but the texture undefined
        // Show Login popup when clicking on `log in` href on leaderboards and matchmaking error
        // React Native - Initial Project Setup
        // React Native - Adding Splashscreen
        // React Native - Adding Server Toggle Button
        // React Native - Adding React Global State Management using React Context
        // React Native - Adding Communication Bridge between React Native and Webview
        // React Native - Adding Tracking Transparency Popup on Initialization
        // React Native - Adding Make Command to run React Native App

        // Devyesh
        // v150 Hotfix: Fixed apple auth login
        // auth redirect url fixed
        // hide ads when user is on mobile

        this.patchNotes.push(getPatchNote(2023, 1, 21, 150, v150))

        const v149: PatchNoteContent[] = []
        v149.push(getContent(PatchNoteType.Feature, 'Login with Apple and Discord', ['Michael'], undefined, 'https://i.imgur.com/KSh6Qih.png', ['https://colonist.featureupvote.com/suggestions/84005/add-more-log-in-methods-other-than-google']))
        v149.push(getContent(PatchNoteType.Feature, 'Link multiple accounts from your profile settings', undefined, undefined, 'https://i.imgur.com/Wr00dJ4.jpg'))
        v149.push(getContent(PatchNoteType.Update, 'Season 4: Added subdivisions I and II to each division'))
        v149.push(getContent(PatchNoteType.Update, 'Mobile app has a splash screen', undefined, undefined, 'https://i.imgur.com/rePQO60.png'))
        v149.push(getContent(PatchNoteType.Update, 'Added a 404 error page instead of redirecting to homepage'))
        v149.push(getContent(PatchNoteType.Update, 'Removed card purchasing in bot games'))
        v149.push(getContent(PatchNoteType.Blog, 'Interview with Demiculus, Colonist Co-Founder! <a href="https://blog.colonist.io/interview-series-3-demiculus/" target="_blank">Read here</a>', [], undefined, undefined, ['https://blog.colonist.io/interview-series-3-demiculus/']))

        // Jeff
        // Refactor leaderboard cache key structure to remember season information
        // Cache ranked total games played to make api `find-game-ranked-state` faster

        // Omar
        // Fix FAQ `<html lang>` attribute

        // Logan
        // add private ad in the side bar for signing in
        // Make right ad box display none on page load
        // fix is user on mobile app detection
        // fix popup dimension on wide screens
        // Hide header in room when the user is on mobile

        // Andreme
        // Improved user, room, game loading and action speed

        // Mau
        // Discord - Implemented Discord Auth when Discord Activity loads up
        // Discord - Discord username and profile picture shows up instead of Colonist Username and Avatar. Just a visual change, no data is changed inside the database
        // Discord - Fixing rulebook sidebar navigation bug where it was not scrolling to the section
        // Discord - Removed Karma, Edit Username Pencil Icon, Color Info Popup. Redirecting to colonist store when clicking on `Add Coins`. Redirecting to Colonist Profile Webpage when clicking on `Show Profile`. Removed version popup when clicking on footer version. Opening Colonist Discord Server when clicking on Discord Link on Footer
        // Discord - Closing activity instead of reloading across all app
        // Discord - Fixed auth bug where we were not getting the user's email
        // Refactoring AuthGoogle and moving some functions to AuthUtils
        // Added new new login popup for Discord, Apple & Google
        // Refactored Auth so it uses User Login Table
        // Implemented Discord Auth
        // Implemented automatic account linking if accounts share the same email
        // Fixing auth bug where you couldn't login if you had any type of query in the URL
        // Adding btn_general style to login button
        // Changing old login popup to new login popup in multiple areas of the app
        // Refactored Auth logic so it is generic
        // Implemented UI for Account Linking on Settings Page
        // Account linking backend logic
        // Fix a bug where javascript was not loading inside careers subpages
        // Removing challenges ABTest
        // Removed SHOW_BUILD_COST_FOR_NEW_PLAYER ABTest and added it as a permanent feature
        // Connected backend to frontend for account linking
        // Added Auth Documentation
        // Updating database docs to include remote database connection
        // Fix a bug where email commands were not working
        // Updated /getinfo command to include UserLogins and PaymentsProvider information

        // Simon
        // Fixed Goku's profile in sitemap
        // Fixed link in FAQ to be on imgur

        this.patchNotes.push(getPatchNote(2023, 1, 7, 149, v149))

        const v148: PatchNoteContent[] = []
        v148.push(getContent(PatchNoteType.Feature, 'Mobile App on <a href="https://apps.apple.com/us/app/colonist-io/id6444831129" target="_blank">iOS</a> & <a href="https://play.google.com/store/apps/details?id=com.colonist.colonist" target="_blank">Android</a>'))
        v148.push(getContent(PatchNoteType.Feature, 'New in game sound effects', undefined, undefined, 'https://www.youtube.com/watch?v=QMuSFzWQEdM'))
        v148.push(getContent(PatchNoteType.Update, 'Room speed, robber, dice settings are saved for next room'))
        v148.push(getContent(PatchNoteType.Update, 'Season 4: Limit placement game max-division to Gold'))
        v148.push(getContent(PatchNoteType.Update, 'Season 4: Rebalance ranked divisions Bronze through Gold'))
        v148.push(getContent(PatchNoteType.Fix, 'Leaderboard points are no longer updated if all players disconnect'))
        v148.push(getContent(PatchNoteType.Fix, 'Fixed matchmaking popup on mobile'))
        v148.push(getContent(PatchNoteType.Fix, 'Exiting room doesn\'t refresh page', [], undefined, undefined))
        v148.push(getContent(PatchNoteType.Blog, 'Best House Rules for Catan. <a href="https://blog.colonist.io/catan-house-rules/" target="_blank">Read here</a>', [], undefined, undefined, ['https://blog.colonist.io/catan-house-rules/']))

        // Demi
        // Added an extra store selling text

        // Jeff
        // vxxx.push(getContent(PatchNoteType.Update, 'Extend Season 4 by 1 month'))
        // Fix upgrading player sentry error
        // Refactored all logic related to pulling/using `user_stat` data. This was our least efficient API call and now it should be significantly more performant.

        // Juan
        // Changed text in end game CTA, Lobby->Home
        // Removed coming soon game modes from room dropdown

        // Logan
        // Refactor SocketController.session.userState to use new CurrentUserState class
        // update sounds for disconnect, reconnect, and discard broadcast
        // update FAQ and disable ad block page with more information
        // Add a new AdView for signing in
        // create separate endpoint for friend requests info to be used to show number of requests in popup
        // fix login popup on profile friends tab when reporting a player
        // create new api endpoint for homepage overview stats
        // Convert disable ad block page to use dashes for SEO

        // Mau
        // Discord - Adding server route to fetch discord access token from their API
        // Discord - Adding initial discord sdk configuration
        // Discord - Initializing discord sdk inside the client
        // Discord - Authenticating docker npm to be able to install discord private sdk package
        // Discord - Adding loading screen when discord activity is loading
        // Discord - Adding external link discord popup
        // Discord - Removing CSRF protection inside discord integration servers
        // Discord - Added NPM_TOKEN to github actions so that it can install discord private sdk package
        // Discord - Adding discord environment setup docs
        // Discord - Updating onboarding md to include npm token command
        // Discord - Using discord voice chat instance id to create rooms and allow players to join the same room
        // Discord - Not displaying ingame player dropdown menu when discord integration is enabled
        // Discord - Changing reconnection and disconnect banner text to make sense inside discord activity
        // Discord - Removing discord sidebar buttons as they are not needed anymore and do the same as other buttons
        // Discord - Hiding ads if inside Discord Integration
        // Discord - Hiding endgame ranked screen, membership promotional banner and add friend / report buttons on Discord Integration
        // Discord - Hardcoding NPM_TOKEN inside dockerfile
        // Aded new new login popup for Discord, Apple & Google
        // Refactored Auth so it uses User Login Table
        // Implemented Discord Auth
        // Implemented automatic account linking if accounts share the same email
        // Fixing auth bug where you couldn't login if you had any type of query in the URL
        // Discord - Fixing chat not working
        // Discord - Changing 'Refresh Tab' to 'Refresh Activity'. Also, 'Refresh Activity' closed Discord Activity

        // Devyesh
        // Removed AB test for balanced dice in cnk games
        // Added Custom user agent for mobile devices
        // added user tracking popup on ios platform

        // Simon
        // Adding / to spanish rulebook in sitemap
        // Adding siteauditbot to robots.txt (on hexs)

        this.patchNotes.push(getPatchNote(2022, 12, 27, 148, v148))

        const v147: PatchNoteContent[] = []
        v147.push(getContent(PatchNoteType.Update, 'Leaderboards show Membership icons', [], undefined, 'https://imgur.com/SsGkifM'))
        v147.push(getContent(PatchNoteType.Update, 'Added info icons to Membership perks in the store', [], undefined, 'https://imgur.com/pZ8MT7d'))
        v147.push(getContent(PatchNoteType.Fix, 'Rulebook Spanish language fix'))
        v147.push(getContent(PatchNoteType.Blog, 'Announcing Translations! <a href="https://blog.colonist.io/new-colonist-languages/" target="_blank">Read here</a>', [], undefined, undefined, ['https://blog.colonist.io/new-colonist-languages/']))
        v147.push(getContent(PatchNoteType.Blog, 'How We Avoid Downtime. <a href="https://blog.colonist.io/how-we-avoid-downtime/" target="_blank">Read here</a>', [], undefined, undefined, ['https://blog.colonist.io/how-we-avoid-downtime/']))

        // Demi
        // added doMyFriendsNeedToBecomeMembersToPlayExpansionsAndMapsTogether to faq
        // Room friendly robber is default option
        // Rulebook style updated
        // Random dice is default in rooms

        // Jeff
        // Fix upgrading player sentry error

        // Omar
        // Fix rulebook hreflang data being broken after landing page translation
        // Replace all machine translations with Google translations
        // Add languages: Afrikaans, Catalan, Hebrew, Hungarian, Serbian
        // Add route-specific supported language system
        // Move FAQ strings to translation JSON files
        // Translate all FAQ strings
        // Enable translated FAQ page

        // Logan
        // refactor user-state api calls to be persistent
        // Iterate on new sound effects
        // Implement sign in links for guests on mainpage ranked cards
        // Remove routing to #overview by default when navigating to a profile
        // Default game speed is Fast for users with at least 5 games played
        // Add mobile app download buttons to the landing page

        // Andreme
        // Run all queries in getUserFromUserEntity in parallel to make the request return faster
        // Instead of clearing the users game counter cache after each game, just increment it to avoid having to count all games repeatedly

        // Mau
        // Forcing subscription on all guests and new users

        // Devyesh
        // AIP ads refresh fixed
        // Delete branch when PR is closed

        // Simon
        // Removed /es from temp redirect pages
        // Removed naked links from privacy policy
        // Added alt images to the rulebook

        this.patchNotes.push(getPatchNote(2022, 12, 9, 147, v147))

        const v146v1: PatchNoteContent[] = []
        v146v1.push(getContent(PatchNoteType.Fix, 'Fixed some issues with servers'))
        this.patchNotes.push(getPatchNote(2022, 12, 7, 146.1, v146v1))

        const v146: PatchNoteContent[] = []
        v146.push(getContent(PatchNoteType.Feature, 'Ranked section added to profile', [], undefined, 'https://user-images.githubusercontent.com/23510542/202740519-dfd6c191-30ac-4cad-a439-84e65f67a2ab.png'))
        v146.push(getContent(PatchNoteType.Feature, 'Membership can be managed in your profile', ['Miguel'], undefined, 'https://i.imgur.com/ffpvQJb.png'))
        v146.push(getContent(PatchNoteType.Update, 'Room remembers previous dice setting'))
        v146.push(getContent(PatchNoteType.Update, 'Updated Diamond division icon', ['Miguel'], 'https://i.imgur.com/GUfCKAX.png', 'https://i.imgur.com/aEkKwro.png'))
        v146.push(getContent(PatchNoteType.Update, 'Clicking on a row in the leaderboards takes to ranked section in player profile'))
        v146.push(getContent(PatchNoteType.Update, 'Balanced dice also applies to the Event die in Cities & Knights'))
        v146.push(getContent(PatchNoteType.Update, 'Default dice in room for old players is Random', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/342022/remove-balanced-dice-as-default-setting']))

        // Demi
        // Player avatars load asynchronously after the game starts
        // Added membership questions to FAQ

        // Jeff
        // Fixed command /consolidaterankingafterseason when dealing with large numbers of ranked players

        // Omar
        // Translation architecture
        // Add temporary landing page translations

        // Logan
        // Add delays to the start of game and end of initial settlement phase sounds
        // Implement ab test on the homepage that shows users different combinations of the overview stats

        // Mau
        // Adding side navigation on discord integration
        // Conditionally linking discord css styles if on discord integration server
        // Adding a global variable that lets the rulebook popup to render anywhere in the app
        // vxxx.push(getContent(PatchNoteType.Update, 'Last selected dice setting now gets saved', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/342022/remove-balanced-dice-as-default-setting'])
        // Redirecting all non-existent careers routes to the careers page

        // Devyesh
        // fixed the popup bug in ranked section
        // Fixed webpack build in ci workflow
        // ABTest for DiceSettings in Ranked CnK games
        // Fixed leaderboard layout
        // Redesigning of time converter utils - part 1
        // Added hotjar recording for new users
        // Redesigning of time converter utils
        // ABTest for showing Build cost card for newer players
        // fixed URL of og image

        // Miguel
        // fixed SEO bug caused by wrong JSON structure - FAQ content

        // Simon
        // fixing hreflang link in catan-rules
        // Fixed catan-rules link in sitemap.xml
        // Fixed typos in careers and community pages

        this.patchNotes.push(getPatchNote(2022, 11, 25, 146, v146))

        const v145: PatchNoteContent[] = []

        v145.push(getContent(PatchNoteType.Feature, 'Buy resource cards in bot games using Colonist Coins', [], 'https://user-images.githubusercontent.com/83441512/197561550-77e5ae3d-c79b-45a0-a219-55072cc1c143.png', 'https://user-images.githubusercontent.com/83441512/197561567-653f43c7-eb72-4ea5-80bb-8242ab63a560.png'))
        v145.push(getContent(PatchNoteType.Feature, 'Add friends during a game by clicking on their avatar', [], 'https://i.imgur.com/6ws6Toa.png', 'https://i.imgur.com/HjvfK5w.png'))
        v145.push(getContent(PatchNoteType.Update, 'Decreased matchmaking wait times'))
        v145.push(getContent(PatchNoteType.Update, 'Order friends on the profile page by last online', ['commonpixel']))
        v145.push(getContent(PatchNoteType.Update, 'Community section moved to footer', [], 'https://i.imgur.com/0EKdVkc.png', 'https://i.imgur.com/ThwpU7y.png'))
        v145.push(getContent(PatchNoteType.Fix, 'Fixed membership popup showing too much', undefined, 'https://imgur.com/W0anMhw', undefined))
        v145.push(getContent(PatchNoteType.Fix, 'Fixed header profile section when logged out', undefined, 'https://imgur.com/a/bnCPaXE', 'https://imgur.com/a/KN4qFmO'))
        v145.push(getContent(PatchNoteType.Blog, 'Learn Catan Strategies from Treeckosaurus. <a href="https://blog.colonist.io/catan-strategies-with-treeckosaurus/" target="_blank">Read here</a>', [], undefined, undefined, ['https://blog.colonist.io/catan-strategies-with-treeckosaurus/']))

        // Demi
        // refactored aip ads to its own controller
        // Activated room abtest friendlyrobber active
        // Default room dice turned from Random to Balanced
        // Default room speed turned from Fast to Normal
        // Default bot dice turned from Random to Balanced
        // Login popup shows on all accounts

        // Jeff
        // vxxx.push(getContent(PatchNoteType.Update, 'Decreased matchmaking queue wait times'))

        // Omar
        // Fix broken <link hreflang> tags
        // Fix default translation handling in EJS.
        // Fix issue where translation library middleware and manual middleware had inconsistent logic for checking ignored routes.
        // Add try/catch to socket initialization code.

        // Logan
        // Rename all cases of `GameSetup` to `InitialPlacement`. Should be no bugs but if players report games bugs in placements it probably this.
        // Create ranked section of the profile page
        // vxxx.push(getContent(PatchNoteType.Fix, 'Fixed membership popup showing too much', undefined, 'https://imgur.com/W0anMhw', undefined))

        // Mukit
        // Remove ABTest 'implement gifs on lobby ads' https://discord.com/channels/605233308577562643/992875689281859706/1033113188918640720
        // Added ABTest that shows membership icon in leaderboards https://github.com/colonistio/katan/issues/8096
        // Removed ABTest - Store show discount amount on yearly  https://github.com/colonistio/katan/issues/8641
        // vxxx.push(getContent(PatchNoteType.Fix, 'Fix header profile section when logged out', undefined, 'https://imgur.com/a/bnCPaXE', 'https://imgur.com/a/KN4qFmO'))

        // Remove abTest 'remove homepage ads' https://discord.com/channels/605233308577562643/992875689281859706/1033113188918640720

        // Jason
        // At the end of the game, the Continue button is now un-clickable until it is faded in, to prevent bugs that happen with end game MMR animation if you hit continue during the animation.
        // Changed SocketDataTypes.NotificationData from class to interface
        // Edited the homepage room logic, such that it behaves differently for the discord integration of colonist. Affects .ejs , .scss and .ts files
        // renamed isDiscordIntegrationServer to isDiscordIntegrationServer.
        // Changed RoomColor.ts and RoomPremiumCheck.ts to use the corner popup notification instead of sending the notifications in the room chat.
        // xxxx.push(getContent(PatchNoteType.Feature, 'Added ability to buy cards in bot games using Colonist Coins.', [], 'https://user-images.githubusercontent.com/83441512/197561550-77e5ae3d-c79b-45a0-a219-55072cc1c143.png', 'https://user-images.githubusercontent.com/83441512/197561567-653f43c7-eb72-4ea5-80bb-8242ab63a560.png), [])

        // Mau
        // Added command that toggles on and off ranked test environment
        // Changed friend add validation from the client to the server
        // Displaying popup instead of server chat when the host doesn't own an item inside game room
        // New players now will only be able to get maps, colors and expansions through subscription
        // Added header for discord integration
        // Added challenges ABTest

        // Devyesh
        // Removed popup from leaderboard's Friends tab and showing error inside table
        // Bugfix: When app is opened in a new instance of firefox + ublock origin, ads are visible
        // When player is guest, the profile history now populates correct data like VP, Rank and Opponents
        // Added htmlhint to figure issues in ejs files
        // refactored links of UIProfileController to make its own Controller
        // Bugfix: hide sprites hover on game end screen
        // added command to crash the application
        // ABTest: Show "Sign In to play ranked" text instead of placement games data. This is a test to see if it increases number of sign ups
        // added documentation for css best practices
        // showing footer notifications on all pages/routes
        // bugfix spanish rulebook redirect fixed. /es/reglas-de-catan/ takes us to spanish version of rulebook

        // Avinash
        // v145.push(getContent(PatchNoteType.Update, 'Order friends on the profile page by last online', ['commonpixel']))

        // Miguel
        // v145.push(getContent(PatchNoteType.Update, 'Community link moved to footer navigation', ['Miguel'], 'https://i.imgur.com/0EKdVkc.png', 'https://i.imgur.com/ThwpU7y.png'))
        // Bugfix on leaderboard table sticky row
        // Bugfix: Payment methods link fixed on FAQ sidebar by adding the missing section
        // v145.push(getContent(PatchNoteType.Feature, 'Add friends while playing by clicking the avatar', ['Miguel'], 'https://i.imgur.com/6ws6Toa.png', 'https://i.imgur.com/HjvfK5w.png'))

        // Simon
        // Changed rulebook pages meta descriptions
        // Fixed link on press kit
        // Added LinkedIn to career page
        // Remove suggestions page from sitemap
        // v145.push(getContent(PatchNoteType.Blog, 'Learn Catan Strategies from Treeckosaurus. <a href="https://blog.colonist.io/catan-strategies-with-treeckosaurus/" target="_blank">Read here</a>', [], undefined, undefined, ['https://blog.colonist.io/catan-strategies-with-treeckosaurus/']))
        // Added alt descriptions to images

        this.patchNotes.push(getPatchNote(2022, 11, 11, 145, v145))

        const v144: PatchNoteContent[] = []

        v144.push(getContent(PatchNoteType.Feature, 'Ranked Cities & Knights!'))
        v144.push(getContent(PatchNoteType.Feature, 'Ranked Season 3'))
        v144.push(getContent(PatchNoteType.Update, 'Toggle keyboard shortcuts with a in-game setting', ['Korm'], undefined, 'https://i.imgur.com/2PRj77i.png', ['https://colonist.featureupvote.com/suggestions/328536/turning-off-keyboard-shortcuts-or-change-them-please']))
        v144.push(getContent(PatchNoteType.Update, 'Enter Ranked C&K from leaderboards page', undefined, undefined, 'https://i.imgur.com/s2DmdQK.jpg'))
        v144.push(getContent(PatchNoteType.Update, 'Manage sent friend requests', undefined, undefined, 'https://i.imgur.com/LOY0cfT.png'))
        v144.push(getContent(PatchNoteType.Blog, 'Catan Strategies: Beginner, Intermediate, Advanced. <a href="https://blog.colonist.io/catan-strategies-beginner-intermediate-advanced/" target="_blank">Read here</a>', [], undefined, undefined, ['https://blog.colonist.io/catan-strategies-beginner-intermediate-advanced/']))
        v144.push(getContent(PatchNoteType.Fix, 'Rebalanced ranking algorithm to prevent players from reaching the top with 10-20 games.'))
        v144.push(getContent(PatchNoteType.Fix, 'Rebalanced ranking algorithm in 4P to treat 2nd - 4th places equally.'))
        v144.push(getContent(PatchNoteType.Fix, 'Leaderboard scrolling is now smoother'))

        // Goku
        // Updates nodemon from 1.18.9 to 2.0.20
        // Updates async from 2.6.0 to 2.6.4
        // Updates geoip-lite from 1.4.4 to 1.4.6
        // Removes got node package
        // Updated sitemap.xml

        // Alex
        // Added analytic events and category to monitor ad performance

        // Logan
        // Make sound effects trigger after animation is complete
        // Create separate audio groups for ui sounds vs game sounds. Game sounds are played at 80% volume
        // add new sound effects for trade offers
        // create/update sounds for longest road, largest army, start game, end settlement phase, and C&K lvl 3 improvements
        // add ab test for new sound effects
        // implement popup when user has exceeded the friends limit
        // remove ship placement action for non seafarers games
        // remove point bleed popup

        // Andreme
        // Add membershipType to LeaderboardRowData
        // Combine PlayerGamesEntityService.getGameIdsFromPlayerId and GameEntityService.getGamesByIds into GameEntityService.getRecentUserGames

        // Jason
        // Changed SocketDataTypes.NotificationData from class to interface

        // Kotoar
        // fix corner popup display overlapping with footer
        // change jobs to careers

        // Mau
        // Added friend suggestions when the user has no friends
        // Added command to set any users karma given its id
        // Added the ability to add friends inside the endgame screen

        // Devyesh
        // Aligned the pixi sprites in center wrt the progress bar
        // Updated footer for the rules page
        // In the endgame screen, the text is updated to make the sentence singular when only 1 game is left
        // Added testimonials in career sections
        // Added check to prevent query of illegal usernames in the database

        // Miraul
        // Added on hover text for country flags in leaderboard

        this.patchNotes.push(getPatchNote(2022, 10, 28, 144, v144))

        const v143: PatchNoteContent[] = []

        v143.push(getContent(PatchNoteType.Feature, `Halloween is coming! Limited edition Mummy avatar <a href="/store#avatars" target="_blank"><img src="${IconMummy}" style="height: 45px"></a>Get it at the <a href="/store#avatars" target="_blank">Store</a>.`))
        v143.push(getContent(PatchNoteType.Feature, 'Friends Leaderboard!', undefined, undefined, 'https://i.imgur.com/Etfv2Vw.jpg'))
        v143.push(getContent(PatchNoteType.Blog, 'Interview Series 1: DyLighted <a href="https://blog.colonist.io/interview-series-1-dylighted/" target="_blank">here</a>', [], undefined, undefined, ['https://blog.colonist.io/interview-series-1-dylighted/']))
        v143.push(getContent(PatchNoteType.Update, 'Join or spectate friends\' games through your profile\'s friends list', undefined, undefined, 'https://i.imgur.com/C9rxbnT.png'))
        v143.push(getContent(PatchNoteType.Update, 'Show notification when you have friend requests', undefined, undefined, 'https://i.imgur.com/znhbhQP.jpeg'))
        v143.push(getContent(PatchNoteType.Update, 'Shows profile for Guests in the header', [], 'https://i.imgur.com/o8Zyr8V.png', 'https://i.imgur.com/2OZ9AH5.png'))
        v143.push(getContent(PatchNoteType.Update, 'Added 5-6 players tutorial video to the rulebook'))
        v143.push(getContent(PatchNoteType.Fix, 'Faster leaderboard username search'))
        v143.push(getContent(PatchNoteType.Fix, 'New users must play 5 games to unlock access to ranked games'))

        // Jeff
        // Added backend API for player profile ranked standing information
        // Added CK to next season (Season 3). Not going live next update.

        // Logan
        // Implement the soft popup check on homepage ranked ctas.
        // Fix the homepage to use a flexbox layout

        // Andreme
        // Added totalCompletedGameCount to user state

        // Mukit
        // ABtest: set dice setting to Balanced for bot game https://github.com/colonistio/katan/issues/8277
        // ABtest: for default room settings https://github.com/colonistio/katan/issues/8311
        // ABtest: show poup login perks to guest https://github.com/colonistio/katan/issues/8330

        // Jason
        // ABtest: Underline store ad buttons in the lobby because they don't look clickable.
        // Max friends limit is increased to 1000 for users with membership.
        // ABtest: In a Bot game, users can use Colonist Coins to purchase resource cards and development cards. https://github.com/colonistio/katan/pull/8388
        // Refactored BaseAnimationWrapper to use Linear Interpolation instead of increasing value every frame.
        // Edited homepage-main.ejs, landing page ejs and other .ejs files to display discord integrated version.

        // Miraul
        // Pointer cursor added for leaderboard location tabs

        // Felix
        // Made profile pages full height https://github.com/colonistio/katan/issues/8331

        // Mau
        // Centered 'room_center_start_explanation' text and adding margin to the top of the text
        // Fixed Tabs Navbar not showing the correct active tab
        // Dropdown now toggles by just clicking on the profile container instead of the arrow

        this.patchNotes.push(getPatchNote(2022, 10, 14, 143, v143))

        const v142: PatchNoteContent[] = []
        v142.push(getContent(PatchNoteType.Feature, 'New home page', undefined, undefined, 'https://i.imgur.com/sJfZcTH.jpg'))
        v142.push(getContent(PatchNoteType.Feature, 'Add friends from their profile page', undefined, undefined, 'https://i.imgur.com/etZYg4m.jpg'))
        v142.push(getContent(PatchNoteType.Update, 'Animated the Rating progress bar at the end of ranked games', [], undefined, 'https://imgur.com/a/0iPX4nF'))
        v142.push(getContent(PatchNoteType.Update, 'Hover over division icons in the leaderboards to see division name', [], undefined, 'https://user-images.githubusercontent.com/17537521/189115849-e2aae9a6-dba6-4481-b480-d9d101363a22.png'))
        v142.push(getContent(PatchNoteType.Fix, 'Fix searching for guests on the profile page', undefined, 'https://imgur.com/8IWGb1b', 'https://imgur.com/6OBHw7I'))
        v142.push(getContent(PatchNoteType.Fix, 'Fixed player avatar not updating correctly in game state box', ['Zepp'], 'https://user-images.githubusercontent.com/83441512/191896695-64a6c400-3100-4905-b3ff-22b085c75c2c.png', 'https://user-images.githubusercontent.com/83441512/191896698-ab30277d-e8b0-40f1-991f-59ddaddd454f.png'))
        v142.push(getContent(PatchNoteType.Fix, 'Fixed player avatars not being selectable without refreshing after being purchased from the Colonist store', ['Wings']))

        // Jeff
        // Profilled GameController for the first time in a year. Gained 30% total GameController efficiency
        // 70% of the improvements came from bot code (about 50% of games on site)
        //     within bot code a lot of improvements came from 2 things
        //     a. Preventing looping by adding checks ahead of time
        //     b. Saving states and only updating them on certain actions to prevent re-calculating the same thing multiple times per turn
        // 30% of improvments came from general actions
        // Again most cases just involved saving states or preventing looping
        // The next round of improvements will need to be a bit more architecture. For example,
        //     - Sending partial states instead of full states when a single thing is updated
        //     - Making longest road calculations more efficient (I have some ideas but it's a bit difficult to implement)

        // Juan
        // Changed wording: MMR -> Rating

        // Logan
        // Add popup on leaderboard page to show platinum users that their points will decay

        // Mukit
        // Added ABtest that shows discount label for yearly membership product https://github.com/colonistio/katan/issues/8159
        // Added ABTest Change command https://github.com/colonistio/katan/issues/7983
        // Removed ABTest: 48 hours of No_Ads https://github.com/colonistio/katan/pull/8236#issue-1373591233
        // Changed top notification font weight to 1000
        // Added ABTest that replaces static image with gifs in lobby ads https://github.com/colonistio/katan/issues/8154
        // Added ABtest with Membership Perk Optimization https://github.com/colonistio/katan/issues/8085
        // Price font size decreased in store membership products

        // Jason
        // Used the sessions table to get friends' roomIds, isOnline, current game data for API /api/profile/:username/friends
        // v142.push(getContent(PatchNoteType.Update, 'Animated the MMR progress bar at the end of ranked games', [], 'https://imgur.com/XBRxnd5', 'https://imgur.com/dIw8zdt'))
        // v142.push(getContent(PatchNoteType.Fix, 'Fixed the bug where the player avatar doesn't change in "It's (name)'s turn" box.', ['Zepp'], 'https://user-images.githubusercontent.com/83441512/191896695-64a6c400-3100-4905-b3ff-22b085c75c2c.png', 'https://user-images.githubusercontent.com/83441512/191896698-ab30277d-e8b0-40f1-991f-59ddaddd454f.png'))
        // refactored UIGameAnimationWrapper.ts into ui_game/ui_game_animation/ ...
        // refactored RankedMMRState because there was duplicate code for current and previous ranked states in my end game MMR animation main branch.
        // Refactored code relating to keyboard shortcut. Could affect Escape on matchmaking popup (4 columns) screen, and Spacebar in the game.
        // Changed all the static functions in UIHeaderCoinController back into this. / constructor style.
        // changed the "remove ads" gif in the end game screen, and improved code quality in UIGameEndItemBoxController.ts
        // Added a limit for how many friends each user can have. The limit adds existing friends and friend requests sent, so it prevents spamming of friend requests & friends.
        // Set up discord domain settings and created Discord .ejs files katan/code/client/views/pages/ejs_content/discord_parts

        // Miraul
        // Underline patch-note-types which have active links in patch notes page

        // Kotoar
        // Created admin command '/getallresources'

        this.patchNotes.push(getPatchNote(2022, 9, 30, 142, v142))

        const v141: PatchNoteContent[] = []
        v141.push(getContent(PatchNoteType.Update, 'Click on division icon to show Ranked information', [], 'https://i.imgur.com/5eaF7gK.png'))
        v141.push(getContent(PatchNoteType.Blog, 'Dive into Settlers of Catan: A Chronological History <a href="https://blog.colonist.io/settlers-of-catan-a-chronological-history/" target="_blank">here</a>', [], undefined, undefined, ['https://blog.colonist.io/settlers-of-catan-a-chronological-history/']))
        v141.push(getContent(PatchNoteType.Fix, 'Fixed ranked games bug where a single user could control 2 colors at once'))
        // v141.push(getContent(PatchNoteType.Fix, 'Improved avatar icon loading speed', [], undefined, undefined)) // Sep 16, 2022 Jason - this feature has a bug, so it'll be fixed and added in next version.
        v141.push(getContent(PatchNoteType.Fix, 'Fixed endgame redirecting to the correct leaderboard tab', [], undefined, 'https://www.loom.com/share/6b307dccb1fd44c0b06324e4dc97e18e'))
        v141.push(getContent(PatchNoteType.Fix, 'Lobby list now refreshes automatically when player wants to join a full room', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/309739/refresh-rooms-list-after-trying-to-join-a-full-room']))

        // Goku
        // Bumps passport from 0.4.0 to 0.6.0.

        // Jeff
        // Added database table to store user reports done from inside the game
        // Upgraded Redis from 6.2.6-alpine to 7.0.4-alpine
        // Added command to consolidate end-of-season rankings

        // Logan
        // Remove end game membership chat message

        // Andreme
        // Created indexes to enforce unique username and email case-insensitive
        // Added season table that is synced on server startup
        // Fixed filtering of UserSessions with unset user
        // Fixed Sentry error: Tried to downgrade user to AccessLevel.Player

        // Jashin
        // Refactored clicking on division code

        // Mukit
        // Added Image Enums for Ranked Division
        // Executed MEMBERSHIP_INC_POPUP_2_MEMBERSHIP ABTest and made it default popup and removed failed popup
        // Added ESLint rule to prevent importing test files in other folders
        // ABTest shows profile section to guest 50% of the time
        // Made a new ABTest that hides Lobby Ads

        // Jason
        // Player avatar icons now load after game starts
        // Fixed the bug where players can go to stripe payment page without logging in.

        // Miraul
        // Center div that shows coins amount for player in header
        // Added condition to prevent unnecessary requests from server (about requesting lobby room list data)
        // Align text in patch notes page

        this.patchNotes.push(getPatchNote(2022, 9, 18, 141, v141))

        const v140: PatchNoteContent[] = []
        v140.push(getContent(PatchNoteType.Feature, 'Press spacebar to roll the dice & end turn', ['Podvin#8781'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/73058/keyboard-shortcuts']))
        v140.push(getContent(PatchNoteType.Feature, 'Added play buttons on leaderboards', [], 'https://i.imgur.com/8LR0Q8m.jpg', 'https://i.imgur.com/pouukpa.jpg'))
        v140.push(getContent(PatchNoteType.Update, 'Endgame redirects to correct leaderboard tab', [], undefined, 'https://imgur.com/a/VPyJVHT', ['https://colonist.featureupvote.com/suggestions/321285/after-ranked-game-return-to-the-leaderboard-of-the-game-type-you-played']))
        v140.push(getContent(PatchNoteType.Fix, 'Logging out not working in single pages'))
        v140.push(getContent(PatchNoteType.Fix, 'Fix leaderboard username search'))
        v140.push(getContent(PatchNoteType.Fix, `Allow unranked games between seasons`))
        v140.push(getContent(PatchNoteType.Fix, 'Fixed leaderboard buggy behavior', [], 'https://imgur.com/WGTzYuc', 'https://imgur.com/NQFInod'))

        // Mukit
        // ABTest Shows Coins on all pages for 50% of the players https://imgur.com/a/hqIK8CA https://github.com/colonistio/katan/issues/7988
        // ABTest Create free 48 hour winning of noads https://github.com/colonistio/katan/issues/7990
        // ABTest decrease store font size https://github.com/colonistio/katan/issues/7987

        // Jashin
        // Decreased size of .png assets

        // Andreme
        // Create indexes to enforce unique username and email case insensitive

        // Omar
        // add another matchmaking optimization AB Test showing small matchmaking buttons with lobby vs history and leaderboards summary, and adding "Play" to the buttons or not

        // Logan
        // Add check to not show popups if in development environment
        // Add check to use default AB test values in development environment
        // Refactor Profile API to use separate calls for each section
        // Add progress bar to ranked end game screen
        // Remove end game item box for users with the founders pack
        // Fix image clipping issues for end game item box

        // Jeff
        // Restructured leaderboard API to add friend tab. All code commented out until database work is done.
        // Reduce matchmaking connection timeout from 10s to 1s to clean things up

        this.patchNotes.push(getPatchNote(2022, 9, 2, 140, v140))

        const v139: PatchNoteContent[] = []
        v139.push(getContent(PatchNoteType.Feature, 'Adding 4 divisions to ranked: Bronze, Silver, Gold and Platinum', undefined, 'https://i.imgur.com/UNMtbKq.jpg', 'https://user-images.githubusercontent.com/58959537/184346246-001e81e1-9aa5-4b0f-83ec-5cd88aad7244.png'))
        v139.push(getContent(PatchNoteType.Blog, 'Want to learn more about 1v1 ranked game strategy? Read about it <a href="https://blog.colonist.io/ranked-1v1-strategy/" target="_blank">here</a>', ['321Packer'], undefined, undefined, ['https://blog.colonist.io/ranked-1v1-strategy/']))
        v139.push(getContent(PatchNoteType.Update, 'Redesigned profile page, more updates coming soon', [], 'https://i.imgur.com/UbjVxG8.jpg', 'https://i.imgur.com/xM6Y8DY.jpg'))
        v139.push(getContent(PatchNoteType.Update, 'Your leaderboard row will stick to bottom or top when scrolling out of view', [], 'https://i.imgur.com/FiA1Ltv.png', 'https://i.imgur.com/q5bBYZC.png'))
        v139.push(getContent(PatchNoteType.Update, 'Missing resource cards to build will be transparent', [], 'https://i.imgur.com/4gdjJXl.png', 'https://i.imgur.com/QvXcI9J.png'))
        v139.push(getContent(PatchNoteType.Update, 'Access player profiles from room', [], undefined, 'https://imgur.com/a/emvP88t'))
        v139.push(getContent(PatchNoteType.Update, 'Info button explains how ranked games work', [], 'https://imgur.com/a/BQHhhJO', 'https://imgur.com/a/99GBdw3'))
        v139.push(getContent(PatchNoteType.Fix, 'Bug when matching in ranked game but being unable to play or enter a new game'))
        v139.push(getContent(PatchNoteType.Fix, `Fixed rulebook scrolling and language changing`, [], 'https://imgur.com/a/vBnF2bJ', 'https://imgur.com/a/Dvp1IwX'))

        // Goku
        // Updates guests who have entered but have not finished a game into player access level in database

        // Demi
        // Shows patchnote popup to members again
        // Added back button to checkout page (result of winning abtest)
        // ABTest play button on the leaderboard
        // ABTest popup types and show frequency
        // Bug where some users can not enter ranked games

        // Jeff
        // New command /resetleaderboardstatsafterseason that will be used to manually reset rating deviation at the end of the season
        // Added dates for Seasons 2 to start 6 hours after season 1
        // Prevent users from matching with similar IP. This is intentionally a hidden PN so users don't see this.

        // Alex
        // created /vli-page

        // Logan
        // Add chat message to end game screen that links non-subscribed users to the store
        // Add membership popup when clicking on buttons after the game
        // Add item box to end game screen that links non-subscribed users to the store
        // Fix end game item box to have no background image
        // create banner linking to product hunt post

        // Omar
        // add another matchmaking optimization AB Test showing small matchmaking buttons with other summaries on the homepage instead of lobby
        // add another matchmaking optimization AB Test only summaries on the homepage instead of lobby, lobby can be accessed through Play button

        // Andreme
        // Update all test related packages to their newest versions
        // Prevent ab test generation from having database insert errors
        // Faster socket message processing

        // Jashin
        // v139.push(getContent(PatchNoteType.Fix, 'Removing coin tags on smaller screens', [], 'https://imgur.com/a/7LHOIEs', 'https://imgur.com/a/4S9OXjt', []))
        // v139.push(getContent(PatchNoteType.Update, 'Room profile access', [], 'https://imgur.com/a/emvP88t'))
        // Removing coin tags on smaller screen

        // Joo Young
        // Stopping games with server command doesn't affect privileged users

        // Mukit
        // Console logs AB test category showing the active test for that category https://imgur.com/a/KSqVjGK
        // Implements two types of membership incentive popup desing https://imgur.com/a/a95w5qL

        this.patchNotes.push(getPatchNote(2022, 8, 20, 139, v139))

        const v138: PatchNoteContent[] = []
        v138.push(getContent(PatchNoteType.Update, 'Added Membership icon to profile avatar', [], 'https://imgur.com/a/vYTQPlw', 'https://imgur.com/a/mQRhfj7'))
        v138.push(getContent(PatchNoteType.Update, 'Membership icon shows in lobby', [], 'https://imgur.com/a/buJSC7f', 'https://imgur.com/a/lwc5UMV'))
        v138.push(getContent(PatchNoteType.Fix, 'Bots no longer know your hidden victory points', ['drizzleddice'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/96837/bots-give-away-when-a-player-is-leading-due-to-vps']))
        v138.push(getContent(PatchNoteType.Fix, 'Fixed username not updating'))

        v138.push(getContent(PatchNoteType.Fix, 'Fix blue screen when joining ranked games'))
        v138.push(getContent(PatchNoteType.Fix, 'Added cursor and hover effect to username', [], 'https://imgur.com/a/yOOEjOt', 'https://imgur.com/a/0CY4l3G'))
        v138.push(getContent(PatchNoteType.Fix, 'In 1v1 games, back arrow directs to lobby', [], 'https://imgur.com/a/UdFu7M5'))
        v138.push(getContent(PatchNoteType.Fix, 'After logging in redirect user to the page they were originally at'))
        v138.push(getContent(PatchNoteType.Fix, 'Fixed wrong icon color in trade bar when counter offering', [], 'https://imgur.com/ZZK6LSm', 'https://imgur.com/Iib39ha'))

        // Goku
        // Moved Toggle Sentry functionality to FeatureFlag
        // Bumps terser from 4.8.0 to 4.8.1.

        // demi
        // Removed old abtest structure
        // Created new abtest system
        // Created abtests for soft & hard adblock limits
        // Created abtest for store forcing to purchase memberships instead of items
        // Created abtest for showing landing page to 5% of players

        // jeff
        // show 0/10 placement games in find game popup if user hasn't played single ranked game
        // added command to reset rating deviation at the end of a season
        // Refactored `BaseRankedSeasonData` structure to include memory of ranked mode data to retain information on what was done in previous seasons
        // vxx.push(getContent(PatchNoteType.Update, 'Added 4 divisions to ranked play. Bronze, Silver, Gold and Platinum.'))

        // juan
        // Moved Rules tab from header to footer

        // Omar
        // ABTest showing matchmaking in the home screen instead of lobby

        // Andreme
        // Log page visits for /store, /checkout, /about and /jobs in analytic table
        // Regularly remove old guest users

        // jashin
        // Created avatar popup

        // Joo Young
        // change setPlayerVictoryPoints(), a testing function, to use public victory points
        // Move regex for checking paths to code/server/Utils.ts

        // Mukit
        // Added Subscription popup in Room
        // Added 'Remove Ads' button under the in game horizontal ads, that redirects to store#membership

        // Ognjen
        // Made the entire membership card clickable

        this.patchNotes.push(getPatchNote(2022, 8, 5, 138, v138))

        const v137: PatchNoteContent[] = []
        v137.push(getContent(PatchNoteType.Update, 'Improved game server processing speed'))
        v137.push(getContent(PatchNoteType.Fix, 'Minor visual fixes in Leaderboard page'))
        v137.push(getContent(PatchNoteType.Fix, 'Fix blue screen error from assets not loaded when quickly joining games via MatchMaking', [], 'https://imgur.com/atEiLC8', 'https://imgur.com/mIX6uw6', ['https://colonist.featureupvote.com/suggestions/135807/blue-screen']))
        v137.push(getContent(PatchNoteType.Fix, 'Minor visual fixes in Checkout page'))
        v137.push(getContent(PatchNoteType.Fix, 'Many small bug fixes under the hood'))

        // goku
        // Bumps moment from 2.29.2 to 2.29.4
        // Edited SEO description
        // Edited about us and press kit descriptions
        // Stripe Memberships purchases and updates are based on userId instead of transactionId

        // demi
        // Added abtest click analytics
        // Fixed some problems with the new ad system and adblocks

        // Omar
        // Convert all relative `dist` and API endpoint URIs to absolute in the front end

        // Andreme
        // Add hourly stats table to enable querying stats quickly over large date ranges, initially only for a guest user counter
        // Lock pixi module version to 5.2.0 for newer npm versions

        // jashin
        // Refactored UILeaderboardSeasonProgressController.ts
        // Leaderboard - Show hours when there is less than 48 hours
        // Checkout page optimization

        // Joo Young
        // changed updateUsernameOperator to two functions, updateUsername and updateUsernamePayment

        // Mukit
        // Remove X icon from purchase success store banner
        // Added subscribe popup to the lobby and starting page.

        this.patchNotes.push(getPatchNote(2022, 7, 22, 137, v137))

        const v136: PatchNoteContent[] = []
        v136.push(getContent(PatchNoteType.Blog, 'Unlock ranked tickets by watching video ads', [], undefined, undefined, ['https://blog.colonist.io/colonist-ranked-games-leaderboards-memberhip-system/']))
        v136.push(getContent(PatchNoteType.Update, 'After game ends directly re-enter ranked queue'))
        v136.push(getContent(PatchNoteType.Update, 'Animation for reloading lobby games', [], undefined, 'https://i.imgur.com/6DUW3UZ.mp4'))
        v136.push(getContent(PatchNoteType.Update, 'Country flags are only shown in ranked end game screen', ['Kotoar']))
        v136.push(getContent(PatchNoteType.Fix, 'Sidebars in all pages highlight'))
        v136.push(getContent(PatchNoteType.Fix, 'Improved Leaderboard searchbox experience'))

        this.patchNotes.push(getPatchNote(2022, 7, 12, 136, v136))

        // demi
        // Before ranked games shows preroll ads
        // ABtest "Cancel Anytime"
        // ABtest Checkout back button

        // Omar
        // Disconnect all user sessions when they log out.

        // Andreme
        // Store adblock status in session
        // Remove UserSettings, make settings real properties of the User and UserState, and real columns in the user table

        // Daniel

        // Kotoar
        // add best value membership UI style in store page

        // jashin
        // fix redirect store
        // Refactored UIProfileUsernameController.ts

        // Adam
        // Updated Leaderboard search to initiate search when SearchBox is empty.

        const v135: PatchNoteContent[] = []
        v135.push(getContent(PatchNoteType.Feature, '<a href="/store#membership" target="_blank">Memberships</a> are out! Enjoy no ads + full screen, unlimited Ranked games, access to all expansions, and more!', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/130105/pay-to-remove-ads']))
        v135.push(getContent(PatchNoteType.Update, 'View other countries\' leaderboards by clicking on the flags'))
        v135.push(getContent(PatchNoteType.Update, 'Added /resign command for 1v1 ranked games', [], undefined, 'https://i.imgur.com/9lcrvbA.jpg'))
        v135.push(getContent(PatchNoteType.Update, 'Show placement games needed on leaderboards', [], undefined, 'https://i.imgur.com/7vMgC3z.png'))
        v135.push(getContent(PatchNoteType.Update, 'Automatically refresh rooms list in the lobby every 30 seconds'))
        v135.push(getContent(PatchNoteType.Update, 'Limited username changes', [], undefined, 'https://i.imgur.com/3WZ8Fww.png', ['https://colonist.featureupvote.com/suggestions/53006/lock-username-once-created-to-prevent-trolling']))
        v135.push(getContent(PatchNoteType.Fix, 'Show new MMR in end game screen'))
        v135.push(getContent(PatchNoteType.Fix, 'Prevent wait times longer than 8 minutes in ranked queue'))
        v135.push(getContent(PatchNoteType.Fix, 'Leaderboards not scrolling past top 200-400 entries'))
        v135.push(getContent(PatchNoteType.Fix, 'Leaderboards tabs update with custom URLs'))
        v135.push(getContent(PatchNoteType.Fix, 'Fixed avatar/color changing bug'))

        // goku
        // Refactored Auth functions

        // demi
        // Change valueimpression to interdogmedia

        // jeff
        // Fixed AccessLevel.Player related bugs
        // Fixed Guest and Users bugging out with certain actions

        // Omar
        // Auto-scroll to the correct store section when the user clicks on the store link in the color and avatar selectors.

        // Andreme
        // BigId is now defined as a string, to match data type returned from the database for bigint ids
        // Prevent updating and deleting enums on the Colonist and Hexes servers

        // jashin
        // Fixed highlight side bar in /privacy policy page

        this.patchNotes.push(getPatchNote(2022, 6, 26, 135, v135))

        const v134: PatchNoteContent[] = []
        v134.push(getContent(PatchNoteType.Feature, 'PayPal and other payment methods accepted in <a href="/store#coins" target="_blank">Store</a>', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/65795/add-paypal-as-alternative-to-buy-maps-and-expansions']))
        v134.push(getContent(PatchNoteType.Blog, '<a href="/profile/WVJoe" target="_blank">Adam</a> proposed to <a href="/profile/QueenElliot3" target="_blank">Zoe</a> while playing a Colonist game! Read here: <a href="https://blog.colonist.io/the-trade-of-a-lifetime/" target="_blank">The Trade of a Lifetime</a>', [], undefined, undefined, ['https://blog.colonist.io/the-trade-of-a-lifetime/']))
        v134.push(getContent(PatchNoteType.Update, 'Rebalanced ranked matchmaking for better matches'))
        v134.push(getContent(PatchNoteType.Update, 'Limited Rating range during Ranked placement games'))
        v134.push(getContent(PatchNoteType.Update, 'Country flags appear in end the game screen', ['Kotoar'], undefined, 'https://i.imgur.com/SvPbGLD.jpg', undefined))
        v134.push(getContent(PatchNoteType.Fix, `Fixed username editing in all pages`))
        v134.push(getContent(PatchNoteType.Fix, 'Fixed end game stats header bug', ['Kotoar'], 'https://i.imgur.com/yAGVEn9.jpg', 'https://i.imgur.com/W7mz8C2.jpg', undefined))

        // goku
        // Improved existing user website loading speed, by 10-30ms
        // A faster way of checking if player has finished a game
        // After finishing a game, a AccessLevel.Guest turns to AccessLevel.Player
        // Moved socket hideads logic into static HTML EJS
        // Added Feature Flag infrastructure
        // Removed Xsolla UI removal and temporary setup logic
        // Changed CTA from "Find Game" to "Play"

        // jeff
        // Prevent ghost sessions from entering and locking up matchmaking engine
        // Prevent ghost sessions from entering and locking up matchmaking engine

        // Andreme
        // Upgraded postgres:11.1-alpine to postgres:14.2-alpine
        // Upgrade redis client package from 3.1.1 to 4.0.6
        // Removed async-redis dependency

        // juan
        // Added FAQ categories in each game mode of rulebook

        // Kotoar
        // Fix homepage footer display bug

        // Joo Young
        // Remove isUsernameAvailable() from UserEntityService

        this.patchNotes.push(getPatchNote(2022, 6, 10, 134, v134))

        const v133: PatchNoteContent[] = []
        v133.push(getContent(PatchNoteType.Update, 'Created <a href="/about" target="_blank">About page</a>'))
        v133.push(getContent(PatchNoteType.Update, 'Updated <a href="/jobs" target="_blank">Jobs page</a>'))
        v133.push(getContent(PatchNoteType.Update, 'Extended beta ranked season by 2 weeks'))
        v133.push(getContent(PatchNoteType.Update, 'End game Rating win/loss shows in green/red', ['Kotoar', 'Jashin'], undefined, 'https://i.imgur.com/vyf9nCp.png'))
        v133.push(getContent(PatchNoteType.Update, 'Added sound when a vote starts', ['H5KY', 'Jashin']))
        v133.push(getContent(PatchNoteType.Fix, 'Clicking on end game Rating stat icon opens the leaderboards', ['Jashin'], undefined, 'https://i.imgur.com/pg7Yog1.png'))
        v133.push(getContent(PatchNoteType.Fix, 'Leaderboards show 4p as default', ['PatAle']))
        v133.push(getContent(PatchNoteType.Fix, 'Fixed counter offering unlimited cards', ['PatAle'], undefined, undefined, ['https://youtu.be/BlcdEyTBsUI']))
        v133.push(getContent(PatchNoteType.Fix, 'Presale pack hats now appear in the avatar selection popup', ['PatAle'], undefined, `https://i.imgur.com/kr8f5bz.png`, undefined))
        v133.push(getContent(PatchNoteType.Fix, 'Fixed /pause command not starting a vote in 1v1 games'))
        v133.push(getContent(PatchNoteType.Fix, 'Fixed games being paused after ending'))
        v133.push(getContent(PatchNoteType.Fix, '/pause command appears when typing /help'))

        // Joo Young
        // "/changeuseremail" command, along with new functions to change user email and check if email is available in UserEntityService

        // jashin
        // store tokens show for guest accounts
        // About us improvements (Remove extra space between words)

        // Kotoar
        // Hide ads on site loading

        // goku
        // Bump handlebars from 4.1.0 to 4.7.7
        // Bump y18n from 4.0.0 to 4.0.3 #7165
        // Refactored Payments, Stripe to prepare for Xsolla integration

        // Andreme
        // Improve AB test analytic load performance
        // Mark PlayerGames.user as optional in TS
        // Update User.setting to always be a UserSetting object
        // Fix syncing of renamed enum labels
        // Update enum sync logic
        // Add Sentry tracing for most api endpoints and pages
        // Increased speed of profile showing game results

        // Alex
        // Jobs page and job roles pages
        // Improved internal code for job roles pages

        // Mauro
        // Testing documentation
        // Tests for static, auth webpack compiled pages routes
        // Write test to verify correct redirection of invalid routes
        // Fix path in RoutesCreator.renderPage

        // PatAle
        // Remove underline from green links
        // Show progress card title in log when stolen using spy

        // Juan
        // Added Pink color to the store (disabled)

        // demi
        // Created abtest structure for easily doing abtests
        // Added notification to jobs in footer

        // Logan
        // refactored leaderboard ui to be a table instead of a grid
        // Leaderboard UI - Clicking on a player navigates to the player's profile

        // Omar
        // Fix issue where users are assigned a list of IP addresses by parsing `X-Forwarded-For` header correctly.
        // Pause Revisit:
        // Add a max pause time for single-player games
        // Vote system now uses `Math.ceil` instead of `Math.round`
        // Vote percentage of pause changed from 65% to 51%

        this.patchNotes.push(getPatchNote(2022, 5, 27, 133, v133))

        const v132: PatchNoteContent[] = []
        v132.push(getContent(PatchNoteType.Feature, '4P Ranked games and Leaderboards'))
        v132.push(getContent(PatchNoteType.Fix, 'Ranked games matches are now closer in Rating, balancing won/lost points'))
        v132.push(getContent(PatchNoteType.Fix, 'Fixed sound not working on iOS', ['kidbroccoli'], undefined, undefined))

        // goku
        // Refactored RedirectRoutes and added some misspellings and synonyms
        // Added new Stripe into the codebase
        // Lowered Sentry traces sample rate 0.2%=>0.1%
        // /clearcacheofuser can use userId now
        // Bumps ejs from 3.0.1 to 3.1.7
        // Bumps y18n from 4.0.0 to 4.0.3.
        // Bumps handlebars from 4.1.0 to 4.7.7.
        // Bumps hosted-git-info from 2.7.1 to 2.8.9.
        // Fixed SyncServerStart problem
        // Rebuilding redis leaderboards on server start
        // Added CSRF check to api endpoints

        // jeff
        // Fix 4P Weighted Glicko returning NaN when winning players didn't have the most points
        // Fix 4P Weighted Glicko where 2nd would sometimes get points
        // Added error catching to leaderboard Redis code to make future debugging easier
        // Fixed balanced dice 1v1 AB test
        // Fixed matchmaking queue bug where users were not being matched on skill

        // Alex
        // Store now has coin cards
        // Created about us page

        // Omar
        // Copy shared utils and separate into files, deprecate existing shared utils

        // Demi
        // Added howler.js as sound library
        // Added 10 abtests for homepage & lobby
        // Added schemas to faq

        // Andreme
        // Add missing query limits some queries that might've returned multiple results now returns only 1
        // Set auto vacuum settings for large db tables to reduce bloat and improve query performance
        // Update all variables that hold bigint ids from the database to the new type BigId
        // Prevent NaN in UserStat.value from being stored in db, remove existing NaN rows

        this.patchNotes.push(getPatchNote(2022, 5, 13, 132, v132))

        const v131: PatchNoteContent[] = []
        v131.push(getContent(PatchNoteType.Feature, 'Ranked leaderboards for 1v1!', undefined, undefined, 'https://i.imgur.com/fDljo70.png'))
        v131.push(getContent(PatchNoteType.Feature, 'Log shows when resource production is blocked by robber', ['drizzleddice'], undefined, 'https://i.imgur.com/a3qcbsf.png'))
        v131.push(getContent(PatchNoteType.Feature, 'Games can be paused by typing /pause in the chat', undefined, undefined, 'https://i.imgur.com/A6UXf6l.jpg', ['https://colonist.featureupvote.com/suggestions/70806/pause-game-feature', 'https://i.imgur.com/7Xhx4q4.png']))
        v131.push(getContent(PatchNoteType.Feature, 'New sounds added, old sounds updated', ['H5KY'], undefined, 'https://youtu.be/eKni6ZVYhZo', undefined))
        v131.push(getContent(PatchNoteType.Update, 'Show the remaining time for in-game votes', undefined, undefined, 'https://i.imgur.com/iIL4r9J.png'))
        v131.push(getContent(PatchNoteType.Update, 'Store UI updated', undefined, 'https://i.imgur.com/P7jzHAX.jpg', 'https://i.imgur.com/E6w6I6G.jpg'))
        v131.push(getContent(PatchNoteType.Update, 'Redesigned lobby tables', undefined, 'https://i.imgur.com/Dj7CkDN.jpg', 'https://i.imgur.com/TF3FQ9j.jpg'))
        v131.push(getContent(PatchNoteType.Update, 'Lobby tables show when connection is broken', undefined, undefined, 'https://i.imgur.com/jQiIpKJ.jpg'))
        v131.push(getContent(PatchNoteType.Fix, 'Fix games broken on iPhone and MacOS when anti-aliasing was turned on'))
        v131.push(getContent(PatchNoteType.Fix, 'Wrong urls now redirect to home page'))

        // juan
        // Clicking on map would higlight chat

        // tyler
        // Added /branch command to display server branch name in chat

        // jashin
        // Fixed text alignment in Find Game Popup
        // Create "Alpha" tag for Leaderboard

        // Kotoar
        // Hamburger menu now work on other pages other than homepage
        // Make mobile sidebar header and footer items aligned left vertically

        // Andreme
        // Add custom user indexes as unsynchronized indexes to the UserEntity
        // Make transaction(user_id, type_id), item(user_id, transaction_id, category_id), session(user_id) not null
        // Improve a couple of queries that may affect user profile
        // Make /api/analytic-events endpoint faster by removing unnecessary queries
        // Remove caching for getUserByXXX functions
        // Make analytic(type_id, category_id), player_games(game_id, player_color_id) not null
        // Enforce that error objects are returned for rejected async functions
        // Add test for AnalyticEntityService.getAnalyticTypeFromUserAndCategory

        // Omar
        // Vote system: improvements
        // Add GitHub actions for timed reminders on issues and pull requests

        // Alex
        // Added loading animation to lobby tables

        // Mauro
        // Complete api/stats with online count data
        // Restore sinon stubs
        // Improvements to rulebooks routes

        // PatAle
        // avatar selection popup, fix according to feedback
        // avatar-selection-popup
        // presskit update new

        // Mousetail
        // Disable PIXI audio and replace with HTML <audio> elements

        // jeff
        // Activate hidden 4P leaderboards for unranked games where only admins can access the API data
        // Users can only play 1 ranked game at a time
        // Users will win ranked games if all other players quit
        // Only public access to 1v1 ranked. 4P ranked is still hidden and only visible to admins
        // Values for alpha season are being stored in own enum to make it easy to reset

        // demi
        // Header works on all pages(shows player logged in status)
        // Fixed a bug where store doesn't directly send player to login
        // Added new ABTestSubscriptionPrice2 abtests

        // goku
        // Bumps moment from 2.24.0 to 2.29.2.
        // Removed throw statement from getUserIdFromCookie
        // Fixed Rulebook language not changing
        // Fixed Rulebook Base Game button taking to home screen
        // getUserIdFromCookie returns undefined if called from a crawler
        // Refreshes online count data every 10s instead of 60s
        // Stopped deleting guest accounts after logging into old accounts
        // Change local postgresql port from 5432=>65432
        // Updated stripe package from 8.64.0=>8.219.0
        // Updated stripe API from 2020-03-02=>2020-08-27
        // Removed packages @types/stripe & @types/stripe-checkout because new stripe package should have TS types covered

        this.patchNotes.push(getPatchNote(2022, 4, 29, 131, v131))

        const v130: PatchNoteContent[] = []
        v130.push(getContent(PatchNoteType.Feature, '2 maps free to play! MiniBase & Turning Tides: Low Tide'))
        v130.push(getContent(PatchNoteType.Update, 'Find Game button shows all modes', [], 'https://i.imgur.com/GOscmGs.jpeg', 'https://i.imgur.com/pwIliWg.jpeg'))
        v130.push(getContent(PatchNoteType.Fix, 'Fixed road building error message', ['PatAle']))

        // Joo Young
        // Restart startHostKickTimer() after a kick in Room.ts
        // Added chat keywords that convert to tile images

        // jashin
        // Each page has different SEO keywords
        // In card description popup, the card aligns with text

        // Kotoar
        // Moved the old patch notes from EJS to TS and reduced the size of PatchNoteData.ts by 200kb

        // Andreme
        // Make sure that no game is saved without a user
        // Use the test db to create new migrations
        // Auto discover enum entities In EnumsService
        // Don't load user presalepacks in getUserById
        // Make presalepack columns not null
        // Remove GameSetting.version
        // Set colonist_version to NOT NULL for all tables
        // Fix syncing enums on server startup
        // Sync GameSetting entity and db
        // Don't load user achievements in getUserById
        // Exclude tests from ts compilation
        // Update AchievementEntity to prevent usage of sub entities that are not loaded
        // Make AchievementEntity not null
        // Remove entity properties that shouldn't be used

        // Daniel
        // vXXX.push(getContent(PatchNoteType.Update, 'Updated lobby table header style', ['BigNell']))

        // Alex
        // Removed proposal code

        // Mauro
        // Migrate game sorting to frontend
        // Refactor API Routes
        // Review and refactor to.throw async tests
        // Links for the Rulebook individual pages do not include their Rulebook base path

        // PatAle
        // Presskit update

        // Mousetail
        // Implemented leaderboard frontend & API

        // jeff
        // Leaderboards General
        // First version of leaderboards will be at `/leaderboards` but not displayed anywhere in the lobby
        // Ranking is done geographically by global, continent, country and region
        // Users IP addresses will pull geographical information and they will be ranked accordinly
        // The leaderboards also support search functionality for finding user by username (for a given region)
        // Leaderboards Backends systems.
        // Redis sorted sets are used to store all ranking stats. Ranking results will be live and update automatically everytime a new entry is added
        // All the "real" data is stored in Postgres and only cached in Redis for speed
        // When Redis cache is cleared, leaderboard cache is automatically re-populated
        // Postgres holds information like total games played/win rate, etc. Once pulled from Postgres once, its cached for future users going to access the leaderboards

        // Demi
        // Edited serverEJS files, ads need testing
        // Created google analytics for hexs, onlinecatan, katanio
        // refactor logrocket code
        // Can click on the whole lobby ad instead of just the button
        // Created employee level system
        // Redirect jobs to notion
        // Created second abtest for subscription & price

        // goku
        // Created KatanDomainConfigs which refactored a lot of .env and .ejs settings
        // On updates servers start in a synced manner reducing problems

        this.patchNotes.push(getPatchNote(2022, 4, 16, 130, v130))

        const v129: PatchNoteContent[] = []
        v129.push(getContent(PatchNoteType.Feature, '5 maps free to play! Trade Islands, Duel, Monopoly, Two Isles, & Turning Tides: High Tide'))
        v129.push(getContent(PatchNoteType.Update, 'Disabled private messages. They will be enabled again once friends feature is released', ['Jashin'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/286825/removedisable-private-player-message-feature-during-games']))
        v129.push(getContent(PatchNoteType.Update, 'Card image hover text shows discard limit while over the limit', ['kotoha'], undefined, 'https://i.imgur.com/Xq0ZSBG.png'))
        v129.push(getContent(PatchNoteType.Update, 'Rooms in lobby are ordered based on number of players'))
        v129.push(getContent(PatchNoteType.Update, 'In-game rulebook popup remembers last viewed category', ['BigNell']))
        v129.push(getContent(PatchNoteType.Update, 'Updated Patch Note style', undefined, 'https://i.imgur.com/LbOp4f9.png', 'https://i.imgur.com/OpKAwDr.png', undefined))
        v129.push(getContent(PatchNoteType.Fix, 'Fixed profile menu showing under advertisements', ['Jashin'], 'https://user-images.githubusercontent.com/71561406/159686806-b688d5cb-5754-4c93-9f3e-7daab7dbfe76.png', 'https://user-images.githubusercontent.com/71561406/159686867-b7e58ee1-4dca-48a2-842a-59e37417f68a.png'))
        v129.push(getContent(PatchNoteType.Fix, 'Single pages highlights selected tab while scrolling', undefined, undefined, 'https://i.imgur.com/f7zIoFh.png'))
        v129.push(getContent(PatchNoteType.Fix, 'Improved user and data loading speed'))

        // goku
        // Fixed ab test not saving into database

        // demi
        // Added subscription abtest

        // jeff
        // Prevent players from entering matchmaking without having starting ELO set
        // Added tracking for user geographical information in DB
        // Using node package to pull location from IP and store in DB. Tracking continent, country, state and city
        // New users have their location set right away, old users have their location set on next sign in. After that its locked and can't be modified
        // Matchmaking 1v1 unranked queue based on Glicko1 skill score

        // juan
        // Removed Credits from Patch Notes

        // Mauro
        // Refactor Pages & Auth Routes

        // Omar
        // Bump axios from 0.21.2 to 0.22.0
        // Changed frontend XMLHttpRequests to axios
        // Converted editing username, preferred color and avatar icon to use AJAX API endpoints instead of sockets
        // Extract method `UserController.getUserFromUserEntity` from `getUserWithId`
        // Ad show logic is sent with EJS variable
        // Disabled anti-aliasing on Apple Mobile devices due to bug introduced in iOS 15.4

        // Andreme
        // Made GameSettings.botSpeed an enum
        // Made GameSettings.gameSpeed an enum
        // Don't load user stats in getUserById
        // Prevent duplicate items in the database
        // Fix saving of user_stats (wrong version)
        // Made user_stat user_id, type_id and category_id NOT NULL
        // Made all GameSettings columns not null
        // Remove unused PresalePackEntityService.addPresalePack
        // Add missing user_stat.game_id index for FK support
        // Fix user access level saving by always using UserEntity.accessLevelId

        // Daniel
        // vXXX.push(getContent(PatchNoteType.Update, 'In-Game Rulebook Saves User Position', ['BigNell']))

        this.patchNotes.push(getPatchNote(2022, 4, 1, 129, v129))

        const v128: PatchNoteContent[] = []
        v128.push(getContent(PatchNoteType.Feature, '5 maps free to play! Romania, Mountain of Riches, King of the Hill, Monopoly Islands & Stripes'))
        v128.push(getContent(PatchNoteType.Feature, `New map: Monopoly Islands <img src="${MapMonopolyIslandsPreview}" style="width: 40%">`))
        v128.push(getContent(PatchNoteType.Feature, 'Created <a href="/jobs" target="_blank">Jobs page</a>, it will be filled in upcoming updates'))
        v128.push(getContent(PatchNoteType.Feature, 'Room list is prioritized based on game mode', undefined, undefined, 'https://user-images.githubusercontent.com/5816878/158254747-8848ce7a-47b9-4f0d-a16f-9cd6f6de9f3a.png', ['https://colonist.featureupvote.com/suggestions/86048/rooms-created-by-paid-members-filter-to-top']))
        v128.push(getContent(PatchNoteType.Update, 'Clicking on a dev/progress card in game log shows its details', undefined, undefined, 'https://user-images.githubusercontent.com/5816878/158255978-fd675d06-9587-435d-90e1-56f9ae364fbf.png'))
        v128.push(getContent(PatchNoteType.Update, 'Can select a reason when reporting people', undefined, undefined, 'https://user-images.githubusercontent.com/5816878/158256107-007aba00-cafb-466e-862f-0576c4f2cc3a.png', ['https://colonist.featureupvote.com/suggestions/179344/improve-reporting-other-players']))
        v128.push(getContent(PatchNoteType.Update, 'Added username to profile tab', ['BigNell'], undefined, 'https://user-images.githubusercontent.com/5816878/158255352-e245aefa-3ac5-412f-b547-fd510a8cf047.png'))
        v128.push(getContent(PatchNoteType.Fix, 'Fixed settings panel buttons from overlapping on Safari', ['BigNell']))
        v128.push(getContent(PatchNoteType.Fix, 'Increased delay for bots to accept trade offers'))
        v128.push(getContent(PatchNoteType.Fix, 'Fixed inactive players getting kicked from games'))
        v128.push(getContent(PatchNoteType.Fix, 'Fixed tabs in rules popup'))
        v128.push(getContent(PatchNoteType.Fix, 'Added hover effect and indication of current page in navigation bar', undefined, undefined, 'https://i.imgur.com/yYKx5YC.png'))

        // goku
        // Doesnt delete the cache from functions getUserByName and getUserByEmail
        // Fixed static server broadCastToAll crash
        // Lowered Sentry traces sample rate 0.5%=>0.2%
        // Separated Sentry projects into 3 for different servers
        // Fixed server crash from heapdump

        // demi
        // Added getadmiral - adblock remove
        // Added isonlinecatan & ishexsio to ejs (This is tech debt, will be fixed)
        // Refactored ad tags
        // AB Testing Lobby CTA
        // Added safety command /toggleabtestcta

        // jeff
        // Stopped logging AnalyticEventType.StartedGame in database
        // Added in Glicko1 algorithm for 1v1 unranked to benchmark the algorithm
        // Fixed lobby session memory leak (caused by laggy DB)

        // Mauro
        // Started Refactoring Routers

        // Omar
        // Add max length to chat inputs on the frontend

        // Andreme
        // Fix getOldGuestUsers not releasing acquired db connection
        // Reduced UserEntity redis cache size and increased db first loading
        // Fixed bugs with ItemEntityService.markItemDeleted doesUserHaveItem
        // Add missing indexes on transaction entity to speedup user deletion
        // Faster DB tests 1:41=>1:16 (on CI)
        // Add DatabaseHelper.beforeDbTest to remove db test code duplication
        // Fix redis.shutdown from preventing script exit
        // Saves game data in a transaction to fix possible null user.id issues
        // Doesn't load user.items in getUserById
        // Fix error in game_setting sequence that prevent games from being saved

        // Daniel
        // vXX.push(getContent(PatchNoteType.Update, 'Added username to Profile tab', [BigNell]))
        // vXX.push(getContent(PatchNoteType.Fix, 'Fixed settings panel buttons from overlapping on Safari', [BigNell]))

        // Kotoar
        // Modified corner error notification popups
        // Change default color popup message of Black to "Get Black color for FREE at the Store!"

        this.patchNotes.push(getPatchNote(2022, 3, 18, 128, v128))

        const v127: PatchNoteContent[] = []
        v127.push(getContent(PatchNoteType.Feature, `New map release! Gold Rush has been added to the <a href="/store" target="_blank">Store</a><img src="${MapGoldrushPreview}" style="width: 40%">`))
        v127.push(getContent(PatchNoteType.Feature, 'Select your preferred color from the profile!'))
        v127.push(getContent(PatchNoteType.Feature, 'New Community page!', undefined, undefined, 'https://i.imgur.com/v4npNeN.png'))
        v127.push(getContent(PatchNoteType.Update, 'Make room settings default when host leaves', ['PatAle']))
        v127.push(getContent(PatchNoteType.Update, 'Improved animations in landing page board', ['AlexC']))
        v127.push(getContent(PatchNoteType.Update, 'Allow profile dropdown menu to be closed by clicking anywhere on the page', ['doon9']))
        v127.push(getContent(PatchNoteType.Update, 'Added hover text for robber and pirate'))
        v127.push(getContent(PatchNoteType.Fix, 'Fixed ghost room hosts'))
        v127.push(getContent(PatchNoteType.Fix, 'Fixed distributing progress cards in the wrong order in Cities and Knights'))
        v127.push(getContent(PatchNoteType.Fix, 'Fixed profile page not loading on some devices'))

        // goku
        // Created CODEOWNERS file
        // Changed all API paths syntax to use hyphens
        // Added jwt token verification to 'can-logout', 'can-login' api endpoints
        // Fixed `colonist_version` becoming null in User and Analytics tables
        // /deteleoldusers query quickened
        // Room doesnt kick admin, manager, moderators due to timeout
        // Remove Analytics.session_id from database because we're not using it
        // Added timer to migrations
        // colonist_version format in database changed from 125=>1250, 125.1=>1251
        // Lowered sentry traces sample rate 5%=>0.5%
        // Fixed /userinfo not working

        // demi
        // Fixed Canonical tag so catan-rules should be indexed by google
        // Added a step in funnel for mouse movements

        // jeff
        // Sync server settings when restarting to prevent things like matchmaking games starting when server is updating.
        // Track when user first signs in
        // Restructured some of the ELO database logic to make sure async operations don't cause adverse bugs
        // Matchmaker is now async when adding new players since ELO needs to be set
        // Before setting starting ELO value it does a raw query to the database to make sure its not added twice
        // Fixed issue where a user stat value couldn't be 0. Returns undefined instead now
        // Added new ELO logic to track in the backend. Still not being used for matchmaking
        // Added 4P head to head chess ELO
        // Added 4P solo winner chess ELO
        // Added 2P Glicko2

        // meron
        // fixed database tests in local
        // fixed another sentry error by using typescript properly (https://sentry.io/organizations/katan/issues/2908286718/?project=1420748&query=is%3Aunresolved)

        // Mousetail
        // Update server errors to correct view
        // Add popup where a user can change their default color, backend by Jeff
        // Refactor: Move all util functions to ui_utils folder and separate out in multiple files to reduce imports
        // Rename a few singleton page related CSS classes
        // Add link to rules in game login message
        // Change link in top bar from `/rules` to `/catan-rules`, we should see a SEO boost

        // Alex
        // Landing page map changed
        // Landing page animation turned from gif to css reducing load on server
        // Responsive Landing page

        // Omar
        // Handle word filtering and long messages on the server, and bypass it for Admins and Managers
        // Refactor chat send message logic to use a single function for special cases
        // Allow spectators to execute in-game commands that don't need the player to be playing in the game

        // Andreme
        // Convert colonist_version to int

        // PatAle
        // Edited popup for already created offer

        this.patchNotes.push(getPatchNote(2022, 3, 5, 127, v127))

        const v126: PatchNoteContent[] = []
        v126.push(getContent(PatchNoteType.Update, 'Make room settings default when host leaves', ['PatAle']))
        v126.push(getContent(PatchNoteType.Update, 'Increased matching speed of Find Game'))
        v126.push(getContent(PatchNoteType.Update, 'Removed Free Map from Find Game'))
        v126.push(getContent(PatchNoteType.Update, 'Added animation to confirm checkbox when placing initial settlements'))
        v126.push(getContent(PatchNoteType.Update, 'Added a popup in Game Speed info icon'))
        v126.push(getContent(PatchNoteType.Fix, 'Google Login errors now show the reason'))

        // Meron:
        // add missing version to addversions command
        // setup new logger framework
        // fixed wrong types in game setting related enum entities
        // blocked ashburn crawler
        // track user device details and start a database user session when a websocket connection gets opened
        // added logrotate docs
        // added nodejs setup docs
        // fixed dependabot inconsistencies
        // added erd entity relationship diagram to docs
        // make logs show up in vscode
        // lower sentry traces sample rate

        // Mousetail:
        // players
        // Refactored FeaturedContent.ts - Will now load from a new spreadsheet
        // Strip oAuth token from URL on homepage load
        // Revert making all maps free, remove vietnam, europe, istanbul, and gold rush
        // Update profile page to have a header with the user name.

        // Mauro:
        // Get CU online counts
        // Writes online count into DB
        // Recounts online players 5s=>1s
        // Complete tests for LobbyOnlinePlayerCounts
        // Create tests for Lobby Maintenance on LobbyController

        // Jeff:
        // refactored quit logic out of KarmaEngine to generalize it
        // simple refactors in KarmaEngine
        // Added hidden chess ELO to 1v1. This is hidden and not being used in matchmaking yet. Just updating values in database
        // Removed Free Map from Find Game

        // Juan:
        // Created Analytics event for game speed info icon clicks
        // Removed funny robbers and brought back original one. Didn't reduce its size
        // Fixed font sizes, headers, alignments, missing info in Matchmaking & Profile
        // Made font sizes more consistent throughout the site

        // Demi:
        // Added eslint rule function-paren-newline
        // Enabled ing.com to access games and removed ads from their games
        // Reverted showing tutorial game to new players

        // Goku:
        // Bumps handlebars from 4.1.0 to 4.7.7
        // Bumps nth-check from 2.0.0 to 2.0.1
        // Bumps y18n from 4.0.0 to 4.0.3
        // Bumps hosted-git-info from 2.7.1 to 2.8.9
        // Bumps undefsafe from 2.0.2 to 2.0.5
        // Bump pathval from 1.1.0 to 1.1.1
        // Bump ajv from 6.10.0 to 6.12.6
        // Bump follow-redirects from 1.14.7 to 1.14.8

        this.patchNotes.push(getPatchNote(2022, 2, 18, 126, v126))

        const v125: PatchNoteContent[] = []
        v125.push(getContent(PatchNoteType.Feature, `Happy Valentines! <a href="/store" target="_blank"><img src="${IconRobberCupid}" style="height: 30px"></a>`))
        v125.push(getContent(PatchNoteType.Feature, 'All maps are free to play for 2 weeks. Enjoy!'))
        v125.push(getContent(PatchNoteType.Update, 'Consolidated all FAQ in a single page'))
        v125.push(getContent(PatchNoteType.Fix, 'Optimized game client for smoother animations'))
        v125.push(getContent(PatchNoteType.Fix, 'Fix game breaking bug when using Merchant with no available tiles'))
        v125.push(getContent(PatchNoteType.Fix, 'Fixed not being able to place settlement after moving knight using Intrigue'))
        v125.push(getContent(PatchNoteType.Fix, 'Fixed using Diplomat to move ship to reveal fog tile'))
        v125.push(getContent(PatchNoteType.Fix, 'Fixed matchmaking flow on mobile devices'))
        // Mauro: Create /stats API path
        // Goku: Bumps shelljs from 0.8.3 to 0.8.5.
        // Goku: Bumps follow-redirects from 1.14.6 to 1.14.7.
        // Demi: Optimized landing page gif by 30%
        // Demi: Shows tutorial mode to new players
        // Jeff: Fixed command logging making new files
        // Meron: Refactor isCrawler
        // Meron: Fixed could not get token from jwt error
        // Meron: Optimize make dev
        // Meron: Add custom sentry transaction logic so we can track websocket performance
        // Meron: Single server setup for docker
        // Meron: Add eslint rule for arrow spacing
        // Meron: Fix production tsconfig
        // Meron: Fix colonist version number bug
        // Meron: fix adduserstat command access
        // Mouse: Update map preview to use a three column layout
        // Mouse: remove "buy maps" from room screen
        // Mouse: Add CA to map preview
        // Mouse: Add /faq to the sitemap
        // Mouse: Updated press kit to show image and video previews
        // Juan: Fixed small font sizes
        this.patchNotes.push(getPatchNote(2022, 2, 4, 125, v125))

        const v124: PatchNoteContent[] = []
        v124.push(getContent(PatchNoteType.Blog, '<a href="https://blog.colonist.io/colonist-io-2021-summary/" target="_blank">Colonist.io Summary of 2021 and plans for 2022</a>'))
        v124.push(getContent(PatchNoteType.Feature, `Happy Lunar New Year! <a href="/store" target="_blank"><img src="${IconRobberLunar}" style="height: 30px"></a>`))
        v124.push(getContent(PatchNoteType.Feature, `New map free for v124: Stripes <img src="${MapStripesPreview}" style="width: 40%">`, ['PatAle']))
        v124.push(getContent(PatchNoteType.Fix, 'Fixed longest road bug when using Diplomat'))
        v124.push(getContent(PatchNoteType.Fix, 'Servers and game works much faster'))
        // PatAle: Make matchmaking popup button background green
        // Mousetail: Change player hover in lobby room list to go to the left of the icon instead of the right
        // Mousetail: Change end game stats table so minimum increment is 1, to prevent fractions from being shown in the scale
        // Mousetail: Change end game stats to remove black border, which was nearly invisible on a black background
        // Mousetail: Updated layout for press_kit, privacy-policy, terms, patch-notes, refund-policy, contact, bugs
        // Meron: Setup performance monitoring with sentry
        // Demi: when user clicks `enter lobby` rooms list refreshes
        // Demi: Sends map & mode events to google analytics
        // Demi: Client Analytics processes strings as well as labels
        // Demi: Fixed desktop fonts
        // Demi: Added Cupid and Lunar Robber
        // Demi: Added mobile solution to /bugs
        // Demi: Edited sitemap.xml
        // Goku: Bump node-sass from 4.12.0 to 4.13.1
        // Goku: Refactored online counts into LobbyOnlinePlayerCounts.ts
        // Goku: Updated env file and clarified socket server urls
        // Goku: Split Redis server from docker containers
        // Goku: Added Redis machine with $120 5.2GB 4 CPU
        // Jeff: big improvments to GameController efficiency by profilling
        // Jeff: created new `ServerClock` to avoid calling `Date.now()` too much
        // Jeff: indexed map components to increase map operations by 80-50%
        // Jeff: Longest road is now only calculated by the player taking the action instead of everyone. This cut back computation time by ~75%
        // Jeff: refactored `getFileName`. Before every log was getting the file name. Refactored so its only grabbed once per day
        // Jeff: `getCards` was calling clone. Couldn't get rid of the clone logic but I wrote a custom clone thats much less computationally heavy
        // Jeff: stored `GameController` in `UserSession` so that `LobbyController` didn't need to loop every game every action to find the game to execute
        this.patchNotes.push(getPatchNote(2022, 1, 22, 124, v124))

        const v123v1: PatchNoteContent[] = []
        v123v1.push(getContent(PatchNoteType.Fix, 'Fixed server crashes'))
        this.patchNotes.push(getPatchNote(2022, 1, 5, 123.1, v123v1))

        const v123: PatchNoteContent[] = []
        v123.push(getContent(PatchNoteType.Update, 'All players in a room become "unready" when another player leaves'))
        v123.push(getContent(PatchNoteType.Fix, 'Fixed server lag', undefined, undefined, undefined, ['https://colonist.featureupvote.com/suggestions/268030/lag']))
        v123.push(getContent(PatchNoteType.Fix, 'Fixed a bug where you could login while you had another guest account tab open'))
        // ardi: Linter now complains about no blank lines after some statements/blocks
        // Meron: Strict boolean for numbers
        // Meron: Add version columns to all database rows
        // Meron: Removed tournament command
        // Meron: Fixed commands
        // Meron: Added eslint rule for folder names
        // Meron: Add eslint rule for space in parens
        // Meron: Fix updateNumberOfGamesPlayedToday sentry error
        // Meron: Added eslint rule for space before func parens
        // Meron: Fixed crawler profile sentry error
        // Meron: Renamed code_tests -> test
        // jeff: Show dummy matchmaker popup in frontend before connecting to backend to reduce perceived lag
        // demi: From LobbyRowData removed AverageKarma and private game infos
        // Goku: Deleted all child process related code residue
        // Goku: Moved all parent/child/shared folder contents into /server/
        // Goku: Stopped sending lobby online count data, every 5s. Instead sending it every 10 minutes
        // Goku: Refactored and split lobby online count data from disconnected game data
        // Goku: Added /stats command
        // Goku: Downgraded node from 16=>12
        // Goku: Bump axios from 0.21.1 to 0.21.2
        // Goku: Bump ws from 6.2.1 to 6.2.2
        // Goku: Bump redis from 2.8.0 to 3.1.1
        // Goku: Bump chart.js from 2.8.0 to 2.9.4
        this.patchNotes.push(getPatchNote(2022, 1, 5, 123, v123))

        const v122v1: PatchNoteContent[] = []
        v122v1.push(getContent(PatchNoteType.Update, 'Matchmaking options show game speed', undefined, undefined, 'https://prnt.sc/24aivbm'))
        v122v1.push(getContent(PatchNoteType.Update, 'Shows game speed in lobby', undefined, undefined, 'https://prnt.sc/24aoqud'))
        v122v1.push(getContent(PatchNoteType.Fix, 'Fixed room list not scrolling', undefined, undefined, 'https://prnt.sc/24akwvq'))
        v122v1.push(getContent(PatchNoteType.Fix, 'Fixed mobile chat sizes'))
        v122v1.push(getContent(PatchNoteType.Fix, 'Reconnect game banner staying after reconnecting to game'))
        // demi: Reconnect banner doesn't come back after clicking x button.
        // demi: While lobby games are loading it is showing Loading... https://www.loom.com/share/31c368395e2446edbca645fcb796f267
        // demi: Fixed game settings showing proper game & mode name: before: https://prnt.sc/24aowmj after: https://prnt.sc/24apn5q
        // ardi: refactored userType to use just a boolean
        // ardi: /updateloginmessage command now supports spaces and reset to the default message
        // ardi: added inline parameter extension to recommended
        // Meron: upgrade to node v16
        this.patchNotes.push(getPatchNote(2021, 12, 26, 122.1, v122v1))

        const v122: PatchNoteContent[] = []
        v122.push(getContent(PatchNoteType.Feature, 'Added 1v1 to matchmaking'))
        v122.push(getContent(PatchNoteType.Feature, 'Added weekly free map to matchmaking'))
        v122.push(getContent(PatchNoteType.Update, 'Lobby has been redesigned'))
        v122.push(getContent(PatchNoteType.Update, 'Added broadcast banners', undefined, undefined, 'https://prnt.sc/23oo5vb'))
        v122.push(getContent(PatchNoteType.Update, 'Patch Notes button in footer shows version number'))
        v122.push(getContent(PatchNoteType.Fix, 'Game not loading in macOS/Safari/Catalina with Blue Screen solution added to <a href="/bugs">bugs page</a>'))
        // Social media icons are hex 'https://prnt.sc/224j4xh', 'https://prnt.sc/224ix56'
        // ardi: refactored userType to use just a boolean
        // Meron: Fixed user agent parse error
        // Meron: Upgraded redis docker image to 6.2.6-alpine
        // Meron: Fix randomly failing test (reduce likelihood of it failing)
        // Meron: Upgrade typescript to 4.5.4 (edited zooming behavior in ad controller and game chat view)
        // Meron: Tracking users effectively
        // Meron: Add user stats
        // Juan: Fixed Christmas Hat avatar
        // Juan: Removed blue background color from all store images
        // Demi: Removed lobby chat spam errors https://prnt.sc/21st1mh
        // Demi: Removed colonist 160x600 ads from the lobby
        // Demi: Mobile room looks similar to dekstop view
        // Demi: Clicking on X during assets loading removes game hash from URL
        // Demi: Room name can't be changed anymore
        // Demi: Made popup design simpler
        // Demi: Removed room name related code
        // Demi: Landingpage prompts playing against bots before matchmaking
        // Demi: Removed lobby chat stuff (might break other chat stuff)
        // Goku: Added a solution to game not loading in, macOS/Safari/Catalina with WebGL/Socket/Blue Screen/Assets Not Loading/Certificate errors into <a href="/bugs">bugs page</a>'
        this.patchNotes.push(getPatchNote(2021, 12, 23, 122, v122))

        const v121: PatchNoteContent[] = []
        v121.push(getContent(PatchNoteType.Feature, `New Fun Map: Europe <img src="${MapEuropePreview}" style="width: 40%">`))
        v121.push(getContent(PatchNoteType.Fix, 'Fixed errors with connecting to servers and matchmaking'))
        // Juan: Fixed being able to do actions in wrong pages
        // Goku: Refactored Jwt.ts
        // Jeff: Fix all `session.user` undefined sentry errors
        // Jeff: Reordered user connection logic. When socket connects, user is pulled from DB right away instead of waiting for the second message
        // Jeff: All server endpoints check if `session.user` is defined before executing the action
        // Jeff: All actions check to make sure `session.location` is correctly defined
        // Jeff: Restructured Matchmaking action so that `session.location` is properly tracked between both Socket and Matchmaking server
        // Meron: Added strict boolean eslint rule
        // Meron: Added Custom Analytics engine
        // Meron: Fixed chat errors in sentry
        // Meron: Clear warning in Auth test and fix ItemEntityService test
        // Meron: Took care of some sentry errors
        // Meron: Fixed enums sync error
        // Meron: Fix rate limit timeouts
        this.patchNotes.push(getPatchNote(2021, 12, 15, 121, v121))

        const v120v1: PatchNoteContent[] = []
        v120v1.push(getContent(PatchNoteType.Feature, `Vietnam map is back! Free to play for 2 weeks. Enjoy! <img src="${MapVietnamPreview}" style="width: 40%">`))
        v120v1.push(getContent(PatchNoteType.Fix, 'Fixed disconnection issue while finding match making games'))
        // Juan: Players now see the lobby after finishing 1 game
        // Juan: Renamed SF scenario Heading for New Shores -> New Shores
        // Goku: Added 100 api call limit per minute with rate limiter in express
        // Goku: Added a 1 purchase item call limit per 5 seconds
        // Goku: Separated servers into different Health Check URLs
        // Demi: Added google optimize
        // Demi: Refactored most ejs files
        // Demi: Headers on all pages show login & profile
        // Demi: Removed test server button
        // Demi: Removed tournament page
        // Meron: Include totalColonistCoins in output of /getinfo command even if user is not logged in
        this.patchNotes.push(getPatchNote(2021, 12, 8, 120.1, v120v1))

        const v120: PatchNoteContent[] = []
        v120.push(getContent(PatchNoteType.Feature, `Added a new avatar <a href="/store" target="_blank"><img src="${IconRobberSanta}" style="height: 40px"></a> Get it at the <a href="/store" target="_blank">Store</a>!`))
        v120.push(getContent(PatchNoteType.Update, 'Find Game matches based on karma'))
        v120.push(getContent(PatchNoteType.Update, 'Vietnam map is back as free map'))
        v120.push(getContent(PatchNoteType.Fix, 'On mobile lobby buttons fixed'))
        v120.push(getContent(PatchNoteType.Fix, 'On mobile corner notification fixed'))
        // Demi: Moved process docs to its own repo
        // Demi: Moved roadmap out of docs to wiki
        // Meron: Fixed refunditem command
        // Meron: Optimized github actions
        // Meron: Refactor game settings
        this.patchNotes.push(getPatchNote(2021, 12, 2, 120, v120))

        const v119: PatchNoteContent[] = []
        v119.push(getContent(PatchNoteType.Feature, 'New <b>Find Game</b> feature! Now you can start an auto match and jump directly into a new game.</br>More game modes will be added later'))
        v119.push(getContent(PatchNoteType.Update, `Robber has a Santa suit <a href="/store" target="_blank"><img src="${IconRobberSanta}" style="height: 30px"></a>`))
        v119.push(getContent(PatchNoteType.Update, 'When a player is reported they automatically get muted'))
        v119.push(getContent(PatchNoteType.Update, 'Added top notification banner'))
        v119.push(getContent(PatchNoteType.Update, 'Added corner notification popup'))
        v119.push(getContent(PatchNoteType.Fix, 'Added sea tiles to Istanbul map'))
        // Goku: Added Matchmaking server to the mix
        // Goku: Changed cache deletions to work in a different way, especially in multi server setting
        // Demi: Turned social media icons from png to svg
        // Demi: Shows guest profiles
        // Demi: Added Main CTA to landing page
        // Demi: Refactored some CTA code
        // Demi: Added robber santa to store
        // Jeff: Added MatchmakingEngineController, MatchmakingEngine, MatchmakingPopulationTrackerController and MatchmakingPopulationTracker
        // Jeff: These classes match players into a game based on karma for now. In the future other variables will be thrown into the mix
        // Jeff: Big refactor to `RoomColor` to move the logic into a new class `PlayerColorSelector` so that that `MatchmakingEngine` could use the same logic.
        // Jeff: Added to Matchmaking server work Goku did. Not client asks MM to find game. MM server finds game, tells client to connect to game, tells socket server game is happening. Client pings socket server and once all the players connect the game starts.
        // Meron: Fix error related to express-useragent
        // Meron: Fix vliemailhash error
        this.patchNotes.push(getPatchNote(2021, 11, 21, 119, v119))

        const v118: PatchNoteContent[] = []
        v118.push(getContent(PatchNoteType.Feature, `New Fun Map: Istanbul <img src="${MapIstanbulPreview}" style="width: 40%">`))
        v118.push(getContent(PatchNoteType.Update, 'Landing page is shown to new players'))
        v118.push(getContent(PatchNoteType.Update, 'Added a navigation bar and cleaned up the site'))
        v118.push(getContent(PatchNoteType.Fix, 'Fixed room names not showing default speed'))
        v118.push(getContent(PatchNoteType.Fix, 'Fixed fun map error in room settings'))
        v118.push(getContent(PatchNoteType.Fix, 'Fixed gap in trade interface'))

        // Demi: Shows karma and username on load
        // Demi: Refactored lots of HTML & CSS part
        // Demi: Implemented Landing Page
        // Demi: Removed lobby banner ads and added 300x250 ad
        // Demi: Implemented navigation bar for most pages
        // Demi: Added moderator command to toggle off landing page for all users except mobile
        // Meron: Add ejs support in vscode
        // Meron: Add method to get users ids from last game played by a certain user
        // Meron: Remove test endpoint
        // Meron: Update stylelint packages to fix vscode bug
        // Meron: Fix eslint no-restricted-import
        // Meron: Convert StoreItemCategory, StoreTransactionType, StorePresalePackType and AccessLevel to table
        // Meron: Index createdAt column in ColonistBaseEntity
        // Meron: Added a Hacky command to edit karma for testing matchmaking
        this.patchNotes.push(getPatchNote(2021, 11, 12, 118, v118))

        const v117: PatchNoteContent[] = []
        v117.push(getContent(PatchNoteType.Feature, 'Gold Rush map will be free for 2 more weeks! Enjoy!'))
        v117.push(getContent(PatchNoteType.Update, 'Default room settings are now Fast speed and Hide Bank Cards'))
        v117.push(getContent(PatchNoteType.Fix, 'Fixed Play vs Bots and Create buttons not showing up on mobile'))
        // Stan: Rulebook added h1 titles
        // Stan: Added 'sync-translations' utility
        // Stan: Rulebook page and language specific html keywords
        // Stan: Rulebook alt tag descriptions for images
        // Stan: Rulebook SEO added hreflang tags
        // Stan: Rulebook translate urls
        // Stan: Added 'sync-translations' utility
        // Stan: Update scrollbar colours
        // Meron: Renamed quited -> quit_with_penalty and removed isHuman column in player_games table
        // Meron: Convert all db columns to snake_case
        // Meron: Fix rulebook routing
        // Meron: Clear cache if pending migrations contain an unsafe migration
        // Meron: Add eslint rule to make sure interfaces aren't prefixed with I
        // Meron: Create enums schema in db
        // Meron: Convert PlayerColors and AchievementType to tables in the enums schema
        // Meron: Add logic to sync enums with their tables
        // Meron: Add role to deal with object curly spacing
        // Jeff: remove enum `GameType` since it was bugged and not logging anything
        this.patchNotes.push(getPatchNote(2021, 10, 27, 117, v117))

        const v116: PatchNoteContent[] = []
        v116.push(getContent(PatchNoteType.Feature, `New Fun Map: Gold Rush <img src="${MapGoldrushPreview}" style="width: 40%">`, ['Andre']))
        v116.push(getContent(PatchNoteType.Update, 'Moved Create and Bot Game to big buttons at the top of the lobby', ['Andre']))
        v116.push(getContent(PatchNoteType.Update, 'Bots no longer accept trades in Cities & Knights'))
        v116.push(getContent(PatchNoteType.Fix, 'Fixed trade bar bug when trading with more than 4 players', ['Andre'], 'https://user-images.githubusercontent.com/541886/135210930-5e9138b5-9d74-4691-961f-eee0f9c8b987.png', 'https://user-images.githubusercontent.com/541886/135210726-d645a503-2c87-4185-8ac6-2b50589ebd84.png', ['https://colonist.featureupvote.com/suggestions/114984/fix-trade-proposal-ui-visual-bug-78-players']))
        v116.push(getContent(PatchNoteType.Fix, 'Fixed gold tiles not highlighting when rolled', ['Andre']))
        v116.push(getContent(PatchNoteType.Fix, 'Profile page loads faster', ['Meron']))
        v116.push(getContent(PatchNoteType.Fix, 'Fixed warning message not displaying properly when winning during Special Build Phase', ['Jeff']))
        // Andre: Room hash will not disappear from the URL when reconnecting to a game
        // Andre: Big lobby buttons are now also visible for logged in users
        // Andre: Replaced tutorial button with create button
        // Stan: Added 'sync-translations' utility
        // Meron: Cleanup access level enum in db
        // Meron: Added disk cleanup instructions
        // Jeff: restructed BaseMapData to include isActive flag
        // Jeff: prevent UI from showing inactive maps
        // Jeff: backend checks to make sure active map is selected
        // Jeff: backend checks to make sure map is active before starting game
        // Jeff: commented in all contributor maps and set flag to false
        // Jeff: added information to add old contributor maps
        // Jeff: Clean up enum names before being added to DB
        // Jeff: renamed all mode code and map code to follow convention <modeName>+<numberOfPlayers>+<P> example: Seafarers56P
        // Jeff: renames all `FiveSix` to `56` and `SevenEight` to `78`
        // Jeff: renamed all instances of "base game" to `Classic` to avoid confusion with `Base` classes like `BaseGameModeData`
        // Jeff: Added numbers to all enums in code being added to DB. This is to avoid people reordering or changing them around
        this.patchNotes.push(getPatchNote(2021, 10, 13, 116, v116))

        const v115: PatchNoteContent[] = []
        v115.push(getContent(PatchNoteType.Feature, `New Fun Map: JellyFish <img src="${MapJellyfishPreview}" style="width: 40%">`, ['John']))
        v115.push(getContent(PatchNoteType.Update, 'Vietnam Map free until next version', ['Kipler']))
        v115.push(getContent(PatchNoteType.Fix, 'Bug: Player being able to place road after ship in Seafarers Cities and Kights', ['RetroPanda']))
        v115.push(getContent(PatchNoteType.Fix, 'Bug: Trade ratio not updating properly when using Merchant Fleet and unlocking Trading House on the same turn', ['karm']))
        // Goku: Refactored presale pack function in /api/user
        // Goku: Did lint fixes
        // Goku: Refactored login/signup function
        // Goku: Refactored site loading token assignment function
        // Cem: autocomplete off for chats
        // Meron: Show ip address in sentry
        // Meron: Fix endlallgames command countdown
        // Meron: Added test for authentication error
        // Meron: Cleaned up tsconfig.json and removed karma.conf.js
        // Meron: Fix user does not exit bug in user profile
        // Meron: Added a doc to set up ftp access to logs
        // Meron: Setup vscode debugger
        // Meron: Removed unused imports and created a eslint rule for it
        // Meron: Updated typescript eslint 3.x=>4.x
        // Meron: Added a new spacing rule in eslint
        // John: Add clean code resource to common-coding-mistakes
        this.patchNotes.push(getPatchNote(2021, 9, 15, 115, v115))

        const v114: PatchNoteContent[] = []
        v114.push(getContent(PatchNoteType.Feature, `New Fun Map: Vietnam <img src="${MapVietnamPreview}" style="width: 40%">`, ['Kipler']))
        v114.push(getContent(PatchNoteType.Feature, `Old Fun Map: Mountain of Riches <img src="${MapMountainOfRichesPreview}" style="width: 40%">`, ['Andrew']))
        v114.push(getContent(PatchNoteType.Update, 'Rulebook shows "URL Copied" text when clicking share link button'))
        v114.push(getContent(PatchNoteType.Update, 'Rulebook has Spanish support'))
        v114.push(getContent(PatchNoteType.Fix, 'User profile: fixed \'User does not exist\' bug'))
        // John: Line up room dropdown when there's a long text
        // John: Add test to check if version numbers in PatchNotes and KatanConfig is the same
        // John: Align text left in contribute and press_kit page
        // Added a doc to set up ftp access to logs
        // Demi: added new binance ads
        // Added mocha test for rulebook language phrase keys
        // Added mocha test for rulebook embedInString function
        // Added mocha test for rulebook url generator
        this.patchNotes.push(getPatchNote(2021, 9, 1, 114, v114))

        const v113: PatchNoteContent[] = []
        v113.push(getContent(PatchNoteType.Feature, '<b>Seafarers + Cities & Knights 5-6 Player Expansion is out!</b> Get it at the <a href="/store" target="_blank">Store</a>'))
        v113.push(getContent(PatchNoteType.Feature, 'Rule book added!'))
        v113.push(getContent(PatchNoteType.Fix, 'Cities & Knights: Bots not selecting Aqueduct resources properly'))
        v113.push(getContent(PatchNoteType.Fix, 'Links to user profiles will work regardless of casing, e.g., https://colonist.io/profile/demiculus and https://colonist.io/profile/Demiculus will point to the profile of the same user.'))
        // France: Hidden spectator buttons. No longer does hover action when hovered.
        // France: Added configurations to settings.json to reduce VSCode memory usage.
        // John: Remove poki from code
        // John: Made volume slider 100% opacity
        // John: Rotate private ads (test with closing & opening adblock to see if anything messes up)
        // Stan: Added recommended docker version to onboarding
        // Stan: head.ejs loads static resources (such as CSS and site icon) from absolute routes
        // Stan: Exclude ansible folder in makefile
        // Meron: Goku and I took care of http to https redirection in nginx config for katan.io personal test servers
        // Meron: Added a new job in CI to check if PatchNoteData.ts has changed
        // Meron: Upgraded pg from 7 to 8 and cleaned up tests
        // Meron: Fix ssl error caused by upgrading pg from 7 to 8
        // Meron: Converted some modules to classes to fix no-inner-declarations eslint error
        // Meron: Update endallgames and add cancelcountdown command
        // Meron: Added naming convention rules
        // Meron: An error was being logged in sentry (https://sentry.io/organizations/katan/issues/2542265534/?project=1418367&referrer=slack) when email token wasn't stored in redis. I fixed it by returning early if email is undefined.
        // Meron: Reduced accuracy of random tests
        // Meron: Hot fixed authentication error when user ends game (https://cdn.discordapp.com/attachments/855295689735405579/872550090944946266/image0.jpg)
        // Juan: Replaced broken Copyright links with webarchive links
        // Juan: New background colour for game log, chat, bank, player info box, card holder, and trade bar
        // Juan: New orange text chat colour for better contrast and readability
        // Jeff: Refactored how bots select resources for aqueduct and gold tiles. The old structure would cause the bots to spam bot actions trying to make a move they couldn't actually make. The new structure cleans it up so they know when they're supposed to make moves.
        // Jeff: fixed the bug where the turn bell would sound 2 times for your turn during game setup. Backend handles it now, not the frontend
        // Jeff: large amount of linting fixes. Went through most files but the sensitive files and fixed the structuring and function calls to fix the errors
        // Jeff: changed the PowerPerformance enums names. Should not affect functionality
        // Demi: removed seo sentences like <display: none; Play settlers of catan online>
        // Demi: Added shapez.io ad
        // Demi: Added colonist con ad toggle admin command

        this.patchNotes.push(getPatchNote(2021, 8, 18, 113, v113))

        const v112: PatchNoteContent[] = []
        v112.push(getContent(PatchNoteType.Feature, `Added a new icon <a href="/store" target="_blank"><img src="${IconSombrero}" style="height: 60px"></a>`))
        v112.push(getContent(PatchNoteType.Fix, 'Cities & Knights: Fix trade ratio locking at 2:1 when using Merchant Fleet', ['NordicZombie']))
        v112.push(getContent(PatchNoteType.Fix, 'Cities & Knights: Game freezing when removing knights after Deserter'))
        v112.push(getContent(PatchNoteType.Fix, 'Fixed timer warning at end of turn not working for certain game actions', ['HansM']))
        // Juan: Room item width overflowing
        // Jeff: Refactored the entire trade ratio system to include temporary and permanent trade ratios. Temporary values override the permanent values and get cleared by their respective controllers.
        // Jeff: Refactored code in UIGameTimerController to clean up the timer logic and make it easier to play the warning sound when a player was taking an action off turn
        // Jeff: Added command /togglegetcardcommandsintestserver
        // Jeff: Refactored AchivementView to take in containers instead of sprites
        // Jeff: Refactored IAchievement to only be in the frontend by creating UIGameCityImprovementAchievementController
        // Jeff: Only show city unlock achivements to player earning the achivement
        // Jeff: Resize AchievementView to be the same height as the game log
        // Jeff: Added game ID to all game logs to make recreating scenarios a lot easier
        // Juan: edited game log messages when a player losses connection. Players will now understand when the bot will take over, depending on the game speed
        // Juan: final tweak on very fast timers, aimed to optimize CK games in this speed
        // Juan: Updated disable_ad_block image links
        // Juan: Added number of VPs for each action in the game log messages
        // Meron: Filter out known bot from analytics events
        // Stan: Reduced size of help buttons and centered volume slider with icon
        // Stan: Fixed squished spectator count display
        // Stan: Created system to throttle Indicative Analytics (currently not active)
        // France: Slowed down error message pop-up. Floating text now appears for 2 seconds.
        this.patchNotes.push(getPatchNote(2021, 8, 4, 112, v112))

        const v111: PatchNoteContent[] = []
        v111.push(getContent(PatchNoteType.Feature, '<b>Seafarers + Cities & Knights Expansion is out!</b> Get it at the <a href="/store" target="_blank">Store</a>'))
        v111.push(getContent(PatchNoteType.Update, 'Optimized very fast timers for Cities & Knights'))
        v111.push(getContent(PatchNoteType.Update, 'No need to scroll down to click Ready and Start Game buttons inside a room'))
        v111.push(getContent(PatchNoteType.Fix, 'Bots now select lowest level deactivated knight when removing knight in C&K', ['NordicZombie']))
        v111.push(getContent(PatchNoteType.Fix, 'Fix popups getting stuck when clicking multiple development cards', ['orangehat']))
        // Juan: Fixed movable ships for loops routes
        // Stan: Update all css to pass stylelint tests
        // Meron: Add new /endallgames command
        // Meron: Add new /endgame command
        // Jeff: refactor on how swappable actions are handled. Logic was moved to shared folder for frontend to do some checks upstream. Then I allowed the frontend to request swapping actions by sending msg to backend. This fixed the bug when clicking multiple development cards
        // Jeff: refactored the hirarchy of button views. now the main button implements `onEvent` and the extended classes add addtional functionality on top of that. This was done to properly update all buttons at the end of the game.
        // Jeff: big refactor in how movable ships are determined. The original algorithm wasn't catching the edge cases properly. Defintely ping play testers to check new algorithm
        // Jeff: the refactor in moving ships is the same algorithm that determins movable roads for diplomat. If the ship moving is bugged so will diplomat
        // Jeff: Refactored UIMapHighlightDiceNumbers, UIGameMapDiceProbabilityView and UIGameMapDiceHighlightView because there was a lot of duplicate code in these classes and I did a really poor job writing it the first time.
        // Jeff: Refactored knight strength broadcasting for better Deserter UX. Might cause random knight strength count bugs but I didn't see any
        // Jeff: Refactored how the merchant owner and merchant VPs are updated when trasferring players to make for better UX
        // Demi: Edited anayltics
        this.patchNotes.push(getPatchNote(2021, 7, 21, 111, v111))

        const v110: PatchNoteContent[] = []
        v110.push(getContent(PatchNoteType.Feature, `Added a new icon <a href="/store" target="_blank"><img src="${IconFarmer}" style="height: 60px"></a>`))
        v110.push(getContent(PatchNoteType.Feature, 'Added indicator when above discard limit'))
        v110.push(getContent(PatchNoteType.Feature, 'New <i>waiting for action</i> indicator in player info box', ['Loaf']))
        v110.push(getContent(PatchNoteType.Update, 'New indicators for Longest Road and Largest Army in player info box', undefined, undefined, 'https://i.imgur.com/9CyTQqA.png', undefined))
        v110.push(getContent(PatchNoteType.Update, 'New Bounties System to earn coins, visit <a href="https://discord.gg/uzCKAWV6qm" target="_blank">Discord</a> for more details.'))
        v110.push(getContent(PatchNoteType.Update, 'Using Monopoly now shows the total amount of cards stolen'))
        v110.push(getContent(PatchNoteType.Update, 'Added Store notification badge to show when new items are released'))
        v110.push(getContent(PatchNoteType.Fix, 'Chat message appears when game can no longer be rematch'))
        v110.push(getContent(PatchNoteType.Fix, 'Cities & Knights not tracking Progress Card stats properly'))
        // Juan: Increased spacing for player profiles on the robber popup
        // Jeff: refactored longest road counting algorithm to be able to handle new knight logic for SF + CK
        // Jeff: refactored placing ship logic to be able to handle new knight logic for SF + CK
        // Jeff: refactored placing ship logic to be able to handle using diplomat with ships
        // Jeff: removed all legacy bank trade code
        // Jeff: refactored and consolidated bank trade code that was duplicated in the frontend and backend
        // Jeff: refactored out PlayerProfiles and consolidated logic into UIGamePopupSelectPlayerContainerView. Nothing should change visually but UIGameTradeInfoController and VoteView might be affected.
        // Jeff: refactored out ProfileView and replaced all instances with PlayreProfile. All logic was basically duplicated. Classes that might be affected: AchievementView, ViewTradeInfoOffer,  ViewTradeInfoOfferCreatorProposal, UIGamePlayerView, UIGameStateController, MultiProfileView
        // Jeff: refactored out SelectablePlayerProfile. At the time of editing PlayerProfile evolved to contain all the logic that was in SelectablePlayerProfile before so it was an easy swap. Classes that might be affected: MultiProfileView
        // Jeff: refactored out MultiProfileView and replaced it with UIGamePopupSelectPlayerContainerView. Classes that might be affected: ViewTradeInfoOffer, TradeExchangeView
        // Jeff: Big refactor on playerProfile naming in the frontend. There was 3 things called 'PlayerProfile' in the frontend
        // Jeff: The circle with icon in the center was renamed to `PlayerAvatar`
        // Jeff: The player box with scores and points in the bottom right corner was renamed to `PlayerInformation`
        // Jeff: The actual player profile page was kept as `PlayerProfile`
        // Meron: Setup Continuous Integration using Github Actions
        // Meron: Setup stylelint for linting css/scss files
        // Stan: Updated analytics controller and setup Indicative analytics
        // Stan: Optimized analytic events that were producing the most data to send less frequently
        // Stan: GameUIEngine refactored to UICanvasEngine.
        // Stan: UICanvasController and UICanvasConfig created to improve the modularity of the UICanvasEngine
        // Stan: Removed the variable UIGameConstants.MARGIN, replaced with variables in UICanvasController & UICanvasConfig
        // Stan: Removed .html from the end of all URLs
        this.patchNotes.push(getPatchNote(2021, 7, 7, 110, v110))

        const v109: PatchNoteContent[] = []
        v109.push(getContent(PatchNoteType.Feature, '<b>Cities & Knights 5-6 Player!</b> Get it at the <a href="/store" target="_blank">Store</a>'))
        v109.push(getContent(PatchNoteType.Update, 'All cards in hand are visible while discarding'))
        v109.push(getContent(PatchNoteType.Update, 'Building buttons are hidden while spectating a game'))
        v109.push(getContent(PatchNoteType.Update, 'Game log lists the players discarding cards'))
        v109.push(getContent(PatchNoteType.Fix, 'End game graphs scale when the screen resizes'))
        v109.push(getContent(PatchNoteType.Fix, 'Clicking building buttons after the game ends doesn\'t take you to the Lobby anymore'))
        // Added action button to lobby store adverts
        // Improved the presskit and updated the images
        // Change to bronze/silver/gold system
        // Text adjusted to fit in the turn state indicator
        // VLI email hash fixes mentioned here https://github.com/colonistio/katan/pull/4145
        // Contact added purchase gone button
        // refactor ad controller
        // Refactored getVariables to a class array property called variables
        // Used isVariableLengthCorrect in commands where we need to check if users are inputting the right number of variables
        // isVariableEmail works as expected using a REGEX
        // Added test cases for isVariableEmail
        // Refactored isVariableEmail, isVariableString and isVariableNumber
        // Refactored how the room handles setting default VPs for all modes
        // Refactored how premium room access handles unlocking maps with different store items (now all arrays)
        // Cleaned up how default settings are defined for Earth and UK when used for Seafarers
        this.patchNotes.push(getPatchNote(2021, 6, 23, 109, v109))

        const v108: PatchNoteContent[] = []
        v108.push(getContent(PatchNoteType.Update, 'Enabled all maps with Cities & Knights 4 Player'))
        v108.push(getContent(PatchNoteType.Update, 'Can accept trades while taking an action', ['Berkin'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/142324/trades-should-have-priority-over-building-building-canceled-if-i-make-a-trade']))
        v108.push(getContent(PatchNoteType.Update, 'Increased timers for Cities & Knights'))
        v108.push(getContent(PatchNoteType.Fix, 'Fixed map scrolling while rule book is open', undefined, undefined, undefined, ['https://colonist.featureupvote.com/suggestions/109056/scrolling-up-and-down-on-learn-to-play-window-in-game-zooms-in-and-out-of-the-ga']))
        v108.push(getContent(PatchNoteType.Fix, 'Discord invite opens in a new tab rather than redirecting', ['Hjalte']))

        // Refactored mechanic files for Special Build Phase
        // Refactored bot discard logic
        // Can now start another action before canceling the first one
        // Refactored string length check in ChatSecurity and ValidateAction
        // Added email hashing for VLI
        // Added an API endpoint for Catan Community. /api/lastgame/:player
        this.patchNotes.push(getPatchNote(2021, 6, 9, 108, v108))

        const v107: PatchNoteContent[] = []
        v107.push(getContent(PatchNoteType.Feature, '<b>Cities & Knights!</b> Get it at the <a href="/store" target="_blank">Store</a>'))
        v107.push(getContent(PatchNoteType.Update, 'Word filter added to room name'))
        v107.push(getContent(PatchNoteType.Fix, 'Fixed oversized chat box in mobile view', undefined, 'https://i.imgur.com/FlGwg6G.png', 'https://i.imgur.com/56mQzJ0.png', undefined))
        v107.push(getContent(PatchNoteType.Fix, 'Fixed hitting enter in room title kicked player out of the room', undefined, undefined, undefined, ['https://colonist.featureupvote.com/suggestions/83631/bug-hitting-enter-key-when-filling-in-room-name-kicks-you-out-your-own-room']))
        v107.push(getContent(PatchNoteType.Fix, 'Fixed incorrect number of 2 and 12 in 7-8 Player map'))
        // Fixed dead zones on screen, 'https://colonist.featureupvote.com/suggestions/91887/disable-ads-that-take-over-page'
        // Fixed undefined game resolution displaying in mobile browsers
        // Compress audio from 280KB to 144KB (~50% decrease in size)
        // Refactored tool tips to include paragraphs
        // Refactored logic to split Bitmaptext
        // Add countdown command
        // Tab title doesn't blink on page load
        // Cache bootstrap css
        this.patchNotes.push(getPatchNote(2021, 5, 26, 107, v107))

        const v106: PatchNoteContent[] = []
        v106.push(getContent(PatchNoteType.Update, 'Increased the size of cards and numbers in player information box'))
        v106.push(getContent(PatchNoteType.Update, 'Tool tips information changes depending on the game mode'))
        v106.push(getContent(PatchNoteType.Update, 'Removed ambiguous characters from room links to avoid confusion (1, I, l, O, 0)'))
        v106.push(getContent(PatchNoteType.Update, 'Moved spectator icon'))
        v106.push(getContent(PatchNoteType.Fix, 'Fixed 5+ player scroll box slider'))
        // Merging all of the remaining C&K logic from phase 7 into base game to stablize'))
        // This includes changes to bank interface and misc. changes to things like cities and roads'))
        // 3-4 base game actions could be influenced by this change'))
        // Added trust proxy into express to redirect http to https
        // Executed JWTCleaning. We're fully in the new JWT system
        // Fixed server sync settings for changing profile and send to hexs limits
        this.patchNotes.push(getPatchNote(2021, 5, 13, 106, v106))

        const v105: PatchNoteContent[] = []
        v105.push(getContent(PatchNoteType.Feature, `New Fun Map: Volcano <img src="${MapVolcanoPreview}" style="width: 40%">`, ['Shutsen']))
        v105.push(getContent(PatchNoteType.Update, 'Redesigned player information box'))
        v105.push(getContent(PatchNoteType.Fix, 'Help buttons scale more properly'))
        v105.push(getContent(PatchNoteType.Fix, 'Featured video titles are limited to 30 characters'))

        // PIXI.text doesn't update if same text
        // Base random map isn't 40% discount anymore (300 -> 500 coins)
        // Fixed adblock detection

        // Refactored city placing logic to handle destroyed cities
        // Refactored resize on help buttons which might affect ofther frontend resizing
        // Added barbarian attack logic to the game
        // Edited discard controller to discard progress cards
        // Added in knight actions, movement, displacement and moving robber
        // Edited help button resizing
        // Added information for all progress cards
        // Added logic to aquire and discard progress cards
        // Edited how development cards are added to the bank controller
        // Edits to longest road algorithm to allow knight to break longest road
        // Edits to longest road algorithm so it could be adapted and used for knight movements
        // Fix layering for cards added to trade container
        // Finished C&K logic but suppressed for base game testing
        // Added all progress card logic
        // Progress card logic touched a LOT of the base game logic
        // Expect a few base game things to be broken but all tests are passing now

        this.patchNotes.push(getPatchNote(2021, 4, 21, 105, v105))

        const v104: PatchNoteContent[] = []
        v104.push(getContent(PatchNoteType.Feature, `Added a new icon <a href="/store" target="_blank"><img src="${IconWorker}" style="height: 30px"></a>`))
        v104.push(getContent(PatchNoteType.Update, 'Card counter gets bold when above the discard limit', [], 'https://prnt.sc/10lojw2', 'https://prnt.sc/10lok2g'))
        v104.push(getContent(PatchNoteType.Update, 'Prevent long usernames from exceeding the container limits', ['Konidias']))
        v104.push(getContent(PatchNoteType.Update, 'Updated tool tips', ['Konidias']))
        v104.push(getContent(PatchNoteType.Update, 'New <a href="https://youtu.be/XUcO2wYcIEY" target="_blank">Tutorial video</a>!'))
        v104.push(getContent(PatchNoteType.Fix, 'Fixed all disconnects'))
        v104.push(getContent(PatchNoteType.Fix, 'Fixed bots being unable to select more than 5 resources from gold tiles'))
        v104.push(getContent(PatchNoteType.Fix, 'Fixed games in profile not updating properly after name change', ['Bugg']))

        // Contact mail to doesn\'t use mailto:
        // Refactor knight state logic to streamline future additions to code
        // Refactor SocketGameSend to instance instead of static
        // Implement alchemist popup
        // Implement commercial harbor popup

        // Server Things:
        // Split onlinecatan, hexs, colonist server into static and socket
        // Updated JWT issuer, audience and had to move players from old to new jwt
        // Created another JWT for server API
        // Added domain setting to cookie
        // Updated and fully automated ansible build and deploy scripts
        // All servers are upgraded from Ubuntu 18.04 (LTS) x64 => Ubuntu 20.04 (LTS) x64
        // Updated nginx settings to stop potential DDOS
        // Fixed nginx 502.html page that is shown while server is down
        // Deleted demiculus server
        // Moved away from Cloudflare websockets
        // Moved away from Cloudflare SSL, instead using letsencrypt SSL that auto generates and updates in the server
        // Refactored and added new EJS settings that are sent via express
        // Logout system checks if socket server has connected sockets
        // Payment system sends POST to socket server to clear cache and kick that player
        // Socket server authmiddleware does not work
        // On settings change via command, socket server syncs the new updated setting to static server
        // Moved database connections to private network. It will respond faster and cost less

        // Created dedicated database for onlinecatan $15
        // Moved onlinecatan to new account and new servers for static and socket. Basic/1 vCPU/2 GB/$10 => Basic/2 vCPUs/2 GB/$15 x2
        // Moved hexs to new servers for static and socket. CPU-Optimized/16 GB/8 vCPUs/$160 => CPU-Optimized/4 GB/2 vCPUs/$40 x2
        // Moved colonist to new servers for static and socket. CPU-Optimized/64 GB/32 vCPUs/$640 => CPU-Optimized/32 GB/16 vCPUs/$320 x2

        // Added temporary features:
        // Temporarily cross delete cache between servers in app.ts
        // Temporarily JWT migration system JWTCleaning

        this.patchNotes.push(getPatchNote(2021, 4, 3, 104, v104))

        const v103: PatchNoteContent[] = []
        v103.push(getContent(PatchNoteType.Feature, `New Fun Map: Black Forest <img src="${MapBlackforestPreview}" style="width: 40%">`, ['Shutsen']))
        v103.push(getContent(PatchNoteType.Update, 'Redesigned karma system to be more fair and reliable', ['Aldrik']))
        v103.push(getContent(PatchNoteType.Update, 'Redesign development card popups'))
        v103.push(getContent(PatchNoteType.Fix, 'Fix discard bug', ['Anora', 'Morty', 'NordicZombie']))
        // Include C&K data logic for city improvement with bonuses
        // Include card popup interfaces for C&K
        // Include multi button in frontend
        // Refactor knight upgrade and placement from 1 to 2 actions
        // Refactor knight upgrade and placement from 1 to 2 actions
        // Removed Error - Failed to load
        // Moved privacy to homepage
        this.patchNotes.push(getPatchNote(2021, 3, 17, 103, v103))

        const v102v1: PatchNoteContent[] = []
        v102v1.push(getContent(PatchNoteType.Fix, 'Fixed getting disconnected while placing settlements'))
        this.patchNotes.push(getPatchNote(2021, 3, 5, 102.1, v102v1))

        const v102: PatchNoteContent[] = []
        v102.push(getContent(PatchNoteType.Feature, `Added 2 new icons <a href="/store" target="_blank"><img src="${IconHelmet}" style="height: 30px"></a> <a href="/store" target="_blank"><img src="${IconScarf}" style="height: 30px"></a>`))
        v102.push(getContent(PatchNoteType.Update, 'Contact updated'))
        v102.push(getContent(PatchNoteType.Update, 'Starting resources are distributed after each player places their second settlement'))
        v102.push(getContent(PatchNoteType.Update, 'Optimized network resource usage in games'))
        v102.push(getContent(PatchNoteType.Fix, 'Fixed bottom ad overlaying the game', ['Klaus0225']))
        v102.push(getContent(PatchNoteType.Fix, 'Fog tiles not revealing sea tiles properly', ['NordicZombie']))
        v102.push(getContent(PatchNoteType.Fix, 'Preventing accidentally completing 2 bank trades during lag'))
        v102.push(getContent(PatchNoteType.Fix, 'Trade window does not refresh when a player reconnects'))

        // Added SocketMessageLoadTest command
        // Store opens get-coin-popup if player doesnt have enough coins
        // Can display one tournament without bugging out the site
        // Refactored how cards are queued and animated in the frontend
        // Refactor how the frontend handle animating dev cards flying out of your hand after using
        // Consolidated all card selection logic in the front end to a single class
        // Consolidated all player selection logic in the front end to a single class
        // Consolidated all discard card selection logic in the front end to a single class
        // Consolidate all card exchange broadcasts
        // Optimize map broadcasting so entire map isn't sent
        // Optimize player broadcasting. Now it only sends data for players to update
        // BIG backend refactor to better handle cards being addded to the game
        // Removed ResourceCardTypes and DevelopmentCardTypes and replaced with CardEnums
        // Created inventory systems for player and bank to handle cards
        // refactored all click actions for cards
        // consolidated all card selector windows and all player selector windows into 1 interface
        // consolidated all card selections broadcasts
        // refactored how the backend handles resources distribution after rolling dice
        // refactor how players select gold resources to make addign aqueduct easier
        // removed TradeFormatClass
        // refactored bank trade ratios into PlayerController to make them more dynamic
        // refactor discard limit to PlayerController to mkae it more dynamic
        // refactor how cards are stolen when moving the robber
        // refactor corners bonuses for tiles to store more information
        // refactor dice and select who to rob actions to make adding C&K dice evnets easier
        // decoupleds MapController and CardController in the frontend
        // ClearCacheOfUser command added
        // Removed make logs from staging & production commands
        this.patchNotes.push(getPatchNote(2021, 3, 4, 102, v102))

        const v101: PatchNoteContent[] = []
        v101.push(getContent(PatchNoteType.Update, 'Increased server capacity'))
        v101.push(getContent(PatchNoteType.Feature, `Added 2 new icons <a href="/store" target="_blank"><img src="${IconTie}" style="height: 30px"></a> <a href="/store" target="_blank"><img src="${IconSnorkel}" style="height: 30px"></a>`))
        v101.push(getContent(PatchNoteType.Fix, 'Shuffle Board map shows the robber', ['BigNell']))
        v101.push(getContent(PatchNoteType.Fix, 'Show error message when username invalid or already taken', ['Akshay'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/86765/cannot-edit-name']))
        v101.push(getContent(PatchNoteType.Fix, 'Not getting bonus points for settling on the desert tile on islands'))
        v101.push(getContent(PatchNoteType.Fix, 'Games loading on tutorial map', ['Seb']))
        v101.push(getContent(PatchNoteType.Fix, 'Element layering for fog tiles'))
        v101.push(getContent(PatchNoteType.Fix, 'Reset the scroll bar when changing categories in the store', ['BigNell']))
        // Started logging ILobbyOnlinePlayerCountData
        // Removed replaceHTMLEventAttributes for now
        // Tried to increaes concurrent socket connections via: https://stackoverflow.com/questions/15872788/maximum-concurrent-socket-io-connections
        this.patchNotes.push(getPatchNote(2021, 2, 17, 101, v101))

        const v100: PatchNoteContent[] = []
        v100.push(getContent(PatchNoteType.Feature, `Added 2 new icons <a href="/store" target="_blank"><img src="${IconAvocado}" style="height: 30px"></a> <a href="/store" target="_blank"><img src="${IconCactus}" style="height: 30px"></a>`))
        v100.push(getContent(PatchNoteType.Feature, 'New Fun Map: Shuffle Board', ['BigNell'])) // <img src="${MapShuffleboardPreview}" style="width: 100%">
        v100.push(getContent(PatchNoteType.Update, 'Swapped trade and buy development card buttons', ['IwannaRock'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/91496/swap-trade-menu-button-with-buy-dev-button']))
        v100.push(getContent(PatchNoteType.Update, 'Number of resources is now displayed in the trade bar'))
        v100.push(getContent(PatchNoteType.Fix, 'Help icons made smaller', ['Twiggeh']))
        v100.push(getContent(PatchNoteType.Fix, 'Fixed chat color of player names beginning with an icon word', ['bocaben'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/133590/bug-no-color-on-usernames-beginning-with-a-parsed-word-wheatknightcity']))

        // Game state is displayed while reconnecting
        // Updated tsconfig es2015=>ES2019
        // Alerts if pixi image name is wrong
        // Big front end refactor
        // Converted front end to observer pattern
        // Decoupled most of the controllers to make adding new contents easier
        // Refactored out old files like ClientLogic, LegacyCardView, View, etc..
        // Started a big refactor on the card system. This also requires refactoring the backend so this is halfway done at this point
        // Many changes to the card system and how they are handled
        // Changed the order the game is loaded. Game takes a bit longer to load now, this was not optimized here
        // Refactored the animation system so that classes can add and remove themselves as listeners. This is the change that resulted in the most bugs during play testing
        // Added layering system for the map views to make stacking easier
        // Many more miscellaneous changes, it was a big refactor

        this.patchNotes.push(getPatchNote(2021, 2, 3, 100, v100))

        const v99: PatchNoteContent[] = []
        v99.push(getContent(PatchNoteType.Feature, `Added 2 new icons <a href="/store" target="_blank"><img src="${IconCrown}" style="height: 30px"></a> <a href="/store" target="_blank"><img src="${IconSwords}" style="height: 30px"></a>`))
        v99.push(getContent(PatchNoteType.Feature, 'New map released: <a href="/store" target="_blank"><b>Base Random</b></a>', [], undefined, 'https://i.imgur.com/GqVZCS4.png', ['https://colonist.featureupvote.com/suggestions/65978/randomize-tiles-and-numbers%27']))

        v99?.push(getContent(PatchNoteType.Update, 'Added bots logic for Seafarers', ['Alistair H'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/139707/bots-on-seafarers-should-be-able-to-play-with-seafarers']))
        v99.push(getContent(PatchNoteType.Update, 'Increased time for bot to take over for very fast and fast game speeds'))
        v99.push(getContent(PatchNoteType.Update, 'Custom link games are private by default'))
        v99.push(getContent(PatchNoteType.Update, 'Featured video & tournaments load fast', ['Andrew']))
        v99.push(getContent(PatchNoteType.Update, 'Shows Scenario and Extension setting in profile and inside game settings'))
        v99.push(getContent(PatchNoteType.Update, 'Removed card count badge for development cards', ['Ryan'], undefined, 'https://i.imgur.com/rc0e38h.png', ['https://colonist.featureupvote.com/suggestions/118888/remove-number-of-cards-from-dev-cards']))

        v99.push(getContent(PatchNoteType.Fix, 'Fixed accessing a rematch game via link'))
        v99.push(getContent(PatchNoteType.Fix, 'Fixed rooms repeating host names after rematch'))
        v99.push(getContent(PatchNoteType.Fix, 'Fixed players sent to a new room when clicked join'))
        v99.push(getContent(PatchNoteType.Fix, 'Fixed player recreating same room'))
        v99.push(getContent(PatchNoteType.Fix, 'Fixed username, icon, karma updating late in Lobby'))
        v99.push(getContent(PatchNoteType.Fix, 'Player report button shows confirmation'))
        v99.push(getContent(PatchNoteType.Fix, 'Game log shows robber more descriptive', ['player'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/65905/enhancement-game-log-should-describe-where-robber-was-placed']))
        v99.push(getContent(PatchNoteType.Fix, 'Game log shows what resources were traded'))
        v99.push(getContent(PatchNoteType.Fix, 'Fixed muting players'))
        v99.push(getContent(PatchNoteType.Fix, 'Seafarers starting properly when using the rematch button.'))
        v99.push(getContent(PatchNoteType.Fix, 'Fixed issues with server lagging'))
        v99.push(getContent(PatchNoteType.Fix, 'End game report button works', ['Vultur']))
        v99.push(getContent(PatchNoteType.Fix, 'Fixed store bug', ['Stoi']))

        // Removed redirect from other websites
        // Refactored sockets
        // Store items can be purchased for discount price

        // Lobby shows store items in random order
        // Implemented heap monitoring system that triggers when heap exceeds 1GB
        // Changed discord link, now demi's permanent link is displayed
        // Added the word "Base" to 5-6 & 7-8 expansions, in StoreItemExpansion and GameModeData
        // Updated store FAQ
        // Removed potential localhost redirect to colonist.io', ['Mavi']
        // Formatted discord link display.', ['Andrew']
        // Fixed tournament popup banner not filling out the entire width', ['Twiggeh']
        // Rematch will send all players to the same room during periods of high lag
        // Store header shows logo, ['Andrew']
        // Split dev card warning into two specific warnings, ['Ryan']
        // Store coin popup shows total coins', ['Andrew']
        // Server updated 16cpu/32ram/200ssd/7tbbandwith/$320 => 32cpu/64ram/200ssd/9tbbandwith/$640
        this.patchNotes.push(getPatchNote(2021, 1, 21, 99, v99))

        const v98: PatchNoteContent[] = []
        v98.push(getContent(PatchNoteType.Feature, `New Fun Map: Mountain of Riches <img src="${MapMountainOfRichesPreview}" style="width: 40%">`, ['Andrew']))
        v98.push(getContent(PatchNoteType.Update, 'Base map now rotates in 6 different positions'))
        v98.push(getContent(PatchNoteType.Update, 'Rebalance dice numbers for fun maps'))
        v98.push(getContent(PatchNoteType.Update, 'Guest accounts profiles show', ['Mircea']))
        v98.push(getContent(PatchNoteType.Update, 'Seafarers on Earth and UK maps now award bonus points for settling new land', ['Michael']))
        v98.push(getContent(PatchNoteType.Fix, 'Fixed being unable to select free map', ['noam'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/142795/the-free-map-stoped-being-free-bug']))
        v98.push(getContent(PatchNoteType.Fix, 'Fixed players being able to steal from player with no cards', ['Pottsitive'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/68443/when-placing-the-robber-and-accidentally-selecting-a-player-with-0-resources-don']))
        v98.push(getContent(PatchNoteType.Fix, 'Fixed logs auto scrolling', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/62686/logs-shouldnt-autoscroll-after-every-new-event']))
        v98.push(getContent(PatchNoteType.Fix, 'Fixed chat size on safari'))
        v98.push(getContent(PatchNoteType.Fix, 'Fixed SBP flag on SF 6p'))
        v98.push(getContent(PatchNoteType.Fix, 'Fixed neighboring ports drawn bug', ['Schaefer'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/86065/bug-port-graphic-wrong-on-56-player-maps']))
        v98.push(getContent(PatchNoteType.Fix, 'Fixed tutorial bot game button'))
        v98.push(getContent(PatchNoteType.Fix, 'Fixed rematch'))
        v98.push(getContent(PatchNoteType.Fix, 'Increased server performance'))

        // Added isHTML check to linkfy algorithm
        // Added privacy policy
        // Other websites redirect to colonist.io
        // Decouple MapController from map creation process
        // Moving common tile functions to TileState consolidating duplicated functions in backend and front end
        // Streamlined the map creation process with TileGroups to automate loading map parts
        // Created a HarborGroup similar to TileGroup
        // Refactored how to restrict starting placement on maps (SF)
        // Removed CornerLocations and EdgeLocations enums
        // Automatically load game mechanics based on mode selection not switch case
        // Rename edge enums
        // Removed Benefits of Login popup', ['Andrew']
        // Fixed memory leaks associated with rematch
        this.patchNotes.push(getPatchNote(2021, 1, 5, 98, v98))

        const v97: PatchNoteContent[] = []
        v97.push(getContent(PatchNoteType.Feature, '<b>Seafarers 5-6!</b>'))
        v97.push(getContent(PatchNoteType.Feature, '<a href="/store" target="_blank">Earth map</a> supports Seafarers'))
        v97.push(getContent(PatchNoteType.Feature, '<a href="/store" target="_blank">UK & Ireland map</a> supports Seafarers'))
        v97.push(getContent(PatchNoteType.Feature, 'Icons can be changed', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/112873/removehide-the-hats']))
        v97.push(getContent(PatchNoteType.Feature, 'Icons added to <a href="/store" target="_blank">store</a>', ['Stan']))
        v97.push(getContent(PatchNoteType.Update, 'Increased network speed by 20%', ['fegfpdj']))
        v97.push(getContent(PatchNoteType.Update, 'Tournament section shows 2 tournaments side by side', ['jayamano57']))
        v97.push(getContent(PatchNoteType.Update, 'Free items in store write Free instead of 0'))
        v97.push(getContent(PatchNoteType.Fix, 'Made help icons smaller', ['Stan'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/137872/icons-too-large-after-v96-update']))
        v97.push(getContent(PatchNoteType.Fix, 'Fixed profile data not loading when the player has 0 games', ['fegfpdj']))
        // Refactored a lot of functions in the room/game creation process
        // Restricted player count for mode and extensions so owning Base 5-6 doesn't allow players to start SF 5-6
        // Refactor sea tile drawing
        // Added binary mode with msgpack
        this.patchNotes.push(getPatchNote(2020, 12, 21, 97, v97))

        const v961: PatchNoteContent[] = []
        v961.push(getContent(PatchNoteType.Update, 'All expansions are free for 12 & 13 December. Enjoy'))
        this.patchNotes.push(getPatchNote(2020, 12, 12, 96.1, v961))

        const v96: PatchNoteContent[] = []
        v96.push(getContent(PatchNoteType.Feature, 'Games can be spectated with a link', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/87960/spectate-games-search-or-jump-to-one-directly']))
        v96.push(getContent(PatchNoteType.Feature, 'Rooms can be created with typing in a unique id (example: colonist.io/#12345)'))
        v96.push(getContent(PatchNoteType.Feature, 'Tournament hosts can request data to spreadsheet'))
        v96.push(getContent(PatchNoteType.Update, '/disablekarma allows players to vote using UI', ['Aldrik'], undefined, 'https://prnt.sc/vnr6xd'))
        v96.push(getContent(PatchNoteType.Update, 'Improved the settings UI to match the rest of the game', ['Stan']))
        v96.push(getContent(PatchNoteType.Update, 'Player searchbar searches when pressing Enter', ['Moha'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/84567/press-enter-on-search-button-at-profile']))
        v96.push(getContent(PatchNoteType.Fix, 'Fixed longest road count being reduced by 1', ['Stefl1504']))
        v96.push(getContent(PatchNoteType.Fix, 'On mobile, profile button prompts google login', ['Mircea']))
        v96.push(getContent(PatchNoteType.Fix, 'On mobile, profile button opens the profile page', ['Mircea']))
        v96.push(getContent(PatchNoteType.Fix, 'Timer displays the proper starting value', ['Moha'], undefined, undefined))
        v96.push(getContent(PatchNoteType.Fix, 'Rebalance dice number distribution on Diamond map'))
        // Setings UI uses HTML elements rather than canvas UI elements. Clicking elsewhere in the window will now close any open settings UI., ['Stan']
        // Spectate UI uses HTML elements rather than canvas, ['Stan']
        // Added hash (#) links to the press kit page, ['shaielc']
        // Made changes to PlayerProfile.ts class in order to show more icons than just X/Checkmark
        // Refactored Road Building. Make sure to notify play testers to test this explicitely
        // Refactor all store maps to new MapBase format
        // Refactored all standard maps in the game, base, 5-6 and 7-8
        // refactor out TileTypes.None
        this.patchNotes.push(getPatchNote(2020, 12, 8, 96, v96))

        const v95: PatchNoteContent[] = []
        v95.push(getContent(PatchNoteType.Feature, `<b>Seafarers!</b> <img src="${GameModeIconsSeafarers}" style="width: 30%">`, undefined, undefined, undefined, ['https://colonist.featureupvote.com/suggestions/84822/seafarers-expansion-testing']))
        v95.push(getContent(PatchNoteType.Feature, `Limited time Fun Map: Romania <img src="${MapRomaniaPreview}" style="width: 30%">`, ['Mircea']))

        v95.push(getContent(PatchNoteType.Update, 'Added numbers to building buttons', ['JUAN'], undefined, 'https://prnt.sc/vlwf86', ['https://colonist.featureupvote.com/suggestions/116356/add-numbers-to-building-icons']))
        v95.push(getContent(PatchNoteType.Update, 'Game chat and log no longer autoscroll when mouse is on them', ['Moha'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/62686/logs-shouldnt-autoscroll-after-every-new-event']))
        v95.push(getContent(PatchNoteType.Update, 'Added a victory sound for the winning player upon game end', ['trusttheprocessor']))

        v95.push(getContent(PatchNoteType.Fix, 'Fixed spectator view being stuck on 0', ['Suprith'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/107076/bug-report-fix-spectator-view-number']))
        v95.push(getContent(PatchNoteType.Fix, 'Fixed turn sound during initial placements', ['timw']))
        v95.push(getContent(PatchNoteType.Fix, 'Fixed placement confirmation button size on mobile', ['timw']))
        v95.push(getContent(PatchNoteType.Fix, 'Fixed visual bug with resource coming from bank instead of the top left tile', ['Hawkaberi']))

        // Replaced lobby friend part with seafarers ad
        // Moved game a bit away from ads, VLI requested
        // Deleted mongodb and admin analytics pages
        this.patchNotes.push(getPatchNote(2020, 11, 23, 95, v95))

        const v94: PatchNoteContent[] = []
        v94.push(getContent(PatchNoteType.Update, 'Added timers description image to speed info in room settings', ['JUAN'], undefined, 'https://i.imgur.com/xoeQ4Bs.png'))
        v94.push(getContent(PatchNoteType.Update, 'Extended time for discard and robber placement in very fast speed', ['JUAN'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/112654/timers-too-fast-during-a-roll-of-7-game-speed-very-fast']))
        v94.push(getContent(PatchNoteType.Update, 'New chat text colour for Blue and MysticBlue', ['JUAN'], undefined, 'https://prnt.sc/vfcnyf'))
        v94.push(getContent(PatchNoteType.Fix, 'Fixed longest road being randomly awarded during a tie', ['Michiel'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/124255/another-longest-road-bug']))
        v94.push(getContent(PatchNoteType.Fix, 'Fixed counter offers', ['leso'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/81973/allow-counter-trades-to-be-accepted']))
        v94.push(getContent(PatchNoteType.Fix, 'Fixed bots not responding to counter offers', ['Ali Octa'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/103665/bots-do-not-response-to-the-trade-offer-counters']))
        v94.push(getContent(PatchNoteType.Fix, 'Fixed bots not responding to multiple open offers'))
        v94.push(getContent(PatchNoteType.Fix, 'Fixed resources not showing up in trade bar on first turns', ['JUAN'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/96839/while-counteroffering-in-the-first-rounds-no-resources-are-displayed']))
        v94.push(getContent(PatchNoteType.Fix, 'Fixed trades displaying properly when player reconnects', ['tal'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/130079/bug-when-trying-to-trade-and-someone-disconnects']))
        v94.push(getContent(PatchNoteType.Fix, 'Fixed bots getting stuck using road builder card', ['Nir'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/94164/bot-is-stuck-when-all-its-roads-are-built-and-has-a-road-building-dev-card']))

        // Fixed ui card play erros
        // Added rollall command
        // Added refund coin command
        // Getinfo command shows coins
        // Transaction commands enter reason to metadata
        // Activated VLI GDPR
        // Made lobby ads according to VLI request
        // Restructure game backend JL2 logs
        // added game piece colours images into announcements

        this.patchNotes.push(getPatchNote(2020, 11, 11, 94, v94))

        const v93: PatchNoteContent[] = []
        v93.push(getContent(PatchNoteType.Feature, 'Added a volume slider', ['Aldrik'], undefined, 'https://prnt.sc/v40i31', ['https://colonist.featureupvote.com/suggestions/110141/volume-slider']))
        v93.push(getContent(PatchNoteType.Feature, 'Added confirm button for initial placements and for robber placements', ['timw'], undefined, 'https://prnt.sc/v40x8u', ['https://colonist.featureupvote.com/suggestions/91509/add-confirmation-button-double-click']))

        v93.push(getContent(PatchNoteType.Update, 'Room automatically sets maximum player count when changing game mode', ['Aldrik']))
        v93.push(getContent(PatchNoteType.Update, 'Cannot accidentally offer duplicate trades', ['Aldrik']))
        v93.push(getContent(PatchNoteType.Update, 'Restricted lobby chat to signed in users only', ['timw'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/104366/restrict-game-and-lobby-chat-to-verified-users']))
        v93.push(getContent(PatchNoteType.Update, 'Added discord button into game', ['timw'], undefined, 'https://prnt.sc/v40k26'))

        v93.push(getContent(PatchNoteType.Fix, 'Fixed colors owned by host being usable by everyone in the room'))
        v93.push(getContent(PatchNoteType.Fix, 'Fixed UI not updating properly when player reconnects while placing board pieces'))
        v93.push(getContent(PatchNoteType.Fix, 'Fixed timer bug for Year Of Plenty and Monopoly'))
        v93.push(getContent(PatchNoteType.Fix, 'Fixed Year Of Plenty bug when requesting a resource the bank did not have', ['RegularRandomZ'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/cee93a/testing_v43/ev848su/?context=3']))
        v93.push(getContent(PatchNoteType.Fix, 'Fixed timer being a few minutes off', ['alan'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/87921/timer-is-set-to-system-time-and-not-internet-time']))
        v93.push(getContent(PatchNoteType.Fix, 'Fixed blank icons on Firefox browser', ['timw']))

        // All related to splitting GC
        // Big GameController refactor => added ActionEngine
        // Converted all old logic to mechanics to be handled by ActionEngine
        // Used ActionEngine to decouple longest road calculations and largest army calculations
        // Used ActionEngine to more easily add special build phase to a GameController
        // Many more small refactors for how actions and mechanics are executed by GameController
        // Rest
        // Refactored Robber logic out of GC => robberController
        // Refactored largestArmy logic out of GC => largestArmyController
        // Added store analytics
        // Fixed gift commands
        // Lobby Ads moved 10px to sides
        // Add best seller and price tag on store items
        // Add sound effects to store

        this.patchNotes.push(getPatchNote(2020, 10, 28, 93, v93))

        const v92: PatchNoteContent[] = []
        v92.push(getContent(PatchNoteType.Feature, 'Maps can be purchased from the <a href="/store" target="_blank">store</a>!'))
        v92.push(getContent(PatchNoteType.Feature, 'New colors can be purchased from the <a href="/store" target="_blank">store</a>!', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/91524/add-more-colors']))
        v92.push(getContent(PatchNoteType.Feature, 'Profile shows owned items'))

        v92.push(getContent(PatchNoteType.Update, 'Descriptions in User Profiles more explicit'))
        v92.push(getContent(PatchNoteType.Update, 'Added total game count in User Profiles'))
        v92.push(getContent(PatchNoteType.Update, 'Contributors page has completely changed. Check it out: <a href="/contribute" target="_blank">Contribute Page</a>'))

        v92.push(getContent(PatchNoteType.Fix, 'Reconnection popup doesn\'t block the game play'))
        v92.push(getContent(PatchNoteType.Fix, 'Fixed issue where chat displayed wrong colors', ['Aldrik'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/51001/2-clients-in-same-game-shows-wrong-color-on-chat']))

        // Refactored Item/Store data structures
        // Removed shop related code
        // Fixed discord channel problem
        // Edited admin gift/refund/delete item commands
        // Restructured GameTimers to abstract class
        // Restructured GameController test files. No changes made to actual code base
        // Restructured out DiceSettings.ts
        this.patchNotes.push(getPatchNote(2020, 10, 14, 92, v92))

        const v91v1: PatchNoteContent[] = []
        v91v1.push(getContent(PatchNoteType.Fix, 'Fixed store pricing bug', ['FishFingers']))
        this.patchNotes.push(getPatchNote(2020, 9, 30, 91.1, v91v1))

        const v91: PatchNoteContent[] = []
        v91.push(getContent(PatchNoteType.Feature, 'New game option: Balanced dice', ['MikeIsMyIke'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/51110/option-to-select-a-different-dice-system']))

        v91.push(getContent(PatchNoteType.Update, 'Tournament descriptions show when clicked on'))
        v91.push(getContent(PatchNoteType.Update, 'Bots are less likely to accept 2+:1 trades with player about to win', ['JUAN'], undefined, undefined))
        v91.push(getContent(PatchNoteType.Update, 'Updated login message'))
        v91.push(getContent(PatchNoteType.Update, 'Updated Store FAQ'))

        v91.push(getContent(PatchNoteType.Fix, 'Fixed Rematch button at end game', ['macolby14'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/93099/rematch-function-does-not-work']))
        v91.push(getContent(PatchNoteType.Fix, 'Opponents don\'t see when you are selecting a card for monopoly or year of plenty', ['Michael'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/92717/remove-player-activity-notice-for-development-card-usage']))
        v91.push(getContent(PatchNoteType.Fix, 'The window to choose a player to steal from properly displays when reconnecting to game', ['Riley'], undefined, undefined))
        v91.push(getContent(PatchNoteType.Fix, 'Choosing cards to discard no longer refreshes when opponent reconnects', ['Riley'], undefined, undefined))
        v91.push(getContent(PatchNoteType.Fix, 'Choosing cards for year of plenty or monopoly no longer refreshes when opponent reconnects', ['Riley'], undefined, undefined))
        v91.push(getContent(PatchNoteType.Fix, 'Fixed featured tournaments distorting mobile view', ['JUAN']))
        v91.push(getContent(PatchNoteType.Fix, 'Fixed players able to steal from themselves after placing robber on their own tile', ['Castor#1325'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/102905/repeated-player-colour-in-steal-selection-box']))
        v91.push(getContent(PatchNoteType.Fix, 'Fixed bank not distributing resources properly for cities when bank out of resources', ['AlexInAuburn'], undefined, undefined))
        v91.push(getContent(PatchNoteType.Fix, 'Bot no longer gets stuck if all players embargo the bot', ['Camille'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/66867/bot-embargo-bug']))
        v91.push(getContent(PatchNoteType.Fix, 'For founder pack owners, expansions and maps show 0Cc in store'))
        v91.push(getContent(PatchNoteType.Fix, 'Fixed store expansion descriptions'))

        // Separated info and usage in commands
        // Removed io games from footer
        // Refactor Room.ts to combine consturctor and Room.createRoomFromSettings()
        // refactored year of plenty UI from ClientLogic => UIGameYearOfPlentyPopupcontroller
        // refactored monopoly UI from ClientLogic => UIGameMonopolyPopupController
        // refactored discard card UI from everywhere in UI => UIGameDiscardCardsController
        // Created Moderator AccessLevel and moved some commands into there
        // Updated expansion error messages inside room
        // Updated coin purchase amounts, increased them according to here: https://github.com/colonistio/katan/pull/2559#issuecomment-699499037
        this.patchNotes.push(getPatchNote(2020, 9, 30, 91, v91))

        const v90: PatchNoteContent[] = []
        v90.push(getContent(PatchNoteType.Feature, 'New <a href="/store" target="_blank">store</a> is up!', ['Martin Gargaglione'])) // https://www.artstation.com/marting
        v90.push(getContent(PatchNoteType.Feature, 'Added featured tournaments section', ['JUAN']))
        v90.push(getContent(PatchNoteType.Update, 'Added description on how to submit youtube videos'))
        v90.push(getContent(PatchNoteType.Update, 'Kicked players cannot rejoin the room they were kicked from', ['macolby14'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/51003/room-kicked-people-should-stay-kicked-and-not-rejoin']))
        v90.push(getContent(PatchNoteType.Fix, 'Fixed players completing trades that were no longer possible'))
        v90.push(getContent(PatchNoteType.Fix, 'Fixed players getting stuck during road building', ['JUAN'], undefined, undefined))
        v90.push(getContent(PatchNoteType.Fix, 'Rebalanced bots trading with high victory point players', ['player'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/52501/bots-should-refuse-to-trade-with-high-point-winning-player']))
        v90.push(getContent(PatchNoteType.Fix, 'Bots are less likely to do 1:2+ trades', ['KettlerSatan'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/94247/bot-trading-bugrequest-thread']))
        v90.push(getContent(PatchNoteType.Fix, 'Bots prioritize losing player when deciding who to trade with', ['player'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/52501/bots-should-refuse-to-trade-with-high-point-winning-player']))
        v90.push(getContent(PatchNoteType.Fix, 'Fix cards staying on screen after closing trade', ['Castor#1325'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/102902/mouse-over-graphics-bug']))
        v90.push(getContent(PatchNoteType.Fix, 'Fixed videos pushing tight screens', ['JUAN']))
        v90.push(getContent(PatchNoteType.Fix, 'Fix robber placement on Diamond Lake fun map', ['Puzzles'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/119474/robber-not-starting-in-the-desert-diamond-lake-map']))
        // Changed discord link
        // v89.3 Fixed Stripe secret key leak
        // Created UIGameDisconnectController
        // Added eslint rule no-invalid-this
        // Refactor yourcolor -> mycolor
        // Refactor KatanClientVariables -> EjsVariables
        // Delay nodemon while editing
        // Updated typeorm 0.2.16=>0.2.25
        this.patchNotes.push(getPatchNote(2020, 9, 16, 90, v90))

        const v89: PatchNoteContent[] = []
        v89.push(getContent(PatchNoteType.Feature, 'Special Build Phase Beta for 5+ player games', ['Sean'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/84829/add-special-build-phase-for-56-player']))
        v89.push(getContent(PatchNoteType.Update, 'Total card counts of cardstacks are shown in a badge on the card', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/64271/add-numbers-to-resource-cards']))
        v89.push(getContent(PatchNoteType.Update, 'Changed help email to help@colonist.io, but we encourage you to use our <a href="https://discord.gg/uzCKAWV6qm" target="_blank">discord</a> for any help'))
        v89.push(getContent(PatchNoteType.Update, 'General button style updated'))
        v89.push(getContent(PatchNoteType.Fix, 'Fix road highlights not resetting when time runs out', ['Blake'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/107564/roads-error']))
        v89.push(getContent(PatchNoteType.Fix, 'Fix tutorial mode popup displaying improperly'))
        v89.push(getContent(PatchNoteType.Fix, 'Fix turn alert sound going off when placing robber before rolling dice'))
        v89.push(getContent(PatchNoteType.Fix, 'Bot now places roads when timer runs out on road building'))
        v89.push(getContent(PatchNoteType.Fix, 'Changing player colors on firefox works more smoothly', ['jayamano57']))
        v89.push(getContent(PatchNoteType.Fix, 'Fix bot automatically placing robber when bot discarded cards for another player', ['Sean'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/111773/glitch-fix-when-bot-discards-for-player-after-7-is-rolled-bot-will-automatically']))
        v89.push(getContent(PatchNoteType.Fix, 'Fixed guests updating room maps', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/116797/any-player-in-the-room-can-change-map-setting']))
        // Fix floating text falling off screen
        // Updated link to new UI/UX form
        // Added multoigri to dist partners
        // Update end game controller to deal with scenario where winning player doesnt have the most VPs (for special build phase)
        // Speed up async tests by ~66% by changing game speed test to very fast
        // Refactor Room.ts to combine consturctor and Room.createRoomFromSettings()
        this.patchNotes.push(getPatchNote(2020, 9, 2, 89, v89))

        const v88: PatchNoteContent[] = []
        v88.push(getContent(PatchNoteType.Feature, `New Fun Map: UK & Ireland <img src="${MapUkPreview}" style="width: 40%">`, ['macolby14']))
        v88.push(getContent(PatchNoteType.Update, 'Title of games automatically change based on Game Speed and Map Settings', ['macolby14'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/84641/titles-of-games-should-change-automatically-according-to-new-game-settings']))
        v88.push(getContent(PatchNoteType.Update, 'Swapped room name, X & edit locations', ['macolby14']))
        v88.push(getContent(PatchNoteType.Fix, 'Fixed Tutorial Mode not properly showing all actions'))
        v88.push(getContent(PatchNoteType.Fix, 'Fixed Monopoly staying in hand when no resources were stolen'))
        v88.push(getContent(PatchNoteType.Fix, 'Fixed road highlights not resetting properly when time runs out'))
        // Refactored all turn related and action related events in GameController
        // Refactor tutorial map initiation
        // Refactor MapController generateMissingParts => GenerateMapParts
        // Created MapController.TestMap() to fix MapController tests
        // Cleaned up GameControllerAsyncTests
        // Removed nextActionList and currentActionList from GameController (old logic that was not used)
        // Added discord link to game & lobby texts
        // Added a manager command that activates free expansion testing in development and staging enviroments
        // Added discord link to initial broadcast
        // Fixed Google Chrome sameSite cookie bug introduced in latest version
        this.patchNotes.push(getPatchNote(2020, 8, 19, 88, v88))

        const v87: PatchNoteContent[] = []
        v87.push(getContent(PatchNoteType.Feature, 'In game players can be reported'))
        v87.push(getContent(PatchNoteType.Feature, 'In game players can be muted'))
        v87.push(getContent(PatchNoteType.Update, 'Added map setting to game history'))
        v87.push(getContent(PatchNoteType.Update, 'Doubled bonus time after using development cards', ['TalkSick'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/92122/road-building-card-glitch']))
        // In game while hovering on player icon, players could see karma. Removed it because it can be clicked
        v87.push(getContent(PatchNoteType.Fix, 'Fixed awarding longest road to 2 players', ['Kenny'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/92883/longest-road-bug-explained-better']))
        v87.push(getContent(PatchNoteType.Fix, 'Fixed free map not changing weekly'))
        v87.push(getContent(PatchNoteType.Fix, 'Fixed longest road counting incorrectly', ['zaloo'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/91517/posible-bug-in-max-roads']))
        // Fixed giftpack100 command
        // Added getuserinfo command
        this.patchNotes.push(getPatchNote(2020, 8, 5, 87, v87))

        const v86: PatchNoteContent[] = []
        v86.push(getContent(PatchNoteType.Feature, 'All available maps can be chosen from'))
        v86.push(getContent(PatchNoteType.Feature, 'Separated game mode and map selection'))
        v86.push(getContent(PatchNoteType.Feature, 'A different map will be free every week for everyone'))
        v86.push(getContent(PatchNoteType.Update, 'Added contributor link to homepage footer'))
        v86.push(getContent(PatchNoteType.Update, 'Increased patchnote size'))
        v86.push(getContent(PatchNoteType.Update, 'Adjusted time before bot takes over when player disconnects for all game speeds'))
        v86.push(getContent(PatchNoteType.Update, 'Game no longer displays "No one has the resource you requested" when bank cards are hidden', ['Aracknid416'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/95242/if-no-one-has-a-resource-when-trading-it-shouldnt-tell-you-error-no-one-has-that']))
        v86.push(getContent(PatchNoteType.Update, 'Lobby shows youtube videos on colonist. Reach out on discord to get yours added.'))
        v86.push(getContent(PatchNoteType.Fix, 'Fixed bank incorrectly distributing resources when only 1 player depletes the bank funds', ['aztechunter'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/52458/not-enough-resource-to-give-to-all-should-mean-no-resources-distributed']))
        v86.push(getContent(PatchNoteType.Fix, 'Repositioned largest army and longest road achievement notification', ['GET'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/103650/longest-road-army-notification-is-annoying-please-reverse-decision']))
        v86.push(getContent(PatchNoteType.Fix, 'Fixed server crashing due to Cloudflare'))

        // Refactored App.ts ejs variables
        // Refactored MapSetting -> GameModeSetting
        // TSLint -> ESLint
        // Open new window showing game timers when clicing info icon
        // resize single pages to fit various size screens
        // TypeScript Version 3.2.2=>3.9.6
        // FPS indicator aded to canvas
        // Featured videos loaded from Google Sheets
        // Shows max 2 featured videos
        // Fixed server crashing due to Cloudflare and Healthcheck
        this.patchNotes.push(getPatchNote(2020, 7, 22, 86, v86))

        const v85: PatchNoteContent[] = []
        v85.push(getContent(PatchNoteType.Feature, `New Fun Map: Earth <img src="${MapEarthPreview}" style="width: 40%">`))
        v85.push(getContent(PatchNoteType.Update, 'Updated shop payment flow so card input happens inside our secure provider Stripe.com', ['Agnilam'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/82716/payment-window-doesnt-look-very-secure']))
        v85.push(getContent(PatchNoteType.Update, 'Players with poor performance will be shown how to enable WebGL'))
        v85.push(getContent(PatchNoteType.Fix, 'Fixed bank incorrectly distributing resources when there are not enough to give', ['aztechunter'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/52458/not-enough-resource-to-give-to-all-should-mean-no-resources-distributed']))
        v85.push(getContent(PatchNoteType.Fix, 'Fixed trade completion bug', ['Ray Redondo'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/92346/bug-trade-can-proceed-without-required-cards']))
        v85.push(getContent(PatchNoteType.Fix, 'Fixed visibility of player with largest army'))

        v85.push(getContent(PatchNoteType.Category, 'Profile:'))
        v85.push(getContent(PatchNoteType.Fix, 'Increased profile loading speed by a lot!', ['Ozz'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/92786/player-profile-info-not-loading']))
        v85.push(getContent(PatchNoteType.Fix, 'Fixed order of games shown in profile', ['Esqarrouth'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/90841/profile-date-orders-are-wrong']))
        v85.push(getContent(PatchNoteType.Fix, 'Fixed games in profile not getting updated', ['MrFarenheit'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/97751/profile-not-updated-since-may23-2020']))

        v85.push(getContent(PatchNoteType.Category, 'Timers:'))
        v85.push(getContent(PatchNoteType.Blog, 'Increased initial settlement placement time for all games modes', ['JeffD'], undefined, undefined, ['https://blog.colonist.io/updated-timers/']))
        v85.push(getContent(PatchNoteType.Update, 'Increased timers for rolling dice and robber placement'))
        v85.push(getContent(PatchNoteType.Fix, 'Adjusting timers for slower game modes', ['DylLighted'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/85555/super-slow-mode-should-extend-time-for-robbing-rolling-the-dice-and-playing-a-kn']))
        v85.push(getContent(PatchNoteType.Fix, 'Fix robber -> roll 7 timer not resetting correctly', ['Andernut'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/56070/bug-rolling-7-after-having-placed-a-knight-can-result-in-a-15-second-turn']))

        // Stripe framework updated 6.28=>8.64
        // Stripe Payment migrated from Stripe Charge to Stripe Checkout
        // Stripe creates and keep track of customers
        // Added 3  expansion pack product types in Stripe UI
        // Payment does not work while game is updating
        // Added Stripe webhooks to verify purchases, added polling to verify purchases in case server crashes
        // GAME_SERVICE_CACHE_TTL changed from 1 day to 7 days
        // Replaced discord links with variable
        // Player, admin and moderator commands are being logged in new files
        this.patchNotes.push(getPatchNote(2020, 7, 8, 85, v85))

        const v84: PatchNoteContent[] = []
        v84.push(getContent(PatchNoteType.Feature, `New Fun Map: Shuriken <img src="${ImageNotAvailable}" style="width: 100%">`))
        v84.push(getContent(PatchNoteType.Update, 'Longest road & largest army achievement animations added'))
        v84.push(getContent(PatchNoteType.Update, 'Largest army icon changed', [], undefined, 'https://prnt.sc/suu3qo'))
        v84.push(getContent(PatchNoteType.Fix, 'Fixed multiple games getting disconnected', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/92995/internet-connection-broken-refresh-browser']))
        v84.push(getContent(PatchNoteType.Fix, 'Can play while using VPN', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/94882/cannot-click-start-game']))
        v84.push(getContent(PatchNoteType.Fix, 'Fixed losing map when zooming out', ['fiskman'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/84599/option-to-reset-zoom-to-home']))
        v84.push(getContent(PatchNoteType.Fix, 'Cards animate from the correct resource'))
        v84.push(getContent(PatchNoteType.Fix, 'User profile shows loading while loading the data.', ['Ozz', 'Gronk88'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/92786/player-profile-info-not-loading']))
        // Fixed pixi tsc errors with writing as unknown as PIXI.Container
        // Node v is 12.16.3 types changed to 12.12.44, closest to our node type
        // Decreased amount of people on logrocket
        // Commented out AIP preroll code
        // Pushes to sentry logs on child process crash
        // Changed announcement to 2 week update schedule
        // Made vli ads auto redirect
        // Cleaned up space with ore card img in chat
        // 84.1 moved bot, custom, spectate, reconnect from child process to main process
        // 84.1 disabled child process
        // Server updated 8cpu/16ram/100ssd/6tbbandwith/$160 => 16cpu/32ram/200ssd/7tbbandwith/$320
        // Added try catch to HealthCheck
        this.patchNotes.push(getPatchNote(2020, 6, 24, 84, v84))

        const v83: PatchNoteContent[] = []
        v83.push(getContent(PatchNoteType.Feature, `New Fun Map: Fight Pit <img src="${ImageNotAvailable}" style="width: 100%">`))
        v83.push(getContent(PatchNoteType.Update, 'Improved GPU usage by more than 50%', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/55589/cpugpu-usage-optimisation#comment184947']))
        v83.push(getContent(PatchNoteType.Fix, 'Fixed triple port graphic bug', ['Schaefer'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/86065/bug-port-graphic-wrong-on-56-player-maps']))
        v83.push(getContent(PatchNoteType.Fix, 'Fixed tile dice numbers for 5-6 player map', ['Joaquin'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/85630/board-numbers-in-56-players-are-wrong']))
        v83.push(getContent(PatchNoteType.Fix, 'Fixed rematch not working properly in bot games with more than 4 players'))
        // fixed some tsc & console errors
        // updated types/node from 8 to 14 to fix tsc errors
        // failed to load error is given only if socket is closed
        // Abstracted pixi-legacy.js to ./PIXI; added dirty flags to all PIXI elements
        // Created patch note item location to decrease merge conflicts
        // Added roadmap link to announcement, removed other stuff
        // Enabled google tag manager
        this.patchNotes.push(getPatchNote(2020, 6, 9, 83, v83))

        const v82v1: PatchNoteContent[] = []
        v82v1.push(getContent(PatchNoteType.Fix, 'Fixed server crashes'))
        v82v1.push(getContent(PatchNoteType.Fix, 'Punished players crashing the servers'))
        // Server & client limited chat character limit to 200
        // Client limits bad words as well
        this.patchNotes.push(getPatchNote(2020, 5, 29, 82.1, v82v1))

        const v82: PatchNoteContent[] = []
        v82.push(getContent(PatchNoteType.Update, 'Fun Map changed to 2 Islands'))
        v82.push(getContent(PatchNoteType.Update, 'Improved room speed settings and descriptions'))
        v82.push(getContent(PatchNoteType.Update, 'Profiles only shows last 100 games'))
        v82.push(getContent(PatchNoteType.Update, 'Improved chat filter', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/86785/block-offensive-language-in-the-game-description-and-chat']))
        v82.push(getContent(PatchNoteType.Update, 'Better error if files don\'t load', ['Austin']))
        v82.push(getContent(PatchNoteType.Fix, 'Fixed "Error-room no longer exist" notice when player clicks back to lobby from end game', ['AlexInAuburn']))
        v82.push(getContent(PatchNoteType.Fix, 'Fixed rematch not working properly with more than 4 players', ['AlexInAuburn']))
        // Login benefits more clear
        // Added a /debug command for players
        // Lowered log amount
        // Writes log every 10 ms
        // Removed gtag manager
        // Added webgl/canvas analytics
        // Added 4 new lines of vli ads.txt
        this.patchNotes.push(getPatchNote(2020, 5, 26, 82, v82))

        const v81: PatchNoteContent[] = []
        v81.push(getContent(PatchNoteType.Feature, `New Fun Map: Fight Corona <img src="${ImageNotAvailable}" style="width: 100%">`))
        v81.push(getContent(PatchNoteType.Update, 'Added featured video section', ['DylLighted']))
        v81.push(getContent(PatchNoteType.Fix, 'Bot trading crash fixed thanks to all amazing pople who sent in bug reports', ['bejewelled', 'Alisan']))
        // All games work on child processes
        // Updated dev contributor link to airtable: https://airtable.com/shrqSxfnbzLVFnSue
        // Added 11 new lines of vli ads.txt
        // Added google tag manager to track click & error events
        this.patchNotes.push(getPatchNote(2020, 5, 14, 81, v81))

        const v80: PatchNoteContent[] = []
        v80.push(getContent(PatchNoteType.Feature, `New Fun Map: Twirl <img src="${MapTwirlPreview}" style="width: 40%">`, ['Panda']))
        v80.push(getContent(PatchNoteType.Fix, 'Increased server performance'))
        v80.push(getContent(PatchNoteType.Fix, 'Room option problem on mobile', ['unoewho', 'NewbJohny']))
        // Bot games work in child process
        // Created ejs partials for room input options
        // New color for selected room options
        this.patchNotes.push(getPatchNote(2020, 5, 7, 80, v80))

        const v79: PatchNoteContent[] = []
        v79.push(getContent(PatchNoteType.Update, 'Invite friend is more obvious in rooms'))
        v79.push(getContent(PatchNoteType.Update, 'Room options better and have descriptions'))
        v79.push(getContent(PatchNoteType.Update, 'Can click on Roll Dice text to roll dice', ['James Murphy']))
        v79.push(getContent(PatchNoteType.Update, 'Decreased maximum room name length'))
        v79.push(getContent(PatchNoteType.Fix, 'Fixed site loading correctly on some devices', ['Zak', 'Zeina']))
        v79.push(getContent(PatchNoteType.Fix, 'Fixed room names changing into pictures', ['Phallus', 'Carni'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/91016/people-ruining-the-game-with-picture-names-for-game']))
        v79.push(getContent(PatchNoteType.Fix, 'Fixed bug with room name without space not showing properly', ['Andrii'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/88240/room-name-without-space-character-broken#comment179129']))
        v79.push(getContent(PatchNoteType.Fix, 'Longest road & largest army images show correctly on logs', ['Starshine', 'Alage'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/86747/longest-road-and-largest-army-arent-correctly-writing-in-the-chat-when-the-sre-r']))
        v79.push(getContent(PatchNoteType.Fix, 'Fixed profile not working on some devices'))
        v79.push(getContent(PatchNoteType.Fix, 'Fixed some game crashes'))
        v79.push(getContent(PatchNoteType.Fix, 'Fixed not working on some mobile')) // hopefully fixed, since the problem was it was stuck at loading but I couldn't reproduce it so we need testing
        // Bootstrap css is pulled from our server
        // Added code contribution announcemnet
        // Paypal payments not accepted anymore
        this.patchNotes.push(getPatchNote(2020, 4, 29, 79, v79))

        const v78: PatchNoteContent[] = []
        v78.push(getContent(PatchNoteType.Feature, 'New Fun Map: Lord of the Rings', ['Camoback']))
        v78.push(getContent(PatchNoteType.Update, 'Removed horizontal ads in lobby'))
        v78.push(getContent(PatchNoteType.Fix, 'Fixed not being able to scroll bug', ['Barhemo', 'Full_Moon_Fever', 'Faunia', 'FECK'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/g0kv9y/colonistio_free_online_settlers_of_catan_version/fndxqpc/', 'https://colonist.featureupvote.com/suggestions/84152/could-not-scroll-down-in-the-game-room-page#comment177922', 'https://colonist.featureupvote.com/suggestions/69514/the-start-screen-cannot-be-scrolled#comment177923']))
        v78.push(getContent(PatchNoteType.Fix, 'Fixed popup covering screen in mobile'))
        v78.push(getContent(PatchNoteType.Fix, 'Fixed server crash'))
        // Healthcheck sends first ping ~2minutes after server is up instead of 1 minute
        // Shop FAQ updated
        this.patchNotes.push(getPatchNote(2020, 4, 24, 78, v78))

        const v77v1: PatchNoteContent[] = []
        v77v1.push(getContent(PatchNoteType.Fix, 'Fixed color bug'))
        // Send player to colonist function added
        this.patchNotes.push(getPatchNote(2020, 4, 19, 77.1, v77v1))

        const v77: PatchNoteContent[] = []
        v77.push(getContent(PatchNoteType.Update, 'Tab text changes on notifications'))
        v77.push(getContent(PatchNoteType.Update, 'Room errors are sent as popup instead of chat message'))
        v77.push(getContent(PatchNoteType.Update, 'Private room hosts are not kicked when AFK'))
        v77.push(getContent(PatchNoteType.Update, 'AFK hosts are kicked sooner'))
        v77.push(getContent(PatchNoteType.Update, 'Gives an error when pieces are finished', ['Rish'], undefined, 'https://prnt.sc/s120gc'))
        v77.push(getContent(PatchNoteType.Fix, 'Changing username is available and much faster'))
        v77.push(getContent(PatchNoteType.Fix, 'Username update immediately reflects inside lobby and room'))
        v77.push(getContent(PatchNoteType.Fix, 'Fixed some more performance issues'))
        // Increased end game loop to 5 seconds
        // Changed lobby interval to timeout
        // Created command to get server last update time
        // Profile lock limit is different than send to hex limit
        // Removed vli gdpr tool
        // Added hexs shop redirect command
        // Wrote you will get faster response if you ask questions on discord to contact
        // FAQ has gift option
        this.patchNotes.push(getPatchNote(2020, 4, 18, 77, v77))

        const v76: PatchNoteContent[] = []
        v76.push(getContent(PatchNoteType.Feature, 'Added mute button to Lobby chat', ['Postwizard'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/52376/mute-lobby-sounds']))
        v76.push(getContent(PatchNoteType.Fix, 'Fixed some performance issues'))
        v76.push(getContent(PatchNoteType.Fix, 'Prevent room link spams on lobby chat'))
        v76.push(getContent(PatchNoteType.Fix, 'Fixed in game sound icon showing wrong'))
        v76.push(getContent(PatchNoteType.Fix, 'Made profiles disabled texts clearer'))
        // Refactored GameSound
        // hexs shop directs to colonist shop
        // Added 21 extra VLI ad text
        // If server is overloaded new players are sent to hexs
        // Auto stops profiles and sends players to hexs after 4000 players
        // Added load test function
        // Logs are saved every 1 minute instead of instantly
        // Log file system only gets opened once instead of for each log
        this.patchNotes.push(getPatchNote(2020, 4, 13, 76, v76))

        const v75v1: PatchNoteContent[] = []
        v75v1.push(getContent(PatchNoteType.Fix, 'Increased website loading speed'))
        // Added index on all user id foreign keys in other tables
        this.patchNotes.push(getPatchNote(2020, 4, 8, 75.1, v75v1))

        const v75: PatchNoteContent[] = []
        v75.push(getContent(PatchNoteType.Feature, `New Fun Map: USA <img src="${MapUsaPreview}" style="width: 40%">`, ['alexcoleman']))
        v75.push(getContent(PatchNoteType.Feature, '7-8 Player is available with its unique map to all Colonist & Founder packs'))
        v75.push(getContent(PatchNoteType.Update, 'Removed unused room presets'))
        v75.push(getContent(PatchNoteType.Update, 'Updated shop FAQ'))
        v75.push(getContent(PatchNoteType.Update, 'Reduced preset rooms into a single Multiplayer Game'))
        v75.push(getContent(PatchNoteType.Fix, 'Fixed players not having enough colors in 7-8 player map'))
        v75.push(getContent(PatchNoteType.Fix, 'Increased website loading speed'))
        // Changed lobby image handling engine
        // Increased log rocket denominator from 600 to 1000
        // Added healthchecks.io
        // Added eager loading to expansion database
        // Deactivated admin stats
        // Changed Random Map name to Base Map
        // Increased lobby refresh ms from 200=>1000
        this.patchNotes.push(getPatchNote(2020, 4, 8, 75, v75))

        const v74v3: PatchNoteContent[] = []
        v74v3.push(getContent(PatchNoteType.Update, 'Added a clear chat button'))
        v74v3.push(getContent(PatchNoteType.Update, 'Added lobby refresh icon'))
        v74v3.push(getContent(PatchNoteType.Fix, 'Fixed new room host not being able to change room settings', ['Matias'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/71243/bug-cant-change-settings-in-remake-lobby#comment175696']))
        v74v3.push(getContent(PatchNoteType.Fix, 'Increased server performance a bit more'))
        // Private room data is not updated every 200ms, instead is sent on each change
        // Decreased size of 2 images
        // Removed client mixpanel
        // Moved ads at the end of file
        // Lobby says loading if hasnt load yet
        // Changed all AIP ads to VLI ads
        // Removed pre-sale are being removed by end of march text from announcement
        // Added discord option to contact button: https://prnt.sc/rsu1y7
        // Added debug logs to auth middleware
        // Tightened customer spam filter
        this.patchNotes.push(getPatchNote(2020, 4, 4, 74.3, v74v3))

        const v74v2: PatchNoteContent[] = []
        v74v2.push(getContent(PatchNoteType.Fix, 'Fixed server crash'))
        v74v2.push(getContent(PatchNoteType.Fix, 'Fixed some parts that were slowing the server down'))
        // Added action limits to server taxing actions so players dont spam
        this.patchNotes.push(getPatchNote(2020, 4, 3, 74.2, v74v2))

        const v74v1: PatchNoteContent[] = []
        v74v1.push(getContent(PatchNoteType.Update, 'Added refresh button to lobby to increase performance'))
        v74v1.push(getContent(PatchNoteType.Update, 'Added 2 new FAQ to shop page'))
        v74v1.push(getContent(PatchNoteType.Fix, 'Large Funmap bug fixed', ['Arjunlal']))
        // Fixed room color ready text color
        // Room not ready text is aligned to right
        // Removed everything related w Amazon ads
        // Rotate phone gif downloads only if player is in mobile (600kb)
        // Added command to update lobby refresh ms
        // Added command to toggle logs
        this.patchNotes.push(getPatchNote(2020, 4, 3, 74.1, v74v1))

        const v74: PatchNoteContent[] = []
        v74.push(getContent(PatchNoteType.Update, 'In lobby disconnected games shows at the top', [], undefined, 'https://prnt.sc/roqwua'))
        v74.push(getContent(PatchNoteType.Update, 'Room action colors changed to make them more distinct', [], undefined, 'https://prnt.sc/roqwua'))
        v74.push(getContent(PatchNoteType.Update, 'Optimized game and made it faster'))
        // Changed lobby room data types. It is event based and sends the whole room data when it is changed
        v74.push(getContent(PatchNoteType.Update, 'Changed server update text'))
        v74.push(getContent(PatchNoteType.Fix, 'Shows amount of online players in mobile'))
        v74.push(getContent(PatchNoteType.Fix, 'Fixed expansion pack not showing immediately after being bought'))
        // We kick all sessions of a user who buys a pack. So they get updated
        // Added a 4th username check step while a user is logging in
        // Added new logs to debug: null userID expansion packs
        // /adminkick kicks all sessions of a user
        // Added rotate phone gif to mobile, https://gyazo.com/31ce20e1c6760269bbb2d5aad4a4ca3d
        // Test server writes that it is a test server and people should play in colonist
        this.patchNotes.push(getPatchNote(2020, 3, 29, 74, v74))

        const v73v3: PatchNoteContent[] = []
        v73v3.push(getContent(PatchNoteType.Fix, 'Completely fixed login errors'))
        this.patchNotes.push(getPatchNote(2020, 3, 27, 73.3, v73v3))

        const v73v2: PatchNoteContent[] = []
        v73v2.push(getContent(PatchNoteType.Fix, 'Fixed a few more account login and error message problems'))
        // Added more logging to debug account problems
        this.patchNotes.push(getPatchNote(2020, 3, 26, 73.2, v73v2))

        const v73v1: PatchNoteContent[] = []
        v73v1.push(getContent(PatchNoteType.Update, 'New page explains login errors'))
        v73v1.push(getContent(PatchNoteType.Fix, 'Fixed some problems with Internal error'))
        v73v1.push(getContent(PatchNoteType.Fix, 'Fixed some problems with logging in'))
        // Updated Sentry logging style
        // Disabled logging commands
        this.patchNotes.push(getPatchNote(2020, 3, 25, 73.1, v73v1))

        const v73: PatchNoteContent[] = []
        v73.push(getContent(PatchNoteType.Feature, 'Official 5-6 player map is ready', [], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/81750/add-6p-map']))
        v73.push(getContent(PatchNoteType.Feature, 'Added 7-8 player setting. Only available for <a href="/store" target="_blank">Founder Pack</a>'))
        v73.push(getContent(PatchNoteType.Update, 'Fun Map changed to Large Map - Enjoy 8 player games'))
        v73.push(getContent(PatchNoteType.Update, 'Hidden quick room create links from guests', [], undefined, 'https://prnt.sc/rkj0mc'))
        v73.push(getContent(PatchNoteType.Update, 'Added Login Benefits popup to Profile & Room'))
        v73.push(getContent(PatchNoteType.Update, 'Changed Online Players list to Friends List (Friend feature coming soon)'))
        v73.push(getContent(PatchNoteType.Fix, 'Fixed room player alignments'))
        // Changed VS Bots to Play vs Bots', https://prnt.sc/rkixic
        // Changed remove ad block ads to join discord ad
        // Fixed Action.PassedTutorial user undefined crash
        this.patchNotes.push(getPatchNote(2020, 3, 23, 73, v73))

        const v72v7: PatchNoteContent[] = []
        v72v7.push(getContent(PatchNoteType.Update, 'Private rooms do not show in lobby'))
        v72v7.push(getContent(PatchNoteType.Update, 'AFK hosts are kicked after 10 minutes', ['Wool'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/84471/afk-hosts']))
        v72v7.push(getContent(PatchNoteType.Fix, 'Fixed some fonts being too big', ['thellimist', 'AlexInAuburn']))
        // Removed unused images from pixi
        // Commented out water tile printing on UI
        // Fixed fonts in: Settings, EndGameName, Tutorial, ToolTip
        this.patchNotes.push(getPatchNote(2020, 3, 21, 72.7, v72v7))

        const v72v6: PatchNoteContent[] = []
        v72v6.push(getContent(PatchNoteType.Update, 'Online players box only shows the count'))
        v72v6.push(getContent(PatchNoteType.Fix, 'Fixed a lot more lag!', ['Rexana', 'cem']))
        // Games count in lobby is taken when clicked, instead of sending to everyone
        // Probably reduced 150mb/s bandwidth from lobby
        this.patchNotes.push(getPatchNote(2020, 3, 19, 72.6, v72v6))

        const v72v5: PatchNoteContent[] = []
        v72v5.push(getContent(PatchNoteType.Fix, 'Fixed lag in new users again..'))
        v72v5.push(getContent(PatchNoteType.Fix, 'Made data in profile prettier'))
        // Increased typeorm connection pool limit 150 => 600
        this.patchNotes.push(getPatchNote(2020, 3, 18, 72.5, v72v5))

        const v72v4: PatchNoteContent[] = []
        v72v4.push(getContent(PatchNoteType.Fix, 'Fixed lag in new users', ['Kan']))
        // Increased typeorm connection pool limit 10 => 150
        this.patchNotes.push(getPatchNote(2020, 3, 18, 72.4, v72v4))

        const v72v3: PatchNoteContent[] = []
        v72v3.push(getContent(PatchNoteType.Fix, 'Game works for new users', ['superpotato']))
        // Optimized random username database search by 10x-100x
        // Added a command to disable username changing when needed
        this.patchNotes.push(getPatchNote(2020, 3, 17, 72.3, v72v3))

        const v72v2: PatchNoteContent[] = []
        v72v2.push(getContent(PatchNoteType.Fix, 'Increased server capacity'))
        v72v2.push(getContent(PatchNoteType.Fix, 'Made servers more responsive'))
        // Mobile home page shows online player count again
        // Added a command to disable profile when needed
        // Database updated 8gb/4cpu/115gb/$120 => 32gb/8cpu/580gb/$480
        // Refactored MapUtils
        this.patchNotes.push(getPatchNote(2020, 3, 17, 72.2, v72v2))

        const v72v1: PatchNoteContent[] = []
        v72v1.push(getContent(PatchNoteType.Update, 'Settler Pack users have access to 5-6 players for a limited time.', ['Flem']))
        v72v1.push(getContent(PatchNoteType.Fix, 'Clicking on player name doesn\'t open too many profiles'))
        v72v1.push(getContent(PatchNoteType.Fix, 'Fixed map numbers', ['thesettler']))
        v72v1.push(getContent(PatchNoteType.Fix, 'Fixed ads pushing view down', ['player'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/83642/bug-the-ads-are-breaking-the-screen-the-screen-is-too-long']))
        v72v1.push(getContent(PatchNoteType.Fix, 'Removed video ad'))
        // Added presales discounts will be removed to announcements
        // Removed contribute popup. No one was messaging, https://prnt.sc/rgj7af
        // Added DoC & miniroyale seo juice
        // Made right ads AIP left ads VLI in lobby, game, profile
        // Mobile home page shows subscribe to know when mobile and doesnt show online player count
        this.patchNotes.push(getPatchNote(2020, 3, 15, 72.1, v72v1))

        const v72: PatchNoteContent[] = []
        v72.push(getContent(PatchNoteType.Feature, 'New Fun Map: St. Patrick\'s Day', ['AlexInAuburn']))
        v72.push(getContent(PatchNoteType.Feature, 'Profile shows player stats, <a href="/profile/thesettler" target="_blank">check it out</a>', ['thesettler']))
        v72.push(getContent(PatchNoteType.Update, 'Increased size of objects in mobile', ['Kir']))
        v72.push(getContent(PatchNoteType.Update, 'Removed chat colors from lobby', ['J'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/79211/please-make-brown-hat-player-text-white-or-magenta-or-periwinkle-or-rainbow-but-']))
        v72.push(getContent(PatchNoteType.Update, 'End game buttons no longer block player stats', [], undefined, 'https://prnt.sc/ra5oh9'))
        v72.push(getContent(PatchNoteType.Update, 'Clicking on usernames go to their profile'))
        v72.push(getContent(PatchNoteType.Update, 'Clicking on player icons go to their profile'))
        v72.push(getContent(PatchNoteType.Update, 'Clicking on player message icon send player private message'))
        v72.push(getContent(PatchNoteType.Fix, 'When player changes color their icon stays same'))
        v72.push(getContent(PatchNoteType.Fix, 'Fixed mobile still showing ads', ['Brandon']))
        v72.push(getContent(PatchNoteType.Fix, 'Doubled server capacity'))
        // Room color checks added to server
        // Added february & april tournament achievements
        // Switched most ads from AIP to VLI
        // Switched remove adblock to amazon affiliate
        // Added log rocket
        // Made private messaging only available to loggedin users
        // Clicking logo on all subpages send to origin
        // Server updated 4cpu/8ram/50ssd/5tbbandwith/$80 => 8cpu/16ram/100ssd/6tbbandwith/$160
        // Database updated 1gb/1cpu/10gb/$15 => 8gb/4cpu/115gb/$120
        this.patchNotes.push(getPatchNote(2020, 3, 14, 72, v72))

        const v71: PatchNoteContent[] = []
        v71.push(getContent(PatchNoteType.Feature, `New Fun Map: Gear <img src="${MapGearPreview}" style="width: 40%">`, ['AlexInAuburn']))
        v71.push(getContent(PatchNoteType.Feature, 'Added past game datas to user profile'))
        v71.push(getContent(PatchNoteType.Update, 'During beta test, <a href="/store" target="_blank">founder pack & colonist pack</a> users have access to 5-6 players'))
        v71.push(getContent(PatchNoteType.Fix, 'Fixed robber placement & resource bug on fun maps', ['Sudo', 'Susan', 'arjunlal']))
        // Added lots of Catan keywords to hidden h1
        // Fixed the image displayed in fun map popup: https://prnt.sc/r9vo38. Should increase sales.
        // v71.1 updated version and included right headers for VLI ads
        this.patchNotes.push(getPatchNote(2020, 3, 3, 71, v71))

        const v70: PatchNoteContent[] = []
        v70.push(getContent(PatchNoteType.Feature, 'Able to select colors in rooms'))
        v70.push(getContent(PatchNoteType.Feature, '5-6 players expansion is ready. During alpha test, only <a href="/store" target="_blank">founder pack</a> users have access to it'))
        v70.push(getContent(PatchNoteType.Feature, `New Fun Map: Large Map with 59 tiles <img src="${ImageNotAvailable}" style="width: 100%">`, ['AlexInAuburn']))
        v70.push(getContent(PatchNoteType.Update, 'Login to get black color: ' +
            `<img src="${RoadBlack}" style="height: 20px">` +
            `<img src="${SettlementBlack}" style="height: 20px">` +
            `<img src="${CityBlack}" style="height: 20px">`))
        v70.push(getContent(PatchNoteType.Update, 'Can disable animations', ['LeBoosted', 'Alexander Lau'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/76969/ability-to-toggle-animations']))
        v70.push(getContent(PatchNoteType.Update, 'Can zoom in/out from the map with scroller'))
        v70.push(getContent(PatchNoteType.Update, 'Removed ads from mobile and made mobile full screen'))
        v70.push(getContent(PatchNoteType.Update, 'Can scroll players if there are more than 4 players', ['AlexInAuburn']))
        v70.push(getContent(PatchNoteType.Update, 'Removed watch video to win packs feature, congrats on winners'))
        v70.push(getContent(PatchNoteType.Fix, 'Fixed bottom ad covering game', ['Flatos', 'Eqbal'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/79829/crazy-ads']))
        // Made only opponent players scroll, ['AlexInAuburn']
        // Added VLI to ads.txt
        this.patchNotes.push(getPatchNote(2020, 2, 21, 70, v70))

        const v69v1: PatchNoteContent[] = []
        v69v1.push(getContent(PatchNoteType.Feature, `Happy Valentines! Check out this weeks funmap<img src="${ImageNotAvailable}" style="width: 100%">`, ['AlexInAuburn']))
        v69v1.push(getContent(PatchNoteType.Update, 'Different sound plays when players leave room', ['Jdubz'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/75604/seperate-sounds-for-players-leaving-and-joining-the-lobby']))
        v69v1.push(getContent(PatchNoteType.Update, 'Wrote buying packs remove ads, make game wide screen and allow access to maps to shop'))
        v69v1.push(getContent(PatchNoteType.Fix, 'Fixed resources being covered when trading', ['AlexInAuburn'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/78518/configuration-option-to-disable-tooltips']))
        // Gave debbie pack
        // Gave Lati pack
        // Tournament maps can be controlled with admin command
        // Funmaps controlled from single variable
        this.patchNotes.push(getPatchNote(2020, 2, 14, 69.1, v69v1))

        const v69: PatchNoteContent[] = []
        v69.push(getContent(PatchNoteType.Update, 'Decreased chat spam filter sensitivity', ['Matias'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/74758/chat-spamblocking-should-be-decreased']))
        v69.push(getContent(PatchNoteType.Update, 'Quitters no longer get the 💩 emoji on their names'))
        // Made source code sharable
        this.patchNotes.push(getPatchNote(2020, 2, 8, 69, v69))

        const v68: PatchNoteContent[] = []
        v68.push(getContent(PatchNoteType.Feature, 'New Fun Map: Diamond Lake', ['AlexInAuburn']))
        v68.push(getContent(PatchNoteType.Update, 'Moved win pack button to lobby top left'))
        // Added disable ad block pretty please cat image
        // Added contribute announcement
        // Gave Celine settler pack
        this.patchNotes.push(getPatchNote(2020, 2, 3, 68, v68))

        const v67v1: PatchNoteContent[] = []
        v67v1.push(getContent(PatchNoteType.Fix, 'Fixed not being able to click top left part of map', ['senseicmj', 'grogdotcom', 'AlexInAuburn']))
        v67v1.push(getContent(PatchNoteType.Fix, 'Bug fixed in tutorial', ['ayame']))
        v67v1.push(getContent(PatchNoteType.Fix, 'Added a Q&A to shop that users can pay through paypal as well', ['vitalis']))
        // Added build road goal to tutorial
        // Removed iogamespace viral ad which doesnt have https
        // Changed ore color to the latest
        // Adblock popup changed to this version https://prnt.sc/qud8fz
        // Patchnotes featureupvote links can be clicked
        this.patchNotes.push(getPatchNote(2020, 1, 29, 67.1, v67v1))

        const v67: PatchNoteContent[] = []
        v67.push(getContent(PatchNoteType.Feature, `New Fun Map: Lakes <img src="${MapLakesPreview}" style="width: 40%">`, ['AlexInAuburn']))
        v67.push(getContent(PatchNoteType.Update, 'Users can change game resolution, antialias & power preference in settings.', ['ivan.popelyshev'], undefined, undefined, ['https://www.html5gamedevs.com/topic/44550-how-does-the-render-work/']))
        v67.push(getContent(PatchNoteType.Update, 'Shows asset loading percentage', ['player'], undefined, 'https://prnt.sc/qr4kvz', ['https://colonist.featureupvote.com/suggestions/73549/bug-slow-advertising-loading-affects-reconnections-rejoining-games-ui-loading']))
        v67.push(getContent(PatchNoteType.Fix, 'Better game performance', ['ivan.popelyshev'], undefined, undefined, ['https://www.html5gamedevs.com/topic/44550-how-does-the-render-work/']))
        v67.push(getContent(PatchNoteType.Fix, 'Fun maps look better with the new sea/shore tiles', ['burak']))
        v67.push(getContent(PatchNoteType.Fix, 'Changed the road images', ['burak']))
        // Removed the shines from sea tiles
        // Added preroll ads to win packs to patch notes
        // Changed color of bronze pieces & teal pieces
        // Changed ore color to iteration 3
        this.patchNotes.push(getPatchNote(2020, 1, 27, 67, v67))

        const v66: PatchNoteContent[] = []
        v66.push(getContent(PatchNoteType.Feature, `New Fun Map: Snowflake <img src="${MapSnowflakePreview}" style="width: 40%">`))
        v66.push(getContent(PatchNoteType.Update, 'Added first tournament map', ['MikeIsMyIke']))
        v66.push(getContent(PatchNoteType.Fix, 'Better game performance', ['cem']))
        // Added funnel analyics
        // Changed ore color to iteration 2
        // Removed game analytics
        // Removed poki sdk downloading when not on poki
        // Fixed some pixi performance
        // Added pixi debugging `window.PIXI = PIXI`
        // Removed limitation to game animations in app.ticker
        // Changed ingame ads zoom to translate
        // Changed tooltip texts from textview to bitmaptext
        this.patchNotes.push(getPatchNote(2020, 1, 20, 66, v66))

        // Fixed indicative crash. It was requiring people to refresh browser 10 times

        const v65: PatchNoteContent[] = []
        v65.push(getContent(PatchNoteType.Feature, 'New Fun Map: 2 Island</img>', []))
        v65.push(getContent(PatchNoteType.Feature, 'Added previous tournament achievements to everyone\'s profiles', ['BongBoy', 'Treeck'], undefined, 'https://prnt.sc/qkurti', ['https://colonist.featureupvote.com/suggestions/55017/discord-roles']))
        v65.push(getContent(PatchNoteType.Update, 'Created a <a href="/bugs">bugs page</a>', ['Minerva', 'WurthAlot']))
        v65.push(getContent(PatchNoteType.Update, 'Got featured on <a href="https://iogames.space/">iogames</a>, to help out, play over there and upvote', []))
        v65.push(getContent(PatchNoteType.Update, 'Created tutorial mode'))
        v65.push(getContent(PatchNoteType.Fix, 'Fixed Year of Plenty card getting used when there isn\'t enough bank resources'))
        v65.push(getContent(PatchNoteType.Fix, 'Fixed Year of Plenty increasing bank resources when there isn\'t enough bank resources'))
        v65.push(getContent(PatchNoteType.Fix, 'Fixed non premium players being able to host fun mode remakes'))
        v65.push(getContent(PatchNoteType.Fix, 'Fixed not being able to change map setting to Random and Beginner Map'))
        // Changed the button Play to Tutorial & Bot Game', undefined, undefined, 'https://prnt.sc/qmv1ew
        // Changed tournament ads back in to shop ads
        // Fixed random anon usernames not getting created 0.5% of the time
        // Added indicative analytics
        // Changed ore color to iteration 1
        this.patchNotes.push(getPatchNote(2020, 1, 14, 65, v65))

        const v64: PatchNoteContent[] = []
        v64.push(getContent(PatchNoteType.Feature, 'New Fun Map: Diamond.', ['Demiculus']))
        v64.push(getContent(PatchNoteType.Feature, 'Added update popup.', ['Demiculus']))
        v64.push(getContent(PatchNoteType.Update, 'Development card icons are bigger',
            ['eigengrau', 'Starshine', 'Matias', 'Couch Tomato'], undefined, 'https://prnt.sc/qgq80e'))
        v64.push(getContent(PatchNoteType.Update, 'Removed end game screen ads.'))
        v64.push(getContent(PatchNoteType.Update, 'Desert color is better',
            ['Matias', 'Starshine', 'Couch Tomato', 'The Commander\'s Son']))
        v64.push(getContent(PatchNoteType.Update,
            'Hovering over victory points shows how much victory points is needed for the game', ['corpsss']))
        v64.push(getContent(PatchNoteType.Update, 'Settlement & City pieces stands out more, color blind friendly',
            ['Couch Tomato', 'Starshine', 'Matias', 'GlryX', 'The Commander\'s Son', 'down_vote_magnet', 'Luke', 'Corey', 'MarcusHelius']))
        v64.push(getContent(PatchNoteType.Fix, 'Mobile safari works better', ['DylLighted'],
            'https://media.discordapp.net/attachments/637403643234222109/649395911675609088/image0.png', 'https://prnt.sc/qhcqpl'))
        this.patchNotes.push(getPatchNote(2020, 1, 7, 64, v64))

        const v63: PatchNoteContent[] = []
        v63.push(getContent(PatchNoteType.Feature, 'New Fun Map: Farmers Guild'))
        v63.push(getContent(PatchNoteType.Update, 'Room players show full screen', ['deliriz']))
        v63.push(getContent(PatchNoteType.Update, 'Turned `4v4` to `4p Game` to decrease confusion', ['Couch Tomato']))
        this.patchNotes.push(getPatchNote(2019, 12, 29, 63, v63))

        const v62: PatchNoteContent[] = []
        v62.push(getContent(PatchNoteType.Feature, 'New Fun Map: Dwarf\'s Fortress'))
        v62.push(getContent(PatchNoteType.Feature, 'Added Very Fast option with 30s turns', ['Swagger', 'Magic']))
        v62.push(getContent(PatchNoteType.Update, 'Increased dice timer to 10s to allow using Knight card before dice', ['Dan']))
        v62.push(getContent(PatchNoteType.Update, 'Changed number font', undefined,
            'https://prnt.sc/qa64cm', 'https://prnt.sc/qa678k'))
        v62.push(getContent(PatchNoteType.Update, 'Made red numbers stand out more', ['minimuscleR']))
        v62.push(getContent(PatchNoteType.Fix, 'Fixed hovers showing big on mobile', ['DylLighted']))
        this.patchNotes.push(getPatchNote(2019, 12, 16, 62, v62))

        const v61: PatchNoteContent[] = []
        v61.push(getContent(PatchNoteType.Feature, 'First Fun Map: Forester\'s Lodge'))
        v61.push(getContent(PatchNoteType.Update, 'Turn state box shows player color', undefined, undefined, 'https://prnt.sc/q7o16h'))
        v61.push(getContent(PatchNoteType.Update, 'Improve tile color & outlines', ['down_vote_magnet'], undefined, 'https://prnt.sc/q7o1hm'))
        v61.push(getContent(PatchNoteType.Update, 'Made sea tiles darker', ['down_vote_magnet'], undefined, 'https://prnt.sc/q7o1hm'))
        v61.push(getContent(PatchNoteType.Fix, 'End game stats screen doesn\'t black out player stats',
            [], undefined, 'https://prnt.sc/q5vjk7'))
        v61.push(getContent(PatchNoteType.Fix, 'Fixed chat card image ratios'))
        v61.push(getContent(PatchNoteType.Fix, 'Added slight delay on mouse-over tool tips', ['Floris']))
        v61.push(getContent(PatchNoteType.Fix, 'Fixed game not being centered on iPad', ['Robofight']))
        v61.push(getContent(PatchNoteType.Fix, 'Fixed server lag', ['Wanda Tinasky']))
        this.patchNotes.push(getPatchNote(2019, 12, 9, 61, v61))

        const v60: PatchNoteContent[] = []
        v60.push(getContent(PatchNoteType.Update, 'Iterated on UI', undefined, 'https://prnt.sc/q557zr', 'https://prnt.sc/q5584f'))
        v60.push(getContent(PatchNoteType.Update, 'Added click sounds to buttons', ['Demiculus']))
        v60.push(getContent(PatchNoteType.Update, 'Trading view is bigger', ['robinQ'], undefined, 'https://prnt.sc/q34h5o'))
        v60.push(getContent(PatchNoteType.Fix, 'Forest green is darker than sheep green', ['minimuscleR', 'down_vote_magnet', 'eigengrau']))
        v60.push(getContent(PatchNoteType.Fix, 'Decreased gradient on the tiles', ['down_vote_magnet']))
        v60.push(getContent(PatchNoteType.Fix, 'Fixed screen becoming stretched on fullscreen', ['Oleg']))
        v60.push(getContent(PatchNoteType.Fix, 'Fixed writing long texts messing up UI', ['Esqarrouth']))
        this.patchNotes.push(getPatchNote(2019, 12, 2, 60, v60))

        const v59: PatchNoteContent[] = []
        v59.push(getContent(PatchNoteType.Feature, 'Revamped all game assets! (Thanks everyone & <a href="https://www.giapponegamesart.com/"> Giappone</a> for drawing)'))
        v59.push(getContent(PatchNoteType.Feature, 'Removed video ads completely'))
        v59.push(getContent(PatchNoteType.Feature, 'Map can be zoomed & moved'))
        v59.push(getContent(PatchNoteType.Update, 'Added a lobby button to game'))
        v59.push(getContent(PatchNoteType.Fix, 'Fixed showing extra players', undefined, undefined, 'https://prnt.sc/pzvvwn'))
        v59.push(getContent(PatchNoteType.Fix, 'Fixed player names not fitting', undefined, undefined, 'https://prnt.sc/pysqsv'))
        this.patchNotes.push(getPatchNote(2019, 11, 27, 59, v59))

        const v58: PatchNoteContent[] = []
        v58.push(getContent(PatchNoteType.Feature, 'Optimized game for mobile', ['Guido', 'Mad', 'MrColonist', 'Matias']))
        v58.push(getContent(PatchNoteType.Feature, 'Can add Colonist page to homescreen on iOS devices', ['Heady'], 'https://colonist.featureupvote.com/suggestions/64834/ipadtablet-optimization'))
        v58.push(getContent(PatchNoteType.Fix, 'Fixed UI alignment problems for all screens'))
        v58.push(getContent(PatchNoteType.Fix, 'Instead of green border, background is highlighted when it\'s players turn', undefined, undefined, 'https://prnt.sc/pyookq'))
        v58.push(getContent(PatchNoteType.Update, 'Updated some UI elements'))
        v58.push(getContent(PatchNoteType.Update, 'Video ads don\'t show on players who own packs', ['Heady'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/64044/ad-popping-up-at-end-of-game-while-i-have-a-founder-pack']))
        v58.push(getContent(PatchNoteType.Update, 'Room writes \'Not Ready\' instead of an orange ready ', ['Husnu']))
        this.patchNotes.push(getPatchNote(2019, 11, 18, 58, v58))

        const v57: PatchNoteContent[] = []
        v57.push(getContent(PatchNoteType.Feature, 'Join the <a href="/tournament">November tournament!</a>'))
        v57.push(getContent(PatchNoteType.Update, 'Game is slightly faster for North American players'))
        v57.push(getContent(PatchNoteType.Update, 'Improved UI performance for weaker machines and Macs'))
        v57.push(getContent(PatchNoteType.Update, 'Update game chat screen to match lobby', undefined, undefined, 'https://prnt.sc/pp0g0h'))
        v57.push(getContent(PatchNoteType.Fix, 'Fixed not being able to copy chat messages'))
        v57.push(getContent(PatchNoteType.Fix, 'Fixed trade pencil button being white'))
        v57.push(getContent(PatchNoteType.Fix, 'Fixed player icon being stretched inside game'))
        v57.push(getContent(PatchNoteType.Fix, 'Fixed end game stats not showing up'))
        v57.push(getContent(PatchNoteType.Fix, 'Fixed end game tabs resetting when clicking on map view'))
        this.patchNotes.push(getPatchNote(2019, 11, 11, 57, v57))

        const v56: PatchNoteContent[] = []
        v56.push(getContent(PatchNoteType.Feature, 'Finally! Can choose who to trade with!', ['Sande24'], undefined, 'https://imgur.com/a/tU08TqZ', ['https://colonist.featureupvote.com/suggestions/51534/more-lifelike-trading']))
        v56.push(getContent(PatchNoteType.Feature, 'Added sound to trade offers'))
        v56.push(getContent(PatchNoteType.Feature, 'Start button in rooms show for Safari',
            ['WaHo4Life', 'mega'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/dismnm/colonistio_play_free_online_settlers_of_catan/f4d1kzb', 'https://colonist.featureupvote.com/suggestions/61488/cant-see-start-button-anymore-cant-play-game']))
        v56.push(getContent(PatchNoteType.Feature, 'Room shows empty player slots', undefined, undefined, 'https://prnt.sc/pnvoxw'))
        v56.push(getContent(PatchNoteType.Feature, 'Room show slots equal to the amount of players', undefined, undefined, 'https://prnt.sc/pnvqby'))
        v56.push(getContent(PatchNoteType.Feature, 'Made chat auto scroll'))
        v56.push(getContent(PatchNoteType.Feature, 'Chat & Logs are visible at the same time', ['Emperor'], undefined, 'https://prnt.sc/povykt', ['https://colonist.featureupvote.com/suggestions/58145/chat-and-log']))
        v56.push(getContent(PatchNoteType.Feature, 'Added place holder to game chatbox', ['Ray'], undefined, 'https://colonist.featureupvote.com/suggestions/52550/place-holder-on-chat-while-in-game'))
        v56.push(getContent(PatchNoteType.Feature, 'Learn to play doesn\'t popup when a player enters site for the first time'))
        v56.push(getContent(PatchNoteType.Feature, 'Lobby works on mobile', undefined, undefined, 'https://prnt.sc/pm1bv5'))
        v56.push(getContent(PatchNoteType.Update, 'Popup UI improved', undefined, undefined, 'https://prnt.sc/povswz'))
        v56.push(getContent(PatchNoteType.Update, 'Timer stops ticking after game ends', ['Schunkadunka', 'corpsss'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/52397/stop-the-timer-ticking-after-you-win-a-game']))
        v56.push(getContent(PatchNoteType.Fix, 'Fixed ads shown on people who purchase packs', ['Shakir', 'livejamie']))
        this.patchNotes.push(getPatchNote(2019, 10, 28, 56, v56))

        const v55: PatchNoteContent[] = []
        v55.push(getContent(PatchNoteType.Feature, 'Added create tournament room option', ['Treeckosaurus'], undefined, 'https://prnt.sc/pmovnw'))
        v55.push(getContent(PatchNoteType.Blog, 'New blog post! <a href="https://blog.colonist.io/introduction-to-settlers-of-catan/">Introduction to Settlers of Catan</a>'))
        v55.push(getContent(PatchNoteType.Update, 'Changed puke green color lobby to blue', ['yorg.io', 'Aeolian', 'Tiffany'], undefined, 'https://prnt.sc/pmovav', ['https://colonist.featureupvote.com/suggestions/61376/white-background-is-better#comment158685']))
        v55.push(getContent(PatchNoteType.Update, 'Updated shop layout to fit the new theme of the website'))
        v55.push(getContent(PatchNoteType.Fix, 'Fixed spectators closing discard window when connecting', ['MikeIsMyIke']))
        this.patchNotes.push(getPatchNote(2019, 10, 21, 55, v55))

        const v54: PatchNoteContent[] = []
        v54.push(getContent(PatchNoteType.Feature, 'Completely revamped lobby!', undefined, undefined, 'https://prnt.sc/pirad2'))
        v54.push(getContent(PatchNoteType.Feature, 'Completely revamped rooms!', undefined, undefined, 'https://prnt.sc/pirahf'))
        v54.push(getContent(PatchNoteType.Feature, 'Added popular create room options', undefined, undefined, 'https://prnt.sc/piralj'))
        v54.push(getContent(PatchNoteType.Feature, 'Separated rooms and games in lobby', undefined, undefined, 'https://prnt.sc/piralj'))
        v54.push(getContent(PatchNoteType.Blog, 'Created a new blog dedicated to publish content for the Catan community <a href="https://blog.colonist.io">Blog</a>'))
        this.patchNotes.push(getPatchNote(2019, 10, 14, 54, v54))

        const v53: PatchNoteContent[] = []
        v53.push(getContent(PatchNoteType.Update, 'In game settings shows game speed and bot speed', undefined, undefined, 'https://prnt.sc/pekbs8'))
        v53.push(getContent(PatchNoteType.Update, 'Fixed 12 dice not showing in stats screen', ['Muids'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/56697/bug-stats-dice-rolls-wrong']))
        v53.push(getContent(PatchNoteType.Update, 'Fixed Resource & Activity Stats orders', ['Taloch'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/59261/stats-are-not-right-at-least-not-in-the-correct-lines']))
        this.patchNotes.push(getPatchNote(2019, 10, 7, 53, v53))

        const v52: PatchNoteContent[] = []
        v52.push(getContent(PatchNoteType.Update, 'Increased maximum custom VP to 20', undefined, undefined, undefined, ['https://colonist.featureupvote.com/suggestions/57300/bring-max-vp-up-to-17-for-1v1-pro-games']))
        v52.push(getContent(PatchNoteType.Fix, 'Fixed trade offers showing wrong', ['raynman4451', 'DylLighted']))
        this.patchNotes.push(getPatchNote(2019, 9, 23, 52, v52))

        const v51: PatchNoteContent[] = []
        v51.push(getContent(PatchNoteType.Feature, 'Added resource stats', ['Sande24'], undefined, 'https://prnt.sc/p5u1kp'))
        v51.push(getContent(PatchNoteType.Feature, 'Added activity stats', undefined, undefined, 'https://prnt.sc/p5u19w'))
        v51.push(getContent(PatchNoteType.Feature, 'Separated resource card and development card stat graphs'))
        v51.push(getContent(PatchNoteType.Update, 'Decreased maximum custom VP to 14', ['Marcin'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/53855/a-way-to-finish-the-game-when-nobody-has-the-chance-to-reach-vp-number-to-win']))
        this.patchNotes.push(getPatchNote(2019, 9, 18, 51, v51))

        const v50: PatchNoteContent[] = []
        v50.push(getContent(PatchNoteType.Feature, 'Separated chat & game logs', ['rdagold', 'greendragonartist', 'Karousis', 'Giltner', 'DylLighted', 'Schunkadunka'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/51644/separate-chat-from-turn-log']))
        v50.push(getContent(PatchNoteType.Update, 'Removed \'not optimized for mobile\' popup for all platforms', ['Truman'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/55939/if-using-linux-it-thinks-you-are-on-mobile']))
        this.patchNotes.push(getPatchNote(2019, 9, 10, 50, v50))

        const v49: PatchNoteContent[] = []
        v49.push(getContent(PatchNoteType.Update, 'August 2019 Tournament <br><p>winner: Mufasa!</p><br><p>Finalists: MikeIsMyIke, DerLeopard, BongBoy</p>', undefined, undefined, undefined, ['https://docs.google.com/spreadsheets/d/1mckNUwIL4c_gqwuCh1rPPVR-Fforq2FxGfeqmSNDZu8/edit#gid=1324556363']))
        v49.push(getContent(PatchNoteType.Feature, 'Added dice stats',
            ['Schunkadunka', 'aztechunter', 'LinkUnseen', 'livejamie', 'rdagold', 'Thomson', 'Rozanski'], undefined, 'https://prnt.sc/p0yfgq', ['https://colonist.featureupvote.com/suggestions/51646/include-a-dice-roll-distribution-in-the-final-screen']))
        v49.push(getContent(PatchNoteType.Feature, 'Added resource & development cards received graphs', ['Sande24', 'MateCrate'], undefined, 'https://prnt.sc/p0yfer'))
        this.patchNotes.push(getPatchNote(2019, 9, 3, 49, v49))

        const v48: PatchNoteContent[] = []
        v48.push(getContent(PatchNoteType.Feature, 'Join the <a href="/tournament">tournament!</a>'))
        v48.push(getContent(PatchNoteType.Feature, 'Lobby shows Players Spectating count and list'))
        v48.push(getContent(PatchNoteType.Feature, 'Spectators are able to send private messages'))
        v48.push(getContent(PatchNoteType.Update, 'Made 6 & 8 red', ['debitcardwinner', 'marvMind', 'ucsbaway', 'arngeir'], undefined, 'https://prnt.sc/oxpmcz', ['https://colonist.featureupvote.com/suggestions/52375/make-6s-and-8s-red']))
        v48.push(getContent(PatchNoteType.Fix, 'Fixed karma showing in wrong order inside game'))
        this.patchNotes.push(getPatchNote(2019, 8, 27, 48, v48))

        const v47: PatchNoteContent[] = []
        v47.push(getContent(PatchNoteType.Update, 'Updated our banner logo!'))
        v47.push(getContent(PatchNoteType.Feature, 'Created a learn to play screen'))
        v47.push(getContent(PatchNoteType.Update, 'Moved the rules page inside learn to play'))
        v47.push(getContent(PatchNoteType.Feature, 'Added game spectating', ['DylLighted', 'Treeckosaurus']))
        v47.push(getContent(PatchNoteType.Feature, 'Game selects good starting spots when turn ends', ['corpsss'], undefined, undefined, ['https://colonist.featureupvote.com/suggestions/51000/randomly-select-good-starting-spots-if-player-disconnects']))
        v47.push(getContent(PatchNoteType.Update, 'Bots select what to discard, where to place robber, selecting who to rob, if your timer runs out'))
        v47.push(getContent(PatchNoteType.Update, 'Game becomes fullscreen when you buy presale pack', ['livejamie'], undefined, undefined, ['https://prnt.sc/otosyb']))
        v47.push(getContent(PatchNoteType.Update, 'Added a new tool to give feedback', undefined, undefined, 'https://colonist.featureupvote.com/?order=popular&filter=allexceptdone&deleted=0'))
        v47.push(getContent(PatchNoteType.Update, 'Updated info in contact button'))
        v47.push(getContent(PatchNoteType.Update, `Added social media links
            <a href="https://www.facebook.com/colonistio/">Facebook</a>,
            <a href="https://twitter.com/colonistio">Twitter</a>,
            <a href="https://www.instagram.com/colonist_io/">Instagram</a>,
            <a href="https://www.reddit.com/r/Colonist/">Reddit</a>,
            <a href="https://www.youtube.com/channel/UCkmPiTR8n0zqT6tIuUK0klA">Youtube</a>
        `))
        v47.push(getContent(PatchNoteType.Update, 'Added a presskit with all the assets'))
        this.patchNotes.push(getPatchNote(2019, 8, 20, 47, v47))

        const v46: PatchNoteContent[] = []
        v46.push(getContent(PatchNoteType.Update, 'Trade edit puts the cards in the right location',
            ['Mikeismyike', 'Matos', 'Stefan'], undefined, 'http://prntscr.com/opusea', ['https://colonist.featureupvote.com/suggestions/51114/bug-when-countering-trade-offers-resources-are-reversed#comment150247']))
        v46.push(getContent(PatchNoteType.Update, 'Hovering over development cards', ['Speedymon'], undefined, 'http://prntscr.com/opv0us', ['https://www.reddit.com/r/WebGames/comments/ci5bac/katanio_free_online_settlers_of_catan/evvkuac/?context=3']))
        v46.push(getContent(PatchNoteType.Update, 'Fixed bots hoarding cards again', ['RegularRandomZ', 'livejamie'], undefined, '', ['https://www.reddit.com/r/Katan/comments/cee93a/testing_v43/euf9y0z/']))
        this.patchNotes.push(getPatchNote(2019, 8, 12, 46, v46))

        const v45: PatchNoteContent[] = []
        v45.push(getContent(PatchNoteType.Update, 'Rebranded game from <a href="https://katan.io">katan.io</a> to <a href="https://colonist.io">colonist.io</a>!'))
        v45.push(getContent(PatchNoteType.Update, 'Cannot create empty offers', ['RegularRandomZ', 'Mikeismyike', 'radumalaxa', 'Davis', 'Patience', 'LeVasseur'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/cgelm2/katanio_play_free_online_settlers_of_catan/eumxeys/']))
        v45.push(getContent(PatchNoteType.Update, 'Created a <a href="https://discord.gg/uzCKAWV6qm">Discord</a> group'))
        v45.push(getContent(PatchNoteType.Update, 'A link will show up in lobby when a new version is ready in our test server'))
        v45.push(getContent(PatchNoteType.Update, 'Changed support email address send all your suggestions to: colonist.help@gmail.com'))
        this.patchNotes.push(getPatchNote(2019, 8, 6, 45, v45))

        const v44: PatchNoteContent[] = []
        v44.push(getContent(PatchNoteType.Feature, 'Added a command to disable karma penalty', ['corpsss'], undefined, 'http://prntscr.com/oi2y42', ['https://www.reddit.com/r/Katan/comments/cb1qb2/karma_system_design_v3/etmhf5a/']))
        v44.push(getContent(PatchNoteType.Feature, 'Green highlight appears when you reconnect to a game', ['corpsss'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/cee93a/testing_v43/eu8e3qd/']))
        v44.push(getContent(PatchNoteType.Update, 'Do you want to work on colonist.io? <a href="https://forms.gle/DcV2SmH1YtsS3FL37">Let us know</a>'))
        v44.push(getContent(PatchNoteType.Update, 'Changed UI according to feedback', ['RegularRandomZ', 'Mikeismyike', 'Sande24'], undefined, 'http://prntscr.com/oknfep', ['https://www.reddit.com/r/Katan/comments/cee93a/testing_v43/eue3q22/', 'https://www.reddit.com/r/Katan/comments/cgynkm/july_22nd_update_bug_new_trading_window/']))
        v44.push(getContent(PatchNoteType.Update, 'Cards stack', undefined, 'http://prntscr.com/ojsdbj'))
        v44.push(getContent(PatchNoteType.Update, 'Removed arrows', ['Sande24'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/cee93a/testing_v43/eu1xl5i/']))
        v44.push(getContent(PatchNoteType.Fix, 'Fixed cards behind trade screen getting clicked', ['Ronald', 'Khoo', 'RegularRandomZ'], undefined, 'http://prntscr.com/oirscv', ['https://www.reddit.com/r/Katan/comments/cee93a/testing_v43/euf5lz0/']))
        v44.push(getContent(PatchNoteType.Fix, 'Fixed trade button showing wrong icon', ['RegularRandomZ'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/cee93a/testing_v43/euggikh/']))
        v44.push(getContent(PatchNoteType.Fix, 'Fixed cards flying behind trade screen', ['RegularRandomZ'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/cicthj/testing_v44/ev7qkcj/']))
        v44.push(getContent(PatchNoteType.Fix, 'Fixed tool tip getting stuck ', ['RegularRandomZ'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/cicthj/testing_v44/ev6yz6v/']))
        v44.push(getContent(PatchNoteType.Fix, 'Fixed rooms staying open infinitely when host was afk'))
        v44.push(getContent(PatchNoteType.Fix, 'Fixed big question mark & game starting with map off the screen'))
        this.patchNotes.push(getPatchNote(2019, 7, 29, 44, v44))

        const v43: PatchNoteContent[] = []
        v43.push(getContent(PatchNoteType.Feature, 'Karma penalty is reactivated if all players rejoin the game', undefined, undefined, 'http://prntscr.com/ogdugr'))
        v43.push(getContent(PatchNoteType.Feature, 'Karma penalty gets deactivated a minute later if the player gets disconnected', ['RegularRandomZ'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/cdn0w7/karma_message_too_early/']))
        v43.push(getContent(PatchNoteType.Feature, 'Karma penalty gets deactivated if 2 people quit before the 5 minute mark', undefined, undefined, 'http://prntscr.com/ohmi5k'))
        v43.push(getContent(PatchNoteType.Feature, 'Karma looks better in rooms', ['corpsss'], 'http://prntscr.com/ohmiih', 'http://prntscr.com/ohmic2', ['https://www.reddit.com/r/Katan/comments/cb1qb2/karma_system_design_v3/etug9d7/']))
        v43.push(getContent(PatchNoteType.Update, 'Changed location of trade button', undefined, undefined, 'http://prntscr.com/oi1zn2'))
        v43.push(getContent(PatchNoteType.Update, 'Trade view changed', ['fromkeith'], undefined, 'http://prntscr.com/oi1zhv'))
        this.patchNotes.push(getPatchNote(2019, 7, 22, 43, v43))

        const v42: PatchNoteContent[] = []
        v42.push(getContent(PatchNoteType.Feature, 'Added Karma System! Your multiplayer game completion and quit status are recorded and shown to all other players',
            ['Mikeismyike', 'corpsss', 'skellz#6078', 'Pinto Killer', 'Kerneled', 'Clementine', 'FredBulbar',
                'Karousis', 'greendragonartist', 'joeyextreme', 'Blow-it-out-your-ass', 'livejamie', 'heady-kitty',
                'chemcrimp', 'Finke', 'y2jl', 'hurren', 'syhm'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/c9m9a7/karma_system_design/']))
        v42.push(getContent(PatchNoteType.Feature, 'It is clear whose turn it is.', ['fromkeith'], 'http://prntscr.com/obllva', 'https://prnt.sc/obxrlc', ['https://www.reddit.com/r/Katan/comments/b6kcp7/feature_requests/']))
        v42.push(getContent(PatchNoteType.Feature, 'Placement location highlights on map have an animation to make them clearer', ['fromkeith']))
        v42.push(getContent(PatchNoteType.Update, 'Your player is more obvious in the UI', ['fromkeith'], 'http://prntscr.com/obllva', 'https://prnt.sc/obxrlc'))
        v42.push(getContent(PatchNoteType.Fix, 'Fixed bot waiting for timer to run out when it doesn\'t have location to place road', ['kaximat1', 'Stan', 'Brattoli']))
        this.patchNotes.push(getPatchNote(2019, 7, 15, 42, v42))

        const v41: PatchNoteContent[] = []
        v41.push(getContent(PatchNoteType.Update, 'Decreased game download size by 840KB'))
        v41.push(getContent(PatchNoteType.Update, 'Bots can use knight before rolling', undefined, undefined, undefined, ['https://www.reddit.com/r/Catan/comments/c1ri89/katanio_play_free_online_settlers_of_catan/eri29y8/']))
        v41.push(getContent(PatchNoteType.Update, 'Bots check if friendly robber is active before using a knight'))
        this.patchNotes.push(getPatchNote(2019, 7, 8, 41, v41))

        const v40: PatchNoteContent[] = []
        v40.push(getContent(PatchNoteType.Feature, 'We\'re looking for advertisers. If you are one or know anyone please reach out:', undefined, undefined, 'https://prntscr.com/o5wka6'))
        v40.push(getContent(PatchNoteType.Feature, 'Bots place more meaningful roads', ['Arens', 'MrPeperoncino']))
        v40.push(getContent(PatchNoteType.Feature, 'Bots are more likely to lengthen their roads instead of branching out', ['Kreliannn', 'RegularRandomZ'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/bwbh1h/katanio_play_free_online_settlers_of_catan/eq4fa4v/']))
        v40.push(getContent(PatchNoteType.Feature, 'Bots fight for longest road', ['Kreliannn', 'Kreliannn'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/c1ri89/katanio_play_free_online_settlers_of_catan/erfghrg/']))
        v40.push(getContent(PatchNoteType.Feature, 'Bots don\'t go all in on placing roads after they get longest road', ['RockandSnow', 'AloeMyChildren'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/bz1cru/katanio_play_free_online_settlers_of_catan/era42xx/']))
        v40.push(getContent(PatchNoteType.Update, 'Embargo, turning off trading works properly', ['down_vote_magnet'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/c0i9ad/bots_should_not_wait_forever_for_you_to_accept_a/']))
        v40.push(getContent(PatchNoteType.Fix, 'Fixed incorrect rank orders with VP cards', ['RegularRandomZ'], undefined, 'https://prnt.sc/o5zrf7', ['https://www.reddit.com/r/Katan/comments/c3z8zf/testing_v39/erxmhw0/']))
        this.patchNotes.push(getPatchNote(2019, 7, 1, 40, v40))

        const v39: PatchNoteContent[] = []
        v39.push(getContent(PatchNoteType.Feature, 'Bots are less likely to accept trades that request multiple resources', ['RegularRandomZ', 'Sande24'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/bxxwxy/testing_v37/eqnxbbx/']))
        v39.push(getContent(PatchNoteType.Feature, 'Bots don\'t accept bad trades when they have a lot of cards in hand'))
        v39.push(getContent(PatchNoteType.Feature, 'Bots are less likely to accept bad trades'))
        v39.push(getContent(PatchNoteType.Feature, 'Made it clear that first game button is Beginner Map (Thanks Steve)'))
        v39.push(getContent(PatchNoteType.Feature, 'After the 1st player creates then closes a rematch room, the next person can create a new rematch room'))
        v39.push(getContent(PatchNoteType.Fix, 'Fixed not being able to reconnect to games', ['Arjunlal', 'Glebic', 'Martindale', 'RegularRandomZ', 'royeab'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/bxxwxy/testing_v37/eqnyxob/']))
        v39.push(getContent(PatchNoteType.Fix, 'Fixed bot skipping bank trading when no one has the resource'))
        v39.push(getContent(PatchNoteType.Fix, 'Fixed another case with games not closing after ending'))
        v39.push(getContent(PatchNoteType.Fix, 'Fixed a bug that crashed the game'))
        this.patchNotes.push(getPatchNote(2019, 6, 24, 39, v39))

        const v38: PatchNoteContent[] = []
        v38.push(getContent(PatchNoteType.Feature, 'If you want to support colonist.io and also buy cryptocurrency, use our <a href="https://www.binance.com/?ref=36967673" target="_blank">Binance referral link</a>'))
        v38.push(getContent(PatchNoteType.Feature, 'Made bots aware of the Card Discard Limit setting'))
        v38.push(getContent(PatchNoteType.Feature, 'Removed wildcard trading feature'))
        v38.push(getContent(PatchNoteType.Feature, 'Added Beginner Map setting in \'Create Room\'', ['fromkeith']))
        v38.push(getContent(PatchNoteType.Feature, 'Bots cancel offers and take action in their last 5 seconds', ['RegularRandomZ', 'AloeMyChildren'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/bxxwxy/testing_v37/eqo0mak/']))
        v38.push(getContent(PatchNoteType.Update, 'Changed \'Play VS Bots\' map layout to Beginner Map'))
        v38.push(getContent(PatchNoteType.Update, 'Changed \'More Games\' link to <a href="https://miniroyale.io/?ref=katan.io" target="_blank">MiniRoyale.io</a>'))
        v38.push(getContent(PatchNoteType.Fix, 'Fixed bots ignoring some choices for road, city and knight locations'))
        v38.push(getContent(PatchNoteType.Fix, 'Fixed bots not placing settlements on top left corner', ['Randy', 'Sande24'], undefined, 'https://prnt.sc/o0mzsx', ['https://www.reddit.com/r/Catan/comments/bls4bq/katanio_play_free_online_settlers_of_catan/emqywte/']))
        this.patchNotes.push(getPatchNote(2019, 6, 17, 38, v38))

        const v37: PatchNoteContent[] = []
        v37.push(getContent(PatchNoteType.Feature, 'Presale Pack hats show up in lobby, rooms and games (Lobby:<a href="http://prntscr.com/nxl5kv"> 🌅</a> Room:<a href="http://prntscr.com/nyz5xw"> 🌅</a>)'))
        v37.push(getContent(PatchNoteType.Feature, 'Trading screen stays open after successful trades', ['ufff#0564']))
        v37.push(getContent(PatchNoteType.Feature, 'Added maximum 120 seconds for action bonus timer', ['Sande24'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/btp4t8/katanio_play_free_online_settlers_of_catan/epwdh02/']))
        v37.push(getContent(PatchNoteType.Feature, 'Increased average bot trade respond time by 2s'))
        v37.push(getContent(PatchNoteType.Feature, 'Bots do not need a reply to offers if you don\'t have that resource', ['Sande24'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/ar7i3g/katanio_play_free_online_settlers_of_catan/eglbrin']))
        v37.push(getContent(PatchNoteType.Feature, 'Bots respond quickly if they don\'t have the resource asked for'))
        v37.push(getContent(PatchNoteType.Feature, 'After rejecting a bot offer, bots respond immediately'))
        v37.push(getContent(PatchNoteType.Feature, 'Bots wait a couple of seconds before jumping on offers that player can accept', ['Arjunlal']))
        v37.push(getContent(PatchNoteType.Feature, 'Bots don\'t immediately trade with bank while they have offers waiting for a response'))
        v37.push(getContent(PatchNoteType.Feature, 'Removed the temporary bot turn timer decrease by 4x'))
        v37.push(getContent(PatchNoteType.Feature, 'Cannot use Road Building card when you don\'t have road pieces', ['Wiskow', 'Irwin', 'Dranca', 'monkjack'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/bv1ns1/bug_when_no_roads_left_and_trying_to_use_road/']))
        v37.push(getContent(PatchNoteType.Feature, 'Road Building card passes to your turn when you run out of road pieces', ['Danny', 'Gospodarek']))
        v37.push(getContent(PatchNoteType.Fix, 'Fixed a scenario where bots traded stupidly', ['Hartle']))
        v37.push(getContent(PatchNoteType.Fix, 'Fixed not getting resources after randomly placing settlement', ['Andersen', 'Jenny', 'FredBulsara', 'livejamie', 'Matos', 'Arjunlal'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/bryqzp/randomly_placed_house_gives_no_resources/']))
        v37.push(getContent(PatchNoteType.Fix, 'Fixed times showing extra 0 at game end stats', ['Марго6789'], undefined, 'http://prntscr.com/nxkuz5'))
        this.patchNotes.push(getPatchNote(2019, 6, 10, 37, v37))

        const v36v1: PatchNoteContent[] = []
        v36v1.push(getContent(PatchNoteType.Fix, 'Fixed infinite bot trading', ['Atilme', 'Sande24', 'AloeMyChildren', 'Glesach'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/bvnmpm/testing_v36/epukd84/']))
        v36v1.push(getContent(PatchNoteType.Fix, 'Fixed bots placing knights on themselves'))
        this.patchNotes.push(getPatchNote(2019, 6, 4, 36.1, v36v1))

        const v36: PatchNoteContent[] = []
        v36.push(getContent(PatchNoteType.Feature, 'Replaced the setting \'Cant Place Robber Until VPs\' with \'Friendly Robber\''))
        v36.push(getContent(PatchNoteType.Feature, 'Fixed bots ignoring Friendly Robber setting', ['Wangyu', 'livejamie', 'wetz1091'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/bnvnct/friendly_robber_bug/']))
        v36.push(getContent(PatchNoteType.Feature, 'Chat prints when friendly robber is active to fix confusion', ['Mango', 'Catalyst', 'Sevil', 'nationaltreasure']))
        v36.push(getContent(PatchNoteType.Feature, 'Slowed \'Play VS Bots\' speed by 2x to make it new player friendly', ['fromkeith']))
        v36.push(getContent(PatchNoteType.Feature, 'Bots make smarter trading'))
        v36.push(getContent(PatchNoteType.Feature, 'Active offers are closed after one has been accepted (Thanks Thellimist</a>)'))
        v36.push(getContent(PatchNoteType.Feature, 'Added new FAQs to <a href="https://colonist.io/store" target="_blank">shop page</a>', ['fromkeith']))
        v36.push(getContent(PatchNoteType.Update, 'Improved texts in game and <a href="https://colonist.io/store" target="_blank">shop</a>', ['fromkeith']))
        v36.push(getContent(PatchNoteType.Fix, 'Fixed manipulating Friendly Robber by timing out', ['Ciupeiu', 'Meir', 'Blow-it-out-your-ass', 's2164059', 'livejamie'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/azi0yj/katanio_is_too_broken_imo/eia7yiv/']))
        v36.push(getContent(PatchNoteType.Fix, 'Fixed bots getting stuck while trading (Only 90% sure this is fixed, if it happens again take a screenshot)', ['LinkUnseen', 'alucidwake', 'Sande24', 'Sobaje', 'Randy', 'Khoo']))
        v36.push(getContent(PatchNoteType.Fix, 'Fixed trade window timer continuing when window closed', ['LinkUnseen', 'down_vote_magnet']))
        v36.push(getContent(PatchNoteType.Fix, 'Fixed bots hoarding cards', ['Randy', 'Giltner', 'Arjunlal']))
        v36.push(getContent(PatchNoteType.Fix, 'Fixed \'Trade with bank\' pop up not closing', ['AloeMyChildren']))
        v36.push(getContent(PatchNoteType.Fix, 'Fixed games hanging around forever after failing to reconnect'))
        v36.push(getContent(PatchNoteType.Fix, 'Fixed some disconnection issues related with temporary slow connection'))
        this.patchNotes.push(getPatchNote(2019, 6, 3, 36, v36))

        const v35: PatchNoteContent[] = []
        v35.push(getContent(PatchNoteType.Feature, 'Each successful action (building, buying/using dev cards) will add +20s to your turn timer', ['Erond', 'pwrx'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/av11sn/katanio_play_free_online_settlers_of_catan/ehhn7dy/?context=3']))
        v35.push(getContent(PatchNoteType.Feature, 'Each successful trade will add +20s to your turn timer', ['Averell', 'wetz1091'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/bqwkuy/katanio_play_free_online_settlers_of_catan/eog861u/']))
        v35.push(getContent(PatchNoteType.Fix, 'Fixed exploiting turn timer by toggling actions', ['Ricky', 'Tripod#7956', 'Teixeira']))
        v35.push(getContent(PatchNoteType.Fix, 'Changed maximum VP setting to 20', ['Margo']))
        this.patchNotes.push(getPatchNote(2019, 5, 27, 35, v35))

        const v34: PatchNoteContent[] = []
        v34.push(getContent(PatchNoteType.Feature, 'Changed Founder\'s Packs <a href="https://colonist.io/store" target="_blank">(Check it out)</a>', ['Dan']))
        v34.push(getContent(PatchNoteType.Feature, 'Rematch doesn\'t create 2 separate rooms anymore', ['Jenny', 'FredBulsara', 'leftsuzuki']))
        v34.push(getContent(PatchNoteType.Update, 'Decreased card animation delay', ['Sande24'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/bj62f2/katanio_play_free_online_settlers_of_catan/em8a0ea/?context=2']))
        this.patchNotes.push(getPatchNote(2019, 5, 20, 34, v34))

        const v33v6: PatchNoteContent[] = []
        v33v6.push(getContent(PatchNoteType.Update, 'Increased discard timer by 10 seconds', ['Casey', 'greendragonartist', 'Yoon']))
        v33v6.push(getContent(PatchNoteType.Fix, 'Fixed discard timer being too fast when Bots rolls 7', ['everyone']))
        v33v6.push(getContent(PatchNoteType.Fix, 'Fixed game crash issues'))
        v33v6.push(getContent(PatchNoteType.Fix, 'Fixed rematch button not working'))
        this.patchNotes.push(getPatchNote(2019, 5, 17, 33.6, v33v6))

        const v33v5: PatchNoteContent[] = []
        v33v5.push(getContent(PatchNoteType.Fix, 'Fixed reconnecting not showing roads', ['Noobie', 'Jenny', 'RegularRandomZ']))
        v33v5.push(getContent(PatchNoteType.Fix, 'Fixed game screen going down', ['Plessinger', 'Samaan', 'Meir', 'Bieberle']))
        v33v5.push(getContent(PatchNoteType.Fix, 'Fixed server crash issues'))
        this.patchNotes.push(getPatchNote(2019, 5, 16, 33.5, v33v5))

        const v33: PatchNoteContent[] = []
        v33.push(getContent(PatchNoteType.Feature, 'Server kicks afk players after 2 turns', ['DontTazeMehBr0', 'nosebooper', 'UnoDosThrace', 'KilikaRei', 'RegularRandomZ', 'DylLighted', 'Todd', 'Arjunlal', 'Yoon'], undefined, 'http://prntscr.com/nnn79z'))
        v33.push(getContent(PatchNoteType.Feature, 'Added 2 game modes: Play VS Bots & Play Fast VS Bots', ['Sande24', 'RegularRandomZ', 'Khoo'], undefined, 'http://prntscr.com/nmhmv2'))
        v33.push(getContent(PatchNoteType.Feature, 'Added profile pictures in game chat log', undefined, undefined, 'http://prntscr.com/nm83au'))
        v33.push(getContent(PatchNoteType.Feature, 'Added hover tooltips on lobby game buttons', undefined, undefined, 'http://prntscr.com/nnmw9g'))
        v33.push(getContent(PatchNoteType.Feature, 'Made Settler Pack roads more stand out from tiles', ['Karousis'], undefined, 'http://prntscr.com/nnn5bo'))
        v33.push(getContent(PatchNoteType.Fix, 'Fixed canceling placements not working', ['Gospodarek', 'RegularRandomZ', 'down_vote_magnet', 'wetz1091']))
        v33.push(getContent(PatchNoteType.Feature, 'Increased robber placement timer by 10 seconds', ['Yoon', 'toochunky']))
        v33.push(getContent(PatchNoteType.Feature, 'After a player disconnects, bot waits before making moves', ['Akkalyoncu']))
        v33.push(getContent(PatchNoteType.Feature, 'Chat limitations lightened for registered users', ['Keli']))
        this.patchNotes.push(getPatchNote(2019, 5, 13, 33, v33))

        const v32: PatchNoteContent[] = []
        v32.push(getContent(PatchNoteType.Feature, 'AFK room hosts get kicked after 20 minutes', ['Arjunlal', 'Giltner']))
        v32.push(getContent(PatchNoteType.Feature, 'Temporarily decreased bot turn timers by 4x to make waiting less painful if they bug out', ['Sande24'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/bj62f2/katanio_play_free_online_settlers_of_catan/em5mmk7/']))
        v32.push(getContent(PatchNoteType.Feature, 'Added profile images and colors for Settler, Colonist & Founder packs (Lobby:<a href="https://prnt.sc/nkq775"> 🌅</a> Game:<a href="https://prnt.sc/nkq9et"> 🌅</a>)'))
        v32.push(getContent(PatchNoteType.Feature, 'Modified piece colors & images', undefined, 'http://prntscr.com/nkjbad', 'http://prntscr.com/nkjbdx'))
        v32.push(getContent(PatchNoteType.Feature, 'Improved port fonts', undefined, 'https://prnt.sc/njwpx1', 'https://prnt.sc/njwpt1'))
        v32.push(getContent(PatchNoteType.Fix, 'Fixed displaying of wrong user information after reconnection'))
        this.patchNotes.push(getPatchNote(2019, 5, 7, 32, v32))

        const v31: PatchNoteContent[] = []
        v31.push(getContent(PatchNoteType.Feature, 'Added Founder\'s Packs for players who want to support the development of colonist.io <a href="https://colonist.io/store" target="_blank">(Link)</a>'))
        v31.push(getContent(PatchNoteType.Feature, 'Lowered the speed of bots in Instant Bot Game', ['RegularRandomZ', 'RedactedByElves', 'foozballguy'], undefined, undefined, ['https://www.reddit.com/r/Katan/comments/b6kcp7/feature_requests/']))
        v31.push(getContent(PatchNoteType.Feature, 'Changed error message when missing pieces to place', ['Davis', 'Babou', 'Hole', 'cbals', 'RedactedByElves'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/be8bh3/katanio_play_free_online_settlers_of_catan/']))
        v31.push(getContent(PatchNoteType.Feature, 'Changed error message when no development cards left in deck', ['Damoc', 'Thellimist']))
        v31.push(getContent(PatchNoteType.Fix, 'Fixed bug when clicking on profile when in room', ['Arjunlal']))
        v31.push(getContent(PatchNoteType.Fix, 'Fixed reconnecting back to game not showing available action'))
        v31.push(getContent(PatchNoteType.Fix, 'Fixed quitting on your turn inside bot games added the poop emoji'))
        this.patchNotes.push(getPatchNote(2019, 4, 30, 31, v31))

        const v30: PatchNoteContent[] = []
        v30.push(getContent(PatchNoteType.Feature, 'Reconnect back to single player games in 60 seconds', ['Barbier'], undefined, 'http://prntscr.com/nbzwyb'))
        v30.push(getContent(PatchNoteType.Feature, 'Quitting single player games don\'t add poop emoji to your username', ['RegularRandomZ']))
        v30.push(getContent(PatchNoteType.Update, 'Socket closing doesn\'t attempt to reconnect and instead gives a message to refresh'))
        v30.push(getContent(PatchNoteType.Fix, 'Fixed using 2 knights bug', ['Jakov', 'Giltner', 'Arjunlal', 'chickendestroy'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/azi0yj/katanio_is_too_broken_imo/eibueto/']))
        this.patchNotes.push(getPatchNote(2019, 4, 15, 30, v30))

        const v29: PatchNoteContent[] = []
        v29.push(getContent(PatchNoteType.Feature, 'Added reconnect button inside the lobby', ['Barbier', 'Giltner', 'Zaidi', 'greendragonartist'], undefined, 'http://prntscr.com/n719b8'))
        v29.push(getContent(PatchNoteType.Feature, 'Gives error message when you try to request a card no one has', ['Ngo'], undefined, 'http://prntscr.com/n95weu'))
        v29.push(getContent(PatchNoteType.Feature, 'Added Google login/logout button', ['Cqrbon One'], undefined, 'http://prntscr.com/n97a2j'))
        v29.push(getContent(PatchNoteType.Fix, 'Fixed reconnect not showing cards', ['Arjunlal']))
        v29.push(getContent(PatchNoteType.Fix, 'Fixed naming and session inconsistencies with reconnection', ['RegularRandomZ']))
        v29.push(getContent(PatchNoteType.Fix, 'Made disconnect/reconnect texts more clear'))
        this.patchNotes.push(getPatchNote(2019, 4, 9, 29, v29))

        const v28: PatchNoteContent[] = []
        v28.push(getContent(PatchNoteType.Feature, 'Reconnection! Refresh page or use the custom link to join', ['Tarik', 'Level126', 'Wolf\'s Hollow']))
        v28.push(getContent(PatchNoteType.Feature, 'Don\'t need to hard refresh the game after update', ['PantieOn', 'Sande24'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/b2t1uk/katanio_issue/']))
        v28.push(getContent(PatchNoteType.Feature, 'Changed lobby text placement'))
        v28.push(getContent(PatchNoteType.Feature, 'Limited maximum rooms per player'))
        v28.push(getContent(PatchNoteType.Fix, 'Fixed ports not showing in Firefox', ['Thellimist']))
        v28.push(getContent(PatchNoteType.Fix, 'Fixed not being able to join rooms from url', ['Japan cakes']))
        v28.push(getContent(PatchNoteType.Fix, 'Fixed not being able to join rematch', ['Zima']))
        v28.push(getContent(PatchNoteType.Fix, 'Fixed private message bugs'))
        v28.push(getContent(PatchNoteType.Fix, 'Fixed bugs with lobby player lists'))
        this.patchNotes.push(getPatchNote(2019, 4, 2, 28, v28))

        const v27: PatchNoteContent[] = []
        v27.push(getContent(PatchNoteType.Feature, 'Made player icon colors dark', ['Giltner', 'Hagerman', 'Sande24'], undefined, 'http://prntscr.com/n28rwg', ['https://www.reddit.com/r/Catan/comments/ar7i3g/katanio_play_free_online_settlers_of_catan/eglbrin/']))
        v27.push(getContent(PatchNoteType.Feature, 'Improved offer separation', undefined, 'https://prnt.sc/n28ha3', 'https://prnt.sc/n28hf1'))
        v27.push(getContent(PatchNoteType.Feature, 'Discard UI shows how many cards left to discard', undefined, undefined, 'http://prntscr.com/n1rxyh'))
        v27.push(getContent(PatchNoteType.Feature, 'Disabling trade is more obvious', undefined, undefined, 'http://prntscr.com/n28a7c'))
        v27.push(getContent(PatchNoteType.Feature, 'Increased initial settlement timer from 90s to 120s', ['pwrx'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/av11sn/katanio_play_free_online_settlers_of_catan/ehe556j/']))
        v27.push(getContent(PatchNoteType.Feature, 'Limited max guest nickname to 6 characters'))
        v27.push(getContent(PatchNoteType.Update, 'Cards hovering over trade info does not show if there is only 1 card'))
        v27.push(getContent(PatchNoteType.Fix, 'Fixed trade cards staying on screen after closing its screen', ['Thellimist'], undefined, undefined))
        v27.push(getContent(PatchNoteType.Fix, 'Fixed usernames resetting everyday'))
        v27.push(getContent(PatchNoteType.Fix, 'Fixed some bugs related to connection'))
        this.patchNotes.push(getPatchNote(2019, 5, 25, 27, v27))

        const v26: PatchNoteContent[] = []
        v26.push(getContent(PatchNoteType.Feature, 'Updated the username system'))
        v26.push(getContent(PatchNoteType.Feature, 'Limited maximum duplicate offers to 3'))
        v26.push(getContent(PatchNoteType.Feature, 'Instead of a (B) prefix, bots now have a 🤖 emoji prefix', undefined, undefined, 'http://prntscr.com/mxypc2'))
        v26.push(getContent(PatchNoteType.Feature, 'Instead of a (G) prefix, guests now have a number a number tag suffix', undefined, undefined, 'http://prntscr.com/mxyq0j'))
        v26.push(getContent(PatchNoteType.Feature, 'Quitters now have a 💩 prefix', undefined, undefined, 'http://prntscr.com/mxyrw1'))
        v26.push(getContent(PatchNoteType.Feature, 'Better random usernames are generated'))
        this.patchNotes.push(getPatchNote(2019, 3, 18, 26, v26))
        v26.push(getContent(PatchNoteType.Fix, 'Fixed randomly placing roads on the first settlement', ['Teixeira', 'Laycock', 'Martyn', 'Blow-it-out-your-ass', 'samtony234'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/azi0yj/katanio_is_too_broken_imo/']))

        const v25v2: PatchNoteContent[] = []
        v25v2.push(getContent(PatchNoteType.Feature, 'Limited maximum active trade offers', ['angrycompanda', 'bERt0r', 'DEG', 'Neusner']))
        v25v2.push(getContent(PatchNoteType.Feature, 'Limited maximum cards that can be requested'))
        this.patchNotes.push(getPatchNote(2019, 5, 5, 25.2, v25v2))

        const v25: PatchNoteContent[] = []
        v25.push(getContent(PatchNoteType.Feature, 'Added player names on steal popup', ['Hagerman', 'samtony234', 'Sande24'], undefined, 'http://prntscr.com/mpwctb', ['https://www.reddit.com/r/Catan/comments/ar7i3g/katanio_play_free_online_settlers_of_catan/eglbrin/']))
        v25.push(getContent(PatchNoteType.Feature, 'Added custom setting to hide bank cards', ['DylLighted'], undefined, 'http://prntscr.com/mpg5rj', ['https://www.reddit.com/r/Catan/comments/arxrv3/katanio_play_free_online_settlers_of_catan/egrmaaf/']))
        v25.push(getContent(PatchNoteType.Fix, 'Fixed new rooms showing up at the bottom of room list instead of top', ['Clementine'], undefined, 'http://prntscr.com/mpwezs'))
        v25.push(getContent(PatchNoteType.Fix, 'Fixed game freezing after Bot trying to steal from a player with 0 cards', ['kaximat1', 'TheRealTinfoil666', 'Hagerman', 'Aurel', 'raynman4451', 'timbosliceAFC', 'Awkwerdna', 'Heavlin']))
        v25.push(getContent(PatchNoteType.Fix, 'Fixed Bot robber targeting tiles with players without cards', ['kaximat1']))
        v25.push(getContent(PatchNoteType.Fix, 'Fixed rematch button not working in Instant Bot games'))
        this.patchNotes.push(getPatchNote(2019, 2, 26, 25, v25))

        const v24: PatchNoteContent[] = []
        v24.push(getContent(PatchNoteType.Feature, 'Made it more clear which cards you need to click to offer trade', ['Randy', 'everyone'], undefined, 'https://prnt.sc/mmcfk8'))
        v24.push(getContent(PatchNoteType.Feature, 'Added a bank trade button', ['everyone'], undefined, 'http://prntscr.com/mmdjoz'))
        v24.push(getContent(PatchNoteType.Feature, 'Doubled the turn timer to give enough time to trade', ['Thellimist']))
        v24.push(getContent(PatchNoteType.Feature, 'Balanced bot waiting delay', ['rdagold']))
        v24.push(getContent(PatchNoteType.Feature, 'Bots close all offers after player accepts one', ['Sande24'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/ar7i3g/katanio_play_free_online_settlers_of_catan/egnn9fd/?context=3']))
        v24.push(getContent(PatchNoteType.Fix, 'Fixed bots responding really slowly to offers in some cases', ['Sande24']))
        v24.push(getContent(PatchNoteType.Fix, 'Fixed bots accepting trades too fast'))
        v24.push(getContent(PatchNoteType.Fix, 'Fixed bots creating same offer twice'))
        v24.push(getContent(PatchNoteType.Fix, 'Fixed bots taking building actions while waiting for trade responses'))
        v24.push(getContent(PatchNoteType.Fix, 'Fixed losing cards to bank when trying to receive a wildcard from it'))
        this.patchNotes.push(getPatchNote(2019, 2, 18, 24, v24))

        const v23: PatchNoteContent[] = []
        v23.push(getContent(PatchNoteType.Feature, 'Trade system overhaul'))
        v23.push(getContent(PatchNoteType.Feature, 'Made trading system similar to Play Catan', ['Dylan', 'Sande2'], undefined, 'https://prnt.sc/mltaxm'))
        v23.push(getContent(PatchNoteType.Feature, 'Added ability to create multiple trade offers asynchronously', ['Teixeira'], undefined, 'https://prnt.sc/mltaxm'))
        v23.push(getContent(PatchNoteType.Feature, 'Added ability to counter trade offers', ['Giltner', 'rdagold', 'Dylan'], undefined, 'http://prntscr.com/mltb5y'))
        v23.push(getContent(PatchNoteType.Feature, 'Added ability to offer wildcard trades', ['Teixeira', 'Dylan'], undefined, 'http://prntscr.com/mltb5y'))
        v23.push(getContent(PatchNoteType.Feature, 'Added ability to embargo other players', undefined, undefined, 'http://prntscr.com/mltbil'))
        v23.push(getContent(PatchNoteType.Feature, 'Added ability to choose multiple trading targets', ['Wolf\'s Hollow'], undefined, 'http://prntscr.com/mltbil'))
        v23.push(getContent(PatchNoteType.Feature, 'Bank automatically accepts any trade it can take', ['rdagold', 'Thomas']))
        v23.push(getContent(PatchNoteType.Feature, 'Trade offers don\'t reset turn timer', ['Teixeira', 'Krendelev', 'Giltner', 'samtony234']))
        v23.push(getContent(PatchNoteType.Feature, 'Added better trade error messages', ['Xiang', 'kaximat1', '31rhcp'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/a7g02e/katanio_play_free_online_settlers_of_catan/ec977lu/']))
        v23.push(getContent(PatchNoteType.Update, 'Made trading UI more compact and clearer', ['Mendel', 'Wolf\'s Hollow', 'RockandSnow', 'Sevil', 'Disclay', 'tarikozket', 'Hubbard', 'Nocturnae', 'Quoth-the-Raisin', 'Izanagi104'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/9yjm6m/katanio_play_free_online_settlers_of_catan/eaqj1x0/']))
        v23.push(getContent(PatchNoteType.Update, 'Increased the auto reject timer for trade', ['Mister E', 'rdagold']))
        v23.push(getContent(PatchNoteType.Update, 'Remade discard screen', undefined, undefined, 'http://prntscr.com/mltdxp'))
        v23.push(getContent(PatchNoteType.Update, 'Remade robber screen', undefined, undefined, 'http://prntscr.com/mltf3b'))
        v23.push(getContent(PatchNoteType.Update, 'Decreased clickable area around lobby logo'))
        v23.push(getContent(PatchNoteType.Update, 'Made timer turning to red feel better'))
        v23.push(getContent(PatchNoteType.Update, 'Updated the link in \'More Games\' button'))
        v23.push(getContent(PatchNoteType.Fix, 'Fixed private rooms with bots hanging around forever'))
        v23.push(getContent(PatchNoteType.Fix, 'Fixed victory screen misalignments'))
        this.patchNotes.push(getPatchNote(2019, 2, 16, 23, v23))

        const v22: PatchNoteContent[] = []
        v22.push(getContent(PatchNoteType.Feature, 'Added private room option', ['Frederic', 'Thomas', 'timbosliceAFC', 'Shafticus'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/ada5l9/katanio_play_free_online_settlers_of_catan/edm73a7/']))
        v22.push(getContent(PatchNoteType.Feature, 'Increased the animation speed of cards', ['timbosliceAFC', 'Mitch', 'Wilmot'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/al1fde/katanio_play_free_online_settlers_of_catan/efgvu73/']))
        v22.push(getContent(PatchNoteType.Feature, 'Added a rematch button at the End Game screen', undefined, undefined, 'http://prntscr.com/mgobyt'))
        v22.push(getContent(PatchNoteType.Feature, 'Improved design of End Game screen', undefined, undefined, 'https://prnt.sc/mgfc9d'))
        v22.push(getContent(PatchNoteType.Update, 'Made game files load faster'))
        this.patchNotes.push(getPatchNote(2019, 2, 6, 22, v22))

        const v21: PatchNoteContent[] = []
        v21.push(getContent(PatchNoteType.Feature, 'Created End Game and Stats Screen', ['Jim', 'kaximat1', 'Dylan', 'rdagold', 'Mihai', 'Teixeira'], undefined, 'https://prnt.sc/mdkjpn'))
        v21.push(getContent(PatchNoteType.Feature, 'Cards animate slower and one at a time'))
        v21.push(getContent(PatchNoteType.Update, 'Improved player & bank stats UI'))
        v21.push(getContent(PatchNoteType.Update, 'Settings button moved to top', ['Alper']))
        v21.push(getContent(PatchNoteType.Update, 'Timer becomes red when time is almost up'))
        v21.push(getContent(PatchNoteType.Update, 'UI improvements', ['Mango']))
        v21.push(getContent(PatchNoteType.Fix, 'Rules and Patch Notes pages don\'t create a new user', ['Thellimist']))
        this.patchNotes.push(getPatchNote(2019, 1, 29, 21, v21))

        const v20: PatchNoteContent[] = []
        v20.push(getContent(PatchNoteType.Feature, 'Secured network connection'))
        v20.push(getContent(PatchNoteType.Feature, 'Added command to disable/enable chat: \'/disablechat\'', ['Bryan', 'Ashley']))
        v20.push(getContent(PatchNoteType.Feature, 'Added measures against weird chat characters', ['rdx_mania']))
        v20.push(getContent(PatchNoteType.Feature, 'Added measures against weird player names', ['rdx_mania']))
        v20.push(getContent(PatchNoteType.Feature, 'Made usernames and message visually distinctive in chat'))
        v20.push(getContent(PatchNoteType.Fix, 'Fixed network connection bugs', ['Elusive']))
        v20.push(getContent(PatchNoteType.Fix, 'Fixed socket is closed bugs', ['Sparrow', 'Elusive', 'Jessica']))
        this.patchNotes.push(getPatchNote(2019, 1, 17, 20, v20))

        const v19v3: PatchNoteContent[] = []
        v19v3.push(getContent(PatchNoteType.Feature, 'Added measures against spamming in chat'))
        v19v3.push(getContent(PatchNoteType.Feature, 'Added measures against setting similar names'))
        this.patchNotes.push(getPatchNote(2019, 1, 11, 19.3, v19v3))

        const v19v2: PatchNoteContent[] = []
        v19v2.push(getContent(PatchNoteType.Feature, 'Lobby shows custom names before guest names'))
        v19v2.push(getContent(PatchNoteType.Fix, 'Fixed games not closing after ending'))
        this.patchNotes.push(getPatchNote(2019, 1, 9, 19.2, v19v2))

        const v19v1: PatchNoteContent[] = []
        v19v1.push(getContent(PatchNoteType.Feature, 'Added message sounds'))
        v19v1.push(getContent(PatchNoteType.Feature, 'Added icons to players in game', ['Tarik']))
        v19v1.push(getContent(PatchNoteType.Feature, 'Made whose turn it is more clear', ['Tarik']))
        v19v1.push(getContent(PatchNoteType.Fix, 'Fixed bug with game loading before downloading images', ['Calvin']))
        this.patchNotes.push(getPatchNote(2019, 1, 8, 19.1, v19v1))

        const v19: PatchNoteContent[] = []
        v19.push(getContent(PatchNoteType.Feature, 'Improved lobby design', ['Alper']))
        v19.push(getContent(PatchNoteType.Feature, 'Improved room design', ['Tarik', 'Sevil']))
        v19.push(getContent(PatchNoteType.Feature, 'Improved dice design', ['Alper', 'Dylan']))
        v19.push(getContent(PatchNoteType.Feature, 'Game dynamically scales with browser screen change', ['Wolf\'s Hollow', 'Sevil', 'Phosegena']))
        v19.push(getContent(PatchNoteType.Feature, 'Shows on lobby when a room is full', ['Tarik']))
        v19.push(getContent(PatchNoteType.Feature, 'Tiles shine when dice is rolled', ['Wolf\'s Hollow', 'rdagold']))
        v19.push(getContent(PatchNoteType.Update, 'Improved information text when hovering over'))
        v19.push(getContent(PatchNoteType.Update, 'Changed game logo'))
        v19.push(getContent(PatchNoteType.Feature, 'Improved some chat emojis'))
        this.patchNotes.push(getPatchNote(2019, 1, 6, 19, v19))

        const v18: PatchNoteContent[] = []
        v18.push(getContent(PatchNoteType.Feature, 'Can play knight cards before rolling dice', ['Paul', 'Dylan']))
        v18.push(getContent(PatchNoteType.Feature, 'Added Game Speed setting to custom games', ['raynman4451'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/a3t039/katanio_play_online_catan_version_13_14_update/ebagibq/']))
        v18.push(getContent(PatchNoteType.Feature, 'Added Bot Speed setting to custom games', ['Frontguenter', 'lolNidi', 'Dylan', 'rdagold'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/9yjm6m/katanio_play_free_online_settlers_of_catan/ea3qigl/']))
        v18.push(getContent(PatchNoteType.Feature, 'Increased settlement and city placement timers from 10s to 15s', ['Sevil']))
        v18.push(getContent(PatchNoteType.Feature, 'Doesn\'t reject trades instantaneously if the other player does not have the requested resource', ['rdagold']))
        v18.push(getContent(PatchNoteType.Feature, 'Background doesn\'t highlight anymore on your turn', ['Thellimist']))
        v18.push(getContent(PatchNoteType.Feature, '11 probability fixed to have 2 pips (from 3)', ['31rhcp'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/a7g02e/katanio_play_free_online_settlers_of_catan/ec977lu/']))
        v18.push(getContent(PatchNoteType.Feature, 'New sounds: Trade, Players enters room', ['rdagold']))
        v18.push(getContent(PatchNoteType.Feature, 'Decreased all sound volumes by 50%', ['Wolf\'s Hollow']))
        v18.push(getContent(PatchNoteType.Feature, 'Turn countdown sound changed'))
        v18.push(getContent(PatchNoteType.Feature, 'The texts: \'wood\', \'sheep\', \'wheat\', \'house\' are also turned into card emojis, type /help to get more info!'))
        v18.push(getContent(PatchNoteType.Feature, 'Chat properly prints 2xOre emoji', ['Wolf\'s Hollow', 'Thellimist']))
        v18.push(getContent(PatchNoteType.Feature, 'Chat emojis show correct color of road, settlement, city'))
        v18.push(getContent(PatchNoteType.Feature, 'Added new card & dice emojis to chat log'))
        v18.push(getContent(PatchNoteType.Feature, 'Made resource distribution emojis more compact in chat'))
        v18.push(getContent(PatchNoteType.Feature, 'All unready player names are shown on chat if they haven\'t pressed ready'))
        v18.push(getContent(PatchNoteType.Feature, 'Can send private messages to people who are in games and room'))
        v18.push(getContent(PatchNoteType.Update, 'Trade icon changed', ['osolmaz']))
        v18.push(getContent(PatchNoteType.Fix, 'Fixed sound not working in Safari', ['31rhcp'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/a7g02e/katanio_play_free_online_settlers_of_catan/ec977lu/']))
        v18.push(getContent(PatchNoteType.Fix, 'Fixed connecting to lobby chat bug on game end', ['Thellimist']))
        this.patchNotes.push(getPatchNote(2018, 12, 25, 18, v18))

        const v17: PatchNoteContent[] = []
        v17.push(getContent(PatchNoteType.Feature, 'Design overhaul!!!', ['Paul Ruettgers', 'Nesir', 'TearOfTheStar', 'Sande24', 'catancollectordotcom', 'PolarEnds', 'Wolf\'s Hollow', 'glryx', 'rdagold', 'Phosegena', 'Lord Nikkas', 'Randy', 'Cqrbon One']))
        v17.push(getContent(PatchNoteType.Feature, 'Increased place road, settlement, city, rob selection, development card timers from 10s to 15s'))
        v17.push(getContent(PatchNoteType.Feature, 'Can turn off sound', ['samtony234'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/a5vsbq/katanio_play_free_online_settlers_of_catan/ebr61l0/']))
        v17.push(getContent(PatchNoteType.Feature, 'Game settings use less space in game, shows up on click'))
        v17.push(getContent(PatchNoteType.Fix, 'Fixed lobby UI player & bot, icon & names being distorted'))
        v17.push(getContent(PatchNoteType.Fix, 'Fixed bug where the leader of the room passed down to bots and the room stayed forever'))
        this.patchNotes.push(getPatchNote(2018, 12, 18, 17, v17))

        const v16: PatchNoteContent[] = []
        v16.push(getContent(PatchNoteType.Feature, 'Game remembers your nickname', ['Jerry', 'Wolf\'s Hollow']))
        v16.push(getContent(PatchNoteType.Feature, 'Can change player name inside room'))
        v16.push(getContent(PatchNoteType.Feature, 'Changed beeping sound for bell sound', ['Wolf\'s Hollow']))
        v16.push(getContent(PatchNoteType.Feature, 'Added sound for your turn'))
        v16.push(getContent(PatchNoteType.Feature, 'Increased initial settlement timer from 30s to 90s', ['ericpalumbo', 'Wolf\'s Hollow']))
        v16.push(getContent(PatchNoteType.Feature, 'Added Roadmap to Patch Notes page'))
        this.patchNotes.push(getPatchNote(2018, 12, 13, 16, v16))
        v16.push(getContent(PatchNoteType.Update, 'Changed private message format, type /help to learn'))
        v16.push(getContent(PatchNoteType.Update, 'Changed favicon and lobby color'))
        v16.push(getContent(PatchNoteType.Fix, 'Fixed cards appearing very small or invisible', ['traveler71214', 'kaximat1', 'Abe']))
        v16.push(getContent(PatchNoteType.Fix, 'Fixed settlements becoming invisible', ['Randy', 'lolNidi', 'Wolf\'s Hollow']))
        v16.push(getContent(PatchNoteType.Fix, 'Fixed kicking a player from room immediately joins them back', ['Wolf\'s Hollow']))
        v16.push(getContent(PatchNoteType.Fix, 'Fixed player limit preventing more people from joining', ['Wolf\'s Hollow']))
        v16.push(getContent(PatchNoteType.Fix, 'Fixed room setting bugs with Can\'t place robber until VPs'))
        v16.push(getContent(PatchNoteType.Fix, 'Fixed HTML Bug: Stray end tag input (Thanks Phosegena)'))

        const v15: PatchNoteContent[] = []
        v15.push(getContent(PatchNoteType.Feature, 'Katan.io link at Google works'))
        v15.push(getContent(PatchNoteType.Fix, 'Fixed server crashes'))
        this.patchNotes.push(getPatchNote(2018, 12, 8, 15, v15))

        const v14: PatchNoteContent[] = []
        v14.push(getContent(PatchNoteType.Feature, 'Chat shows information and error messages', undefined, undefined, 'http://prntscr.com/lq6qvw'))
        v14.push(getContent(PatchNoteType.Update, 'Players in room look better', undefined, undefined, 'http://prntscr.com/lq60dr'))
        v14.push(getContent(PatchNoteType.Update, 'Players in lobby look better', undefined, undefined, 'http://prntscr.com/lrkkn9'))
        v14.push(getContent(PatchNoteType.Update, 'Reduced max length of guest and bot names to 6'))
        v14.push(getContent(PatchNoteType.Fix, 'Fixed bug where you couldn\'t use monopoly if all the resources in bank were taken', ['George', 'Randy']))
        v14.push(getContent(PatchNoteType.Fix, 'Fixed bug where you got disconnected from bot games, lobby and room', ['lolNidi']))
        v14.push(getContent(PatchNoteType.Fix, 'Fixed bug with bot game chat not working'))
        v14.push(getContent(PatchNoteType.Fix, 'Fixed server crashes'))
        this.patchNotes.push(getPatchNote(2018, 12, 6, 14, v14))

        const v13: PatchNoteContent[] = []
        v13.push(getContent(PatchNoteType.Feature, 'Rooms always show above games in lobby'))
        v13.push(getContent(PatchNoteType.Feature, 'Rooms have a different background color'))
        v13.push(getContent(PatchNoteType.Feature, 'Added a favicon to game to differentiate from tabs'))
        v13.push(getContent(PatchNoteType.Feature, 'Removed the annoying game starting and ending texts from the lobby'))
        v13.push(getContent(PatchNoteType.Feature, 'When the room leader leaves the next person is appointed as leader'))
        v13.push(getContent(PatchNoteType.Feature, 'Room leader is always shown at the top'))
        v13.push(getContent(PatchNoteType.Feature, 'Can not edit other players room names'))
        v13.push(getContent(PatchNoteType.Update, 'UI optimizations'))
        this.patchNotes.push(getPatchNote(2018, 11, 29, 13, v13))

        const v12: PatchNoteContent[] = []
        v12.push(getContent(PatchNoteType.Feature, 'Complete lobby overhaul!!!', undefined, undefined, 'https://imgur.com/a/kHkUSoI'))
        v12.push(getContent(PatchNoteType.Feature, 'Can create custom games in the lobby', ['Jerry', 'Valentin'], undefined, 'http://prntscr.com/lnqsw7'))
        v12.push(getContent(PatchNoteType.Feature, 'Player nicks can be changed', ['Valentin'], undefined, 'http://prntscr.com/lnqp5g'))
        v12.push(getContent(PatchNoteType.Feature, 'Added friendly robber setting from Play Catan inside game settings', ['Krystof', 'lolNidi'], undefined, 'http://prntscr.com/lnqrrc'))
        v12.push(getContent(PatchNoteType.Feature, 'Reduced bots trade offering per turn from 3=>2', ['RockandSnow']))
        v12.push(getContent(PatchNoteType.Feature, 'Chat doesn\'t write every joined and disconnected players', ['Ray']))
        v12.push(getContent(PatchNoteType.Feature, 'Players are given a random human name instead of id at the start', undefined, undefined, 'http://prntscr.com/lnqs5p'))
        v12.push(getContent(PatchNoteType.Feature, 'Game shows settings', undefined, undefined, 'http://prntscr.com/lnqsc3'))
        v12.push(getContent(PatchNoteType.Feature, 'Game loads faster'))
        v12.push(getContent(PatchNoteType.Fix, 'Fixed chat not working at times', ['Ray']))
        this.patchNotes.push(getPatchNote(2018, 11, 27, 12, v12))

        const v11: PatchNoteContent[] = []
        v11.push(getContent(PatchNoteType.Feature, 'Timer turns red and beeps last 5 seconds', ['lolNidi'], undefined, 'http://prntscr.com/lka9sf', ['https://www.reddit.com/r/Catan/comments/9wu9aq/katanio_play_free_online_settlers_of_catan/e9yreq5/']))
        v11.push(getContent(PatchNoteType.Feature, 'Players have background colors', ['lolNidi'], undefined, 'http://prntscr.com/lkaa2q', ['https://www.reddit.com/r/Catan/comments/9wu9aq/katanio_play_free_online_settlers_of_catan/e9yreq5/']))
        v11.push(getContent(PatchNoteType.Feature, 'Hovering over cards show tips', ['Ray'], undefined, 'http://prntscr.com/lkad55'))
        v11.push(getContent(PatchNoteType.Feature, 'Chat shows icons', undefined, undefined, 'http://prntscr.com/lkaf3a'))
        v11.push(getContent(PatchNoteType.Feature, 'Shows current turn with an arrow near players side', undefined, undefined, 'http://prntscr.com/lkafdm'))
        v11.push(getContent(PatchNoteType.Feature, 'Dice images are properly updated', ['wetz1091'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/9vrfex/katanio_free_online_catan_huge_version_9_update/e9hv2kp/']))
        v11.push(getContent(PatchNoteType.Feature, 'Wrong clicks show floating texts instead of popups', undefined, undefined, undefined, ['http://prntscr.com/lkaby8']))
        v11.push(getContent(PatchNoteType.Feature, 'Clicking on build actions results in error texts when can\'t build', undefined, undefined, 'http://prntscr.com/lkadvv'))
        v11.push(getContent(PatchNoteType.Feature, 'Clicking on ports explain what they do', undefined, undefined, 'http://prntscr.com/lkaell'))
        v11.push(getContent(PatchNoteType.Feature, 'Pressing ESC on trade offers denies trades', ['Iron']))
        v11.push(getContent(PatchNoteType.Feature, 'Bots are more careful on discarding'))
        v11.push(getContent(PatchNoteType.Update, 'Your player info is always at the right bottom'))
        v11.push(getContent(PatchNoteType.Update, 'Can\'t click development cards when it is not your turn', ['Iron']))
        v11.push(getContent(PatchNoteType.Fix, 'Fixed bug with card tips showing', ['Ray']))
        v11.push(getContent(PatchNoteType.Fix, 'Fixed start game button sending to white screen', ['Baris']))
        v11.push(getContent(PatchNoteType.Fix, 'Fixed your action colors always showing red'))
        this.patchNotes.push(getPatchNote(2018, 11, 19, 11, v11))

        const v10: PatchNoteContent[] = []
        v10.push(getContent(PatchNoteType.Feature, 'Winning players icon lights up gold (<a href="https://imgur.com/a/F1d98Al">Image</a>)', ['LordGrayMock']))
        v10.push(getContent(PatchNoteType.Feature, 'Hovering on player stat images shows information about them', undefined, undefined, 'https://imgur.com/a/5GpWedo'))
        v10.push(getContent(PatchNoteType.Feature, 'Current turn player is highlighted in yellow', ['gargantuaSy'], undefined, 'https://imgur.com/a/khA8GU9'))
        v10.push(getContent(PatchNoteType.Feature, 'Victory points show the private VPs (when you have VP development card)', undefined, undefined, 'https://prnt.sc/lhzbuo'))
        v10.push(getContent(PatchNoteType.Feature, 'Animation shows where to click the dices if the player doesn\'t for 5 seconds', ['redempt98'], undefined, 'https://prnt.sc/lhzbg5'))
        v10.push(getContent(PatchNoteType.Update, 'Rules button added to top left of the game', undefined, undefined, 'https://prnt.sc/lhzb4b'))
        v10.push(getContent(PatchNoteType.Update, 'Decreased settlement & city sizes'))
        v10.push(getContent(PatchNoteType.Update, 'Hidden game screen scrolls bars'))
        v10.push(getContent(PatchNoteType.Fix, 'Fixed buying development cards not being truly random', ['QThellimist']))
        v10.push(getContent(PatchNoteType.Fix, 'Fixed stolen resources not being truly random', ['QThellimist']))
        v10.push(getContent(PatchNoteType.Fix, 'Fixed bug where total cards in the game increases', ['Iron']))
        this.patchNotes.push(getPatchNote(2019, 11, 13, 10, v10))

        const v9: PatchNoteContent[] = []
        v9.push(getContent(PatchNoteType.Feature, 'Complete game UI overhaul!!!', undefined, undefined, 'https://imgur.com/a/mefWozQ'))
        v9.push(getContent(PatchNoteType.Feature, 'Bots initiate and accept trades that are actually good for them'))
        v9.push(getContent(PatchNoteType.Feature, 'Bots accept multiple resource trades, 2:1, 3:1, 3:2 etc..'))
        v9.push(getContent(PatchNoteType.Feature, 'Bots can try to trade multiple times in a single turn'))
        v9.push(getContent(PatchNoteType.Feature, 'Made development cards clearer & moved dice to center with other buttons', ['avi_g_foodie']))
        v9.push(getContent(PatchNoteType.Feature, 'Moved game to a new server with 48x more speed'))
        v9.push(getContent(PatchNoteType.Fix, 'Fixed bots not initiating trades'))
        v9.push(getContent(PatchNoteType.Fix, 'Fixed being able to build cities after your 4th city', ['Ray']))
        v9.push(getContent(PatchNoteType.Fix, 'Fixed being able to misplace second starting road', ['Krystof']))
        this.patchNotes.push(getPatchNote(2018, 11, 9, 9, v9))

        const v8: PatchNoteContent[] = []
        v8.push(getContent(PatchNoteType.Feature, 'Bots are more aggressive on taking longest road from opponents (Thanks RockandSnow)'))
        v8.push(getContent(PatchNoteType.Feature, 'Bots don\'t place stupid looking roads', ['QThellimist']))
        v8.push(getContent(PatchNoteType.Feature, 'Bots are more aggressive and smarter in stealing resources'))
        v8.push(getContent(PatchNoteType.Feature, 'Bots refuse to trade with the winning player late game'))
        v8.push(getContent(PatchNoteType.Feature, 'Bots accept trade faster when it\'s an all bot game'))
        this.patchNotes.push(getPatchNote(2018, 10, 25, 8, v8))

        const v7: PatchNoteContent[] = []
        v7.push(getContent(PatchNoteType.Feature, 'Orange & White colors are more easily identifiable', ['Dezza88'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/7nb7pe/katanio_online_catan_new_years_update/ds23sfm/']))
        v7.push(getContent(PatchNoteType.Feature, 'Smaller placement circles', ['Dezza88'], undefined, undefined, ['https://www.reddit.com/r/Catan/comments/7nb7pe/katanio_online_catan_new_years_update/ds23sfm/']))
        v7.push(getContent(PatchNoteType.Fix, 'Fixed North-West tile not distributing resources at the beginning of the game', ['Paul Ruettgers']))
        v7.push(getContent(PatchNoteType.Fix, 'Fixed bots targeting red to steal from while there are better targets', ['Paul Ruettgers']))
        this.patchNotes.push(getPatchNote(2018, 10, 16, 7, v7))

        const v6: PatchNoteContent[] = []
        v6.push(getContent(PatchNoteType.Feature, 'Bots will not accept trades that don\'t benefit them anymore', ['atilling99']))
        v6.push(getContent(PatchNoteType.Update, 'Performance updates to make the game work better in lower end devices'))
        v6.push(getContent(PatchNoteType.Update, 'Changed support email address send all your suggestions to: katan.io.sup@gmail.com'))
        this.patchNotes.push(getPatchNote(2018, 10, 7, 6, v6))

        const v5: PatchNoteContent[] = []
        v5.push(getContent(PatchNoteType.Feature, 'Added bots trade with bank when they have too much cards', ['Prasaanth']))
        v5.push(getContent(PatchNoteType.Feature, 'Added bots trade with bank if they need a card and can\'t trade', ['Prasaanth']))
        v5.push(getContent(PatchNoteType.Update, 'Changed AI Game name to Bot Game'))
        v5.push(getContent(PatchNoteType.Fix, 'Fixed bots trading too fast', ['atilling99', 'Dezza88']))
        v5.push(getContent(PatchNoteType.Fix, 'Fixed bots accepting every trade player asks', ['atilling99']))
        v5.push(getContent(PatchNoteType.Fix, 'Fixed bot trading with itself'))
        v5.push(getContent(PatchNoteType.Fix, 'Fixed bots failing to use Year of Plenty card'))
        this.patchNotes.push(getPatchNote(2018, 10, 4, 5, v5))

        const v4: PatchNoteContent[] = []
        v4.push(getContent(PatchNoteType.Feature, 'AI plays development cards', ['Perron', 'Prasaanth']))
        v4.push(getContent(PatchNoteType.Feature, 'AI game waiting timer is now 4x longer', ['Vagrant_Charlatan', 'Catherine']))
        v4.push(getContent(PatchNoteType.Fix, 'Fixed game continuing after winning the game with largest army', ['jxv_']))
        v4.push(getContent(PatchNoteType.Fix, 'Fixed AI not placing robber in some cases', ['Paul Ruettgers']))
        v4.push(getContent(PatchNoteType.Fix, 'Fixed longest road not changing hands when someone cuts the road', ['Paul Ruettgers']))
        this.patchNotes.push(getPatchNote(2018, 9, 28, 4, v4))

        const v3: PatchNoteContent[] = []
        v3.push(getContent(PatchNoteType.Feature, 'Improved AI'))
        v3.push(getContent(PatchNoteType.Feature, 'Added randomized map'))
        v3.push(getContent(PatchNoteType.Feature, 'Added initial game placements'))
        v3.push(getContent(PatchNoteType.Feature, 'Made better patch note'))
        v3.push(getContent(PatchNoteType.Feature, 'Game starts instantly when all players are found'))
        v3.push(getContent(PatchNoteType.Fix, 'Not showing ad bug fixed'))
        v3.push(getContent(PatchNoteType.Fix, 'Fixed colors and building placement'))
        this.patchNotes.push(getPatchNote(2017, 12, 31, 3, v3))

        const v2: PatchNoteContent[] = []
        v2.push(getContent(PatchNoteType.Feature, 'Added lobby'))
        v2.push(getContent(PatchNoteType.Feature, 'Can choose to play vs humans or AI'))
        v2.push(getContent(PatchNoteType.Feature, 'Updated colors & other game UI elements based on feedback'))
        v2.push(getContent(PatchNoteType.Feature, 'Added a short rules page'))
        v2.push(getContent(PatchNoteType.Feature, 'Better card animations'))
        this.patchNotes.push(getPatchNote(2017, 12, 25, 2, v2))

        const v1: PatchNoteContent[] = []
        v1.push(getContent(PatchNoteType.Feature, 'Can use Knight before dice roll'))
        v1.push(getContent(PatchNoteType.Feature, 'If you don\'t find a game for 30 seconds you\'ll be matched with lightning fast weak AI opponents'))
        v1.push(getContent(PatchNoteType.Feature, 'Added card animations when using: Knight, Year of Plenty, Monopoly, Robber'))
        v1.push(getContent(PatchNoteType.Feature, 'Writes in chat console when a player leaves'))
        this.patchNotes.push(getPatchNote(2017, 12, 18, 1, v1))

        const v0: PatchNoteContent[] = []
        v0.push(getContent(PatchNoteType.Feature, 'Initializing the game'))
        this.patchNotes.push(getPatchNote(2017, 12, 11, 0, v0))
    }
}
